// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"eJH2p":[function(require,module,exports) {
/**
 * This is the main script file for the theme.
 * All the other scripts are loaded here.
 *
 * This file is deferred, so it will be downloaded asynchronously,
 * but only executed when DOM is ready. You do not need to wait
 * for the DOM to be ready in these scripts.
 *
 * You should make use of custom events in the DOM to wait
 * for parts of the application to be loaded.
 * Example: document.addEventListener('swiperReady', () => {
 *   new Swiper('.swiper-container', {.. etc});
 * });
 *
 * Please comment out any modules you are not using
 * in order to keep the theme lightweight.
 *
 * Remember to keep your code clean, readable and maintainable.
 * Keep your code DRY. https://codinglead.co/javascript/what-is-DRY-code
 * Write code for humans. Parcel will build it for machines.
 * Use the linter. $ npm run lint
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _mainScss = require("../css/main.scss");
var _geoJs = require("./framework/_geo.js");
var _swatchesJs = require("./framework/_swatches.js");
var _recentlyViewedJs = require("./framework/_recently-viewed.js");
var _cartJs = require("./framework/_cart.js");
var _minicartJs = require("./framework/_minicart.js");
// import './framework/_filter.js';
var _wishlistJs = require("./framework/_wishlist.js");
var _quickshopJs = require("./framework/_quickshop.js");
// import './framework/_predictive-search.js';
var _productRecommendationsJs = require("./framework/_product-recommendations.js");
var _bundlesJs = require("./framework/_bundles.js");
// Expose any required utilities to the window
var _utilsJs = require("./framework/utils.js");
// Custom modules
var _countdownTimerJs = require("./custom/_countdown-timer.js");
var _detectOsJs = require("./custom/_detect-os.js");
var _uwpfilters = require("./custom/uwpfilters");
var _quickSearch = require("./custom/_quick-search");
var _faqFiltersJs = require("./custom/_faq-filters.js");
var _productDescriptionJs = require("./custom/_product-description.js");
var _shopboxComponentTsx = require("./custom/shopbox/ShopboxComponent.tsx");
var _productRedirectJs = require("./custom/_product-redirect.js");
var _productRedirectJsDefault = parcelHelpers.interopDefault(_productRedirectJs);
var _cartJs1 = require("./custom/_cart.js");
var _cartJsDefault = parcelHelpers.interopDefault(_cartJs1);
var _findInStoreJs = require("./custom/_find-in-store.js");
var _findInStoreJsDefault = parcelHelpers.interopDefault(_findInStoreJs);
var _pdpKlarnaStylerJs = require("./custom/_pdp-klarna-styler.js");
/*
 * **************************
 *
 *         Swiper
 *
 * **************************
 */ var _swiperEsmJs = require("swiper/swiper.esm.js");
var _swiperBundleCss = require("swiper/swiper-bundle.css");
/*
 * **************************
 *
 *     Framework Modules
 *
 * **************************
 */ var ThemeVars = window.ThemeVars;
window.toMoneyString = (0, _utilsJs.toMoneyString);
window.addEventListener("load", function(event) {
    (0, _cartJsDefault.default).init();
    (0, _findInStoreJsDefault.default).init();
});
if (window.storePage == "pdp") (0, _productRedirectJsDefault.default).init();
(0, _swiperEsmJs.Swiper).use([
    (0, _swiperEsmJs.Navigation),
    (0, _swiperEsmJs.Pagination),
    (0, _swiperEsmJs.Autoplay),
    (0, _swiperEsmJs.Thumbs)
]);
window.Swiper = (0, _swiperEsmJs.Swiper);
document.dispatchEvent(new CustomEvent("swiperReady"));
/*
 * **************************
 *
 *    Preview Bar Toggle
 *
 * **************************
 */ var previewToggleEnabled = true;
// Only show the toggle if the theme is not the live theme. Note: This property is deprecated and may lose support, that's why we use the opposite of checking if the theme is live.
if (previewToggleEnabled && ThemeVars && (ThemeVars.theme.role == "unpublished" || ThemeVars.theme.role == "demo" || ThemeVars.theme.role == "development")) {
    var previewBarToggle = document.createElement("div");
    previewBarToggle.classList.add("preview-bar-toggle");
    previewBarToggle.innerHTML = '<span class="preview-bar-toggle__icon">\n      <?xml version="1.0" ?><!DOCTYPE svg  PUBLIC \'-//W3C//DTD SVG 1.1//EN\'  \'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\'><svg enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.1" viewBox="0 0 32 32" width="32px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><polyline fill="none" points="   649,137.999 675,137.999 675,155.999 661,155.999  " stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/><polyline fill="none" points="   653,155.999 649,155.999 649,141.999  " stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/><polyline fill="none" points="   661,156 653,162 653,156  " stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/></g><g><g><path d="M16,25c-4.265,0-8.301-1.807-11.367-5.088c-0.377-0.403-0.355-1.036,0.048-1.413c0.404-0.377,1.036-0.355,1.414,0.048    C8.778,21.419,12.295,23,16,23c4.763,0,9.149-2.605,11.84-7c-2.69-4.395-7.077-7-11.84-7c-4.938,0-9.472,2.801-12.13,7.493    c-0.272,0.481-0.884,0.651-1.363,0.377c-0.481-0.272-0.649-0.882-0.377-1.363C5.147,10.18,10.333,7,16,7    c5.668,0,10.853,3.18,13.87,8.507c0.173,0.306,0.173,0.68,0,0.985C26.853,21.819,21.668,25,16,25z"/></g><g><path d="M16,21c-2.757,0-5-2.243-5-5s2.243-5,5-5s5,2.243,5,5S18.757,21,16,21z M16,13c-1.654,0-3,1.346-3,3s1.346,3,3,3    s3-1.346,3-3S17.654,13,16,13z"/></g></g></svg>\n    </span>';
    previewBarToggle.addEventListener("click", function() {
        var previewBar = document.querySelector("#preview-bar-iframe");
        previewBar && previewBar.classList.toggle("closed");
        previewBar && previewBarToggle.classList.toggle("open");
        previewBarToggle.style.bottom = previewBar && previewBarToggle.classList.contains("open") ? "calc(".concat(previewBar.offsetHeight, "px + 1rem)") : "";
    });
    document.body.appendChild(previewBarToggle);
    // Use a mutation observer to wait for an element with id "preview-bar-iframe" to be added to the DOM
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type == "childList" && mutation.addedNodes.length > 0) {
                var previewBar = document.querySelector("#preview-bar-iframe");
                if (previewBar) previewBar.classList.add("closed");
            }
        });
    });
    observer.observe(document.body, {
        childList: true
    });
    // If the preview bar is already in the DOM, add the class "closed" to it
    var previewBar = document.querySelector("#preview-bar-iframe");
    if (previewBar) previewBar.classList.add("closed");
}

},{"../css/main.scss":"hLkIH","./framework/_geo.js":"jN0S3","./framework/_swatches.js":"6VH5x","./framework/_recently-viewed.js":"48A1E","./framework/_cart.js":"lMAlE","./framework/_minicart.js":"fGhsA","./framework/_wishlist.js":"bk4ve","./framework/_quickshop.js":"dZwOO","./framework/_product-recommendations.js":"fJLOJ","./framework/_bundles.js":"OEros","./framework/utils.js":"fP4IO","./custom/_countdown-timer.js":"gQHzL","./custom/_detect-os.js":"2f8U0","./custom/uwpfilters":"5egIY","./custom/_quick-search":"7z4FV","./custom/_faq-filters.js":"39t2b","./custom/_product-description.js":"kQmsa","./custom/shopbox/ShopboxComponent.tsx":"159X2","./custom/_product-redirect.js":"kUeqk","./custom/_cart.js":"6Dc29","./custom/_find-in-store.js":"jsMxg","./custom/_pdp-klarna-styler.js":"2WjDp","swiper/swiper.esm.js":"dBrcy","swiper/swiper-bundle.css":"jB0W0","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"hLkIH":[function() {},{}],"jN0S3":[function(require,module,exports) {
/**
 * This file contains geolocation code. 
 * It's primary function is to return location data,
 * not to actually perform any redirection etc.
 * You should consume this data and perform your own actions.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _asyncToGeneratorMjs = require("@swc/helpers/src/_async_to_generator.mjs");
var _asyncToGeneratorMjsDefault = parcelHelpers.interopDefault(_asyncToGeneratorMjs);
var _tsGeneratorMjs = require("@swc/helpers/src/_ts_generator.mjs");
var _tsGeneratorMjsDefault = parcelHelpers.interopDefault(_tsGeneratorMjs);
var _utils = require("./utils");
var lookup = require("f104a5a108e5ed50");
var Geo = {
    /**
   * Gets data about the users location.
   * @returns {object} Information about the users location.
   */ getUserLocationData: /*#__PURE__*/ (0, _asyncToGeneratorMjsDefault.default)(function() {
        var userData, countryCode, locationData;
        return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        this.getUserData()
                    ];
                case 1:
                    userData = _state.sent();
                    if (userData == null || userData === "") {
                        console.warn("Geo.getUserLocationData() : userData is unavailable.");
                        return [
                            2,
                            undefined
                        ];
                    }
                    countryCode = userData.loc;
                    locationData = lookup.byIso(countryCode);
                    return [
                        2,
                        locationData
                    ];
            }
        });
    }),
    /**
   * Returns the user data from storage if available.
   * If not, returns user data from the API and also stores it in storage.
   * @returns {object} The user data.
   */ getUserData: /*#__PURE__*/ (0, _asyncToGeneratorMjsDefault.default)(function() {
        var userData;
        return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        this.getUserDataFromStorage()
                    ];
                case 1:
                    userData = _state.sent();
                    if (!(!userData || (0, _utils.isEmpty)(userData))) return [
                        3,
                        3
                    ];
                    console.log("No user data found in storage, fetching from API instead...");
                    return [
                        4,
                        this.getUserDataFromAPI()
                    ];
                case 2:
                    userData = _state.sent();
                    window.localStorage.setItem("userData", JSON.stringify(userData));
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        userData
                    ];
            }
        });
    }),
    /**
   * Returns the user data from storage if available.
   * @returns {object} The user data.
   */ getUserDataFromStorage: /*#__PURE__*/ (0, _asyncToGeneratorMjsDefault.default)(function() {
        var userData;
        return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
            userData = localStorage.getItem("userData");
            if (userData) userData = JSON.parse(userData);
            return [
                2,
                userData
            ];
        });
    }),
    /**
   * Returns the user data from the API.
   * @returns {object} The user data.
   */ getUserDataFromAPI: /*#__PURE__*/ (0, _asyncToGeneratorMjsDefault.default)(function() {
        var userData, userDataArray, userDataObject;
        return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("https://www.cloudflare.com/cdn-cgi/trace").then(function(res) {
                            return res.text();
                        })
                    ];
                case 1:
                    userData = _state.sent();
                    userDataArray = userData.split("\n");
                    userDataObject = {};
                    userDataArray.forEach(function(line) {
                        var lineArray = line.split("=");
                        userDataObject[lineArray[0]] = lineArray[1];
                    });
                    return [
                        2,
                        userDataObject
                    ];
            }
        });
    })
};
window.Geo = Geo;
document.dispatchEvent(new Event("geoReady"));

},{"@swc/helpers/src/_async_to_generator.mjs":"7nC9G","@swc/helpers/src/_ts_generator.mjs":"cT4KU","./utils":"fP4IO","f104a5a108e5ed50":"9IX7l","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"7nC9G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
exports.default = _asyncToGenerator;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"3Oqqe":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"cT4KU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _tslib.__generator;
});
var _tslib = require("tslib");

},{"tslib":"e9R7i","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"e9R7i":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
/** @deprecated */ parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__spreadArray", function() {
    return __spreadArray;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
parcelHelpers.export(exports, "__classPrivateFieldIn", function() {
    return __classPrivateFieldIn;
});
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    var __ = function __() {
        this.constructor = d;
    };
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
}
var __createBinding = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    var verb = function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    };
    var resume = function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    };
    var step = function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    };
    var fulfill = function fulfill(value) {
        resume("next", value);
    };
    var reject = function reject(value) {
        resume("throw", value);
    };
    var settle = function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
}
function __asyncDelegator(o) {
    var verb = function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    };
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
}
function __asyncValues(o) {
    var verb = function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    };
    var settle = function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"fP4IO":[function(require,module,exports) {
/*
 * You need to import utility functions yourself
 * e.g. at the top of your file:
 *    import {makeArrayUnique, handleize} from './_utils.js';
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Removes duplicates from an array and returns the result.
 * @param {Array} array - The array containing duplicates.
 * @returns {Array} A unique array.
 * @example
 * makeArrayUnique([1, 2, 3, 3, 4, 5, 5, 6, 7, 7, 7, 8, 9, 9, 9, 10]);
 * // [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
 */ parcelHelpers.export(exports, "makeArrayUnique", function() {
    return makeArrayUnique;
});
/**
 * Converts a string to a valid URL slug.
 * @param {String} string - The string to convert.
 * @returns {String} A URL slug.
 * @example
 * handleize('This is a test!');
 * // this-is-a-test
 */ parcelHelpers.export(exports, "handleize", function() {
    return handleize;
});
/**
 * Gets an object representing destructured form data using name and value attributes.
 * @param {HTMLFormElement} form - The form to get data from.
 * @returns {Object} An object containing the form data.
 * @example
 * getParamsFromForm(document.querySelector('form'));
 * // {
 * //   id: '12345',
 * //   quantity: 1,
 * //   properties: {
 * //     'Gift Message': 'Happy Birthday!'
 * //   }
 * // }
 */ parcelHelpers.export(exports, "getParamsFromForm", function() {
    return getParamsFromForm;
});
/**
 * Gets a query string representing destructured form data.
 * @param {HTMLFormElement} form - The form to get data from.
 * @param {String} prefix - OPTIONAL: A prefix to prepend to the query string.
 * @returns {String} A query string.
 * @example
 * getQueryStringFromForm(document.querySelector('form'));
 * // id=12345&quantity=1&properties[Gift%20Message]=Happy%20Birthday!
 */ parcelHelpers.export(exports, "getQueryFromForm", function() {
    return getQueryFromForm;
});
/**
 * Gets a query string representing a destructured object.
 * @param {Object} object - The object to get data from.
 * @param {String} prefix - OPTIONAL: A prefix to prepend to the query string.
 * @returns {String} A query string.
 * @example
 * getQueryStringFromObject({
 *  id: '12345',
 *  quantity: 1
 * });
 * // id=12345&quantity=1
 */ parcelHelpers.export(exports, "objectToQueryString", function() {
    return objectToQueryString;
});
/**
 * Converts an amount into cents (or pennies etc).
 * @param {String|Number} amount - The amount to convert.
 * @returns {Integer} The amount in cents.
 * @example
 * toCents('$1.00');
 * // 100
 */ parcelHelpers.export(exports, "toCents", function() {
    return toCents;
});
/**
 * Converts an amount into a money formatted string.
 * @param {String|Number} amount - The amount to convert.
 * @param {Boolean} cents - OPTIONAL: Whether or not the amount is already in cents. Default: true.
 * @returns {String} The amount in money formatted string.
 * @example
 * toMoneyString(100);
 * // '$1.00'
 * toMoneyString(100, false);
 * // '$100.00'
 */ parcelHelpers.export(exports, "toMoneyString", function() {
    return toMoneyString;
});
/**
 * Generates a modal window with a given outer class and inner content.
 * @param {String} outerClass - The outer class to add to the modal.
 * @param {String} innerContent - The inner content to add to the modal.
 * @returns {String} The modal window markup.
 */ parcelHelpers.export(exports, "generateModal", function() {
    return generateModal;
});
/**
 * Removes and re-adds script tags from an element so they are loaded again.
 * @param {HTMLElement} element - The element to remove and re-add script tags from.
 * @returns {Boolean} Whether or not the element was valid (and thus any script tags were removed and re-added).
 */ parcelHelpers.export(exports, "reloadScripts", function() {
    return reloadScripts;
});
/**
 * Capitalizes the first letter in each word of a string.
 * @param {String} string - The string to titleize.
 * @returns {String} A titleized string.
 * @example
 * titleize('hello world');
 * // Hello World
 */ parcelHelpers.export(exports, "titleize", function() {
    return titleize;
});
/**
 * Remove keys from an object that are null, undefined, or empty strings/arrays/objects.
 * @param {Object} object - The object to remove keys from.
 * @returns {Object} The object with keys removed.
 * @example
 * removeEmptyKeys({ a: 'Lorem ipsum', b: [1, 2, 3], c: null, d: undefined, e: '', f: [], g: {} });
 * // { a: 'Lorem ipsum', b: [1, 2, 3] }
 */ parcelHelpers.export(exports, "removeEmptyKeys", function() {
    return removeEmptyKeys;
});
/**
 * Checks if a passed string/array/object is empty.
 * @param {String|Array|Object} value - The value to check.
 * @returns {Boolean} Whether or not the value is empty.
 * @example
 * isEmpty([]);
 * // true
 * isEmpty('hello');
 * // false
 */ parcelHelpers.export(exports, "isEmpty", function() {
    return isEmpty;
});
/**
 * Strips whitespace (except single space between words) from a passed in string.
 * @param {String} string - The string to strip.
 * @returns {String} The stripped string.
 * @example
 * stripWhitespace('  hello world  ');
 * // 'hello world'
 */ parcelHelpers.export(exports, "stripWhitespace", function() {
    return stripWhitespace;
});
/**
 * Strips all HTML tags from a passed in string.
 * @param {String} string - The string to strip.
 * @returns {String} The stripped string.
 * @example
 * stripHTML('<p>hello world</p>');
 * // 'hello world'
 */ parcelHelpers.export(exports, "stripHTML", function() {
    return stripHTML;
});
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var ThemeVars = window.ThemeVars;
function makeArrayUnique(array) {
    return array.filter(function(item, index) {
        return array.indexOf(item) === index;
    });
}
function handleize(string) {
    return string.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
}
function getParamsFromForm(form) {
    var formData = new FormData(form);
    var params = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArrayMjsDefault.default)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (key.includes("[]")) {
                var arrayKey = key.replace("[]", "");
                if (!params[arrayKey]) params[arrayKey] = [];
                params[arrayKey].push(value);
            } else params[key] = value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return params;
}
function getQueryFromForm(form) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var params = getParamsFromForm(form);
    var queryString = Object.keys(params).map(function(key) {
        var value = params[key];
        if (Array.isArray(value)) return value.map(function(item) {
            return "".concat(key, "[]=").concat(item);
        }).join("&");
        else if (typeof value === "object") return Object.keys(value).map(function(subKey) {
            return "".concat(key, "[").concat(subKey, "]=").concat(value[subKey]);
        }).join("&");
        else return "".concat(key, "=").concat(value);
    }).join("&");
    return "".concat(prefix).concat(queryString);
}
function objectToQueryString(object) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return prefix + Object.keys(object).map(function(key) {
        return "".concat(key, "=").concat(object[key]);
    }).join("&");
}
function toCents(amount) {
    amount = amount.toString().replace(/[^0-9.]/g, "");
    if (amount.includes(".")) {
        amount = parseFloat(amount);
        amount *= 100;
        return Math.round(amount);
    }
    return parseInt(amount * 100);
}
function toMoneyString(amount) {
    var cents = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (!cents) amount = toCents(amount);
    var moneyAmount = (parseFloat(amount) / 100).toFixed(2);
    var moneyFormat = ThemeVars.moneyFormat || "${{amount}}";
    return moneyFormat.replace("{{amount}}", moneyAmount);
}
function generateModal(outerClass, innerContent) {
    return '\n  <div class="'.concat(outerClass, '">\n    <div class="').concat(outerClass, '__inner">\n      ').concat(innerContent, "\n    </div>\n    <style>\n      body {\n        overflow: hidden;\n      }\n      .").concat(outerClass, " {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background-color: rgba(0, 0, 0, 0.5);\n        z-index: 9999999999;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n      .").concat(outerClass, "__inner {\n        width: 800px;\n        max-width: 96%;\n        max-height: 100%;\n        min-height: 250px;\n        background-color: #fff;\n        border-radius: 4px;\n        overflow-y: auto;\n        overflow-x: hidden;\n        box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n      }\n    </style>\n  </div>\n");
}
function reloadScripts(element) {
    if (!element || !(element instanceof HTMLElement)) return false;
    var scriptTags = element.querySelectorAll("script");
    scriptTags.forEach(function(oldScriptTag) {
        var newScriptTag = document.createElement("script");
        newScriptTag.textContent = oldScriptTag.textContent;
        oldScriptTag.remove();
        element.appendChild(newScriptTag);
    });
    return true;
}
function titleize(string) {
    return string.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}
function removeEmptyKeys(object) {
    var keys = Object.keys(object);
    keys.forEach(function(key) {
        if (object[key] === null || object[key] === undefined || isEmpty(object[key])) delete object[key];
    });
    return object;
}
function isEmpty(value) {
    if (Array.isArray(value)) return value.length === 0;
    else if (typeof value === "object") return Object.keys(value).length === 0;
    else return value === "";
}
function stripWhitespace(string) {
    return string.replace(/\s{2,}/g, " ").trim();
}
function stripHTML(string) {
    return string.replace(/<[^>]*>/g, "");
}

},{"@swc/helpers/src/_sliced_to_array.mjs":"l34hS","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"l34hS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayWithHolesMjs = require("./_array_with_holes.mjs");
var _arrayWithHolesMjsDefault = parcelHelpers.interopDefault(_arrayWithHolesMjs);
var _iterableToArrayMjs = require("./_iterable_to_array.mjs");
var _iterableToArrayMjsDefault = parcelHelpers.interopDefault(_iterableToArrayMjs);
var _nonIterableRestMjs = require("./_non_iterable_rest.mjs");
var _nonIterableRestMjsDefault = parcelHelpers.interopDefault(_nonIterableRestMjs);
var _unsupportedIterableToArrayMjs = require("./_unsupported_iterable_to_array.mjs");
var _unsupportedIterableToArrayMjsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayMjs);
function _slicedToArray(arr, i) {
    return (0, _arrayWithHolesMjsDefault.default)(arr) || (0, _iterableToArrayMjsDefault.default)(arr, i) || (0, _unsupportedIterableToArrayMjsDefault.default)(arr, i) || (0, _nonIterableRestMjsDefault.default)();
}
exports.default = _slicedToArray;

},{"./_array_with_holes.mjs":"1ILsw","./_iterable_to_array.mjs":"dgYS2","./_non_iterable_rest.mjs":"fVBvM","./_unsupported_iterable_to_array.mjs":"gLmrA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"1ILsw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
exports.default = _arrayWithHoles;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"dgYS2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
exports.default = _iterableToArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"fVBvM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
exports.default = _nonIterableRest;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"gLmrA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayLikeToArrayMjs = require("./_array_like_to_array.mjs");
var _arrayLikeToArrayMjsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayMjs);
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, _arrayLikeToArrayMjsDefault.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, _arrayLikeToArrayMjsDefault.default)(o, minLen);
}
exports.default = _unsupportedIterableToArray;

},{"./_array_like_to_array.mjs":"hHqRn","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"hHqRn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
exports.default = _arrayLikeToArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"9IX7l":[function(require,module,exports) {
module.exports.byFips = function(code) {
    return search("fips", code.toUpperCase());
};
module.exports.byIso = function(code) {
    if (!isNaN(parseInt(code))) return search("isoNo", code.toString());
    if (code.length === 2) return search("iso2", code.toUpperCase());
    if (code.length === 3) return search("iso3", code.toUpperCase());
    throw new Error("cannot determine ISO code type");
};
module.exports.byInternet = function(code) {
    return search("internet", code.toUpperCase());
};
module.exports.byCountry = function(country) {
    return search("country", country);
};
function search(field, code) {
    for(var i = 0; i < countries.length; i++){
        if (countries[i][field] === code) return countries[i];
    }
    return null;
}
var countries = [
    {
        continent: "Asia",
        region: "South Asia",
        country: "Afghanistan",
        capital: "Kabul",
        fips: "AF",
        iso2: "AF",
        iso3: "AFG",
        isoNo: "4",
        internet: "AF"
    },
    {
        continent: "Europe",
        region: "South East Europe",
        country: "Albania",
        capital: "Tirana",
        fips: "AL",
        iso2: "AL",
        iso3: "ALB",
        isoNo: "8",
        internet: "AL"
    },
    {
        continent: "Africa",
        region: "Northern Africa",
        country: "Algeria",
        capital: "Algiers",
        fips: "AG",
        iso2: "DZ",
        iso3: "DZA",
        isoNo: "12",
        internet: "DZ"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "American Samoa",
        capital: "Pago Pago",
        fips: "AQ",
        iso2: "AS",
        iso3: "ASM",
        isoNo: "16",
        internet: "AS"
    },
    {
        continent: "Europe",
        region: "South West Europe",
        country: "Andorra",
        capital: "Andorra la Vella",
        fips: "AN",
        iso2: "AD",
        iso3: "AND",
        isoNo: "20",
        internet: "AD"
    },
    {
        continent: "Africa",
        region: "Southern Africa",
        country: "Angola",
        capital: "Luanda",
        fips: "AO",
        iso2: "AO",
        iso3: "AGO",
        isoNo: "24",
        internet: "AO"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Anguilla",
        capital: "The Valley",
        fips: "AV",
        iso2: "AI",
        iso3: "AIA",
        isoNo: "660",
        internet: "AI"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Antigua and Barbuda",
        capital: "Saint John's",
        fips: "AC",
        iso2: "AG",
        iso3: "ATG",
        isoNo: "28",
        internet: "AG"
    },
    {
        continent: "Americas",
        region: "South America",
        country: "Argentina",
        capital: "Buenos Aires",
        fips: "AR",
        iso2: "AR",
        iso3: "ARG",
        isoNo: "32",
        internet: "AR"
    },
    {
        continent: "Asia",
        region: "South West Asia",
        country: "Armenia",
        capital: "Yerevan",
        fips: "AM",
        iso2: "AM",
        iso3: "ARM",
        isoNo: "51",
        internet: "AM"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Aruba",
        capital: "Oranjestad",
        fips: "AA",
        iso2: "AW",
        iso3: "ABW",
        isoNo: "533",
        internet: "AW"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Australia",
        capital: "Canberra",
        fips: "AS",
        iso2: "AU",
        iso3: "AUS",
        isoNo: "36",
        internet: "AU"
    },
    {
        continent: "Europe",
        region: "Central Europe",
        country: "Austria",
        capital: "Vienna",
        fips: "AU",
        iso2: "AT",
        iso3: "AUT",
        isoNo: "40",
        internet: "AT"
    },
    {
        continent: "Asia",
        region: "South West Asia",
        country: "Azerbaijan",
        capital: "Baku (Baki)",
        fips: "AJ",
        iso2: "AZ",
        iso3: "AZE",
        isoNo: "31",
        internet: "AZ"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "The Bahamas",
        capital: "Nassau",
        fips: "BF",
        iso2: "BS",
        iso3: "BHS",
        isoNo: "44",
        internet: "BS"
    },
    {
        continent: "Asia",
        region: "South West Asia",
        country: "Bahrain",
        capital: "Manama",
        fips: "BA",
        iso2: "BH",
        iso3: "BHR",
        isoNo: "48",
        internet: "BH"
    },
    {
        continent: "Asia",
        region: "South Asia",
        country: "Bangladesh",
        capital: "Dhaka",
        fips: "BG",
        iso2: "BD",
        iso3: "BGD",
        isoNo: "50",
        internet: "BD"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Barbados",
        capital: "Bridgetown",
        fips: "BB",
        iso2: "BB",
        iso3: "BRB",
        isoNo: "52",
        internet: "BB"
    },
    {
        continent: "Europe",
        region: "Eastern Europe",
        country: "Belarus",
        capital: "Minsk",
        fips: "BO",
        iso2: "BY",
        iso3: "BLR",
        isoNo: "112",
        internet: "BY"
    },
    {
        continent: "Europe",
        region: "Western Europe",
        country: "Belgium",
        capital: "Brussels",
        fips: "BE",
        iso2: "BE",
        iso3: "BEL",
        isoNo: "56",
        internet: "BE"
    },
    {
        continent: "Americas",
        region: "Central America",
        country: "Belize",
        capital: "Belmopan",
        fips: "BH",
        iso2: "BZ",
        iso3: "BLZ",
        isoNo: "84",
        internet: "BZ"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "Benin",
        capital: "Porto-Novo��",
        fips: "BN",
        iso2: "BJ",
        iso3: "BEN",
        isoNo: "204",
        internet: "BJ"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Bermuda",
        capital: "Hamilton",
        fips: "BD",
        iso2: "BM",
        iso3: "BMU",
        isoNo: "60",
        internet: "BM"
    },
    {
        continent: "Asia",
        region: "South Asia",
        country: "Bhutan",
        capital: "Thimphu",
        fips: "BT",
        iso2: "BT",
        iso3: "BTN",
        isoNo: "64",
        internet: "BT"
    },
    {
        continent: "Americas",
        region: "South America",
        country: "Bolivia",
        capital: "La Paz / Sucre",
        fips: "BL",
        iso2: "BO",
        iso3: "BOL",
        isoNo: "68",
        internet: "BO"
    },
    {
        continent: "Europe",
        region: "South East Europe",
        country: "Bosnia and Herzegovina",
        capital: "Sarajevo",
        fips: "BK",
        iso2: "BA",
        iso3: "BIH",
        isoNo: "70",
        internet: "BA"
    },
    {
        continent: "Africa",
        region: "Southern Africa",
        country: "Botswana",
        capital: "Gaborone",
        fips: "BC",
        iso2: "BW",
        iso3: "BWA",
        isoNo: "72",
        internet: "BW"
    },
    {
        continent: "Americas",
        region: "South America",
        country: "Brazil",
        capital: "Brasilia",
        fips: "BR",
        iso2: "BR",
        iso3: "BRA",
        isoNo: "76",
        internet: "BR"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "British Virgin Islands",
        capital: "Road Town",
        fips: "VI",
        iso2: "VG",
        iso3: "VGB",
        isoNo: "92",
        internet: "VG"
    },
    {
        continent: "Asia",
        region: "South East Asia",
        country: "Brunei",
        capital: "Bandar Seri Begawan",
        fips: "BX",
        iso2: "BN",
        iso3: "BRN",
        isoNo: "96",
        internet: "BN"
    },
    {
        continent: "Europe",
        region: "South East Europe",
        country: "Bulgaria",
        capital: "Sofia",
        fips: "BU",
        iso2: "BG",
        iso3: "BGR",
        isoNo: "100",
        internet: "BG"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "Burkina Faso",
        capital: "Ouagadougou",
        fips: "UV",
        iso2: "BF",
        iso3: "BFA",
        isoNo: "854",
        internet: "BF"
    },
    {
        continent: "Africa",
        region: "Central Africa",
        country: "Burundi",
        capital: "Bujumbura",
        fips: "BY",
        iso2: "BI",
        iso3: "BDI",
        isoNo: "108",
        internet: "BI"
    },
    {
        continent: "Asia",
        region: "South East Asia",
        country: "Cambodia",
        capital: "Phnom Penh",
        fips: "CB",
        iso2: "KH",
        iso3: "KHM",
        isoNo: "116",
        internet: "KH"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "Cameroon",
        capital: "Yaounde",
        fips: "CM",
        iso2: "CM",
        iso3: "CMR",
        isoNo: "120",
        internet: "CM"
    },
    {
        continent: "Americas",
        region: "North America",
        country: "Canada",
        capital: "Ottawa",
        fips: "CA",
        iso2: "CA",
        iso3: "CAN",
        isoNo: "124",
        internet: "CA"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "Cape Verde",
        capital: "Praia",
        fips: "CV",
        iso2: "CV",
        iso3: "CPV",
        isoNo: "132",
        internet: "CV"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Cayman Islands",
        capital: "George Town",
        fips: "CJ",
        iso2: "KY",
        iso3: "CYM",
        isoNo: "136",
        internet: "KY"
    },
    {
        continent: "Africa",
        region: "Central Africa",
        country: "Central African Republic",
        capital: "Bangui",
        fips: "CT",
        iso2: "CF",
        iso3: "CAF",
        isoNo: "140",
        internet: "CF"
    },
    {
        continent: "Africa",
        region: "Central Africa",
        country: "Chad",
        capital: "N'Djamena",
        fips: "CD",
        iso2: "TD",
        iso3: "TCD",
        isoNo: "148",
        internet: "TD"
    },
    {
        continent: "Americas",
        region: "South America",
        country: "Chile",
        capital: "Santiago",
        fips: "CI",
        iso2: "CL",
        iso3: "CHL",
        isoNo: "152",
        internet: "CL"
    },
    {
        continent: "Asia",
        region: "East Asia",
        country: "China",
        capital: "Beijing",
        fips: "CH",
        iso2: "CN",
        iso3: "CHN",
        isoNo: "156",
        internet: "CN"
    },
    {
        continent: "Asia",
        region: "South East Asia",
        country: "Christmas Island",
        capital: "The Settlement",
        fips: "KT",
        iso2: "CX",
        iso3: "CXR",
        isoNo: "162",
        internet: "CX"
    },
    {
        continent: "Asia",
        region: "South East Asia",
        country: "Cocos (Keeling) Islands",
        capital: "West Island",
        fips: "CK",
        iso2: "CC",
        iso3: "CCK",
        isoNo: "166",
        internet: "CC"
    },
    {
        continent: "Americas",
        region: "South America",
        country: "Colombia",
        capital: "Bogota",
        fips: "CO",
        iso2: "CO",
        iso3: "COL",
        isoNo: "170",
        internet: "CO"
    },
    {
        continent: "Africa",
        region: "Indian Ocean",
        country: "Comoros",
        capital: "Moroni",
        fips: "CN",
        iso2: "KM",
        iso3: "COM",
        isoNo: "174",
        internet: "KM"
    },
    {
        continent: "Africa",
        region: "Central Africa",
        country: "Republic of the Congo",
        capital: "Brazzaville",
        fips: "CF",
        iso2: "CG",
        iso3: "COG",
        isoNo: "178",
        internet: "CG"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Cook Islands",
        capital: "Avarua",
        fips: "CW",
        iso2: "CK",
        iso3: "COK",
        isoNo: "184",
        internet: "CK"
    },
    {
        continent: "Americas",
        region: "Central America",
        country: "Costa Rica",
        capital: "San Jose",
        fips: "CS",
        iso2: "CR",
        iso3: "CRI",
        isoNo: "188",
        internet: "CR"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "Cote d'Ivoire",
        capital: "Yamoussoukro",
        fips: "IV",
        iso2: "CI",
        iso3: "CIV",
        isoNo: "384",
        internet: "CI"
    },
    {
        continent: "Europe",
        region: "South East Europe",
        country: "Croatia",
        capital: "Zagreb",
        fips: "HR",
        iso2: "HR",
        iso3: "HRV",
        isoNo: "191",
        internet: "HR"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Cuba",
        capital: "Havana",
        fips: "CU",
        iso2: "CU",
        iso3: "CUB",
        isoNo: "192",
        internet: "CU"
    },
    {
        continent: "Asia",
        region: "South West Asia",
        country: "Cyprus",
        capital: "Nicosia",
        fips: "CY",
        iso2: "CY",
        iso3: "CYP",
        isoNo: "196",
        internet: "CY"
    },
    {
        continent: "Europe",
        region: "Central Europe",
        country: "Czech Republic",
        capital: "Prague",
        fips: "EZ",
        iso2: "CZ",
        iso3: "CZE",
        isoNo: "203",
        internet: "CZ"
    },
    {
        continent: "Europe",
        region: "Northern Europe",
        country: "Denmark",
        capital: "Copenhagen",
        fips: "DA",
        iso2: "DK",
        iso3: "DNK",
        isoNo: "208",
        internet: "DK"
    },
    {
        continent: "Africa",
        region: "Eastern Africa",
        country: "Djibouti",
        capital: "Djibouti",
        fips: "DJ",
        iso2: "DJ",
        iso3: "DJI",
        isoNo: "262",
        internet: "DJ"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Dominica",
        capital: "Roseau",
        fips: "DO",
        iso2: "DM",
        iso3: "DMA",
        isoNo: "212",
        internet: "DM"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Dominican Republic",
        capital: "Santo Domingo",
        fips: "DR",
        iso2: "DO",
        iso3: "DOM",
        isoNo: "214",
        internet: "DO"
    },
    {
        continent: "Americas",
        region: "South America",
        country: "Ecuador",
        capital: "Quito",
        fips: "EC",
        iso2: "EC",
        iso3: "ECU",
        isoNo: "218",
        internet: "EC"
    },
    {
        continent: "Africa",
        region: "Northern Africa",
        country: "Egypt",
        capital: "Cairo",
        fips: "EG",
        iso2: "EG",
        iso3: "EGY",
        isoNo: "818",
        internet: "EG"
    },
    {
        continent: "Americas",
        region: "Central America",
        country: "El Salvador",
        capital: "San Salvador",
        fips: "ES",
        iso2: "SV",
        iso3: "SLV",
        isoNo: "222",
        internet: "SV"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "Equatorial Guinea",
        capital: "Malabo",
        fips: "EK",
        iso2: "GQ",
        iso3: "GNQ",
        isoNo: "226",
        internet: "GQ"
    },
    {
        continent: "Africa",
        region: "Eastern Africa",
        country: "Eritrea",
        capital: "Asmara",
        fips: "ER",
        iso2: "ER",
        iso3: "ERI",
        isoNo: "232",
        internet: "ER"
    },
    {
        continent: "Europe",
        region: "Eastern Europe",
        country: "Estonia",
        capital: "Tallinn",
        fips: "EN",
        iso2: "EE",
        iso3: "EST",
        isoNo: "233",
        internet: "EE"
    },
    {
        continent: "Africa",
        region: "Eastern Africa",
        country: "Ethiopia",
        capital: "Addis Ababa",
        fips: "ET",
        iso2: "ET",
        iso3: "ETH",
        isoNo: "231",
        internet: "ET"
    },
    {
        continent: "Americas",
        region: "South America",
        country: "Falkland Islands (Islas Malvinas)",
        capital: "Stanley",
        fips: "FA",
        iso2: "FK",
        iso3: "FLK",
        isoNo: "238",
        internet: "FK"
    },
    {
        continent: "Europe",
        region: "Northern Europe",
        country: "Faroe Islands",
        capital: "Torshavn",
        fips: "FO",
        iso2: "FO",
        iso3: "FRO",
        isoNo: "234",
        internet: "FO"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Fiji",
        capital: "Suva",
        fips: "FJ",
        iso2: "FJ",
        iso3: "FJI",
        isoNo: "242",
        internet: "FJ"
    },
    {
        continent: "Europe",
        region: "Northern Europe",
        country: "Finland",
        capital: "Helsinki",
        fips: "FI",
        iso2: "FI",
        iso3: "FIN",
        isoNo: "246",
        internet: "FI"
    },
    {
        continent: "Europe",
        region: "Western Europe",
        country: "France",
        capital: "Paris",
        fips: "FR",
        iso2: "FR",
        iso3: "FRA",
        isoNo: "250",
        internet: "FR"
    },
    {
        continent: "Americas",
        region: "South America",
        country: "French Guiana",
        capital: "Cayenne",
        fips: "FG",
        iso2: "GF",
        iso3: "GUF",
        isoNo: "254",
        internet: "GF"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "French Polynesia",
        capital: "Papeete",
        fips: "FP",
        iso2: "PF",
        iso3: "PYF",
        isoNo: "258",
        internet: "PF"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "Gabon",
        capital: "Libreville",
        fips: "GB",
        iso2: "GA",
        iso3: "GAB",
        isoNo: "266",
        internet: "GA"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "The Gambia",
        capital: "Banjul",
        fips: "GA",
        iso2: "GM",
        iso3: "GMB",
        isoNo: "270",
        internet: "GM"
    },
    {
        continent: "Asia",
        region: "South West Asia",
        country: "Georgia",
        capital: "T'bilisi",
        fips: "GG",
        iso2: "GE",
        iso3: "GEO",
        isoNo: "268",
        internet: "GE"
    },
    {
        continent: "Europe",
        region: "Western Europe",
        country: "Germany",
        capital: "Berlin",
        fips: "GM",
        iso2: "DE",
        iso3: "DEU",
        isoNo: "276",
        internet: "DE"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "Ghana",
        capital: "Accra",
        fips: "GH",
        iso2: "GH",
        iso3: "GHA",
        isoNo: "288",
        internet: "GH"
    },
    {
        continent: "Europe",
        region: "South West Europe",
        country: "Gibraltar",
        capital: "Gibraltar",
        fips: "GI",
        iso2: "GI",
        iso3: "GIB",
        isoNo: "292",
        internet: "GI"
    },
    {
        continent: "Europe",
        region: "South East Europe",
        country: "Greece",
        capital: "Athens",
        fips: "GR",
        iso2: "GR",
        iso3: "GRC",
        isoNo: "300",
        internet: "GR"
    },
    {
        continent: "Americas",
        region: "North America",
        country: "Greenland",
        capital: "Nuuk (Godthab)",
        fips: "GL",
        iso2: "GL",
        iso3: "GRL",
        isoNo: "304",
        internet: "GL"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Grenada",
        capital: "Saint George's",
        fips: "GJ",
        iso2: "GD",
        iso3: "GRD",
        isoNo: "308",
        internet: "GD"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Guadeloupe",
        capital: "Basse-Terre",
        fips: "GP",
        iso2: "GP",
        iso3: "GLP",
        isoNo: "312",
        internet: "GP"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Guam",
        capital: "Hagatna (Agana)",
        fips: "GQ",
        iso2: "GU",
        iso3: "GUM",
        isoNo: "316",
        internet: "GU"
    },
    {
        continent: "Americas",
        region: "Central America",
        country: "Guatemala",
        capital: "Guatemala",
        fips: "GT",
        iso2: "GT",
        iso3: "GTM",
        isoNo: "320",
        internet: "GT"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "Guinea",
        capital: "Conakry",
        fips: "GV",
        iso2: "GN",
        iso3: "GIN",
        isoNo: "324",
        internet: "GN"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "Guinea-Bissau",
        capital: "Bissau",
        fips: "PU",
        iso2: "GW",
        iso3: "GNB",
        isoNo: "624",
        internet: "GW"
    },
    {
        continent: "Americas",
        region: "South America",
        country: "Guyana",
        capital: "Georgetown",
        fips: "GY",
        iso2: "GY",
        iso3: "GUY",
        isoNo: "328",
        internet: "GY"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Haiti",
        capital: "Port-au-Prince",
        fips: "HA",
        iso2: "HT",
        iso3: "HTI",
        isoNo: "332",
        internet: "HT"
    },
    {
        continent: "Europe",
        region: "Southern Europe",
        country: "Holy See (Vatican City)",
        capital: "Vatican City",
        fips: "VT",
        iso2: "VA",
        iso3: "VAT",
        isoNo: "336",
        internet: "VA"
    },
    {
        continent: "Americas",
        region: "Central America",
        country: "Honduras",
        capital: "Tegucigalpa",
        fips: "HO",
        iso2: "HN",
        iso3: "HND",
        isoNo: "340",
        internet: "HN"
    },
    {
        continent: "Europe",
        region: "Central Europe",
        country: "Hungary",
        capital: "Budapest",
        fips: "HU",
        iso2: "HU",
        iso3: "HUN",
        isoNo: "348",
        internet: "HU"
    },
    {
        continent: "Europe",
        region: "Northern Europe",
        country: "Iceland",
        capital: "Reykjavik",
        fips: "IC",
        iso2: "IS",
        iso3: "ISL",
        isoNo: "352",
        internet: "IS"
    },
    {
        continent: "Asia",
        region: "South Asia",
        country: "India",
        capital: "New Delhi",
        fips: "IN",
        iso2: "IN",
        iso3: "IND",
        isoNo: "356",
        internet: "IN"
    },
    {
        continent: "Asia",
        region: "South East Asia",
        country: "Indonesia",
        capital: "Jakarta",
        fips: "ID",
        iso2: "ID",
        iso3: "IDN",
        isoNo: "360",
        internet: "ID"
    },
    {
        continent: "Asia",
        region: "South West Asia",
        country: "Iran",
        capital: "Tehran",
        fips: "IR",
        iso2: "IR",
        iso3: "IRN",
        isoNo: "364",
        internet: "IR"
    },
    {
        continent: "Asia",
        region: "South West Asia",
        country: "Iraq",
        capital: "Baghdad",
        fips: "IZ",
        iso2: "IQ",
        iso3: "IRQ",
        isoNo: "368",
        internet: "IQ"
    },
    {
        continent: "Europe",
        region: "Western Europe",
        country: "Ireland",
        capital: "Dublin",
        fips: "EI",
        iso2: "IE",
        iso3: "IRL",
        isoNo: "372",
        internet: "IE"
    },
    {
        continent: "Asia",
        region: "South West Asia",
        country: "Israel",
        capital: "Jerusalem",
        fips: "IS",
        iso2: "IL",
        iso3: "ISR",
        isoNo: "376",
        internet: "IL"
    },
    {
        continent: "Europe",
        region: "Southern Europe",
        country: "Italy",
        capital: "Rome",
        fips: "IT",
        iso2: "IT",
        iso3: "ITA",
        isoNo: "380",
        internet: "IT"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Jamaica",
        capital: "Kingston",
        fips: "JM",
        iso2: "JM",
        iso3: "JAM",
        isoNo: "388",
        internet: "JM"
    },
    {
        continent: "Asia",
        region: "East Asia",
        country: "Japan",
        capital: "Tokyo",
        fips: "JA",
        iso2: "JP",
        iso3: "JPN",
        isoNo: "392",
        internet: "JP"
    },
    {
        continent: "Asia",
        region: "South West Asia",
        country: "Jordan",
        capital: "Amman",
        fips: "JO",
        iso2: "JO",
        iso3: "JOR",
        isoNo: "400",
        internet: "JO"
    },
    {
        continent: "Asia",
        region: "Central Asia",
        country: "Kazakhstan",
        capital: "Astana (Akmola)",
        fips: "KZ",
        iso2: "KZ",
        iso3: "KAZ",
        isoNo: "398",
        internet: "KZ"
    },
    {
        continent: "Africa",
        region: "Eastern Africa",
        country: "Kenya",
        capital: "Nairobi",
        fips: "KE",
        iso2: "KE",
        iso3: "KEN",
        isoNo: "404",
        internet: "KE"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Kiribati",
        capital: "Tarawa",
        fips: "KR",
        iso2: "KI",
        iso3: "KIR",
        isoNo: "296",
        internet: "KI"
    },
    {
        continent: "Asia",
        region: "East Asia",
        country: "North Korea",
        capital: "P'yongyang",
        fips: "KN",
        iso2: "KP",
        iso3: "PRK",
        isoNo: "408",
        internet: "KP"
    },
    {
        continent: "Asia",
        region: "East Asia",
        country: "South Korea",
        capital: "Seoul",
        fips: "KS",
        iso2: "KR",
        iso3: "KOR",
        isoNo: "410",
        internet: "KR"
    },
    {
        continent: "Asia",
        region: "South West Asia",
        country: "Kuwait",
        capital: "Kuwait",
        fips: "KU",
        iso2: "KW",
        iso3: "KWT",
        isoNo: "414",
        internet: "KW"
    },
    {
        continent: "Asia",
        region: "Central Asia",
        country: "Kyrgyzstan",
        capital: "Bishkek",
        fips: "KG",
        iso2: "KG",
        iso3: "KGZ",
        isoNo: "417",
        internet: "KG"
    },
    {
        continent: "Asia",
        region: "South East Asia",
        country: "Laos",
        capital: "Vientiane",
        fips: "LA",
        iso2: "LA",
        iso3: "LAO",
        isoNo: "418",
        internet: "LA"
    },
    {
        continent: "Europe",
        region: "Eastern Europe",
        country: "Latvia",
        capital: "Riga",
        fips: "LG",
        iso2: "LV",
        iso3: "LVA",
        isoNo: "428",
        internet: "LV"
    },
    {
        continent: "Asia",
        region: "South West Asia",
        country: "Lebanon",
        capital: "Beirut",
        fips: "LE",
        iso2: "LB",
        iso3: "LBN",
        isoNo: "422",
        internet: "LB"
    },
    {
        continent: "Africa",
        region: "Southern Africa",
        country: "Lesotho",
        capital: "Maseru",
        fips: "LT",
        iso2: "LS",
        iso3: "LSO",
        isoNo: "426",
        internet: "LS"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "Liberia",
        capital: "Monrovia",
        fips: "LI",
        iso2: "LR",
        iso3: "LBR",
        isoNo: "430",
        internet: "LR"
    },
    {
        continent: "Africa",
        region: "Northern Africa",
        country: "Libya",
        capital: "Tripoli",
        fips: "LY",
        iso2: "LY",
        iso3: "LBY",
        isoNo: "434",
        internet: "LY"
    },
    {
        continent: "Europe",
        region: "Central Europe",
        country: "Liechtenstein",
        capital: "Vaduz",
        fips: "LS",
        iso2: "LI",
        iso3: "LIE",
        isoNo: "438",
        internet: "LI"
    },
    {
        continent: "Europe",
        region: "Eastern Europe",
        country: "Lithuania",
        capital: "Vilnius",
        fips: "LH",
        iso2: "LT",
        iso3: "LTU",
        isoNo: "440",
        internet: "LT"
    },
    {
        continent: "Europe",
        region: "Western Europe",
        country: "Luxembourg",
        capital: "Luxembourg",
        fips: "LU",
        iso2: "LU",
        iso3: "LUX",
        isoNo: "442",
        internet: "LU"
    },
    {
        continent: "Europe",
        region: "South East Europe",
        country: "North Macedonia",
        capital: "Skopje",
        fips: "MK",
        iso2: "MK",
        iso3: "MKD",
        isoNo: "807",
        internet: "MK"
    },
    {
        continent: "Africa",
        region: "Indian Ocean",
        country: "Madagascar",
        capital: "Antananarivo",
        fips: "MA",
        iso2: "MG",
        iso3: "MDG",
        isoNo: "450",
        internet: "MG"
    },
    {
        continent: "Africa",
        region: "Southern Africa",
        country: "Malawi",
        capital: "Lilongwe",
        fips: "MI",
        iso2: "MW",
        iso3: "MWI",
        isoNo: "454",
        internet: "MW"
    },
    {
        continent: "Asia",
        region: "South East Asia",
        country: "Malaysia",
        capital: "Kuala Lumpur",
        fips: "MY",
        iso2: "MY",
        iso3: "MYS",
        isoNo: "458",
        internet: "MY"
    },
    {
        continent: "Asia",
        region: "South Asia",
        country: "Maldives",
        capital: "Male (Maale)",
        fips: "MV",
        iso2: "MV",
        iso3: "MDV",
        isoNo: "462",
        internet: "MV"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "Mali",
        capital: "Bamako",
        fips: "ML",
        iso2: "ML",
        iso3: "MLI",
        isoNo: "466",
        internet: "ML"
    },
    {
        continent: "Europe",
        region: "Southern Europe",
        country: "Malta",
        capital: "Valletta",
        fips: "MT",
        iso2: "MT",
        iso3: "MLT",
        isoNo: "470",
        internet: "MT"
    },
    {
        continent: "Europe",
        region: "Western Europe",
        country: "Isle of Man",
        capital: "Douglas",
        fips: "IM",
        iso2: "IM",
        iso3: "IMN",
        isoNo: "833",
        internet: "IM"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Marshall Islands",
        capital: "Majuro",
        fips: "RM",
        iso2: "MH",
        iso3: "MHL",
        isoNo: "584",
        internet: "MH"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Martinique",
        capital: "Fort-de-France",
        fips: "MB",
        iso2: "MQ",
        iso3: "MTQ",
        isoNo: "474",
        internet: "MQ"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "Mauritania",
        capital: "Nouakchott",
        fips: "MR",
        iso2: "MR",
        iso3: "MRT",
        isoNo: "478",
        internet: "MR"
    },
    {
        continent: "Africa",
        region: "Indian Ocean",
        country: "Mauritius",
        capital: "Port Louis",
        fips: "MP",
        iso2: "MU",
        iso3: "MUS",
        isoNo: "480",
        internet: "MU"
    },
    {
        continent: "Africa",
        region: "Indian Ocean",
        country: "Mayotte",
        capital: "Mamoutzou",
        fips: "MF",
        iso2: "YT",
        iso3: "MYT",
        isoNo: "175",
        internet: "YT"
    },
    {
        continent: "Americas",
        region: "Central America",
        country: "Mexico",
        capital: "Mexico",
        fips: "MX",
        iso2: "MX",
        iso3: "MEX",
        isoNo: "484",
        internet: "MX"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Federated States of Micronesia",
        capital: "Palikir",
        fips: "",
        iso2: "FM",
        iso3: "FSM",
        isoNo: "583",
        internet: "FM"
    },
    {
        continent: "Europe",
        region: "Eastern Europe",
        country: "Moldova",
        capital: "Chisinau",
        fips: "MD",
        iso2: "MD",
        iso3: "MDA",
        isoNo: "498",
        internet: "MD"
    },
    {
        continent: "Europe",
        region: "Western Europe",
        country: "Monaco",
        capital: "Monaco",
        fips: "MN",
        iso2: "MC",
        iso3: "MCO",
        isoNo: "492",
        internet: "MC"
    },
    {
        continent: "Asia",
        region: "Northern Asia",
        country: "Mongolia",
        capital: "Ulaanbaatar",
        fips: "MG",
        iso2: "MN",
        iso3: "MNG",
        isoNo: "496",
        internet: "MN"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Montserrat",
        capital: "Plymouth",
        fips: "MH",
        iso2: "MS",
        iso3: "MSR",
        isoNo: "500",
        internet: "MS"
    },
    {
        continent: "Africa",
        region: "Northern Africa",
        country: "Morocco",
        capital: "Rabat",
        fips: "MO",
        iso2: "MA",
        iso3: "MAR",
        isoNo: "504",
        internet: "MA"
    },
    {
        continent: "Africa",
        region: "Southern Africa",
        country: "Mozambique",
        capital: "Maputo",
        fips: "MZ",
        iso2: "MZ",
        iso3: "MOZ",
        isoNo: "508",
        internet: "MZ"
    },
    {
        continent: "Asia",
        region: "South East Asia",
        country: "Myanmar (Burma)",
        capital: "Rangoon (Yangon)",
        fips: "BM",
        iso2: "MM",
        iso3: "MMR",
        isoNo: "104",
        internet: "MM"
    },
    {
        continent: "Africa",
        region: "Southern Africa",
        country: "Namibia",
        capital: "Windhoek",
        fips: "WA",
        iso2: "NA",
        iso3: "NAM",
        isoNo: "516",
        internet: "NA"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Nauru",
        capital: "no official capital",
        fips: "NR",
        iso2: "NR",
        iso3: "NRU",
        isoNo: "520",
        internet: "NR"
    },
    {
        continent: "Asia",
        region: "South Asia",
        country: "Nepal",
        capital: "Kathmandu",
        fips: "NP",
        iso2: "NP",
        iso3: "NPL",
        isoNo: "524",
        internet: "NP"
    },
    {
        continent: "Europe",
        region: "Western Europe",
        country: "Netherlands",
        capital: "Amsterdam",
        fips: "NL",
        iso2: "NL",
        iso3: "NLD",
        isoNo: "528",
        internet: "NL"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Netherlands Antilles",
        capital: "Willemstad",
        fips: "NT",
        iso2: "AN",
        iso3: "ANT",
        isoNo: "530",
        internet: "AN"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "New Caledonia",
        capital: "Noumea",
        fips: "NC",
        iso2: "NC",
        iso3: "NCL",
        isoNo: "540",
        internet: "NC"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "New Zealand",
        capital: "Wellington",
        fips: "NZ",
        iso2: "NZ",
        iso3: "NZL",
        isoNo: "554",
        internet: "NZ"
    },
    {
        continent: "Americas",
        region: "Central America",
        country: "Nicaragua",
        capital: "Managua",
        fips: "NU",
        iso2: "NI",
        iso3: "NIC",
        isoNo: "558",
        internet: "NI"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "Niger",
        capital: "Niamey",
        fips: "NG",
        iso2: "NE",
        iso3: "NER",
        isoNo: "562",
        internet: "NE"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "Nigeria",
        capital: "Abuja",
        fips: "NI",
        iso2: "NG",
        iso3: "NGA",
        isoNo: "566",
        internet: "NG"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Niue",
        capital: "Alofi",
        fips: "NE",
        iso2: "NU",
        iso3: "NIU",
        isoNo: "570",
        internet: "NU"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Norfolk Island",
        capital: "Kingston",
        fips: "NF",
        iso2: "NF",
        iso3: "NFK",
        isoNo: "574",
        internet: "NF"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Northern Mariana Islands",
        capital: "Saipan",
        fips: "CQ",
        iso2: "MP",
        iso3: "MNP",
        isoNo: "580",
        internet: "MP"
    },
    {
        continent: "Europe",
        region: "Northern Europe",
        country: "Norway",
        capital: "Oslo",
        fips: "NO",
        iso2: "NO",
        iso3: "NOR",
        isoNo: "578",
        internet: "NO"
    },
    {
        continent: "Asia",
        region: "South West Asia",
        country: "Oman",
        capital: "Muscat",
        fips: "MU",
        iso2: "OM",
        iso3: "OMN",
        isoNo: "512",
        internet: "OM"
    },
    {
        continent: "Asia",
        region: "South Asia",
        country: "Pakistan",
        capital: "Islamabad",
        fips: "PK",
        iso2: "PK",
        iso3: "PAK",
        isoNo: "586",
        internet: "PK"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Palau",
        capital: "Koror",
        fips: "PS",
        iso2: "PW",
        iso3: "PLW",
        isoNo: "585",
        internet: "PW"
    },
    {
        continent: "Asia",
        region: "South West Asia",
        country: "Palestinian Territory",
        capital: "East Jerusalem",
        fips: "WE",
        iso2: "PS",
        iso3: "PSE",
        isoNo: "275",
        internet: "PS"
    },
    {
        continent: "Americas",
        region: "Central America",
        country: "Panama",
        capital: "Panama",
        fips: "PM",
        iso2: "PA",
        iso3: "PAN",
        isoNo: "591",
        internet: "PA"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Papua New Guinea",
        capital: "Port Moresby",
        fips: "PP",
        iso2: "PG",
        iso3: "PNG",
        isoNo: "598",
        internet: "PG"
    },
    {
        continent: "Americas",
        region: "South America",
        country: "Paraguay",
        capital: "Asuncion",
        fips: "PA",
        iso2: "PY",
        iso3: "PRY",
        isoNo: "600",
        internet: "PY"
    },
    {
        continent: "Americas",
        region: "South America",
        country: "Peru",
        capital: "Lima",
        fips: "PE",
        iso2: "PE",
        iso3: "PER",
        isoNo: "604",
        internet: "PE"
    },
    {
        continent: "Asia",
        region: "South East Asia",
        country: "Philippines",
        capital: "Manila",
        fips: "RP",
        iso2: "PH",
        iso3: "PHL",
        isoNo: "608",
        internet: "PH"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Pitcairn Islands",
        capital: "Adamstown",
        fips: "PC",
        iso2: "PN",
        iso3: "PCN",
        isoNo: "612",
        internet: "PN"
    },
    {
        continent: "Europe",
        region: "Eastern Europe",
        country: "Poland",
        capital: "Warsaw",
        fips: "PL",
        iso2: "PL",
        iso3: "POL",
        isoNo: "616",
        internet: "PL"
    },
    {
        continent: "Europe",
        region: "South West Europe",
        country: "Portugal",
        capital: "Lisbon",
        fips: "PO",
        iso2: "PT",
        iso3: "PRT",
        isoNo: "620",
        internet: "PT"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Puerto Rico",
        capital: "San Juan",
        fips: "RQ",
        iso2: "PR",
        iso3: "PRI",
        isoNo: "630",
        internet: "PR"
    },
    {
        continent: "Asia",
        region: "South West Asia",
        country: "Qatar",
        capital: "Doha",
        fips: "QA",
        iso2: "QA",
        iso3: "QAT",
        isoNo: "634",
        internet: "QA"
    },
    {
        continent: "Africa",
        region: "Indian Ocean",
        country: "Reunion",
        capital: "Saint-Denis",
        fips: "RE",
        iso2: "RE",
        iso3: "REU",
        isoNo: "638",
        internet: "RE"
    },
    {
        continent: "Europe",
        region: "South East Europe",
        country: "Romania",
        capital: "Bucharest",
        fips: "RO",
        iso2: "RO",
        iso3: "ROU",
        isoNo: "642",
        internet: "RO"
    },
    {
        continent: "Asia",
        region: "Northern Asia",
        country: "Russia",
        capital: "Moscow",
        fips: "RS",
        iso2: "RU",
        iso3: "RUS",
        isoNo: "643",
        internet: "RU"
    },
    {
        continent: "Africa",
        region: "Central Africa",
        country: "Rwanda",
        capital: "Kigali",
        fips: "RW",
        iso2: "RW",
        iso3: "RWA",
        isoNo: "646",
        internet: "RW"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Saint Kitts and Nevis",
        capital: "Basseterre",
        fips: "SC",
        iso2: "KN",
        iso3: "KNA",
        isoNo: "659",
        internet: "KN"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Saint Lucia",
        capital: "Castries",
        fips: "ST",
        iso2: "LC",
        iso3: "LCA",
        isoNo: "662",
        internet: "LC"
    },
    {
        continent: "Americas",
        region: "North America",
        country: "Saint Pierre and Miquelon",
        capital: "Saint-Pierre",
        fips: "SB",
        iso2: "PM",
        iso3: "SPM",
        isoNo: "666",
        internet: "PM"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Saint Vincent and the Grenadines",
        capital: "Kingstown",
        fips: "VC",
        iso2: "VC",
        iso3: "VCT",
        isoNo: "670",
        internet: "VC"
    },
    {
        continent: "Europe",
        region: "Southern Europe",
        country: "San Marino",
        capital: "San Marino",
        fips: "SM",
        iso2: "SM",
        iso3: "SMR",
        isoNo: "674",
        internet: "SM"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "Sao Tome and Principe",
        capital: "Sao Tome",
        fips: "TP",
        iso2: "ST",
        iso3: "STP",
        isoNo: "678",
        internet: "ST"
    },
    {
        continent: "Asia",
        region: "South West Asia",
        country: "Saudi Arabia",
        capital: "Riyadh",
        fips: "SA",
        iso2: "SA",
        iso3: "SAU",
        isoNo: "682",
        internet: "SA"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "Senegal",
        capital: "Dakar",
        fips: "SG",
        iso2: "SN",
        iso3: "SEN",
        isoNo: "686",
        internet: "SN"
    },
    {
        continent: "Africa",
        region: "Indian Ocean",
        country: "Seychelles",
        capital: "Victoria",
        fips: "SE",
        iso2: "SC",
        iso3: "SYC",
        isoNo: "690",
        internet: "SC"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "Sierra Leone",
        capital: "Freetown",
        fips: "SL",
        iso2: "SL",
        iso3: "SLE",
        isoNo: "694",
        internet: "SL"
    },
    {
        continent: "Asia",
        region: "South East Asia",
        country: "Singapore",
        capital: "Singapore",
        fips: "SN",
        iso2: "SG",
        iso3: "SGP",
        isoNo: "702",
        internet: "SG"
    },
    {
        continent: "Europe",
        region: "Central Europe",
        country: "Slovakia",
        capital: "Bratislava",
        fips: "LO",
        iso2: "SK",
        iso3: "SVK",
        isoNo: "703",
        internet: "SK"
    },
    {
        continent: "Europe",
        region: "South East Europe",
        country: "Slovenia",
        capital: "Ljubljana",
        fips: "SI",
        iso2: "SI",
        iso3: "SVN",
        isoNo: "705",
        internet: "SI"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Solomon Islands",
        capital: "Honiara",
        fips: "BP",
        iso2: "SB",
        iso3: "SLB",
        isoNo: "90",
        internet: "SB"
    },
    {
        continent: "Africa",
        region: "Eastern Africa",
        country: "Somalia",
        capital: "Mogadishu",
        fips: "SO",
        iso2: "SO",
        iso3: "SOM",
        isoNo: "706",
        internet: "SO"
    },
    {
        continent: "Africa",
        region: "Southern Africa",
        country: "South Africa",
        capital: "Pretoria��",
        fips: "SF",
        iso2: "ZA",
        iso3: "ZAF",
        isoNo: "710",
        internet: "ZA"
    },
    {
        continent: "Europe",
        region: "South West Europe",
        country: "Spain",
        capital: "Madrid",
        fips: "SP",
        iso2: "ES",
        iso3: "ESP",
        isoNo: "724",
        internet: "ES"
    },
    {
        continent: "Asia",
        region: "South Asia",
        country: "Sri Lanka",
        capital: "Colombo",
        fips: "CE",
        iso2: "LK",
        iso3: "LKA",
        isoNo: "144",
        internet: "LK"
    },
    {
        continent: "Africa",
        region: "Northern Africa",
        country: "Sudan",
        capital: "Khartoum",
        fips: "SU",
        iso2: "SD",
        iso3: "SDN",
        isoNo: "736",
        internet: "SD"
    },
    {
        continent: "Americas",
        region: "South America",
        country: "Suriname",
        capital: "Paramaribo",
        fips: "NS",
        iso2: "SR",
        iso3: "SUR",
        isoNo: "740",
        internet: "SR"
    },
    {
        continent: "Europe",
        region: "Northern Europe",
        country: "Svalbard",
        capital: "Longyearbyen",
        fips: "SV",
        iso2: "SJ",
        iso3: "SJM",
        isoNo: "744",
        internet: "SJ"
    },
    {
        continent: "Africa",
        region: "Southern Africa",
        country: "Eswatini",
        capital: "Mbabane",
        fips: "WZ",
        iso2: "SZ",
        iso3: "SWZ",
        isoNo: "748",
        internet: "SZ"
    },
    {
        continent: "Europe",
        region: "Northern Europe",
        country: "Sweden",
        capital: "Stockholm",
        fips: "SW",
        iso2: "SE",
        iso3: "SWE",
        isoNo: "752",
        internet: "SE"
    },
    {
        continent: "Europe",
        region: "Central Europe",
        country: "Switzerland",
        capital: "Bern",
        fips: "SZ",
        iso2: "CH",
        iso3: "CHE",
        isoNo: "756",
        internet: "CH"
    },
    {
        continent: "Asia",
        region: "South West Asia",
        country: "Syria",
        capital: "Damascus",
        fips: "SY",
        iso2: "SY",
        iso3: "SYR",
        isoNo: "760",
        internet: "SY"
    },
    {
        continent: "Asia",
        region: "East Asia",
        country: "Taiwan",
        capital: "Taipei",
        fips: "TW",
        iso2: "TW",
        iso3: "TWN",
        isoNo: "158",
        internet: "TW"
    },
    {
        continent: "Asia",
        region: "Central Asia",
        country: "Tajikistan",
        capital: "Dushanbe",
        fips: "TI",
        iso2: "TJ",
        iso3: "TJK",
        isoNo: "762",
        internet: "TJ"
    },
    {
        continent: "Africa",
        region: "Eastern Africa",
        country: "Tanzania",
        capital: "Dar es Salaam",
        fips: "TZ",
        iso2: "TZ",
        iso3: "TZA",
        isoNo: "834",
        internet: "TZ"
    },
    {
        continent: "Asia",
        region: "South East Asia",
        country: "Thailand",
        capital: "Bangkok",
        fips: "TH",
        iso2: "TH",
        iso3: "THA",
        isoNo: "764",
        internet: "TH"
    },
    {
        continent: "Africa",
        region: "Western Africa",
        country: "Togo",
        capital: "Lome",
        fips: "TO",
        iso2: "TG",
        iso3: "TGO",
        isoNo: "768",
        internet: "TG"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Tokelau",
        capital: "none",
        fips: "TL",
        iso2: "TK",
        iso3: "TKL",
        isoNo: "772",
        internet: "TK"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Tonga",
        capital: "Nuku'alofa",
        fips: "TN",
        iso2: "TO",
        iso3: "TON",
        isoNo: "776",
        internet: "TO"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Trinidad and Tobago",
        capital: "Port-of-Spain",
        fips: "TD",
        iso2: "TT",
        iso3: "TTO",
        isoNo: "780",
        internet: "TT"
    },
    {
        continent: "Africa",
        region: "Northern Africa",
        country: "Tunisia",
        capital: "Tunis",
        fips: "TS",
        iso2: "TN",
        iso3: "TUN",
        isoNo: "788",
        internet: "TN"
    },
    {
        continent: "Asia",
        region: "South West Asia",
        country: "Turkey",
        capital: "Ankara",
        fips: "TU",
        iso2: "TR",
        iso3: "TUR",
        isoNo: "792",
        internet: "TR"
    },
    {
        continent: "Asia",
        region: "Central Asia",
        country: "Turkmenistan",
        capital: "Ashgabat",
        fips: "TX",
        iso2: "TM",
        iso3: "TKM",
        isoNo: "795",
        internet: "TM"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Turks and Caicos Islands",
        capital: "Grand Turk",
        fips: "TK",
        iso2: "TC",
        iso3: "TCA",
        isoNo: "796",
        internet: "TC"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Tuvalu",
        capital: "Funafuti",
        fips: "TV",
        iso2: "TV",
        iso3: "TUV",
        isoNo: "798",
        internet: "TV"
    },
    {
        continent: "Africa",
        region: "Eastern Africa",
        country: "Uganda",
        capital: "Kampala",
        fips: "UG",
        iso2: "UG",
        iso3: "UGA",
        isoNo: "800",
        internet: "UG"
    },
    {
        continent: "Europe",
        region: "Eastern Europe",
        country: "Ukraine",
        capital: "Kiev",
        fips: "UP",
        iso2: "UA",
        iso3: "UKR",
        isoNo: "804",
        internet: "UA"
    },
    {
        continent: "Asia",
        region: "South West Asia",
        country: "United Arab Emirates",
        capital: "Abu Dhabi",
        fips: "TC",
        iso2: "AE",
        iso3: "ARE",
        isoNo: "784",
        internet: "AE"
    },
    {
        continent: "Europe",
        region: "Western Europe",
        country: "United Kingdom",
        capital: "London",
        fips: "UK",
        iso2: "GB",
        iso3: "GBR",
        isoNo: "826",
        internet: "UK"
    },
    {
        continent: "Americas",
        region: "North America",
        country: "United States",
        capital: "Washington DC",
        fips: "US",
        iso2: "US",
        iso3: "USA",
        isoNo: "840",
        internet: "US"
    },
    {
        continent: "Americas",
        region: "North America",
        country: "United States Minor Outlying Islands",
        capital: "Washington DC",
        fips: "",
        iso2: "UM",
        iso3: "UMI",
        isoNo: "581",
        internet: "US"
    },
    {
        continent: "Americas",
        region: "South America",
        country: "Uruguay",
        capital: "Montevideo",
        fips: "UY",
        iso2: "UY",
        iso3: "URY",
        isoNo: "858",
        internet: "UY"
    },
    {
        continent: "Asia",
        region: "Central Asia",
        country: "Uzbekistan",
        capital: "Tashkent (Toshkent)",
        fips: "UZ",
        iso2: "UZ",
        iso3: "UZB",
        isoNo: "860",
        internet: "UZ"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Vanuatu",
        capital: "Port-Vila",
        fips: "NH",
        iso2: "VU",
        iso3: "VUT",
        isoNo: "548",
        internet: "VU"
    },
    {
        continent: "Americas",
        region: "South America",
        country: "Venezuela",
        capital: "Caracas",
        fips: "VE",
        iso2: "VE",
        iso3: "VEN",
        isoNo: "862",
        internet: "UE"
    },
    {
        continent: "Asia",
        region: "South East Asia",
        country: "Vietnam",
        capital: "Hanoi",
        fips: "VN",
        iso2: "VN",
        iso3: "VNM",
        isoNo: "704",
        internet: "VN"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Virgin Islands",
        capital: "Charlotte Amalie",
        fips: "VQ",
        iso2: "VI",
        iso3: "VIR",
        isoNo: "850",
        internet: "VI"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Wallis and Futuna",
        capital: "Mata-Utu (on Ile Uvea)",
        fips: "WF",
        iso2: "WF",
        iso3: "WLF",
        isoNo: "876",
        internet: "WF"
    },
    {
        continent: "Africa",
        region: "Northern Africa",
        country: "Western Sahara",
        capital: "none",
        fips: "WI",
        iso2: "EH",
        iso3: "ESH",
        isoNo: "732",
        internet: "EH"
    },
    {
        continent: "Oceania",
        region: "Pacific",
        country: "Western Samoa",
        capital: "Apia",
        fips: "WS",
        iso2: "WS",
        iso3: "WSM",
        isoNo: "882",
        internet: "WS"
    },
    {
        continent: "Asia",
        region: "South West Asia",
        country: "Yemen",
        capital: "Sanaa",
        fips: "YM",
        iso2: "YE",
        iso3: "YEM",
        isoNo: "887",
        internet: "YE"
    },
    {
        continent: "Africa",
        region: "Central Africa",
        country: "Democratic Republic of the Congo",
        capital: "Kinshasa",
        fips: "CG",
        iso2: "CD",
        iso3: "COD",
        isoNo: "180",
        internet: "ZR"
    },
    {
        continent: "Africa",
        region: "Southern Africa",
        country: "Zambia",
        capital: "Lusaka",
        fips: "ZA",
        iso2: "ZM",
        iso3: "ZMB",
        isoNo: "894",
        internet: "ZM"
    },
    {
        continent: "Africa",
        region: "Southern Africa",
        country: "Zimbabwe",
        capital: "Harare",
        fips: "ZI",
        iso2: "ZW",
        iso3: "ZWE",
        isoNo: "716",
        internet: "ZW"
    },
    {
        continent: "Asia",
        region: "East Asia",
        country: "Hong Kong",
        capital: "Victoria",
        fips: "HK",
        iso2: "HK",
        iso3: "HKG",
        isoNo: "344",
        internet: "HK"
    },
    {
        continent: "Asia",
        region: "East Asia",
        country: "Macau",
        capital: "Macau",
        fips: "MC",
        iso2: "MO",
        iso3: "MAC",
        isoNo: "446",
        internet: "MO"
    },
    {
        continent: "Antarctica",
        region: "Antarctica",
        country: "Antarctica",
        capital: "",
        fips: "AY",
        iso2: "AQ",
        iso3: "ATA",
        isoNo: "10",
        internet: "AQ"
    },
    {
        continent: "Atlantic Ocean",
        region: "South Atlantic Ocean",
        country: "Bouvet Island",
        capital: "",
        fips: "BV",
        iso2: "BV",
        iso3: "BVT",
        isoNo: "74",
        internet: "BV"
    },
    {
        continent: "Asia",
        region: "South Asia",
        country: "British Indian Ocean Territory",
        capital: "",
        fips: "IO",
        iso2: "IO",
        iso3: "IOT",
        isoNo: "86",
        internet: "IO"
    },
    {
        continent: "Indian Ocean",
        region: "Southern Indian Ocean",
        country: "French Southern and Antarctic Lands",
        capital: "",
        fips: "FS",
        iso2: "TF",
        iso3: "ATF",
        isoNo: "260",
        internet: "--"
    },
    {
        continent: "Indian Ocean",
        region: "Southern Indian Ocean",
        country: "Heard Island and McDonald Islands",
        capital: "",
        fips: "HM",
        iso2: "HM",
        iso3: "HMD",
        isoNo: "334",
        internet: "HM"
    },
    {
        continent: "Atlantic Ocean",
        region: "South Atlantic Ocean",
        country: "Saint Helena",
        capital: "",
        fips: "SH",
        iso2: "SH",
        iso3: "SHN",
        isoNo: "654",
        internet: "SH"
    },
    {
        continent: "Atlantic Ocean",
        region: "South Atlantic Ocean",
        country: "South Georgia and the South Sandwich Islands",
        capital: "",
        fips: "SX",
        iso2: "GS",
        iso3: "SGS",
        isoNo: "239",
        internet: "GS"
    },
    {
        continent: "Europe",
        region: "Western Europe",
        country: "Guernsey",
        capital: "Saint Peter Port",
        fips: "GK",
        iso2: "GG",
        iso3: "GGY",
        isoNo: "831",
        internet: "GG"
    },
    {
        continent: "Europe",
        region: "South East Europe",
        country: "Serbia",
        capital: "Belgrade",
        fips: "RI",
        iso2: "RS",
        iso3: "SRB",
        isoNo: "688",
        internet: "RS"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Saint Barth\xe9lemy",
        capital: "Gustavia",
        fips: "TB",
        iso2: "BL",
        iso3: "BLM",
        isoNo: "652",
        internet: "BL"
    },
    {
        continent: "Europe",
        region: "South East Europe",
        country: "Montenegro",
        capital: "Podgorica",
        fips: "MJ",
        iso2: "ME",
        iso3: "MNE",
        isoNo: "499",
        internet: "ME"
    },
    {
        continent: "Europe",
        region: "Western Europe",
        country: "Jersey",
        capital: "Saint Helier",
        fips: "JE",
        iso2: "JE",
        iso3: "JEY",
        isoNo: "832",
        internet: "JE"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Cura\xe7ao",
        capital: "Willemstad",
        fips: "UC",
        iso2: "CW",
        iso3: "CUW",
        isoNo: "531",
        internet: "CW"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Saint Martin",
        capital: "Marigot",
        fips: "RN",
        iso2: "MF",
        iso3: "MAF",
        isoNo: "663",
        internet: "MF"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Sint Maarten",
        capital: "Philipsburg",
        fips: "NN",
        iso2: "SX",
        iso3: "SXM",
        isoNo: "534",
        internet: "SX"
    },
    {
        continent: "Asia",
        region: "South East Asia",
        country: "Timor-Leste",
        capital: "Dili",
        fips: "TT",
        iso2: "TL",
        iso3: "TLS",
        isoNo: "626",
        internet: "TL"
    },
    {
        continent: "Africa",
        region: "Northern Africa",
        country: "South Sudan",
        capital: "Juba",
        fips: "OD",
        iso2: "SS",
        iso3: "SSD",
        isoNo: "728",
        internet: "SS"
    },
    {
        continent: "Europe",
        region: "Northern Europe",
        country: "\xc5land Islands",
        capital: "Mariehamn",
        fips: "AX",
        iso2: "AX",
        iso3: "ALA",
        isoNo: "248",
        internet: "AX"
    },
    {
        continent: "Americas",
        region: "West Indies",
        country: "Bonaire",
        capital: "Kralendijk",
        fips: "BQ",
        iso2: "BQ",
        iso3: "BES",
        isoNo: "535",
        internet: "BQ"
    },
    {
        continent: "Europe",
        region: "South East Europe",
        country: "Republic of Kosovo",
        capital: "Pristina",
        fips: "KV",
        iso2: "XK",
        iso3: "UNK",
        isoNo: null,
        internet: "XK"
    }
];
module.exports.countries = countries;

},{}],"6VH5x":[function(require,module,exports) {
/**
 * Handles the logic for option swatches
 *
 * document.addEventListener("swatchesReady", function() {
 *   new SwatchGroup({
 *     wrapper: ".some-swatch-wrapper",
 *     productData: {{ product | json }},
 *     swatchData: {{ product.metafields.swatches | json }},
 *     [OPTIONAL] allowUnavailableSelections: true
 *   });
 * });
 *
 * If you assign the swatch group to a variable, you can access the
 * selectSwatchesFromUrl function.
 * e.g. let swatchGroup = new SwatchGroup({...});
 *      swatchGroup.selectSwatchesFromUrl();
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _classCallCheckMjs = require("@swc/helpers/src/_class_call_check.mjs");
var _classCallCheckMjsDefault = parcelHelpers.interopDefault(_classCallCheckMjs);
var _createClassMjs = require("@swc/helpers/src/_create_class.mjs");
var _createClassMjsDefault = parcelHelpers.interopDefault(_createClassMjs);
var _definePropertyMjs = require("@swc/helpers/src/_define_property.mjs");
var _definePropertyMjsDefault = parcelHelpers.interopDefault(_definePropertyMjs);
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _utilsJs = require("./utils.js");
var ThemeVars = window.ThemeVars;
var SwatchGroup = /*#__PURE__*/ function() {
    "use strict";
    function SwatchGroup(args) {
        (0, _classCallCheckMjsDefault.default)(this, SwatchGroup);
        (0, _definePropertyMjsDefault.default)(this, "selectedOptions", {});
        (0, _definePropertyMjsDefault.default)(this, "variantSelector", null);
        (0, _definePropertyMjsDefault.default)(this, "allowUnavailableSelections", true);
        var wrapper = args.wrapper, productData = args.productData, swatchData = args.swatchData, allowUnavailableSelections = args.allowUnavailableSelections;
        // Handle basic errors
        if (!wrapper) return console.error("SwatchGroup: Could not create swatch group, requires a wrapper.");
        if (!productData) return console.error("SwatchGroup: Could not create swatch group, requires a productData object.");
        if (!swatchData) return console.error("SwatchGroup: Could not create swatch group, requires a swatchData object.");
        if (!document.querySelector(wrapper)) return console.error("SwatchGroup: Could not create swatch group, wrapper does not exist.");
        if (!ThemeVars) return console.error("SwatchGroup: Could not create swatch group, theme variables do not exist.");
        if (!ThemeVars.hasOwnProperty("swatches")) return console.error("SwatchGroup: Swatches are not enabled in the current theme's settings.");
        // Add product and swatch data
        this.wrapper = document.querySelector(wrapper);
        this.productData = productData;
        this.swatchData = swatchData;
        if (allowUnavailableSelections) this.allowUnavailableSelections = allowUnavailableSelections;
        // Generate random key for variant selector
        var variantSelectorKey = Math.random().toString(36).substring(2, 10);
        // Add swatches markup to DOM and set up event listeners
        var variantSelectorMarkup = '\n      <select style="display: none;" name="id" id="variant-selector-'.concat(this.productData.id, '" data-key="').concat(variantSelectorKey, '">\n        <option value="" selected disabled></option>\n        ').concat(this.productData.variants.map(function(variant) {
            return '<option\n          data-option-1="'.concat(variant.option1, '"\n          data-option-2="').concat(variant.option2, '"\n          data-option-3="').concat(variant.option3, '"\n          data-available="').concat(variant.available, '"\n          data-sku="').concat(variant.sku, '"\n          value="').concat(variant.id, '">').concat(variant.title, "</option>");
        }).join(""), "\n      </select>");
        this.wrapper.insertAdjacentHTML("beforeend", variantSelectorMarkup);
        this.variantSelector = document.querySelector('[data-key="'.concat(variantSelectorKey, '"]'));
        this.addSwatchesToDOM();
    }
    (0, _createClassMjsDefault.default)(SwatchGroup, [
        {
            /**
   * Adds the swatch markup to the DOM and sets up event listeners
   */ key: "addSwatchesToDOM",
            value: function addSwatchesToDOM() {
                var _this = this;
                var _this1 = this, wrapper = _this1.wrapper, productData = _this1.productData;
                var productOptions = {
                    option1: (0, _utilsJs.makeArrayUnique)(productData.variants.map(function(variant) {
                        return variant.option1;
                    })),
                    option2: (0, _utilsJs.makeArrayUnique)(productData.variants.map(function(variant) {
                        return variant.option2;
                    })),
                    option3: (0, _utilsJs.makeArrayUnique)(productData.variants.map(function(variant) {
                        return variant.option3;
                    }))
                };
                Object.keys(productOptions).forEach(function(optionPosition) {
                    var optionName = productData.options[parseInt(optionPosition.replace("option", "")) - 1]; // e.g. Colour
                    var optionValues = productOptions[optionPosition]; // e.g. ['Red', 'Blue', 'Green']
                    if (optionName && optionValues.length) {
                        var _this_generateSwatches = _this.generateSwatches(optionName, optionPosition, optionValues), swatches = _this_generateSwatches.swatches, selector = _this_generateSwatches.selector;
                        wrapper.insertAdjacentHTML("beforeend", swatches);
                        wrapper.querySelectorAll(selector).forEach(function(swatch) {
                            swatch.addEventListener("click", _this.handleSwatchClick.bind(_this));
                        });
                    }
                    if (document.querySelector(".product__tab") !== null) document.querySelector(".product__tab").addEventListener("click", _this.handleSwatchClick.bind(_this));
                });
            }
        },
        {
            /**
   * Generates the markup for the swatches for a given option
   * @param {string} optionName - The name of the option e.g. Colour
   * @param {string} optionPosition - The position of the option e.g. option1
   * @param {array} optionValues - The values of the option e.g. ['Red', 'Blue', 'Green']
   * @returns {object} - An object containing the markup and a selector for this set of swatches
   */ key: "generateSwatches",
            value: function generateSwatches(optionName, optionPosition, optionValues) {
                var _this = this;
                var selector = "swatch-".concat(optionPosition);
                var swatchItemsMarkup = optionValues.map(function(optionValue) {
                    var swatchBackground = _this.getSwatchBackground(optionValue);
                    var swatchType;
                    if (swatchBackground) swatchType = swatchBackground.includes("http") ? "image" : "colour";
                    else swatchType = "text";
                    var swatchBackgroundCss = swatchType == "image" ? "background-image: url(".concat(swatchBackground, ");") : "background-color: ".concat(swatchBackground, ";");
                    var optionValueText = optionValue;
                    /*
       * switch (optionValue) {
       * case 'XS':
       *   optionValueText = 'Extra Small';
       *   break;
       * case 'S':
       *   optionValueText = 'Small';
       *   break;
       * case 'M':
       *   optionValueText = 'Medium';
       *   break;
       * case 'L':
       *   optionValueText = 'Large';
       *   break;
       * case 'XL':
       *   optionValueText = 'Extra Large';
       *   break;
       * case 'XXL':
       *   optionValueText = 'Extra Extra Large';
       *   break;
       * default:
       *   optionValueText = optionValue;
       *   break;
       * }
       */ return '\n        <div\n          data-selector="'.concat(selector, '"\n          style="').concat(swatchBackgroundCss, '"\n          data-option-index="').concat(optionPosition, '"\n          data-option-value="').concat(optionValue, '"\n          class="swatch-group__swatch swatch-group__swatch--').concat(swatchType, '">\n          ').concat(swatchType == "text" ? "<span>".concat(optionValueText, "</span>") : "", "\n        </div>\n      ");
                }).join("\n");
                /*
     * const swatches = `
     *   <div class="swatch-group">
     *     <div class="swatch-group__label">${optionName}:<span> <span></div>
     *     <div class="swatch-group__swatches">${swatchItemsMarkup}</div>
     *   </div>
     * `;
     */ // Create dropdown selector for swatches
                var swatches = optionValues.length > 5 ? '\n    <div class="swatch-group swatch-group__selector">\n            <div class="swatch-group__label">'.concat(optionName, ':<span> <span></div>\n    <div class="product__tab">\n        <div class="product__tab__title">\n            <p class="product__tab__text">').concat(optionValues[0], '</p>\n            <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path d="M1 1L6 6L11 1" stroke="black" stroke-linecap="round"></path>\n            </svg>\n        </div>\n        <div class="product__tab__content" style="display: none;">\n          \n            <div class="swatch-group__swatches">').concat(swatchItemsMarkup, "</div>\n          \n        </div>\n    </div>\n    </div>\n    \n    ") : '\n      <div class="swatch-group" style="'.concat(optionName === "Title" ? "display:none;" : "display:block;", '">\n        <div class="swatch-group__label">').concat(optionName, ':<span> <span></div>\n        <div class="swatch-group__swatches">').concat(swatchItemsMarkup, "</div>\n      </div>\n    ");
                return {
                    swatches: swatches,
                    selector: '[data-selector="'.concat(selector, '"]')
                };
            }
        },
        {
            /**
   * Handles the click event on a swatch item
   *  - Sets the selected option for this swatch group
   *  - Visibly selects the swatch item
   *  - Marks swatches that would be unavailable with this selection
   *  - Updates the variant selector if a variant is selected and emits an event
   * @param {object} event - The click event
   */ key: "handleSwatchClick",
            value: function handleSwatchClick(event) {
                event.stopPropagation();
                var swatchItem = event.currentTarget;
                var _swatchItem_dataset = swatchItem.dataset, optionIndex = _swatchItem_dataset.optionIndex, optionValue = _swatchItem_dataset.optionValue;
                this.selectedOptions[optionIndex] = optionValue;
                this.visiblySelectSwatch(swatchItem);
                this.markUnavailableSwatches(swatchItem);
                this.setSelectedVariant(this.getSelectedVariant());
                this.changeLabelValue(optionIndex, optionValue, swatchItem);
            }
        },
        {
            // Changes the value displayed next to the swatch group label
            key: "changeLabelValue",
            value: function changeLabelValue(optionIndex, optionValue, swatchItem) {
                var label = "";
                if (swatchItem.classList.contains("product__tab") && swatchItem.classList.contains("selected")) return;
                if (swatchItem.parentNode.parentNode.className == "product__tab__content") label = swatchItem.parentNode.parentNode.parentNode.previousElementSibling;
                else label = swatchItem.parentNode.previousElementSibling;
                var labelValue = label ? label.querySelector("span") : null;
                if (labelValue) labelValue.innerHTML = " ".concat(optionValue);
                if (swatchItem.parentNode.parentNode.className == "product__tab__content") {
                    var selectorLabel = swatchItem.parentNode.parentNode.parentNode.querySelector(".product__tab__text");
                    if (selectorLabel) selectorLabel.innerHTML = optionValue;
                    document.querySelector(".product__tab__content").style.display = "none";
                }
            }
        },
        {
            /**
   * Visibly selects a swatch item with a class and deselects all other sibling swatch items
   * @param {object} swatch - The swatch item to visibly select
   * @returns {function | void} - Either a console error or nothing
   */ key: "visiblySelectSwatch",
            value: function visiblySelectSwatch(swatch) {
                var _swatch_parentNode;
                if (!swatch) return console.error("SwatchGroup: Could not visibly select swatch, swatch does not exist.");
                /* Check if this swatch is inside a fake dropdown - see generateSwatches() */ var dropdownCheck = (_swatch_parentNode = swatch.parentNode) === null || _swatch_parentNode === void 0 ? void 0 : _swatch_parentNode.parentNode;
                if (dropdownCheck && dropdownCheck.classList.contains("product__tab__content")) {
                    var dropdownContainer = dropdownCheck.parentNode;
                    var optionText = dropdownContainer.querySelector(".product__tab__text");
                    optionText.textContent = swatch.dataset.optionValue;
                }
                var swatchClass = swatch.classList[0];
                var swatchSiblings = swatch.parentNode.querySelectorAll(".".concat(swatchClass));
                swatchSiblings.forEach(function(swatchSibling) {
                    swatchSibling.classList.remove("selected");
                });
                swatch.classList.add("selected");
            }
        },
        {
            /**
   * Combines a recently selected swatch with all other relevant swatches
   * If this combination would be an unavailable variant, marks the swatch as unavailable
   * Otherwise marks the swatch as available
   * @param {object} selectedSwatch - The swatch that was just selected
   */ key: "markUnavailableSwatches",
            value: function markUnavailableSwatches(selectedSwatch) {
                var _this = this;
                var swatchClass = selectedSwatch.classList[0];
                var allSwatches = this.wrapper.querySelectorAll(".".concat(swatchClass));
                allSwatches.forEach(function(swatch) {
                    if (selectedSwatch.dataset.optionIndex != swatch.dataset.optionIndex) {
                        var temporarySelections = (0, _objectSpreadMjsDefault.default)({}, _this.selectedOptions);
                        temporarySelections[swatch.dataset.optionIndex] = swatch.dataset.optionValue;
                        var variant = _this.getSelectedVariant(temporarySelections);
                        if (variant && variant.dataset.available != "true") {
                            swatch.classList.add("unavailable");
                            /* If swatch only has 1 option, visually mark as available while keeping it unavailable */ var siblingsCheck = swatch.parentNode.children.length;
                            if (siblingsCheck <= 1) swatch.classList.add("swatch__only-option");
                            if (siblingsCheck <= 5) swatch.classList.add("swatch__style-notify-me");
                            if (!_this.allowUnavailableSelections) swatch.classList.add("disabled");
                        } else swatch.classList.remove("unavailable", "disabled");
                    }
                });
            }
        },
        {
            /**
   * Gets the variant that matches some specific option selections
   * @param {object} selections - An object containing the selected options, defaults to the user's selections
   * @returns {HTMLElement} - The variant <option> that matches the selected options
   */ key: "getSelectedVariant",
            value: function getSelectedVariant() {
                var selections = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.selectedOptions;
                var variants = Array.from(this.variantSelector.querySelectorAll("option"));
                var selectedVariant = variants.find(function(variant) {
                    return (variant.dataset["option-1"] === selections.option1 || variant.dataset["option-1"] == "null") && (variant.dataset["option-2"] === selections.option2 || variant.dataset["option-2"] == "null") && (variant.dataset["option-3"] === selections.option3 || variant.dataset["option-3"] == "null");
                });
                return selectedVariant;
            }
        },
        {
            /**
   * Sets the selected variant for the variant selector
   * Emits a variantChanged event if a variant is selected
   * @param {object} variant - The variant <option> to select
   */ key: "setSelectedVariant",
            value: function setSelectedVariant(variant) {
                if (this.variantSelector && variant) {
                    this.variantSelector.value = variant.value;
                    var variantChangedEvent = new CustomEvent("variantChanged", {
                        detail: {
                            wrapper: this.wrapper,
                            variant: this.variantSelector.value,
                            available: variant.dataset.available == "true"
                        }
                    });
                    document.dispatchEvent(variantChangedEvent);
                }
            }
        },
        {
            /**
   * Gets the background colour or image of a swatch item
   * Defaults to the data from ThemeVars if this product doesn't have specific data for this swatch value
   * @param {string} swatchValue - The value of the swatch e.g. Red
   * @returns {string} - The background colour or image of the swatch item
   */ key: "getSwatchBackground",
            value: function getSwatchBackground(swatchValue) {
                return this.swatchData.hasOwnProperty(swatchValue) ? this.swatchData[swatchValue] : ThemeVars.swatches[swatchValue];
            }
        },
        {
            /**
   * Selects swatches in this swatch group based on a variant URL parameter
   * @returns {boolean} - Whether or not swatches were selected
   */ key: "selectSwatchesFromUrl",
            value: function selectSwatchesFromUrl() {
                var _this = this;
                var urlParams = new URLSearchParams(window.location.search);
                var variant = urlParams.get("variant");
                // set the default variant if none is found in the url
                if (!variant) variant = this.productData.variants[0].id;
                var variantSelection = Array.from(this.variantSelector.querySelectorAll("option")).find(function(option) {
                    return option.value == variant;
                });
                /* If variant unavailable, select the first available one, if such exists */ if (variantSelection.dataset.available !== "true" && this.variantSelector.querySelector('option[data-available="true"]')) variantSelection = this.variantSelector.querySelector('option[data-available="true"]');
                if (variantSelection && (variantSelection.dataset.available == "true" || this.allowUnavailableSelections)) {
                    this.selectedOptions = {
                        option1: variantSelection.dataset["option-1"].replace("null", ""),
                        option2: variantSelection.dataset["option-2"].replace("null", ""),
                        option3: variantSelection.dataset["option-3"].replace("null", "")
                    };
                    this.setSelectedVariant(variantSelection);
                    Object.keys(this.selectedOptions).forEach(function(optionIndex) {
                        var swatch = _this.wrapper.querySelector('[data-option-value="'.concat(_this.selectedOptions[optionIndex], '"]'));
                        if (swatch) {
                            _this.visiblySelectSwatch(swatch);
                            _this.markUnavailableSwatches(swatch);
                        }
                    });
                    return true;
                }
                return false;
            }
        }
    ]);
    return SwatchGroup;
}();
window.SwatchGroup = SwatchGroup;
document.dispatchEvent(new CustomEvent("swatchesReady"));

},{"@swc/helpers/src/_class_call_check.mjs":"eguiP","@swc/helpers/src/_create_class.mjs":"14PLJ","@swc/helpers/src/_define_property.mjs":"eI7TS","@swc/helpers/src/_object_spread.mjs":"kTy2G","./utils.js":"fP4IO","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"eguiP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
exports.default = _classCallCheck;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"14PLJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
exports.default = _createClass;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"eI7TS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
exports.default = _defineProperty;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"kTy2G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _definePropertyMjs = require("./_define_property.mjs");
var _definePropertyMjsDefault = parcelHelpers.interopDefault(_definePropertyMjs);
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, _definePropertyMjsDefault.default)(target, key, source[key]);
        });
    }
    return target;
}
exports.default = _objectSpread;

},{"./_define_property.mjs":"eI7TS","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"48A1E":[function(require,module,exports) {
/**
 * This file keeps track of a users recently viewed products.
 */ var _utilsJs = require("./utils.js");
var ThemeVars = window.ThemeVars;
var currencySymbol = window.ThemeVars.currency.symbol;
var RecentlyViewed = {
    config: {
        maxProducts: 5
    },
    state: {
        products: []
    },
    reloadScripts: (0, _utilsJs.reloadScripts),
    /**
   * Initialize the Recently Viewed module.
   * - Set the state to the current products in local storage
   * - Make sure the products tracked are not more than the maxProducts config
   * - If user is viewing a product, add it to the list
   * - Emits a recentlyViewedReady event at the end
   */ init: function init() {
        if (localStorage.getItem("recentlyViewed")) this.state.products = JSON.parse(localStorage.getItem("recentlyViewed"));
        if (this.state.products.length > this.config.maxProducts) {
            var deleteCount = this.state.products.length - this.config.maxProducts;
            this.state.products.splice(this.config.maxProducts, deleteCount);
            this.updateProducts(this.state.products);
        }
        if (ThemeVars && ThemeVars.product) this.addProduct(ThemeVars.product);
        document.dispatchEvent(new CustomEvent("recentlyViewedReady"));
    },
    // prod card
    createProductCard: function createProductCard(product) {
        var _product_images, _product_images_;
        var compare_at_price = product.compare_at_price;
        var price = product.price;
        var saleText = "SALE";
        var saleBannerColor = "#CE0E2D";
        if (window.ThemeVars.site_wide_sale.activated == true) {
            console.log("got here");
            var promoTag = window.ThemeVars.site_wide_sale.promotion_tag;
            var tags = product.tags;
            var discount = (100 - window.ThemeVars.site_wide_sale.promotion_percentage) / 100.0;
            tags.map(function(tag) {
                if (tag === promoTag) {
                    compare_at_price = price;
                    price = price * discount;
                    saleText = window.ThemeVars.site_wide_sale.banner_text;
                    saleBannerColor = window.ThemeVars.site_wide_sale.banner_color;
                }
            });
        }
        var onSale = +compare_at_price > +price;
        var exchangeRate = 1; // window.Shopify.currency.rate;
        // TODO: is new logic
        var isNew = false;
        var card = document.createElement("div");
        card.classList.add("prod-card");
        card.innerHTML = '\n      <div class="prod-card__image-container">\n      <div class="prod-card__rollover-images">\n\n      <div class="prod-card__alternate-image">\n        <a href="/products/'.concat(product.handle, '">\n          <img width="295" height="443" src="').concat(product.images[1], '&width=400" alt="').concat((_product_images = product.images) === null || _product_images === void 0 ? void 0 : (_product_images_ = _product_images[1]) === null || _product_images_ === void 0 ? void 0 : _product_images_.alt, '" class="prod-card__image" />\n        </a>\n        ').concat(window.themeSettings.enable_quickview ? '\n          <div class="prod-card__quick-view prod-card__quick-view-'.concat(product.handle, '">\n            <button class="prod-card__quick-view__button" data-quickshop="').concat(product.handle, '">Buy Now</button>\n          </div>\n          ') : "", '\n      </div>\n\n      <div class="prod-card__original-image">\n        <a href="/products/').concat(product.handle, '">\n          <img width="295" height="443" src="').concat(product.images[0], '&width=400" alt="').concat(product.images[0].alt, '" class="prod-card__image" />\n        </a>\n      </div>\n      \n    \n    \n        </div>\n        <div class="prod-card__badges">\n          ').concat(isNew ? '<div class="prod-card__tag">\n              <span class="prod-card__tag__text">{{- new_tag_text -}}</span>\n            </div>' : "", "\n            \n        </div>\n        ").concat(!product.tags.includes("free-gift-product") ? '<div class="prod-card__wishlist-heart prod-card__wishlist-heart-'.concat(product.handle, '">\n          <button\n            data-with-epi="true"\n            class="swym-button swym-add-to-wishlist-view-product product_').concat(product.id, '"\n            data-swaction="addToWishlist"\n            data-product-id={product.id}\n            data-variant-id={product.variants[0].id}\n            data-product-url="https://www.carraigdonn.com/products/').concat(product.handle, '">\n          </button>\n        </div>') : "", '\n      </div>\n      <div class="prod-card__banner">\n        ').concat(onSale ? '<div class="prod-card__sale-banner" style="background-color: '.concat(saleBannerColor, '">\n                    <span class="prod-card__banner__text">').concat(saleText, "</span>\n                  </div>") : "", '\n              </div>\n      <div class="prod-card__info">\n        <div class="prod-card__info__details">\n          <a href="/products/').concat(product.handle, '">\n            <h3 class="prod-card__title">\n              ').concat(product.title, '\n            </h3>\n          </a>\n          <div class="prod-card__info__price">\n          <div class="prod-card__price__container">\n            ').concat(onSale ? '\n            <div class="prod-card__compare-at-price">\n              '.concat(currencySymbol).concat((compare_at_price * exchangeRate / 100).toFixed(2), "\n            </div>") : "", '\n            <div class="prod-card__price ').concat(onSale ? "prod-card__price__sale" : "", '">\n            ').concat(currencySymbol).concat((price * exchangeRate / 100).toFixed(2), '\n            </div>\n          </div>\n        </div>\n        </div>\n        \n          <div class="prod-card__vendor">\n            ').concat(product.vendor, "\n          </div>\n      </div>\n  \n  ");
        return card;
    },
    /**
   * Add a product to the list of recently viewed products
   * @param {Object} product - The product to add
   */ addProduct: function addProduct(product) {
        var products = this.state.products;
        if (products.findIndex(function(p) {
            return p.id == product.id;
        }) === -1) {
            if (products.length >= this.config.maxProducts) products.shift();
            products.push(product);
            this.updateProducts(products);
        }
    },
    /**
   * Update the list of recently viewed products
   * - Updates both state and local storage
   * - Emits a recentlyViewedUpdated event at the end
   * @param {Array} products - The products to update
   */ updateProducts: function updateProducts(products) {
        this.state.products = products;
        localStorage.setItem("recentlyViewed", JSON.stringify(this.state.products));
        document.dispatchEvent(new CustomEvent("recentlyViewedUpdated"));
    }
};
window.RecentlyViewed = RecentlyViewed;
RecentlyViewed.init();

},{"./utils.js":"fP4IO"}],"lMAlE":[function(require,module,exports) {
/**
 * This file handles interactions with the Shopify cart object.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGeneratorMjs = require("@swc/helpers/src/_async_to_generator.mjs");
var _asyncToGeneratorMjsDefault = parcelHelpers.interopDefault(_asyncToGeneratorMjs);
var _definePropertyMjs = require("@swc/helpers/src/_define_property.mjs");
var _definePropertyMjsDefault = parcelHelpers.interopDefault(_definePropertyMjs);
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _tsGeneratorMjs = require("@swc/helpers/src/_ts_generator.mjs");
var _tsGeneratorMjsDefault = parcelHelpers.interopDefault(_tsGeneratorMjs);
var _utilsJs = require("./utils.js");
var ThemeVars = window.ThemeVars;
var Cart = {
    /**
   * Sets up the cart object.
   * Values will be provided with init.
   * The keys are snake case to preserve parity with the Shopify cart object.
   */ cartData: {
        attributes: {},
        cart_level_discount_applications: [],
        currency: "",
        item_count: 0,
        items: [],
        items_subtotal_price: "",
        note: null,
        original_total_price: 0,
        requires_shipping: false,
        token: null,
        total_discount: 0,
        total_price: 0,
        total_weight: 0
    },
    isEligibleForFreeGift: false,
    /**
   * Initialises the cart object.
   */ init: /*#__PURE__*/ (0, _asyncToGeneratorMjsDefault.default)(function() {
        var _this, atcForms;
        return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _this = this;
                    this.freeGiftSettings = this.freeGiftSettings || {};
                    document.addEventListener("itemsAddedToCart", this.setCartData.bind(this));
                    document.addEventListener("cartUpdated", this.setCartData.bind(this));
                    atcForms = document.querySelectorAll('form[action="/cart/add"]');
                    atcForms.forEach(function(form) {
                        form.addEventListener("submit", _this.handleAtcSubmit);
                    });
                    return [
                        4,
                        this.setCartData()
                    ];
                case 1:
                    _state.sent();
                    document.dispatchEvent(new CustomEvent("cartReady"));
                    return [
                        2
                    ];
            }
        });
    }),
    /**
   * Updates the cartData attribute with the current state of the cart from the API.
   */ setCartData: /*#__PURE__*/ (0, _asyncToGeneratorMjsDefault.default)(function() {
        var cartData;
        return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("/cart.js").then(function(response) {
                            return response.json();
                        })
                    ];
                case 1:
                    cartData = _state.sent();
                    this.cartData = (0, _objectSpreadMjsDefault.default)({}, cartData);
                    document.dispatchEvent(new CustomEvent("cartDataUpdated"));
                    return [
                        2
                    ];
            }
        });
    }),
    /*
   * ================================================
   * 
   *                  ADDING ITEMS
   * 
   * ================================================
   */ /**
   * Handles submission of an add to cart form for a single variant.
   * @param {Event} event The submit event.
   */ handleAtcSubmit: function() {
        var _ref = (0, _asyncToGeneratorMjsDefault.default)(function(event) {
            var form, params, quantity, propertyInputKeys, properties;
            return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                event.preventDefault();
                form = event.target;
                params = (0, _utilsJs.getParamsFromForm)(form);
                if (!params.id) return [
                    2,
                    console.error("handleAtcSubmit: No variant ID found in form.")
                ];
                quantity = params.quantity || 1;
                propertyInputKeys = Object.keys(params).filter(function(key) {
                    return key.startsWith("properties");
                });
                properties = {};
                propertyInputKeys.forEach(function(key) {
                    var propertyName = key.replace("properties[", "").replace("]", "");
                    properties[propertyName] = params[key];
                });
                Cart.addItem(params.id.toString(), parseInt(quantity), properties);
                return [
                    2
                ];
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(),
    /**
   * Adds a single gift item to the cart.
   * @param {String|Integer} id - The variant ID for the item to add.
   * @param {Integer} quantity - The quantity of the item to add. Defaults to 1.
   * @param {Object} properties - Optional properties to add to the cart item.
   * @returns {void}
   */ addGiftItem: function addGiftItem(id) {
        var quantity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, properties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (!id) return console.error("Cart.addItem() : id is required.");
        var item = {
            id: parseInt(id),
            quantity: quantity,
            properties: properties
        };
        var freeGiftBlock = false;
        var freeGiftVariantIds = [];
        var freeGiftProducts = Array.isArray(ThemeVars.freeGiftProducts) ? ThemeVars.freeGiftProducts : [
            ThemeVars.freeGiftProducts
        ]; // convert to array 
        if (freeGiftProducts && freeGiftProducts.length > 0) freeGiftProducts.forEach(function(product) {
            if (product && product.variants > 0) product.variants.forEach(function(variant) {
                freeGiftVariantIds.push(variant.id);
            });
        });
        // Check if the item being added is a free gift product
        if (freeGiftVariantIds.includes(parseInt(item.id))) for(var i = 0; i < this.cartData.items.length; i++){
            var cartItem = this.cartData.items[i];
            if (freeGiftVariantIds.includes(parseInt(cartItem.id))) {
                freeGiftBlock = true;
                break;
            }
        }
        if (!freeGiftBlock) this.sendAddGift([
            item
        ]);
        else console.error("Cart.addItem() : Free gift item already in cart");
    },
    /**
   * Adds a single item to the cart.
   * @param {String|Integer} id - The variant ID for the item to add.
   * @param {Integer} quantity - The quantity of the item to add. Defaults to 1.
   * @param {Object} properties - Optional properties to add to the cart item.
   * @returns {void}
   */ addItem: function addItem(id) {
        var quantity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, properties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (!id) return console.error("Cart.addItem() : id is required.");
        var item = {
            id: parseInt(id),
            quantity: quantity,
            properties: properties
        };
        this.sendAddToCart([
            item
        ]);
    },
    /**
   * Adds multiple items to the cart.
   * @param {Array} items - An array of objects containing the item data. Each should match format of Cart.addItem().
   * @returns {void}
   */ addMultipleItems: function addMultipleItems(items) {
        if (!items || !items.length) return console.error("Cart.addMultipleItems() : items is required.");
        this.sendAddToCart(items);
    },
    /**
   * Add a free gift item to the cart, and remove any that have already been added.
   * @param {number} id 
   * @returns {void}
   */ addFreeGift: function addFreeGift(id) {
        this.addGiftItem(id, 1, {
            _free_gift: true
        });
    },
    sendAddGift: function sendAddGift(items) {
        fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            body: JSON.stringify({
                items: items
            })
        }).then(function(response) {
            return response.json();
        }).then(function(cart) {
            if (cart.status) console.error("Cart.sendAddToCart() : ".concat(cart.description || cart.message || "Unknown error"));
            else Minicart.reloadDrawer();
        });
    },
    /**
   * Sends the add to cart form to Shopify.
   * NOTE: You should use addItems or addMultipleItems instead of this method directly.
   * @param {Array} items - An array of objects containing the item data. Each should match format of Cart.addItem().
   */ sendAddToCart: function sendAddToCart(items) {
        fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            body: JSON.stringify({
                items: items
            })
        }).then(function(response) {
            return response.json();
        }).then(function(cart) {
            if (cart.status) console.error("Cart.sendAddToCart() : ".concat(cart.description || cart.message || "Unknown error"));
            else document.dispatchEvent(new CustomEvent("itemsAddedToCart", {
                detail: {
                    items: items
                }
            }));
        });
    },
    /*
   * ================================================
   * 
   *            UPDATING CART PROPERTIES
   * 
   * ================================================
   */ /**
   * Adds a note to the current cart. 
   * @param {String} note - The note to add.
   */ addNote: function addNote(note) {
        var updateBody = {
            note: note
        }; // E.g. {note: 'This is a note'}
        this.sendCartUpdate(updateBody);
    },
    /**
   * Adds a single cart attribute to the current cart.
   * @param {String} key - The key of the attribute to add.
   * @param {String} value - The value of the attribute to add.
   */ addAttribute: function addAttribute(key, value) {
        var updateBody = {
            attributes: (0, _definePropertyMjsDefault.default)({}, key, value)
        };
        this.sendCartUpdate(updateBody);
    },
    /**
   * Adds multiple cart attributes to the current cart.
   * @param {Object} attributes - An object containing the attributes to add.
   * Example: {'Gift Message': 'Happy Birthday!', 'Gift Wrap': 'true'}
   */ addMultipleAttributes: function addMultipleAttributes(attributes) {
        var updateBody = {
            attributes: attributes
        };
        this.sendCartUpdate(updateBody);
    },
    /**
   * Sends a cart update request to Shopify.
   * Fires the 'cartUpdated' event if successful.
   * @param {Object} updateBody - The body of the update request.
   */ sendCartUpdate: function sendCartUpdate(updateBody) {
        fetch("/cart/update.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            body: JSON.stringify(updateBody)
        }).then(function(response) {
            return response.json();
        }).then(function(cart) {
            if (cart.status) console.error("Cart.sendCartUpdate() : ".concat(cart.description || cart.message || "Unknown error"));
            else document.dispatchEvent(new CustomEvent("cartUpdated"));
        });
    },
    /*
   * ================================================
   * 
   *             CHANGING LINE ITEM DATA
   * 
   * ================================================
   */ /**
   * Change the quantity of an item in the cart. 
   * @param {String|Integer} itemId - The variant ID or 1-based index position for the item to update.
   * @param {Integer} quantity - The new quantity of the item.
   * @returns {void}
   */ changeItemQuantity: function changeItemQuantity(itemId, quantity) {
        if (!itemId || quantity == null) return console.error("Cart.changeItemQuantity() : itemId and quantity are required.");
        var itemKey = parseInt(itemId) < 1000 ? "line" : "id";
        var _obj;
        var changeBody = (_obj = {}, (0, _definePropertyMjsDefault.default)(_obj, itemKey, itemId.toString()), (0, _definePropertyMjsDefault.default)(_obj, "quantity", parseInt(quantity)), _obj);
        this.sendCartChange(changeBody);
        if (ThemeVars.freeGiftEnabled) {
            var freeGiftVariantIds = [];
            var freeGiftProducts = Array.isArray(ThemeVars.freeGiftProducts) ? ThemeVars.freeGiftProducts : [
                ThemeVars.freeGiftProducts
            ]; // convert to array 
            if (freeGiftProducts && freeGiftProducts.length > 0) freeGiftProducts.forEach(function(product) {
                if (product && product.variants > 0) product.variants.forEach(function(variant) {
                    freeGiftVariantIds.push(variant.id);
                });
            });
            // Check if the item being added is a free gift product
            if (freeGiftVariantIds.includes(parseInt(itemId)) && quantity !== 0) window.setTimeout(function() {
                Minicart.reloadDrawer();
            }, 3000);
        }
    },
    changeItemQuantityGift: function changeItemQuantityGift(itemId, quantity) {
        if (!itemId || quantity == null) return console.error("Cart.changeItemQuantity() : itemId and quantity are required.");
        var itemKey = parseInt(itemId) < 1000 ? "line" : "id";
        var _obj;
        var changeBody = (_obj = {}, (0, _definePropertyMjsDefault.default)(_obj, itemKey, itemId.toString()), (0, _definePropertyMjsDefault.default)(_obj, "quantity", parseInt(quantity)), _obj);
        this.sendCartChangeGift(changeBody);
    },
    /**
   * Changes custom properties of an item in the cart. 
   * @param {String|Integer} itemId - The variant ID or 1-based index position for the item to update.
   * @param {Object} properties - The new properties of the item.
   * @returns {void}
   * Example: {'Gift Message': 'Happy Birthday!', 'Gift Wrap': 'true'}
   */ changeItemProperties: function changeItemProperties(itemId) {
        var properties = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (!itemId) return console.error("Cart.changeItemProperties() : itemId is required.");
        if (!properties || Object.keys(properties).length === 0) return console.error("Cart.changeItemProperties() : properties is required and cannot be empty.");
        var itemKey = parseInt(itemId) < 1000 ? "line" : "id";
        var _obj;
        var changeBody = (_obj = {}, (0, _definePropertyMjsDefault.default)(_obj, itemKey, itemId.toString()), (0, _definePropertyMjsDefault.default)(_obj, "properties", properties), _obj);
        this.sendCartChange(changeBody);
    },
    sendCartChangeGift: function sendCartChangeGift(changeBody) {
        fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            body: JSON.stringify(changeBody)
        }).then(function(response) {
            if (response.status && response.status != 200) console.error("Cart.sendCartChange() : ".concat(response.status == 404 ? "Item not in cart" : "Unknown error"));
        });
    },
    /**
   * Sends a cart change request to Shopify. 
   * NOTE: You should use changeItemQuantity or changeItemProperties instead of this method directly.
   * NOTE: This method will trigger the 'cartUpdated' event, rather than a 'cartChanged' event.
   * @param {Object} changeBody - The body of the change request.
   */ sendCartChange: function sendCartChange(changeBody) {
        fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            body: JSON.stringify(changeBody)
        }).then(function(response) {
            if (response.status && response.status != 200) console.error("Cart.sendCartChange() : ".concat(response.status == 404 ? "Item not in cart" : "Unknown error"));
            else document.dispatchEvent(new CustomEvent("cartUpdated"));
        });
    }
};
exports.default = Cart;
window.Cart = Cart;
Cart.init();

},{"@swc/helpers/src/_async_to_generator.mjs":"7nC9G","@swc/helpers/src/_define_property.mjs":"eI7TS","@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_ts_generator.mjs":"cT4KU","./utils.js":"fP4IO","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"fGhsA":[function(require,module,exports) {
/**
 * This file handles logic relating to the minicart drawer.
 * See _cart.js for interactions with the Shopify cart object.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _asyncToGeneratorMjs = require("@swc/helpers/src/_async_to_generator.mjs");
var _asyncToGeneratorMjsDefault = parcelHelpers.interopDefault(_asyncToGeneratorMjs);
var _tsGeneratorMjs = require("@swc/helpers/src/_ts_generator.mjs");
var _tsGeneratorMjsDefault = parcelHelpers.interopDefault(_tsGeneratorMjs);
var _utilsJs = require("./utils.js");
var Minicart = {
    /**
   * Sets up minicart config.
   * You will need to change this at the start of your project to your own minicart.
   */ config: {
        drawer: document.querySelector("[data-minicart-drawer]"),
        openClass: "is-open",
        minimalCartClass: "minimalcart__drawer",
        minicartSection: "minicart",
        openDrawerOnAdd: true
    },
    state: {
        // The stores and clickAndCollect states get updated in the minicart.liquid section
        isLoading: false,
        step: 1,
        stores: [],
        clickAndCollect: true,
        deliveryType: "home_delivery",
        selectedStore: {},
        hasHeavyGoods: false,
        hasExcludedCC: false,
        isInROI: true
    },
    /**
   * Initialises the minicart.
   */ init: function init() {
        this.setupEventListeners();
        /*
     * this.state.cartItems = JSON.parse(document.getElementById('CartItems').innerHTML);
     * console.log('cartItems HTML', this.state.cartItems);
     */ document.dispatchEvent(new CustomEvent("minicartReady"));
    },
    showFreeGiftForm: function(visible) {
        var form = document.getElementById("free-gift-form");
        if (!form) return;
        form.hidden = !visible;
    },
    showFreeGiftPrompt: function(visible) {
        // QSAll in case design requires multiple prompts in the future. --GAD
        document.querySelectorAll(".minicart__body__").forEach(function(p) {
            return p.hidden = !visible;
        });
    },
    /**
   * Prepares correct URL format for the relevant shipping address object and cart attribute
   * @param {Object} data - The object to encode. Defaults to empty object for home delivery.
   */ encodeParameters: function() {
        var mappedParams = [];
        //const mappedParams = ['checkout[shipping_address]' + '[address1]=' + this.state.selectedStore.address1 + '[address2]=' + this.state.selectedStore.address2 + '[city]=' + this.state.selectedStore.city + '[county]=' + this.state.selectedStore.county + '[country]=' + this.state.selectedStore.country + '[province]=' + this.state.selectedStore.province + '[zip]=' + this.state.selectedStore.zip];
        mappedParams.push("attributes[delivery_type]=" + this.state.deliveryType);
        mappedParams.push("attributes[click_and_collect_email]=" + (this.state.deliveryType == "click_and_collect" ? this.state.selectedStore.email : "N/A"));
        mappedParams.push("attributes[click_and_collect_store]=" + (this.state.deliveryType == "click_and_collect" ? this.state.selectedStore.name : "N/A"));
        var joinedParams = "?step=contact_information&" + mappedParams.join("&");
        return joinedParams;
    },
    setDeliveryType: function(type) {
        var ccErrorMessage = document.querySelector("#CCErrorMessage");
        var ccSuccessMessage = document.querySelector("#CCSuccessMessage");
        var ccStoreSelector = document.querySelector("#ClickAndCollectStoreSelector");
        if (this.state.hasHeavyGoods && type == "click_and_collect" || this.state.hasExcludedCC && type == "click_and_collect") {
            this.state.deliveryType = "home_delivery";
            // document.querySelector('.minicart__delivery-options__selector').innerHTML = 'Only Home Dleivery is available for this order';
            ccErrorMessage.hidden = false;
            ccSuccessMessage.hidden = true;
            ccStoreSelector.hidden = true;
        } else {
            this.state.deliveryType = type;
            if (type == "click_and_collect") {
                this.state.selectedStore = this.state.stores[0];
                ccErrorMessage.hidden = true;
                ccSuccessMessage.hidden = false;
                ccStoreSelector.hidden = false;
            }
        }
    },
    setDeliveryStore: function(store) {
        this.state.selectedStore = store;
    },
    handleCheckoutSubmit: function() {
        window.location.href = "/checkout" + this.encodeParameters();
    },
    setHasInteractedWithMinicart: function(trueOrFalse) {
        this.state.hasInteractedWithMinicart = trueOrFalse;
    },
    /**
   * Sets up event listeners for the minicart.
   *  - Separated so we can re-add them if the minicart is re-rendered.
   */ setupEventListeners: /*#__PURE__*/ (0, _asyncToGeneratorMjsDefault.default)(function() {
        var _this, onItemsAddedToCart;
        return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
            _this = this;
            onItemsAddedToCart = function(e) {
                var item;
                if (e.detail.items && e.detail.items.length > 0) item = e.detail.items[0];
                Minicart.reloadDrawer();
                if (Minicart.config.openDrawerOnAdd) {
                    var onMinicartReloaded = function() {
                        if (item) {
                            Minicart.openDrawer("minimal", item.id);
                            setTimeout(function() {
                                Minicart.closeDrawer("minimal");
                            }, 5000);
                        } else Minicart.openDrawer();
                        document.removeEventListener("minicartReloaded", onMinicartReloaded);
                    };
                    document.addEventListener("minicartReloaded", onMinicartReloaded);
                }
                document.removeEventListener("itemsAddedToCart", onItemsAddedToCart);
            };
            document.addEventListener("itemsAddedToCart", onItemsAddedToCart);
            this.config.drawer.addEventListener("click", function() {
                _this.setHasInteractedWithMinicart(true);
            });
            this.config.drawer.addEventListener("pointerenter", function() {
                _this.setHasInteractedWithMinicart(true);
            });
            document.querySelectorAll(".js-show-free-gift-form").forEach(function(el) {
                return el.addEventListener("click", function() {
                    return _this.showFreeGiftForm(true);
                });
            });
            document.querySelectorAll(".js-hide-free-gift-form").forEach(function(el) {
                return el.addEventListener("click", function(e) {
                    if (e.target !== e.currentTarget) return;
                    _this.showFreeGiftForm(false);
                });
            });
            document.addEventListener("freeGiftEligibilityChanged", function(e) {
                var isEligible = e.detail.isEligible;
                _this.showFreeGiftPrompt(isEligible);
            });
            return [
                2
            ];
        });
    }),
    openDrawer: function openDrawer(cartType, productId) {
        if (window.location.pathname == "/cart") return false;
        if (cartType == "minimal") {
            this.config.drawer.classList.add(this.config.minimalCartClass);
            if (productId) {
                var lineItem = this.config.drawer.querySelector(".minicart__item--".concat(productId));
                if (lineItem) lineItem.classList.add("minicart__item-new");
            }
            var underlay = document.querySelector(".modal-underlay");
            underlay.classList.add("modal-underlay-mini-cart");
        } else this.config.drawer.classList.remove(this.config.minimalCartClass);
        this.config.drawer.classList.add(this.config.openClass);
        var underlay1 = document.querySelector(".modal-underlay");
        underlay1.style.display = "block";
        var bodyContent = document.querySelector("body");
        bodyContent.style.overflow = "hidden";
    },
    closeDrawer: function closeDrawer(cartType) {
        var _this = this;
        this.config.drawer.classList.remove(this.config.openClass);
        var underlay = document.querySelector(".modal-underlay");
        underlay.classList.remove("modal-underlay-mini-cart");
        underlay.style.display = "none";
        var bodyContent = document.querySelector("body");
        bodyContent.style.overflow = "auto";
        if (cartType == "minimal") {
            setTimeout(function() {
                _this.config.drawer.classList.add("is-closing");
            }, 500);
            setTimeout(function() {
                _this.config.drawer.classList.remove(_this.config.minimalCartClass);
                var lineItems = document.querySelectorAll(".minicart__item-new");
                if (lineItems.length > 0) lineItems.forEach(function(lineItem) {
                    lineItem.classList.remove("minicart__item-new");
                });
                _this.config.drawer.classList.remove("is-closing");
            }, 1000);
        }
    },
    toggleDrawer: function toggleDrawer() {
        if (window.location.pathname == "/cart") return false;
        this.config.drawer.classList.toggle(this.config.openClass);
        var underlay = document.querySelector(".modal-underlay");
        underlay.style.display == "none" ? underlay.style.display = "block" : underlay.style.display = "none";
        var bodyContent = document.querySelector("body");
        bodyContent.style.overflow == "auto" ? bodyContent.style.overflow = "hidden" : bodyContent.style.overflow = "auto";
    },
    /**
   * Reloads the minicart drawer markup.
   * Sets up new event listeners.
   * Shows a loading state between.
   */ reloadDrawer: /*#__PURE__*/ (0, _asyncToGeneratorMjsDefault.default)(function() {
        var newMinicartDrawer, temporaryElement, newMinicartDrawerMarkup;
        return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
            switch(_state.label){
                case 0:
                    this.state.isLoading = true;
                    this.config.drawer.innerHTML = this.loadingScreenMarkup;
                    return [
                        4,
                        fetch("?section_id=".concat(this.config.minicartSection)).then(function(response) {
                            return response.text();
                        })
                    ];
                case 1:
                    newMinicartDrawer = _state.sent();
                    temporaryElement = document.createElement("div");
                    temporaryElement.innerHTML = newMinicartDrawer;
                    newMinicartDrawerMarkup = temporaryElement.querySelector("[data-minicart-drawer]").innerHTML;
                    this.config.drawer.innerHTML = newMinicartDrawerMarkup;
                    (0, _utilsJs.reloadScripts)(this.config.drawer);
                    this.setupEventListeners();
                    this.state.isLoading = false;
                    /*
     * this.state.cartItems = JSON.parse(document.getElementById('CartItems').innerHTML);
     * console.log('cartItems HTML', this.state.cartItems);
     */ this.state.cartItems = JSON.parse(document.getElementById("CartItems").innerHTML);
                    document.dispatchEvent(new CustomEvent("minicartReloaded"));
                    return [
                        2
                    ];
            }
        });
    }),
    loadingScreenMarkup: '\n    <!-- Loading Screen -->\n    <div style="display: flex; width: 100%; height: 100%; min-height: 250px; justify-content: center; align-items: center;">\n      <div class="loader__container">\n        <div class="loader__inner">\n          <div></div>\n        </div>\n      </div>\n    </div>\n  '
};
window.Minicart = Minicart;
Minicart.init();

},{"@swc/helpers/src/_async_to_generator.mjs":"7nC9G","@swc/helpers/src/_ts_generator.mjs":"cT4KU","./utils.js":"fP4IO","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"bk4ve":[function(require,module,exports) {
/**
 * This file handles the wishlist functionality.
 * A user does not need to be logged in to have a wishlist.
 * The wishlist is stored in local storage - therefore specific to the browser, not the user.
 * Storing the wishlist on the user or cross device will require a third party service.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _asyncToGeneratorMjs = require("@swc/helpers/src/_async_to_generator.mjs");
var _asyncToGeneratorMjsDefault = parcelHelpers.interopDefault(_asyncToGeneratorMjs);
var _tsGeneratorMjs = require("@swc/helpers/src/_ts_generator.mjs");
var _tsGeneratorMjsDefault = parcelHelpers.interopDefault(_tsGeneratorMjs);
var Wishlist = {
    config: {
        maxProducts: 0 // 0 means no limit
    },
    state: {
        products: []
    },
    /**
   * Initialize the Wishlist module.
   * - Set the state to the current products in local storage
   * - Make sure the products tracked are not more than the maxProducts config
   * - Emits a wishlistReady event at the end
   */ init: function init() {
        if (localStorage.getItem("wishlist")) this.state.products = JSON.parse(localStorage.getItem("wishlist"));
        if (this.state.products.length > this.config.maxProducts && this.config.maxProducts != 0) {
            var deleteCount = this.state.products.length - this.config.maxProducts;
            this.state.products.splice(this.config.maxProducts, deleteCount);
            this.updateProducts(this.state.products);
        }
        document.dispatchEvent(new CustomEvent("wishlistReady"));
    },
    /**
   * Add a product to the list of wishlist products
   * - Updates both state and local storage
   * @param {String} handle - The product handle to add
   */ addProduct: function addProduct(handle) {
        if (this.state.products.length >= this.config.maxProducts && this.config.maxProducts != 0) {
            console.error("Wishlist.addProduct() : Cannot add product to wishlist. Max products reached.");
            return;
        }
        var products = this.state.products;
        if (products.findIndex(function(p) {
            return p == handle;
        }) === -1) {
            products.push(handle);
            this.updateProducts(products);
        }
    },
    /**
   * Remove a product from the list of wishlist products
   * - Updates both state and local storage
   * @param {String} handle - The product handle to remove
   * @returns {Boolean} - Whether the product was removed or not
   */ removeProduct: function removeProduct(handle) {
        var products = this.state.products;
        var index = products.findIndex(function(p) {
            return p == handle;
        });
        if (index !== -1) {
            products.splice(index, 1);
            this.updateProducts(products);
            return true;
        }
        return false;
    },
    /**
   * Update the list of wishlist products
   * - Updates both state and local storage
   * - Emits a wishlistUpdated event at the end
   * @param {Array} products - The products to update
   */ updateProducts: function updateProducts(products) {
        this.state.products = products;
        localStorage.setItem("wishlist", JSON.stringify(this.state.products));
        document.dispatchEvent(new CustomEvent("wishlistUpdated"));
    },
    /**
   * Gets product data of the wishlist products
   * @returns {Array} - The products in the wishlist
   */ getProducts: /*#__PURE__*/ (0, _asyncToGeneratorMjsDefault.default)(function() {
        var _this, products;
        return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _this = this;
                    return [
                        4,
                        Promise.all(this.state.products.map(function() {
                            var _ref = (0, _asyncToGeneratorMjsDefault.default)(function(handle) {
                                return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _this.getProduct(handle)
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                    }
                                });
                            });
                            return function(handle) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 1:
                    products = _state.sent();
                    return [
                        2,
                        products
                    ];
            }
        });
    }),
    /**
   * Gets product data of a single product
   * @param {String} handle - The product handle to get
   */ getProduct: function() {
        var _ref = (0, _asyncToGeneratorMjsDefault.default)(function(handle) {
            var data;
            return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("/products/".concat(handle, ".js"), {
                                method: "GET",
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            }).then(function(response) {
                                return response.json();
                            })
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function(handle) {
            return _ref.apply(this, arguments);
        };
    }()
};
window.Wishlist = Wishlist;
Wishlist.init();

},{"@swc/helpers/src/_async_to_generator.mjs":"7nC9G","@swc/helpers/src/_ts_generator.mjs":"cT4KU","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"dZwOO":[function(require,module,exports) {
/**
 * This file handles rendering and interactions with the quick shop modal.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Quickshop", function() {
    return Quickshop;
});
var _asyncToGeneratorMjs = require("@swc/helpers/src/_async_to_generator.mjs");
var _asyncToGeneratorMjsDefault = parcelHelpers.interopDefault(_asyncToGeneratorMjs);
var _tsGeneratorMjs = require("@swc/helpers/src/_ts_generator.mjs");
var _tsGeneratorMjsDefault = parcelHelpers.interopDefault(_tsGeneratorMjs);
var _utils = require("./utils");
var Quickshop = {
    config: {
        section: "quickshop",
        quickshopClass: "quickshop-modal",
        triggerQuery: "[data-quickshop]",
        handleAttribute: "data-quickshop" // Attribute to use for quickshop handle
    },
    state: {
        atcEvent: null
    },
    /**
   * Initialize the quickshop object.
   *  - Add event listeners to all trigger elements.
   */ init: function init() {
        var _this = this;
        var triggerElements = document.querySelectorAll(this.config.triggerQuery);
        triggerElements.forEach(function(triggerElement) {
            // Check if the button already has the event listener so is not added again.
            if (!triggerElement.dataset.hasClickEvent) triggerElement.addEventListener("click", _this.handleTriggerClick.bind(_this, triggerElement));
            triggerElement.dataset.hasClickEvent = "true";
        });
    },
    /**
   * Handle the click event on a quickshop trigger.
   *  - Prevents default action.
   *  - Get the handle attribute value.
   *  - Create a quickshop for this product hanlde.
   * @param {object} event - The click event.
   * @param {object} target - The triggered element.
   */ handleTriggerClick: function handleTriggerClick(target, event) {
        event.preventDefault();
        var handle = target.getAttribute(this.config.handleAttribute);
        console.log("HANDLE", handle);
        this.createQuickshop(handle);
    },
    /**
   * Removes the quickshop modal from the page, and removes the atc event listener.
   */ destroyQuickshop: function destroyQuickshop() {
        var modal = document.querySelector(".".concat(this.config.quickshopClass));
        if (modal) modal.remove();
        document.removeEventListener("itemsAddedToCart", this.state.atcEvent);
    },
    /**
   * Gets quickshop modal markup, appends it to the page, and adds an atc event listener.
   *  - Will also reload any scripts in the markup.
   *  - Shows a loading screen briefly.
   * @param {string} productHandle - The handle of the product to quickshop.
   */ createQuickshop: function() {
        var _ref = (0, _asyncToGeneratorMjsDefault.default)(function(productHandle, shopboxProductURL) {
            var loadingMarkup, modalInner, quickshopMarkup, addToCart;
            return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        loadingMarkup = (0, _utils.generateModal)(this.config.quickshopClass, this.loadingScreenMarkup);
                        document.body.insertAdjacentHTML("beforeend", loadingMarkup);
                        modalInner = document.querySelector(".".concat(this.config.quickshopClass, "__inner"));
                        return [
                            4,
                            this.getQuickshopMarkup(productHandle)
                        ];
                    case 1:
                        quickshopMarkup = _state.sent();
                        modalInner.innerHTML = quickshopMarkup;
                        addToCart = modalInner.querySelector(".product__atc-button");
                        if (addToCart && shopboxProductURL) addToCart.setAttribute("data-url", shopboxProductURL);
                        (0, _utils.reloadScripts)(modalInner);
                        this.state.atcEvent = document.addEventListener("itemsAddedToCart", this.destroyQuickshop.bind(this));
                        document.dispatchEvent(new CustomEvent("quickshopCreated"));
                        return [
                            2
                        ];
                }
            });
        });
        return function(productHandle, shopboxProductURL) {
            return _ref.apply(this, arguments);
        };
    }(),
    /**
   * Gets the quickshop markup for the product.
   * @param {string} productHandle - The handle of the product to quickshop.
   * @returns {string} - The markup for the quickshop modal.
   */ getQuickshopMarkup: function() {
        var _ref = (0, _asyncToGeneratorMjsDefault.default)(function(productHandle) {
            var response;
            return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("/products/".concat(productHandle, "?section_id=").concat(this.config.section)).then(function(response) {
                                return response.text();
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            response
                        ];
                }
            });
        });
        return function(productHandle) {
            return _ref.apply(this, arguments);
        };
    }(),
    /**
   * Markup for the loading screen when quickshop is loading.
   */ loadingScreenMarkup: '\n    <!-- Loading Screen -->\n    <div style="display: flex; width: 100%; height: 100%; min-height: 250px; justify-content: center; align-items: center;">\n      <div class="loader__container">\n        <div class="loader__inner">\n          <div></div>\n        </div>\n      </div>\n    </div>\n  '
};
window.Quickshop = Quickshop;
document.dispatchEvent(new CustomEvent("quickshopReady"));

},{"@swc/helpers/src/_async_to_generator.mjs":"7nC9G","@swc/helpers/src/_ts_generator.mjs":"cT4KU","./utils":"fP4IO","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"fJLOJ":[function(require,module,exports) {
/**
 * This file is responsible for getting product recommendations from the Shopify API.
 * It requires a "seed" product, which is the product that the recommendations are based on.
 * 
 * It uses the following data (dependant on Shopify plan) to generate the recommendations:
 * - Purchase History - Finds products that have historically been purchased with the seed product.
 * - Product Description - Finds products that have similar descriptions to the seed product.
 * - Related Collections - Finds products from collections that the seed product is a part of. Does not include 'all' or 'frontpage' collections.
 * 
 * See the following for more information:
 * https://shopify.dev/themes/product-merchandising/recommendations#recommendation-logic
 * 
 * Use the recommendations object for markup if you are requesting a section:
 * https://shopify.dev/api/liquid/objects/recommendations 
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _asyncToGeneratorMjs = require("@swc/helpers/src/_async_to_generator.mjs");
var _asyncToGeneratorMjsDefault = parcelHelpers.interopDefault(_asyncToGeneratorMjs);
var _tsGeneratorMjs = require("@swc/helpers/src/_ts_generator.mjs");
var _tsGeneratorMjsDefault = parcelHelpers.interopDefault(_tsGeneratorMjs);
var ProductRecommendations = {
    config: {
        limit: 6 // How many products to return - max is 10
    },
    state: {
        json: null,
        markup: null
    },
    /**
   * Get the product recommendations from the Shopify API.
   * @param {string|integer} seedProduct - The product ID of the seed product.
   * @param {string} section - Optional. A section to render with recommendations.
   * @returns {object} - The product recommendations. Always with json, optionally with markup.
   * @example
   * const recommendations = await ProductRecommendations.getRecommendations(seedProductId);
   * console.log(recommendations.json);
   * console.log(recommendations.markup);
   */ getRecommendations: function() {
        var _ref = (0, _asyncToGeneratorMjsDefault.default)(function(seedProduct) {
            var section, _, _1;
            var _arguments = arguments;
            return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        section = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null;
                        if (!seedProduct) return [
                            2,
                            console.error("getRecommendations: No seed product provided.")
                        ];
                        if (!parseInt(seedProduct)) return [
                            2,
                            console.error("getRecommendations: seedProduct must be a product ID.")
                        ];
                        _ = this.state;
                        return [
                            4,
                            this.getJson(seedProduct)
                        ];
                    case 1:
                        _.json = _state.sent();
                        if (!section) return [
                            3,
                            3
                        ];
                        _1 = this.state;
                        return [
                            4,
                            this.getMarkup(seedProduct, section)
                        ];
                    case 2:
                        _1.markup = _state.sent();
                        _state.label = 3;
                    case 3:
                        this.dispatchRecommendationEvent();
                        return [
                            2,
                            this.state
                        ];
                }
            });
        });
        return function(seedProduct) {
            return _ref.apply(this, arguments);
        };
    }(),
    /**
   * Returns parsed JSON of the product recommendations.
   * @param {string|integer} seedProduct - The product ID of the seed product.
   * @returns {object} - The product recommendations.
   * @example
   * const recommendations = await ProductRecommendations.getJson(seedProductId);
   * console.log(recommendations);
   */ getJson: function() {
        var _ref = (0, _asyncToGeneratorMjsDefault.default)(function(seedProduct) {
            var jsonUrl, jsonResponse;
            return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        jsonUrl = "/recommendations/products.json?product_id=".concat(seedProduct, "&limit=").concat(this.config.limit || 10);
                        return [
                            4,
                            fetch(jsonUrl).then(function(response) {
                                return response.json();
                            })
                        ];
                    case 1:
                        jsonResponse = _state.sent();
                        if (jsonResponse.status) {
                            console.error("getJson: ".concat(jsonResponse.description || jsonResponse.message));
                            return [
                                2,
                                null
                            ];
                        }
                        return [
                            2,
                            jsonResponse
                        ];
                }
            });
        });
        return function(seedProduct) {
            return _ref.apply(this, arguments);
        };
    }(),
    /**
   * Returns the product recommendations markup.
   * @param {string|integer} seedProduct - The product ID of the seed product.
   * @param {string} section - The section to render.
   * @returns {string} - The product recommendations markup.
   * @example
   * const markup = await ProductRecommendations.getMarkup(seedProductId, 'related-products');
   * myElement.outerHTML = markup;
   */ getMarkup: function() {
        var _ref = (0, _asyncToGeneratorMjsDefault.default)(function(seedProduct, section) {
            var markupUrl, markupResponse;
            return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        markupUrl = "/recommendations/products?product_id=".concat(seedProduct, "&section_id=").concat(section, "&limit=").concat(this.config.limit || 10);
                        return [
                            4,
                            fetch(markupUrl).then(function(response) {
                                if (!response.ok) {
                                    if (response.status == 422) console.error("getMarkup: Invalid parameter error - seedProduct was not provided.");
                                    if (response.status == 404) console.error("getMarkup: Not found error - either the seed product or the section does not exist.");
                                    if (response.status != 422 && response.status != 404) console.error("getMarkup: Unknown error - ".concat(response.status));
                                    return "";
                                }
                                return response.text();
                            }).catch(function(error) {
                                return console.error("getMarkup: ".concat(error));
                            })
                        ];
                    case 1:
                        markupResponse = _state.sent();
                        return [
                            2,
                            markupResponse
                        ];
                }
            });
        });
        return function(seedProduct, section) {
            return _ref.apply(this, arguments);
        };
    }(),
    /**
   * Dispatches a custom event to the document.
   * Contains the product recommendations data in the event detail.
   */ dispatchRecommendationEvent: function dispatchRecommendationEvent() {
        var event = new CustomEvent("productRecommendationsReceived", {
            detail: {
                json: this.state.json,
                markup: this.state.markup
            }
        });
        document.dispatchEvent(event);
    }
};
window.ProductRecommendations = ProductRecommendations;
document.dispatchEvent(new CustomEvent("productRecommendationsReady"));

},{"@swc/helpers/src/_async_to_generator.mjs":"7nC9G","@swc/helpers/src/_ts_generator.mjs":"cT4KU","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"OEros":[function(require,module,exports) {
/**
 * This file provides utilities for creating a "bundle" of products that can be added to the cart.
 * 
 * Example usage:
 * var myBundle = new Bundle();
 * myBundle.addProduct(handle, variantId);
 * myBundle.addProduct(handle, variantId2, quantity, {"Gift Message": "Happy Birthday!"});
 * myBundle.removeProduct(variantId); 
 * myBundle.addToCart();
 * 
 * var myBundleProducts = myBundle.products;
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _asyncToGeneratorMjs = require("@swc/helpers/src/_async_to_generator.mjs");
var _asyncToGeneratorMjsDefault = parcelHelpers.interopDefault(_asyncToGeneratorMjs);
var _classCallCheckMjs = require("@swc/helpers/src/_class_call_check.mjs");
var _classCallCheckMjsDefault = parcelHelpers.interopDefault(_classCallCheckMjs);
var _createClassMjs = require("@swc/helpers/src/_create_class.mjs");
var _createClassMjsDefault = parcelHelpers.interopDefault(_createClassMjs);
var _tsGeneratorMjs = require("@swc/helpers/src/_ts_generator.mjs");
var _tsGeneratorMjsDefault = parcelHelpers.interopDefault(_tsGeneratorMjs);
var _cart = require("./_cart");
var _cartDefault = parcelHelpers.interopDefault(_cart);
var Bundle = /*#__PURE__*/ function() {
    "use strict";
    function Bundle() {
        (0, _classCallCheckMjsDefault.default)(this, Bundle);
        this.products = [];
    }
    (0, _createClassMjsDefault.default)(Bundle, [
        {
            key: "addProduct",
            value: /**
   * Adds a product to the current bundle.
   * @param {String} handle - The handle of the product to add.
   * @param {String} id - The ID of the variant to add.
   * @param {Integer} quantity - The quantity of the item to add. Defaults to 1.
   * @param {Object} properties - Optional properties to add to the cart item.
   * @returns {Bundle} - Returns the current bundle.
   */ function addProduct(handle, id) {
                var quantity = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, properties = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                var _this = this;
                return (0, _asyncToGeneratorMjsDefault.default)(function() {
                    var productJson, product;
                    return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("/products/".concat(handle, ".js")).then(function(response) {
                                        return response.json();
                                    })
                                ];
                            case 1:
                                productJson = _state.sent();
                                if (productJson.variants) productJson.variants = productJson.variants.filter(function(variant) {
                                    return variant.id.toString() === id.toString();
                                });
                                product = {
                                    data: productJson,
                                    quantity: quantity,
                                    properties: properties
                                };
                                _this.products.push(product);
                                document.dispatchEvent(new CustomEvent("bundleProductsChanged", {
                                    detail: _this.products
                                }));
                                return [
                                    2,
                                    _this
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * Removes all products that match the query (handle or variant ID) from the bundle.
   * Removes all products if no arguments are provided.
   * @param {String} query - The handle or variant ID of the product to remove.
   * @returns {Bundle} - Returns the current bundle.
   */ key: "removeProduct",
            value: function removeProduct(query) {
                if (query) this.products = this.products.filter(function(product) {
                    return product.data.handle !== query && product.data.variants[0].id.toString() !== query.toString();
                });
                else this.products = [];
                document.dispatchEvent(new CustomEvent("bundleProductsChanged", {
                    detail: this.products
                }));
                return this;
            }
        },
        {
            /**
   * Sets the quantity of a product in the bundle.
   * @param {String} query - The handle or variant ID of the product to change.
   * @param {Integer} quantity - The new quantity of the product.
   * @returns {Bundle} - Returns the current bundle.
   */ key: "setQuantity",
            value: function setQuantity(query, quantity) {
                if (!query) return console.error("setQuantity: query (either handle or variant id) is required.");
                if (!quantity) return console.error("setQuantity: quantity is required.");
                this.products = this.products.map(function(product) {
                    if (product.data.handle === query || product.data.variants[0].id.toString() === query.toString()) product.quantity = quantity;
                    return product;
                });
                document.dispatchEvent(new CustomEvent("bundleProductsChanged", {
                    detail: this.products
                }));
                return this;
            }
        },
        {
            /** 
   * Removes a product from the bundle at a specific index.
   * @param {Integer} index - The index of the product to remove.
   * @returns {Bundle} - Returns the current bundle.
   */ key: "removeProductAtIndex",
            value: function removeProductAtIndex(index) {
                if (!index) return console.error("removeProductAtIndex: index is required.");
                this.products.splice(index, 1);
                document.dispatchEvent(new CustomEvent("bundleProductsChanged", {
                    detail: this.products
                }));
                return this;
            }
        },
        {
            /**
   * Adds the bundle to the cart.
   * Note: Cart dispatches it's own "itemsAddedToCart" event if successful.
   */ key: "addToCart",
            value: function addToCart() {
                var products = this.products.reduce(function(accumulator, product) {
                    var existingProduct = accumulator.find(function(p) {
                        return p.data.handle === product.data.handle;
                    });
                    if (existingProduct) existingProduct.quantity += product.quantity;
                    else accumulator.push(product);
                    return accumulator;
                }, []);
                var productsWithIds = products.map(function(product) {
                    return {
                        id: product.data.variants[0].id,
                        quantity: product.quantity,
                        properties: product.properties
                    };
                });
                (0, _cartDefault.default).addMultipleItems(productsWithIds);
            }
        }
    ]);
    return Bundle;
}();
window.Bundle = Bundle;
document.dispatchEvent(new CustomEvent("bundlesReady"));

},{"@swc/helpers/src/_async_to_generator.mjs":"7nC9G","@swc/helpers/src/_class_call_check.mjs":"eguiP","@swc/helpers/src/_create_class.mjs":"14PLJ","@swc/helpers/src/_ts_generator.mjs":"cT4KU","./_cart":"lMAlE","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"gQHzL":[function(require,module,exports) {
(function() {
    var updateTimer = function updateTimer(timer, timerParts, timeLeft, removeZeroElements) {
        var days = Math.floor(timeLeft / 86400);
        var hours = Math.floor(timeLeft % 86400 / 3600);
        var minutes = Math.floor(timeLeft % 3600 / 60);
        var seconds = timeLeft % 60;
        var formattedDays = formatNumber(days);
        var formattedHours = formatNumber(hours);
        var formattedMinutes = formatNumber(minutes);
        var formattedSeconds = formatNumber(seconds);
        timerParts.daysNumber.innerText = formattedDays;
        timerParts.hoursNumber.innerText = formattedHours;
        timerParts.minutesNumber.innerText = formattedMinutes;
        timerParts.secondsNumber.innerText = formattedSeconds;
        if (removeZeroElements) {
            var elements = 4;
            if (formattedDays == "00") {
                elements = 3;
                if (formattedHours == "00") {
                    elements = 2;
                    if (formattedMinutes == "00") {
                        elements = 1;
                        if (formattedSeconds == "00") elements = 0;
                    }
                }
            }
            var elementHidingClasses = [
                "elements-3",
                "elements-2",
                "elements-1",
                "elements-0"
            ];
            var elementHidingClass = "elements-".concat(elements);
            if (elements == 4 || elements < 4 && !timer.classList.contains(elementHidingClass)) elementHidingClasses.forEach(function(className) {
                timer.classList.remove(className);
            });
            if (elements < 4 && !timer.classList.contains(elementHidingClass)) timer.classList.add(elementHidingClass);
        }
    };
    var formatNumber = function formatNumber(num) {
        return "".concat(num > 9 ? "" : "0").concat(num);
    };
    var timers = document.querySelectorAll("[data-countdown-timer]");
    timers.forEach(function(timer) {
        var difference = Number(timer.dataset.difference);
        var daysNumber = timer.querySelector('[data-countdown-number][data-type="days"]');
        var hoursNumber = timer.querySelector('[data-countdown-number][data-type="hours"]');
        var minutesNumber = timer.querySelector('[data-countdown-number][data-type="minutes"]');
        var secondsNumber = timer.querySelector('[data-countdown-number][data-type="seconds"]');
        var removeZeroElements = timer.hasAttribute("data-remove-zero-elements");
        if (!(daysNumber && hoursNumber && minutesNumber && secondsNumber && !isNaN(difference) && difference > 0)) return;
        var timerParts = {
            daysNumber: daysNumber,
            hoursNumber: hoursNumber,
            minutesNumber: minutesNumber,
            secondsNumber: secondsNumber
        };
        var secondsLeft = difference;
        updateTimer(timer, timerParts, secondsLeft, removeZeroElements);
        var interval = setInterval(function() {
            secondsLeft -= 1;
            if (secondsLeft < 0) {
                clearInterval(interval);
                return;
            }
            updateTimer(timer, timerParts, secondsLeft, removeZeroElements);
        }, 1000);
    });
})();

},{}],"2f8U0":[function(require,module,exports) {
(function() {
    var _window_navigator, _window_navigator_userAgentData;
    var os = "unknown";
    var userAgent = window.navigator.userAgent;
    var platform = ((_window_navigator = window.navigator) === null || _window_navigator === void 0 ? void 0 : (_window_navigator_userAgentData = _window_navigator.userAgentData) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform;
    var macosPlatforms = [
        "Macintosh",
        "MacIntel",
        "MacPPC",
        "Mac68K",
        "Mac OS X",
        "macOS"
    ];
    var windowsPlatforms = [
        "Win32",
        "Win64",
        "Windows",
        "WinCE"
    ];
    var iosPlatforms = [
        "iPhone",
        "iPad",
        "iPod",
        "iOS"
    ];
    if (macosPlatforms.indexOf(platform) !== -1) os = "mac";
    else if (iosPlatforms.indexOf(platform) !== -1) os = "ios";
    else if (windowsPlatforms.indexOf(platform) !== -1) os = "windows";
    else if (/Android/.test(userAgent)) os = "android";
    else if (/Linux/.test(platform)) os = "linux";
    document.body.classList.add("os-".concat(os));
})();

},{}],"5egIY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _preact = require("preact");
var _preactDefault = parcelHelpers.interopDefault(_preact);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _productCollection = require("./components/ProductCollection");
var _productCollectionDefault = parcelHelpers.interopDefault(_productCollection);
function initProductCollection() {
    var parent = document.querySelector((0, _configDefault.default).queries.productGridParent);
    if (!parent) return;
    (0, _preact.render)(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _productCollectionDefault.default), {}), parent);
}
document.addEventListener("DOMContentLoaded", initProductCollection);

},{"react/jsx-runtime":"ebSqZ","preact":"fiBpF","./config":"1C44m","./components/ProductCollection":"5UpZn","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"ebSqZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Fragment", function() {
    return 0, _preact.Fragment;
});
parcelHelpers.export(exports, "jsx", function() {
    return o;
});
parcelHelpers.export(exports, "jsxDEV", function() {
    return o;
});
parcelHelpers.export(exports, "jsxs", function() {
    return o;
});
var _preact = require("preact");
var _ = 0;
function o(o, e, n, t, f) {
    var l, s, u = {};
    for(s in e)"ref" == s ? l = e[s] : u[s] = e[s];
    var a = {
        type: o,
        props: u,
        key: n,
        ref: l,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: --_,
        __source: f,
        __self: t
    };
    if ("function" == typeof o && (l = o.defaultProps)) for(s in l)void 0 === u[s] && (u[s] = l[s]);
    return (0, _preact.options).vnode && (0, _preact.options).vnode(a), a;
}

},{"preact":"fiBpF","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"fiBpF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Component", function() {
    return d;
});
parcelHelpers.export(exports, "Fragment", function() {
    return p;
});
parcelHelpers.export(exports, "cloneElement", function() {
    return q;
});
parcelHelpers.export(exports, "createContext", function() {
    return B;
});
parcelHelpers.export(exports, "createElement", function() {
    return h;
});
parcelHelpers.export(exports, "createRef", function() {
    return y;
});
parcelHelpers.export(exports, "h", function() {
    return h;
});
parcelHelpers.export(exports, "hydrate", function() {
    return S;
});
parcelHelpers.export(exports, "isValidElement", function() {
    return i;
});
parcelHelpers.export(exports, "options", function() {
    return l;
});
parcelHelpers.export(exports, "render", function() {
    return P;
});
parcelHelpers.export(exports, "toChildArray", function() {
    return x;
});
var _typeOfMjs = require("@swc/helpers/src/_type_of.mjs");
var _typeOfMjsDefault = parcelHelpers.interopDefault(_typeOfMjs);
var n, l, u, i, t, o, r, f = {}, e = [], c = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function s(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function a(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function h(l, u, i) {
    var t, o, r, f = {};
    for(r in u)"key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return v(l, f, t, o, null);
}
function v(n, i, t, o, r) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == r ? ++u : r
    };
    return null == r && null != l.vnode && l.vnode(f), f;
}
function y() {
    return {
        current: null
    };
}
function p(n) {
    return n.children;
}
function d(n, l) {
    this.props = n, this.context = l;
}
function _(n, l) {
    if (null == l) return n.__ ? _(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? _(n) : null;
}
function k(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return k(n);
    }
}
function b(n) {
    (!n.__d && (n.__d = !0) && t.push(n) && !g.__r++ || o !== l.debounceRendering) && ((o = l.debounceRendering) || setTimeout)(g);
}
function g() {
    for(var n; g.__r = t.length;)n = t.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }), t = [], n.some(function(n) {
        var l, u, i, t, o, r;
        n.__d && (o = (t = (l = n).__v).__e, (r = l.__P) && (u = [], (i = s({}, t)).__v = t.__v + 1, j(r, t, i, l.__n, void 0 !== r.ownerSVGElement, null != t.__h ? [
            o
        ] : null, u, null == o ? _(t) : o, t.__h), z(u, t), t.__e != o && k(t)));
    });
}
function w(n, l, u, i, t, o, r, c, s, a) {
    var h, y, _$d, k, b, _$g, w, x = i && i.__k || e, C = x.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (k = u.__k[h] = null == (k = l[h]) || "boolean" == typeof k ? null : "string" == typeof k || "number" == typeof k || "bigint" == (typeof k === "undefined" ? "undefined" : (0, _typeOfMjsDefault.default)(k)) ? v(null, k, null, null, k) : Array.isArray(k) ? v(p, {
        children: k
    }, null, null, null) : k.__b > 0 ? v(k.type, k.props, k.key, k.ref ? k.ref : null, k.__v) : k)) {
        if (k.__ = u, k.__b = u.__b + 1, null === (_$d = x[h]) || _$d && k.key == _$d.key && k.type === _$d.type) x[h] = void 0;
        else for(y = 0; y < C; y++){
            if ((_$d = x[y]) && k.key == _$d.key && k.type === _$d.type) {
                x[y] = void 0;
                break;
            }
            _$d = null;
        }
        j(n, k, _$d = _$d || f, t, o, r, c, s, a), b = k.__e, (y = k.ref) && _$d.ref != y && (w || (w = []), _$d.ref && w.push(_$d.ref, null, k), w.push(y, k.__c || b, k)), null != b ? (null == _$g && (_$g = b), "function" == typeof k.type && k.__k === _$d.__k ? k.__d = s = m(k, s, n) : s = A(n, k, _$d, x, b, s), "function" == typeof u.type && (u.__d = s)) : s && _$d.__e == s && s.parentNode != n && (s = _(_$d));
    }
    for(u.__e = _$g, h = C; h--;)null != x[h] && N(x[h], x[h]);
    if (w) for(h = 0; h < w.length; h++)M(w[h], w[++h], w[++h]);
}
function m(n, l, u) {
    for(var i, t = n.__k, o = 0; t && o < t.length; o++)(i = t[o]) && (i.__ = n, l = "function" == typeof i.type ? m(i, l, u) : A(u, i, i, t, i.__e, l));
    return l;
}
function x(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        x(n, l);
    }) : l.push(n)), l;
}
function A(n, l, u, i, t, o) {
    var r, f, e;
    if (void 0 !== l.__d) r = l.__d, l.__d = void 0;
    else if (null == u || t != o || null == t.parentNode) n: if (null == o || o.parentNode !== n) n.appendChild(t), r = null;
    else {
        for(f = o, e = 0; (f = f.nextSibling) && e < i.length; e += 1)if (f == t) break n;
        n.insertBefore(t, o), r = o;
    }
    return void 0 !== r ? r : t.nextSibling;
}
function C(n, l, u, i, t) {
    var o;
    for(o in u)"children" === o || "key" === o || o in l || H(n, o, null, u[o], i);
    for(o in l)t && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || H(n, o, l[o], u[o], i);
}
function $(n, l, u) {
    "-" === l[0] ? n.setProperty(l, u) : n[l] = null == u ? "" : "number" != typeof u || c.test(l) ? u : u + "px";
}
function H(n, l, u, i, t) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? i || n.addEventListener(l, o ? T : I, o) : n.removeEventListener(l, o ? T : I, o);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n1) {}
        "function" == typeof u || (null == u || !1 === u && -1 == l.indexOf("-") ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function I(n) {
    this.l[n.type + !1](l.event ? l.event(n) : n);
}
function T(n) {
    this.l[n.type + !0](l.event ? l.event(n) : n);
}
function j(n, u, i, t, o, r, f, e, c) {
    var a, h, v, y, _, k, b, _$g, m, x, A, C, $, H, I, T = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, r = [
        e
    ]), (a = l.__b) && a(u);
    try {
        n: if ("function" == typeof T) {
            if (_$g = u.props, m = (a = T.contextType) && t[a.__c], x = a ? m ? m.props.value : a.__ : t, i.__c ? b = (h = u.__c = i.__c).__ = h.__E : ("prototype" in T && T.prototype.render ? u.__c = h = new T(_$g, x) : (u.__c = h = new d(_$g, x), h.constructor = T, h.render = O), m && m.sub(h), h.props = _$g, h.state || (h.state = {}), h.context = x, h.__n = t, v = h.__d = !0, h.__h = [], h._sb = []), null == h.__s && (h.__s = h.state), null != T.getDerivedStateFromProps && (h.__s == h.state && (h.__s = s({}, h.__s)), s(h.__s, T.getDerivedStateFromProps(_$g, h.__s))), y = h.props, _ = h.state, v) null == T.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), null != h.componentDidMount && h.__h.push(h.componentDidMount);
            else {
                if (null == T.getDerivedStateFromProps && _$g !== y && null != h.componentWillReceiveProps && h.componentWillReceiveProps(_$g, x), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(_$g, h.__s, x) || u.__v === i.__v) {
                    for(h.props = _$g, h.state = h.__s, u.__v !== i.__v && (h.__d = !1), h.__v = u, u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), A = 0; A < h._sb.length; A++)h.__h.push(h._sb[A]);
                    h._sb = [], h.__h.length && f.push(h);
                    break n;
                }
                null != h.componentWillUpdate && h.componentWillUpdate(_$g, h.__s, x), null != h.componentDidUpdate && h.__h.push(function() {
                    h.componentDidUpdate(y, _, k);
                });
            }
            if (h.context = x, h.props = _$g, h.__v = u, h.__P = n, C = l.__r, $ = 0, "prototype" in T && T.prototype.render) {
                for(h.state = h.__s, h.__d = !1, C && C(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
                h._sb = [];
            } else do h.__d = !1, C && C(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
            while (h.__d && ++$ < 25);
            h.state = h.__s, null != h.getChildContext && (t = s(s({}, t), h.getChildContext())), v || null == h.getSnapshotBeforeUpdate || (k = h.getSnapshotBeforeUpdate(y, _)), I = null != a && a.type === p && null == a.key ? a.props.children : a, w(n, Array.isArray(I) ? I : [
                I
            ], u, i, t, o, r, f, e, c), h.base = u.__e, u.__h = null, h.__h.length && f.push(h), b && (h.__E = h.__ = null), h.__e = !1;
        } else null == r && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = L(i.__e, u, i, t, o, r, f, c);
        (a = l.diffed) && a(u);
    } catch (n1) {
        u.__v = null, (c || null != r) && (u.__e = e, u.__h = !!c, r[r.indexOf(e)] = null), l.__e(n1, u, i);
    }
}
function z(n, u) {
    l.__c && l.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n1) {
            l.__e(n1, u.__v);
        }
    });
}
function L(l, u, i, t, o, r, e, c) {
    var s, h, v, y = i.props, _$p = u.props, _$d = u.type, k = 0;
    if ("svg" === _$d && (o = !0), null != r) {
        for(; k < r.length; k++)if ((s = r[k]) && "setAttribute" in s == !!_$d && (_$d ? s.localName === _$d : 3 === s.nodeType)) {
            l = s, r[k] = null;
            break;
        }
    }
    if (null == l) {
        if (null === _$d) return document.createTextNode(_$p);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", _$d) : document.createElement(_$d, _$p.is && _$p), r = null, c = !1;
    }
    if (null === _$d) y === _$p || c && l.data === _$p || (l.data = _$p);
    else {
        if (r = r && n.call(l.childNodes), h = (y = i.props || f).dangerouslySetInnerHTML, v = _$p.dangerouslySetInnerHTML, !c) {
            if (null != r) for(y = {}, k = 0; k < l.attributes.length; k++)y[l.attributes[k].name] = l.attributes[k].value;
            (v || h) && (v && (h && v.__html == h.__html || v.__html === l.innerHTML) || (l.innerHTML = v && v.__html || ""));
        }
        if (C(l, _$p, y, o, c), v) u.__k = [];
        else if (k = u.props.children, w(l, Array.isArray(k) ? k : [
            k
        ], u, i, t, o && "foreignObject" !== _$d, r, e, r ? r[0] : i.__k && _(i, 0), c), null != r) for(k = r.length; k--;)null != r[k] && a(r[k]);
        c || ("value" in _$p && void 0 !== (k = _$p.value) && (k !== l.value || "progress" === _$d && !k || "option" === _$d && k !== y.value) && H(l, "value", k, y.value, !1), "checked" in _$p && void 0 !== (k = _$p.checked) && k !== l.checked && H(l, "checked", k, y.checked, !1));
    }
    return l;
}
function M(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n1) {
        l.__e(n1, i);
    }
}
function N(n, u, i) {
    var t, o;
    if (l.unmount && l.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || M(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n1) {
            l.__e(n1, u);
        }
        t.base = t.__P = null, n.__c = void 0;
    }
    if (t = n.__k) for(o = 0; o < t.length; o++)t[o] && N(t[o], u, i || "function" != typeof n.type);
    i || null == n.__e || a(n.__e), n.__ = n.__e = n.__d = void 0;
}
function O(n, l, u) {
    return this.constructor(n, u);
}
function P(u, i, t) {
    var o, r, e;
    l.__ && l.__(u, i), r = (o = "function" == typeof t) ? null : t && t.__k || i.__k, e = [], j(i, u = (!o && t || i).__k = h(p, null, [
        u
    ]), r || f, f, void 0 !== i.ownerSVGElement, !o && t ? [
        t
    ] : r ? null : i.firstChild ? n.call(i.childNodes) : null, e, !o && t ? t : r ? r.__e : i.firstChild, o), z(e, u);
}
function S(n, l) {
    P(n, l, S);
}
function q(l, u, i) {
    var t, o, r, f = s({}, l.props);
    for(r in u)"key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : i), v(l.type, f, t || l.key, o || l.ref, null);
}
function B(n, l) {
    var u = {
        __c: l = "__cC" + r++,
        __: n,
        Consumer: function Consumer(n, l) {
            return n.children(l);
        },
        Provider: function Provider(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(b);
            }, this.sub = function(n) {
                u.push(n);
                var _$l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), _$l && _$l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
n = e.slice, l = {
    __e: function __e(n, l, u, i) {
        for(var t, o, r; l = l.__;)if ((t = l.__c) && !t.__) try {
            if ((o = t.constructor) && null != o.getDerivedStateFromError && (t.setState(o.getDerivedStateFromError(n)), r = t.__d), null != t.componentDidCatch && (t.componentDidCatch(n, i || {}), r = t.__d), r) return t.__E = t;
        } catch (l1) {
            n = l1;
        }
        throw n;
    }
}, u = 0, i = function i(n) {
    return null != n && void 0 === n.constructor;
}, d.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = s({}, this.state), "function" == typeof n && (n = n(s({}, u), this.props)), n && s(u, n), null != n && this.__v && (l && this._sb.push(l), b(this));
}, d.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), b(this));
}, d.prototype.render = p, t = [], g.__r = 0, r = 0;

},{"@swc/helpers/src/_type_of.mjs":"52Yae","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"52Yae":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
}
exports.default = _typeof;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"1C44m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _window_ThemeVars;
exports.default = {
    apiUrl: "https://storefront.cdconsole.com/api/v2",
    // apiUrl: 'http://localhost:3000/api/v2',
    classes: {
        container: "collection__results",
        containerFiltersOpen: "collection__results--filters-open",
        containerMinimumColumns: "collection__results--min",
        filterForm: "filters__form",
        filterFormApplyButton: "filters__form__apply-button",
        filterFormClearButton: "filters__form__clear-button",
        filterFormExpanded: "filters__form--open",
        filterFormFieldset: "filters__form__toggle-list",
        filterFormHeader: "filters__form__header",
        filterFormInputLabel: "filters__form__toggle",
        filterFormMoreButton: "filters__form__more-button",
        filterFormTitle: "filters__form__title",
        filterFormWrapper: "filters__form-wrapper",
        gridViewToggle: "collection__results__header__toggle",
        productGrid: "products-grid",
        productGridContainer: "products-grid__container",
        productGridHeader: "collection__results__header",
        backToTopButton: "products-grid__back-to-top"
    },
    currencySymbol: window.ThemeVars.currency.symbol,
    exchangeRate: +window.Shopify.currency.rate,
    matchType: "all",
    namedTags: {
        style: "Style",
        sleevelength: "Sleeve Length",
        birth: "Birth Month"
    },
    numPriceFilters: 5,
    priceFilterRound: 10,
    queries: {
        productGridParent: "#uwpfilters"
    },
    sortOptions: {
        "": "Relevance",
        "price:asc": "Price (low-to-high)",
        "price:desc": "Price (high-to-low)",
        "title:asc": "Name (A-Z)",
        "title:desc": "Name (Z-A)",
        "published_at:asc": "Date (old-to-new)",
        "published_at:desc": "Date (new-to-old)"
    },
    themeVars: (_window_ThemeVars = window.ThemeVars) !== null && _window_ThemeVars !== void 0 ? _window_ThemeVars : {},
    collectionSettings: {
        "*": {
            hideOptions: [
                "Title"
            ]
        },
        "handbags": {
            type: false
        },
        "womens-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "curve-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "dresses-sale": {
            hideOptions: [
                "Style"
            ]
        },
        "new-in-gift-home": {
            hideOptions: [
                "Style"
            ]
        },
        "dresses-a-line": {
            hideOptions: [
                "Style"
            ]
        },
        "dresses-bodycon": {
            hideOptions: [
                "Style"
            ]
        },
        "dresses-shirt": {
            hideOptions: [
                "Style"
            ]
        },
        "dresses-skater": {
            hideOptions: [
                "Style"
            ]
        },
        "dresses-tunic": {
            hideOptions: [
                "Style"
            ]
        },
        "dresses-wrap": {
            hideOptions: [
                "Style"
            ]
        },
        "mini-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "knee-length-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "midi-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "maxi-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "sleeveless-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "short-sleeve-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "3-4-sleeve-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "long-sleeve-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "as-seen-on-social": {
            hideOptions: [
                "Style"
            ]
        }
    }
} // [TODO] Make this configurable and pull from app/theme settings instead.
;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"5UpZn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _definePropertyMjs = require("@swc/helpers/src/_define_property.mjs");
var _definePropertyMjsDefault = parcelHelpers.interopDefault(_definePropertyMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _preact = require("preact");
var _preactDefault = parcelHelpers.interopDefault(_preact);
var _useCollectionView = require("../hooks/useCollectionView");
var _useCollectionViewDefault = parcelHelpers.interopDefault(_useCollectionView);
var _useFilterContext = require("../hooks/useFilterContext");
var _useFilterContextDefault = parcelHelpers.interopDefault(_useFilterContext);
var _filterForm = require("./FilterForm");
var _filterFormDefault = parcelHelpers.interopDefault(_filterForm);
var _productGrid = require("./ProductGrid");
var _productGridDefault = parcelHelpers.interopDefault(_productGrid);
var _collectionHeader = require("./CollectionHeader");
var _collectionHeaderDefault = parcelHelpers.interopDefault(_collectionHeader);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _config = require("../config");
var _configDefault = parcelHelpers.interopDefault(_config);
function ProductCollection() {
    var collection = getCollection();
    var search = getSearch();
    var filterContext = (0, _useFilterContextDefault.default)({
        collection: collection,
        search: search
    });
    var collectionView = (0, _useCollectionViewDefault.default)();
    var _obj;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        class: (0, _classnamesDefault.default)((_obj = {}, (0, _definePropertyMjsDefault.default)(_obj, (0, _configDefault.default).classes.container, true), (0, _definePropertyMjsDefault.default)(_obj, (0, _configDefault.default).classes.containerFiltersOpen, collectionView.expanded), (0, _definePropertyMjsDefault.default)(_obj, (0, _configDefault.default).classes.containerMinimumColumns, collectionView.minColumns), _obj)),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collectionHeaderDefault.default), {
                collectionView: collectionView,
                filterContext: filterContext
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterFormDefault.default), {
                filterContext: filterContext,
                collectionView: collectionView
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _productGridDefault.default), {
                filterContext: filterContext,
                collectionView: collectionView
            })
        ]
    });
}
exports.default = ProductCollection;
function getCollection() {
    var _window_location_pathname_match;
    var rx = /^\/collections\/(?:.+\/)*(?!all\b)([^\/]+)\/?$/;
    var _window_location_pathname_match_;
    // Matches the final path in a /collections URL except "all", ignoring parents.
    // e.g.
    //  /collections/dresses = 'dresses'
    //  /collections/all/dresses = 'dresses'
    //  /collections/dresses/mini-dresses = 'mini-dresses'
    //  /collections/all = null
    //                             --GAD
    var collection = (_window_location_pathname_match_ = (_window_location_pathname_match = window.location.pathname.match(rx)) === null || _window_location_pathname_match === void 0 ? void 0 : _window_location_pathname_match[1]) !== null && _window_location_pathname_match_ !== void 0 ? _window_location_pathname_match_ : null;
    return collection;
}
function getSearch() {
    var usp = new URLSearchParams(window.location.search);
    // Previously we appended a search param to the /collections/all page to render a search,
    // e.g. /collections/all?search=xyz. We will continue to support this here, in case a
    // user has bookmarked a search page. --GAD
    if (/^\/collections/.test(window.location.pathname)) return usp.get("search");
    if (/^\/search/.test(window.location.pathname)) return usp.get("q");
    return null;
}

},{"@swc/helpers/src/_define_property.mjs":"eI7TS","react/jsx-runtime":"ebSqZ","preact":"fiBpF","../hooks/useCollectionView":"4AsEo","../hooks/useFilterContext":"fnKMK","./FilterForm":"khrlc","./ProductGrid":"6tpxS","./CollectionHeader":"6KiBe","classnames":"dEqmu","../config":"1C44m","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"4AsEo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _hooks = require("preact/hooks");
function useCollectionView() {
    var _useState = (0, _slicedToArrayMjsDefault.default)((0, _hooks.useState)(false), 2), minColumns = _useState[0], setMinColumns = _useState[1];
    var _useState1 = (0, _slicedToArrayMjsDefault.default)((0, _hooks.useState)(false), 2), expanded = _useState1[0], setExpanded = _useState1[1];
    var toggleExpanded = (0, _hooks.useCallback)(function() {
        return setExpanded(!expanded);
    }, [
        expanded
    ]);
    return (0, _hooks.useMemo)(function() {
        return {
            expanded: expanded,
            toggleExpanded: toggleExpanded,
            minColumns: minColumns,
            setMinColumns: setMinColumns
        };
    }, [
        minColumns,
        setMinColumns,
        expanded,
        toggleExpanded
    ]);
}
exports.default = useCollectionView;

},{"@swc/helpers/src/_sliced_to_array.mjs":"l34hS","preact/hooks":"fdDeA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"fdDeA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCallback", function() {
    return T;
});
parcelHelpers.export(exports, "useContext", function() {
    return q;
});
parcelHelpers.export(exports, "useDebugValue", function() {
    return x;
});
parcelHelpers.export(exports, "useEffect", function() {
    return h;
});
parcelHelpers.export(exports, "useErrorBoundary", function() {
    return P;
});
parcelHelpers.export(exports, "useId", function() {
    return V;
});
parcelHelpers.export(exports, "useImperativeHandle", function() {
    return A;
});
parcelHelpers.export(exports, "useLayoutEffect", function() {
    return s;
});
parcelHelpers.export(exports, "useMemo", function() {
    return F;
});
parcelHelpers.export(exports, "useReducer", function() {
    return y;
});
parcelHelpers.export(exports, "useRef", function() {
    return _;
});
parcelHelpers.export(exports, "useState", function() {
    return p;
});
var _preact = require("preact");
var t, r, u, i, o = 0, f = [], c = [], e = (0, _preact.options).__b, a = (0, _preact.options).__r, v = (0, _preact.options).diffed, l = (0, _preact.options).__c, m = (0, _preact.options).unmount;
function d(t, u) {
    (0, _preact.options).__h && (0, _preact.options).__h(r, t, o || u), o = 0;
    var i = r.__H || (r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: c
    }), i.__[t];
}
function p(n) {
    return o = 1, y(B, n);
}
function y(n, u, i) {
    var o = d(t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : B(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = r, !r.u)) {
        r.u = !0;
        var f = r.shouldComponentUpdate;
        r.shouldComponentUpdate = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var _$u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (_$u.every(function(n) {
                return !n.__N;
            })) return !f || f.call(this, n, t, r);
            var _$i = !1;
            return _$u.forEach(function(n) {
                if (n.__N) {
                    var _$t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, _$t !== n.__[0] && (_$i = !0);
                }
            }), !(!_$i && o.__c.props === n) && (!f || f.call(this, n, t, r));
        };
    }
    return o.__N || o.__;
}
function h(u, i) {
    var o = d(t++, 3);
    !(0, _preact.options).__s && z(o.__H, i) && (o.__ = u, o.i = i, r.__H.__h.push(o));
}
function s(u, i) {
    var o = d(t++, 4);
    !(0, _preact.options).__s && z(o.__H, i) && (o.__ = u, o.i = i, r.__h.push(o));
}
function _(n) {
    return o = 5, F(function() {
        return {
            current: n
        };
    }, []);
}
function A(n, t, r) {
    o = 6, s(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function F(n, r) {
    var u = d(t++, 7);
    return z(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function T(n, t) {
    return o = 8, F(function() {
        return n;
    }, t);
}
function q(n) {
    var u = r.context[n.__c], i = d(t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub(r)), u.props.value) : n.__;
}
function x(t, r) {
    (0, _preact.options).useDebugValue && (0, _preact.options).useDebugValue(r ? r(t) : t);
}
function P(n) {
    var u = d(t++, 10), i = p();
    return u.__ = n, r.componentDidCatch || (r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function V() {
    var _$n = d(t++, 11);
    if (!_$n.__) {
        for(var u = r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        _$n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return _$n.__;
}
function b() {
    for(var t; t = f.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach(k), t.__H.__h.forEach(w), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], (0, _preact.options).__e(r, t.__v);
    }
}
(0, _preact.options).__b = function(n) {
    r = null, e && e(n);
}, (0, _preact.options).__r = function(n) {
    a && a(n), t = 0;
    var i = (r = n.__c).__H;
    i && (u === r ? (i.__h = [], r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = c, n.__N = n.i = void 0;
    })) : (i.__h.forEach(k), i.__h.forEach(w), i.__h = [])), u = r;
}, (0, _preact.options).diffed = function(t) {
    v && v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== f.push(o) && i === (0, _preact.options).requestAnimationFrame || ((i = (0, _preact.options).requestAnimationFrame) || j)(b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== c && (n.__ = n.__V), n.i = void 0, n.__V = c;
    })), u = r = null;
}, (0, _preact.options).__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach(k), t.__h = t.__h.filter(function(n) {
                return !n.__ || w(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], (0, _preact.options).__e(u, t.__v);
        }
    }), l && l(t, r);
}, (0, _preact.options).unmount = function(t) {
    m && m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            k(n);
        } catch (n1) {
            r = n1;
        }
    }), u.__H = void 0, r && (0, _preact.options).__e(r, u.__v));
};
var g = "function" == typeof requestAnimationFrame;
function j(n) {
    var t, r = function r() {
        clearTimeout(u), g && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    g && (t = requestAnimationFrame(r));
}
function k(n) {
    var t = r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), r = t;
}
function w(n) {
    var t = r;
    n.__c = n.__(), r = t;
}
function z(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function B(n, t) {
    return "function" == typeof t ? t(n) : t;
}

},{"preact":"fiBpF","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"fnKMK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGeneratorMjs = require("@swc/helpers/src/_async_to_generator.mjs");
var _asyncToGeneratorMjsDefault = parcelHelpers.interopDefault(_asyncToGeneratorMjs);
var _definePropertyMjs = require("@swc/helpers/src/_define_property.mjs");
var _definePropertyMjsDefault = parcelHelpers.interopDefault(_definePropertyMjs);
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _objectWithoutPropertiesMjs = require("@swc/helpers/src/_object_without_properties.mjs");
var _objectWithoutPropertiesMjsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesMjs);
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _toConsumableArrayMjs = require("@swc/helpers/src/_to_consumable_array.mjs");
var _toConsumableArrayMjsDefault = parcelHelpers.interopDefault(_toConsumableArrayMjs);
var _tsGeneratorMjs = require("@swc/helpers/src/_ts_generator.mjs");
var _tsGeneratorMjsDefault = parcelHelpers.interopDefault(_tsGeneratorMjs);
var _hooks = require("preact/hooks");
var _fetch = require("../fetch");
var _config = require("../config");
var _configDefault = parcelHelpers.interopDefault(_config);
var defaultSettings = {
    type: true
};
function useFilterContext(param) {
    var collection = param.collection, search = param.search;
    var _useState = (0, _slicedToArrayMjsDefault.default)((0, _hooks.useState)(null), 2), availableFilters = _useState[0], setAvailableFilters = _useState[1];
    var _useState1 = (0, _slicedToArrayMjsDefault.default)((0, _hooks.useState)({}), 2), filterValues = _useState1[0], setFilterValues = _useState1[1];
    var _useState2 = (0, _slicedToArrayMjsDefault.default)((0, _hooks.useState)(null), 2), results = _useState2[0], setResults = _useState2[1];
    var _useState3 = (0, _slicedToArrayMjsDefault.default)((0, _hooks.useState)(1), 2), statePage = _useState3[0], setPage = _useState3[1];
    var _useState4 = (0, _slicedToArrayMjsDefault.default)((0, _hooks.useState)(null), 2), count = _useState4[0], setCount = _useState4[1];
    var _useState5 = (0, _slicedToArrayMjsDefault.default)((0, _hooks.useState)(true), 2), hasNextPage = _useState5[0], setHasNextPage = _useState5[1];
    var _useState6 = (0, _slicedToArrayMjsDefault.default)((0, _hooks.useState)(null), 2), cursor = _useState6[0], setCursor = _useState6[1];
    var _config_collectionSettings_collection;
    // console.log('Filter Values', filterValues)
    // console.log('PAGE', statePage)
    var settings = (_config_collectionSettings_collection = (0, _configDefault.default).collectionSettings[collection]) !== null && _config_collectionSettings_collection !== void 0 ? _config_collectionSettings_collection : defaultSettings;
    var _filterValues_, _availableFilters_map;
    var filtersWithValues = (_availableFilters_map = availableFilters === null || availableFilters === void 0 ? void 0 : availableFilters.map(function(filter) {
        return (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, filter), {
            values: (_filterValues_ = filterValues[filter.key + filter.operator]) !== null && _filterValues_ !== void 0 ? _filterValues_ : [],
            setValues: function(values) {
                return setFilterValues((0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, filterValues), (0, _definePropertyMjsDefault.default)({}, filter.key + filter.operator, values)));
            }
        });
    })) !== null && _availableFilters_map !== void 0 ? _availableFilters_map : null;
    (0, _hooks.useEffect)(function() {
        // Reset pagination if the collection, search, filterValues is changed.
        setHasNextPage(true);
        setCursor(null);
        setPage(1);
        var queryString = filtersToQueryString(filtersWithValues, collection, search);
        applyFilters(queryString, true, null);
    }, [
        collection,
        search,
        filterValues
    ]);
    // Refresh when the page number changes
    (0, _hooks.useEffect)(function() {
        var queryString = filtersToQueryString(filtersWithValues, collection, search);
        applyFilters(queryString, hasNextPage, statePage);
    }, [
        statePage
    ]);
    var applyFilters = function() {
        var _ref = (0, _asyncToGeneratorMjsDefault.default)(function(queryString, hasNextPage, page) {
            var _ref, products, meta, pageInfo, count, filters, err;
            return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log("HAS NEXT PAGE", hasNextPage);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (!queryString) return [
                            2
                        ];
                        if (!hasNextPage) return [
                            2
                        ];
                        return [
                            4,
                            (0, _fetch.filterFetch)("/products?".concat(queryString !== null && queryString !== void 0 ? queryString : "").concat(page ? "&page=".concat(page) : ""))
                        ];
                    case 2:
                        _ref = _state.sent(), products = _ref.products, meta = _ref.meta, pageInfo = _ref.pageInfo, count = _ref.count;
                        setResults(function(existingResults) {
                            return statePage === 1 || !existingResults ? products : (0, _toConsumableArrayMjsDefault.default)(existingResults).concat((0, _toConsumableArrayMjsDefault.default)(products));
                        });
                        setCount(meta.count);
                        filters = parseFiltersMeta(meta, settings, !!search);
                        setAvailableFilters(filters);
                        setHasNextPage(pageInfo.hasNextPage);
                        setCursor(pageInfo.endCursor);
                        setCount(count);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        console.error(err);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function applyFilters(queryString, hasNextPage, page) {
            return _ref.apply(this, arguments);
        };
    }();
    var incrementPage = (0, _hooks.useCallback)(function() {
        console.log("incrementing page");
        setPage(function(page) {
            return page + 1;
        });
    }, []);
    var reset = (0, _hooks.useCallback)(function() {
        setFilterValues({});
    }, [
        availableFilters
    ]);
    return {
        collection: collection,
        count: count,
        filters: filtersWithValues,
        incrementPage: incrementPage,
        reset: reset,
        results: results,
        search: search
    };
}
exports.default = useFilterContext;
function filtersToQueryString(filters, collection, search) {
    var query = new URLSearchParams();
    // Need to build this manually, as W3C and Express disagree on arrays. --GAD
    if (collection) query.append("collection", collection);
    if (search) query.append("search", search);
    filters === null || filters === void 0 ? void 0 : filters.forEach(function(filter) {
        var key = filter.key + filter.operator;
        filter.values.forEach(function(val) {
            return isTruthyOrZero(val) && query.append(key, String(val));
        });
    });
    var _config_matchType;
    query.append("match", (_config_matchType = (0, _configDefault.default).matchType) !== null && _config_matchType !== void 0 ? _config_matchType : "any");
    return query.toString();
}
function parseFiltersMeta(meta, settings, isSearch) {
    var options = meta.options, tags = meta.tags, vendors = meta.vendors, types = meta.types, prices = meta.prices;
    var isSearchPage = window.location.pathname.includes("search");
    if (isSearchPage) {
        var _config_sortOptions, _config_sortOptions1, _config_sortOptions2;
        ((_config_sortOptions = (0, _configDefault.default).sortOptions) === null || _config_sortOptions === void 0 ? void 0 : _config_sortOptions["title:asc"]) && delete (0, _configDefault.default).sortOptions["title:asc"];
        ((_config_sortOptions1 = (0, _configDefault.default).sortOptions) === null || _config_sortOptions1 === void 0 ? void 0 : _config_sortOptions1["title:desc"]) && delete (0, _configDefault.default).sortOptions["title:desc"];
        ((_config_sortOptions2 = (0, _configDefault.default).sortOptions) === null || _config_sortOptions2 === void 0 ? void 0 : _config_sortOptions2["published_at:asc"]) && delete (0, _configDefault.default).sortOptions["published_at:asc"];
    }
    var sortOptions = {
        category: "Sort by",
        key: "sort",
        operator: "",
        type: "sort",
        options: Object.entries((0, _configDefault.default).sortOptions).map(function(param) {
            var _param = (0, _slicedToArrayMjsDefault.default)(param, 2), value = _param[0], label = _param[1];
            return {
                label: label,
                value: value
            };
        })
    };
    var vendorFilters = {
        category: "Brand",
        key: "vendor",
        operator: "",
        multiple: !isSearch,
        type: "attribute",
        options: vendors.map(function(vendor) {
            return {
                label: vendor,
                value: vendor
            };
        })
    };
    var typeFilters = {
        category: "Type",
        key: "type",
        multiple: !isSearch,
        operator: "",
        type: "attribute",
        options: settings.type ? types.map(function(type) {
            return {
                label: type,
                value: type
            };
        }) : []
    };
    var tagCategories = tags.map(function(tag) {
        var tagCategory = tag.label;
        var tagValue = tag.value; // Assuming the value is stored in the value property
        var tagName = (0, _configDefault.default).namedTags[tagCategory];
        if (!tagName) return null;
        return {
            category: tagName,
            label: tagValue,
            value: tag.label
        };
    }).filter(function(t) {
        return !!t;
    }).sort(sortLabelsAlphaNum).reduce(splitByCategory, {});
    var tagFilters = Object.entries(tagCategories).map(function(param) {
        var _param = (0, _slicedToArrayMjsDefault.default)(param, 2), category = _param[0], options = _param[1];
        return {
            category: category,
            key: "tag",
            operator: "",
            multiple: !isSearch,
            type: "tag",
            options: options,
            values: []
        };
    });
    var optionCategories = options.filter(function(option) {
        var _settings_hideOptions;
        return option && !(0, _configDefault.default).collectionSettings["*"].hideOptions.includes(option.name) && !((_settings_hideOptions = settings.hideOptions) === null || _settings_hideOptions === void 0 ? void 0 : _settings_hideOptions.includes(option.name));
    }).map(function(option) {
        return option.values.map(function(value) {
            return {
                category: option.name,
                label: value.label,
                value: value,
                count: option
            };
        }).sort(sortLabelsAlphaNum);
    }).flat().reduce(splitByCategory, {});
    var optionFilters = Object.entries(optionCategories).map(function(param) {
        var _param = (0, _slicedToArrayMjsDefault.default)(param, 2), category = _param[0], options = _param[1];
        return {
            category: category,
            key: "option:".concat(category),
            operator: "",
            type: "option",
            multiple: !isSearch,
            options: options,
            values: []
        };
    });
    var priceFloor = Math.floor(+prices.min);
    var priceCeil = Math.ceil(+prices.max);
    var priceFilters = [
        {
            category: "Price",
            key: "price",
            operator: "<",
            type: "attribute",
            min: priceFloor,
            max: priceCeil,
            options: []
        },
        {
            category: "Price",
            key: "price",
            operator: ">",
            type: "attribute",
            min: priceFloor,
            max: priceCeil,
            options: []
        }
    ];
    var filters = [
        sortOptions
    ].concat((0, _toConsumableArrayMjsDefault.default)((0, _toConsumableArrayMjsDefault.default)(optionFilters).concat((0, _toConsumableArrayMjsDefault.default)(tagFilters), [
        typeFilters,
        vendorFilters
    ], (0, _toConsumableArrayMjsDefault.default)(priceFilters)).sort(function(o1, o2) {
        return o1.category > o2.category ? 1 : -1;
    })));
    return filters;
}
function sortLabelsAlphaNum(o1, o2) {
    if (isNaN(+(o1.label + o2.label))) return o1.label > o2.label ? 1 : -1;
    return +o1.label > +o2.label ? 1 : -1;
}
function splitByCategory() {
    var acc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, current = arguments.length > 1 ? arguments[1] : void 0;
    if (!current) return acc;
    var category = current.category, rest = (0, _objectWithoutPropertiesMjsDefault.default)(current, [
        "category"
    ]);
    var _acc_category;
    return (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, acc), (0, _definePropertyMjsDefault.default)({}, category, (0, _toConsumableArrayMjsDefault.default)((_acc_category = acc[category]) !== null && _acc_category !== void 0 ? _acc_category : []).concat([
        rest
    ])));
}
function isTruthyOrZero(value) {
    return value === 0 || !!value;
}

},{"@swc/helpers/src/_async_to_generator.mjs":"7nC9G","@swc/helpers/src/_define_property.mjs":"eI7TS","@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","@swc/helpers/src/_object_without_properties.mjs":"d0eOZ","@swc/helpers/src/_sliced_to_array.mjs":"l34hS","@swc/helpers/src/_to_consumable_array.mjs":"11hUU","@swc/helpers/src/_ts_generator.mjs":"cT4KU","preact/hooks":"fdDeA","../fetch":"jpCid","../config":"1C44m","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"ia8HR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
exports.default = _objectSpreadProps;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"d0eOZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLooseMjs = require("./_object_without_properties_loose.mjs");
var _objectWithoutPropertiesLooseMjsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLooseMjs);
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = (0, _objectWithoutPropertiesLooseMjsDefault.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
exports.default = _objectWithoutProperties;

},{"./_object_without_properties_loose.mjs":"4ufyG","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"4ufyG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
exports.default = _objectWithoutPropertiesLoose;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"11hUU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayWithoutHolesMjs = require("./_array_without_holes.mjs");
var _arrayWithoutHolesMjsDefault = parcelHelpers.interopDefault(_arrayWithoutHolesMjs);
var _iterableToArrayMjs = require("./_iterable_to_array.mjs");
var _iterableToArrayMjsDefault = parcelHelpers.interopDefault(_iterableToArrayMjs);
var _nonIterableSpreadMjs = require("./_non_iterable_spread.mjs");
var _nonIterableSpreadMjsDefault = parcelHelpers.interopDefault(_nonIterableSpreadMjs);
var _unsupportedIterableToArrayMjs = require("./_unsupported_iterable_to_array.mjs");
var _unsupportedIterableToArrayMjsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayMjs);
function _toConsumableArray(arr) {
    return (0, _arrayWithoutHolesMjsDefault.default)(arr) || (0, _iterableToArrayMjsDefault.default)(arr) || (0, _unsupportedIterableToArrayMjsDefault.default)(arr) || (0, _nonIterableSpreadMjsDefault.default)();
}
exports.default = _toConsumableArray;

},{"./_array_without_holes.mjs":"3s2Mw","./_iterable_to_array.mjs":"dgYS2","./_non_iterable_spread.mjs":"kXOBN","./_unsupported_iterable_to_array.mjs":"gLmrA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"3s2Mw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayLikeToArrayMjs = require("./_array_like_to_array.mjs");
var _arrayLikeToArrayMjsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayMjs);
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return (0, _arrayLikeToArrayMjsDefault.default)(arr);
}
exports.default = _arrayWithoutHoles;

},{"./_array_like_to_array.mjs":"hHqRn","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"kXOBN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
exports.default = _nonIterableSpread;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"jpCid":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterFetch", function() {
    return filterFetch;
});
parcelHelpers.export(exports, "cancelPendingFetch", function() {
    return cancelPendingFetch;
});
var _asyncToGeneratorMjs = require("@swc/helpers/src/_async_to_generator.mjs");
var _asyncToGeneratorMjsDefault = parcelHelpers.interopDefault(_asyncToGeneratorMjs);
var _tsGeneratorMjs = require("@swc/helpers/src/_ts_generator.mjs");
var _tsGeneratorMjsDefault = parcelHelpers.interopDefault(_tsGeneratorMjs);
var _shopify = require("./shopify");
var searchController = new AbortController();
var fetchPromise = null; // Promise to store the result
function filterFetch(url) {
    return _filterFetch.apply(this, arguments);
}
function _filterFetch() {
    _filterFetch = (0, _asyncToGeneratorMjsDefault.default)(function(url) {
        var params;
        var _arguments = arguments;
        return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
            params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
            // [NOTE] Don't refactor searchController to be set here - this will prevent us from
            // cancelling simultaneous requests.
            // check + return for existing fetch if already running
            if (fetchPromise) return [
                2,
                fetchPromise
            ];
            // create new fetch promise
            fetchPromise = (0, _asyncToGeneratorMjsDefault.default)(function() {
                var responseFromShopify;
                return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                ,
                                2,
                                3
                            ]);
                            return [
                                4,
                                (0, _shopify.getAllProductsFromShopify)(url, params)
                            ];
                        case 1:
                            responseFromShopify = _state.sent();
                            return [
                                2,
                                responseFromShopify
                            ];
                        case 2:
                            fetchPromise = null; // clear promise after completion
                            return [
                                7
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
            return [
                2,
                fetchPromise
            ];
        });
    });
    return _filterFetch.apply(this, arguments);
}
function cancelPendingFetch() {
    searchController === null || searchController === void 0 ? void 0 : searchController.abort();
    searchController = new AbortController();
}
function parseError(res) {
    return _parseError.apply(this, arguments);
}
function _parseError() {
    _parseError = (0, _asyncToGeneratorMjsDefault.default)(function(res) {
        var _res_headers_get, json, _json_error;
        return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!((_res_headers_get = res.headers.get("content-type")) === null || _res_headers_get === void 0 ? void 0 : _res_headers_get.startsWith("application/json"))) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        res.json()
                    ];
                case 1:
                    json = _state.sent();
                    return [
                        2,
                        (_json_error = json.error) !== null && _json_error !== void 0 ? _json_error : json
                    ];
                case 2:
                    return [
                        4,
                        res.text()
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return _parseError.apply(this, arguments);
}

},{"@swc/helpers/src/_async_to_generator.mjs":"7nC9G","@swc/helpers/src/_ts_generator.mjs":"cT4KU","./shopify":"30egH","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"30egH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStorefrontApiUrl", function() {
    return getStorefrontApiUrl;
});
parcelHelpers.export(exports, "getPublicTokenHeaders", function() {
    return getPublicTokenHeaders;
});
parcelHelpers.export(exports, "getAllProductsFromShopify", function() {
    return getAllProductsFromShopify;
});
parcelHelpers.export(exports, "convertShopifyProductToApiProduct", function() {
    return convertShopifyProductToApiProduct;
});
parcelHelpers.export(exports, "convertSectionProductToApiProduct", function() {
    return convertSectionProductToApiProduct;
});
parcelHelpers.export(exports, "convertShopifyFiltersToApiFilters", function() {
    return convertShopifyFiltersToApiFilters;
});
parcelHelpers.export(exports, "convertSectionFiltersToApiFilters", function() {
    return convertSectionFiltersToApiFilters;
});
var _asyncToGeneratorMjs = require("@swc/helpers/src/_async_to_generator.mjs");
var _asyncToGeneratorMjsDefault = parcelHelpers.interopDefault(_asyncToGeneratorMjs);
var _tsGeneratorMjs = require("@swc/helpers/src/_ts_generator.mjs");
var _tsGeneratorMjsDefault = parcelHelpers.interopDefault(_tsGeneratorMjs);
var _hydrogenReact = require("@shopify/hydrogen-react");
var storefrontParams = {
    storefrontAccessToken: "f8a75d98d3f83b7e1faa22dcd0e7e60b",
    domain: "carraigdonn.myshopify.com"
};
var shopify = (0, _hydrogenReact.createStorefrontClient)({
    publicStorefrontToken: storefrontParams.storefrontAccessToken,
    storeDomain: storefrontParams.domain,
    storefrontApiVersion: "2023-07",
    contentType: "graphql"
});
var getStorefrontApiUrl = shopify.getStorefrontApiUrl;
var getPublicTokenHeaders = shopify.getPublicTokenHeaders;
var getSortKey = function(sort, isSearch) {
    switch(sort){
        case "published_at:asc":
            return "CREATED";
        case "published_at:desc":
            return "CREATED";
        case "price:asc":
            return "PRICE";
        case "price:desc":
            return "PRICE";
        case "title:asc":
            return "TITLE";
        case "title:desc":
            return "TITLE";
        case "best-selling":
            return "BEST_SELLING";
        case "relevance":
            return "RELEVANCE";
        default:
            return isSearch ? "RELEVANCE" : "CREATED";
    }
};
var getSortKeyForQuery = function(sort) {
    switch(sort){
        case "published_at:asc":
            return "created-ascending";
        case "published_at:desc":
            return "created-descending";
        case "price:asc":
            return "price-ascending";
        case "price:desc":
            return "price-descending";
        case "title:asc":
            return "title-ascending";
        case "title:desc":
            return "title-descending";
        case "best-selling":
            return "best-selling";
        case "relevance":
            return "relevance";
        default:
            return "relevance";
    }
};
function getAllProductsFromShopify(url) {
    return _getAllProductsFromShopify.apply(this, arguments);
}
function _getAllProductsFromShopify() {
    _getAllProductsFromShopify = (0, _asyncToGeneratorMjsDefault.default)(function(url) {
        var params, queries, filters, page, search, sort, collection, tag, vendor, type, priceFilter, options, tagsFragment, vendorsFragment, typesFragment, optionsFragment, priceFragment, sortKey, direction, optionQuery, vendorQuery, tagsQuery, typesQuery, priceQuery, sortQuery, pageQuery, replaceWhitespaceAndAmpersand, constructProductsUrl, productsUrl, isSearchPage, filteredProductsResponse, filteredProductsText, filteredProductsString, filteredProducts, apiFilters, checkedValue, allProductsFromSectionApi, sortByButtons, defaultSortOption, sortProductsByPublishedAt, error;
        var _arguments = arguments;
        return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    queries = new URLSearchParams(url.split("?")[1]);
                    filters = {};
                    queries.forEach(function(value, key) {
                        if (filters[key]) {
                            if (Array.isArray(filters[key])) filters[key].push(value);
                            else filters[key] = [
                                filters[key],
                                value
                            ];
                        } else filters[key] = value;
                    });
                    page = filters.page, search = filters.search, sort = filters.sort, collection = filters.collection, tag = filters.tag, vendor = filters.vendor, type = filters.type;
                    priceFilter = {
                        max: filters["price<"] || 1000000000,
                        min: filters["price>"] || 0
                    };
                    options = Object.keys(filters).filter(function(key) {
                        return key.startsWith("option:");
                    }).map(function(key) {
                        return {
                            name: key.split(":")[1],
                            value: filters[key]
                        };
                    });
                    tagsFragment = function(tags) {
                        var fragment = "";
                        if (!tags) return "";
                        if ((tags === null || tags === void 0 ? void 0 : tags.length) === 0) return "";
                        tags.map(function(tag) {
                            search ? fragment += '\n            tag: "'.concat(tag, '",\n            ') : fragment += '\n            {\n                tag: "'.concat(tag, '"\n            },\n            ');
                        });
                        return fragment;
                    };
                    vendorsFragment = function(vendors) {
                        var fragment = "";
                        if (!vendors) return "";
                        if ((vendors === null || vendors === void 0 ? void 0 : vendors.length) === 0) return "";
                        vendors.map(function(vendor) {
                            search ? fragment += '\n                productVendor: "'.concat(vendor, '",\n                ') : fragment += '\n                {\n                    productVendor: "'.concat(vendor, '"\n                },\n                ');
                        });
                        return fragment;
                    };
                    typesFragment = function(types) {
                        var fragment = "";
                        if (!types) return "";
                        if ((types === null || types === void 0 ? void 0 : types.length) === 0) return "";
                        types.map(function(type) {
                            search ? fragment += '\n                productType: "'.concat(type, '",\n                ') : fragment += '\n                {\n                    productType: "'.concat(type, '"\n                },\n                ');
                        });
                        return fragment;
                    };
                    optionsFragment = function(options) {
                        var fragment = "";
                        if (!options) return "";
                        if ((options === null || options === void 0 ? void 0 : options.length) === 0) return "";
                        options.map(function(option) {
                            Array.isArray(option.value) ? option.value.map(function(value) {
                                search ? fragment += '\n                    variantOption: {\n                        name: "'.concat(option.name, '"\n                        value: "').concat(value, '"\n                    },\n                    ') : fragment += '\n                    {\n                        variantOption: {\n                            name: "'.concat(option.name, '"\n                            value: "').concat(value, '"\n                        }\n                    },\n                    ');
                            }) : search ? fragment += '\n                variantOption: {\n                    name: "'.concat(option.name, '"\n                    value: "').concat(option.value, '"\n                },\n                ') : fragment += '\n                {\n                    variantOption: {\n                        name: "'.concat(option.name, '"\n                        value: "').concat(option.value, '"\n                    }\n                },\n                ');
                        });
                        return fragment;
                    };
                    priceFragment = function(price) {
                        var fragment = "";
                        if (!price) return "";
                        if ((price === null || price === void 0 ? void 0 : price.min) === 0 && (price === null || price === void 0 ? void 0 : price.max) === 0) return "";
                        search ? fragment += "\n        price: {\n            min: ".concat(price.min, ",\n            max: ").concat(price.max, "\n        },\n        ") : fragment += "\n        {\n            price: {\n                min: ".concat(price.min, "\n                max: ").concat(price.max, "\n            }\n        },\n        ");
                        return fragment;
                    };
                    sortKey = search ? getSortKey(sort, true) : getSortKey(sort);
                    direction = sort ? sort.split(":")[1] === "desc" : true;
                    optionQuery = function(option) {
                        if (!option) return "";
                        var optionQuery = "";
                        var valuesLength = option.value.length - 1;
                        // console.log('option values', option.value)
                        Array.isArray(option.value) ? optionQuery += "filter.v.option.".concat(option.name.toLowerCase(), "=").concat(option.value.map(function(value, index) {
                            return "".concat(value).concat(index !== valuesLength ? "," : "");
                        }), "&") : optionQuery += "filter.v.option.".concat(option.name.toLowerCase(), "=").concat(option.value);
                        return optionQuery;
                    };
                    vendorQuery = function(vendors) {
                        // console.log('vendors from func', vendors)
                        if (!vendors) return "";
                        if (Array.isArray(vendors)) return "filter.p.vendor=".concat(vendors.map(function(vendor, index) {
                            return "".concat(vendor);
                        }));
                        return "filter.p.vendor=".concat(vendors);
                    };
                    tagsQuery = function(tags) {
                        if (!tags) return "";
                        if (Array.isArray(tags)) return "filter.p.tag=".concat(tags.map(function(tag, index) {
                            return "".concat(tag);
                        }), "&");
                        return "filter.p.tag=".concat(tags);
                    };
                    typesQuery = function(types) {
                        if (!types) return "";
                        if (Array.isArray(types)) return "filter.p.product_type=".concat(types.map(function(type, index) {
                            return "".concat(type);
                        }));
                        return "filter.p.product_type=".concat(types);
                    };
                    priceQuery = function(price) {
                        if (!price) return "";
                        // to two decimal places
                        price.min = Math.round(price.min * 100) / 100;
                        price.max = Math.round(price.max * 100) / 100;
                        return "filter.v.price.lte=".concat(price.max, "&filter.v.price.gte=").concat(price.min);
                    };
                    sortQuery = function(sort) {
                        if (!sort) return "";
                        return "sort_by=".concat(getSortKeyForQuery(sort));
                    };
                    pageQuery = function(page) {
                        if (!page) return "";
                        return "page=".concat(page);
                    };
                    replaceWhitespaceAndAmpersand = function(string) {
                        return string.replace(/\s/g, "%20").replace(/&/g, "%26");
                    };
                    constructProductsUrl = function(options, vendors, tags, types, price) {
                        var productsUrl = "";
                        if (options) options.map(function(option) {
                            productsUrl += "&".concat(optionQuery(option));
                        });
                        if (vendors) productsUrl += "&".concat(replaceWhitespaceAndAmpersand(vendorQuery(vendors)));
                        if (tags) productsUrl += "&".concat(tagsQuery(tags));
                        if (types) productsUrl += "&".concat(typesQuery(types));
                        if (price) productsUrl += "&".concat(priceQuery(price));
                        if (page) productsUrl += "&".concat(pageQuery(page));
                        if (sort) productsUrl += "&".concat(sortQuery(sort));
                        productsUrl += "&section_id=collections-filters-data-backup";
                        if (search) productsUrl = "search?q=".concat(search) + productsUrl;
                        else {
                            // remove any & from the beginning of the string (could be more than one)
                            productsUrl = productsUrl.replace(/^&+/, "");
                            // add the ? to the url
                            productsUrl = "?".concat(productsUrl);
                        }
                        return productsUrl;
                    };
                    productsUrl = constructProductsUrl(options, vendor, tag, type, priceFilter);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    isSearchPage = window.location.pathname.includes("search");
                    return [
                        4,
                        fetch(productsUrl)
                    ];
                case 2:
                    filteredProductsResponse = _state.sent();
                    return [
                        4,
                        filteredProductsResponse.text()
                    ];
                case 3:
                    filteredProductsText = _state.sent();
                    filteredProductsString = filteredProductsText.replace(/(<([^>]+)>)/gi, "").trim();
                    filteredProducts = JSON.parse(filteredProductsString);
                    apiFilters = convertSectionFiltersToApiFilters(filteredProducts.filters);
                    checkedValue = null;
                    allProductsFromSectionApi = {
                        products: filteredProducts.products,
                        pageInfo: {
                            hasNextPage: filteredProducts.pagination.currentPage == filteredProducts.pagination.pages ? false : true,
                            hasPreviousPage: false,
                            endCursor: null,
                            startCursor: null
                        },
                        count: filteredProducts.productCount,
                        meta: apiFilters
                    };
                    sortByButtons = document.querySelectorAll('fieldset.filters__form__toggle-list input[type="radio"]');
                    defaultSortOption = document.querySelector('fieldset.filters__form__toggle-list input[value="published_at:desc"]');
                    if (sortByButtons.length > 0) sortByButtons.forEach(function(radioButton) {
                        if (radioButton.checked) checkedValue = radioButton.value; // Store the checked sort by radio button value
                    });
                    if (checkedValue === null) {
                        if (defaultSortOption) defaultSortOption.checked = true;
                        checkedValue = "published_at:desc";
                    }
                    sortProductsByPublishedAt = function() {
                        allProductsFromSectionApi.products.sort(function(a, b) {
                            var dateA = new Date(a.published_at).getTime();
                            var dateB = new Date(b.published_at).getTime();
                            return dateB - dateA; // Newest to oldest
                        });
                    };
                    if (isSearchPage && checkedValue == "published_at:desc") sortProductsByPublishedAt();
                    return [
                        2,
                        allProductsFromSectionApi
                    ];
                case 4:
                    error = _state.sent();
                    console.error("ERROR:", error);
                    return [
                        2,
                        null
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _getAllProductsFromShopify.apply(this, arguments);
}
var convertShopifyProductToApiProduct = function(shopifyProduct) {
    var apiProduct = {
        compare_at_price: shopifyProduct.compareAtPriceRange.maxVariantPrice.amount,
        handle: shopifyProduct.handle,
        id: shopifyProduct.id.split("/").pop(),
        images: shopifyProduct.images.nodes.map(function(image) {
            return {
                alt: image.altText,
                height: image.height,
                src: image.url,
                width: image.width
            };
        }),
        price: shopifyProduct.priceRange.maxVariantPrice.amount,
        tags: shopifyProduct.tags,
        title: shopifyProduct.title,
        variants: shopifyProduct.variants.nodes.map(function(variant) {
            return {
                id: variant.id.split("/").pop(),
                inventory_quantity: variant.quantityAvailable
            };
        }),
        vendor: shopifyProduct.vendor
    };
    return apiProduct;
};
var convertSectionProductToApiProduct = function(sectionProduct) {
    var apiProduct = {
        compare_at_price: sectionProduct.compareAtPriceRange.maxVariantPrice.amount,
        handle: sectionProduct.handle,
        id: sectionProduct.id,
        created_at: sectionProduct.createdAt,
        images: sectionProduct.images.nodes.map(function(image) {
            return {
                alt: image.altText,
                height: image.height,
                src: image.url,
                width: image.width
            };
        }),
        price: sectionProduct.priceRange.maxVariantPrice.amount,
        tags: sectionProduct.tags,
        title: sectionProduct.title,
        variants: sectionProduct.variants.nodes.map(function(variant) {
            return {
                id: variant.id.split("/").pop(),
                inventory_quantity: variant.quantityAvailable
            };
        }),
        vendor: sectionProduct.vendor
    };
    return apiProduct;
};
var convertShopifyFiltersToApiFilters = function(shopifyFilters) {
    // get all the options by splitting the filter id
    var options = shopifyFilters.map(function(filter) {
        return filter.id.split(".").includes("option") ? filter : null;
    }).filter(function(filter) {
        return filter !== null;
    });
    // get all the product types by splitting the filter id
    var types = shopifyFilters.map(function(filter) {
        return filter.id.split(".").includes("product_type") ? filter : null;
    }).filter(function(filter) {
        return filter !== null;
    });
    // get all the vendors by splitting the filter id
    var vendors = shopifyFilters.map(function(filter) {
        return filter.id.split(".").includes("vendor") ? filter : null;
    }).filter(function(filter) {
        return filter !== null;
    });
    // get all the tags by splitting the filter id
    var tags = shopifyFilters.map(function(filter) {
        return filter.id.split(".").includes("tag") ? filter : null;
    }).filter(function(filter) {
        return filter !== null;
    });
    // get the price filter
    var price = shopifyFilters.find(function(filter) {
        return filter.id.split(".").includes("price");
    });
    // create the api filters object
    var apiFilters = {
        options: [],
        types: [],
        vendors: [],
        tags: [],
        prices: {
            min: 0,
            max: 0
        }
    };
    // add the options to the api filters
    if (options.length > 0) // console.log('options', options)
    apiFilters.options = options.map(function(option) {
        return {
            name: option.label,
            values: option.values.map(function(value) {
                return value.label;
            })
        };
    });
    // add the types to the api filters
    if (types.length > 0) apiFilters.types = types[0].values.map(function(type) {
        return type.label;
    });
    // add the vendors to the api filters
    if (vendors.length > 0) apiFilters.vendors = vendors[0].values.map(function(vendor) {
        return vendor.label;
    });
    // add the tags to the api filters
    if (tags.length > 0) // console.log('tags', tags)
    apiFilters.tags = tags[0].values.map(function(tag) {
        return tag.label;
    });
    // add the price to the api filters
    if (price) apiFilters.prices = JSON.parse(price.values[0].input).price;
    return apiFilters;
};
var convertSectionFiltersToApiFilters = function(sectionFilters) {
    // console.log('SECTION FILTERS', sectionFilters)
    // get all the options by splitting the filter id
    var options = sectionFilters.map(function(filter) {
        return filter.param_name.split(".").includes("option") ? filter : null;
    }).filter(function(filter) {
        return filter !== null;
    });
    // get all the product types by splitting the filter id
    var types = sectionFilters.map(function(filter) {
        return filter.param_name.split(".").includes("product_type") ? filter : null;
    }).filter(function(filter) {
        return filter !== null;
    });
    // get all the vendors by splitting the filter id
    var vendors = sectionFilters.map(function(filter) {
        return filter.param_name.split(".").includes("vendor") ? filter : null;
    }).filter(function(filter) {
        return filter !== null;
    });
    // get all the tags by splitting the filter id
    var tags = sectionFilters.map(function(filter) {
        return filter.param_name.split(".").includes("tag") ? filter : null;
    }).filter(function(filter) {
        return filter !== null;
    });
    // get the price filter
    var price = sectionFilters.find(function(filter) {
        return filter.param_name.split(".").includes("price");
    });
    // console.log('section filters')
    // console.log('options', options)
    // console.log('types', types)
    // console.log('vendors', vendors)
    // console.log('tags', tags)
    // console.log('PRICE FROM CONVERt FUNCtiON', price)
    // create the api filters object
    var apiFilters = {
        options: [],
        types: [],
        vendors: [],
        tags: [],
        prices: {
            min: 0,
            max: 0
        }
    };
    // add the options to the api filters
    if (options.length > 0) apiFilters.options = options.map(function(option) {
        return {
            name: option.label,
            values: option.values.map(function(value) {
                return {
                    label: value.label,
                    count: value.count
                };
            })
        };
    });
    // add the types to the api filters
    if (types.length > 0) apiFilters.types = types[0].values.map(function(type) {
        return {
            label: type.label,
            count: type.count
        };
    });
    // add the vendors to the api filters
    if (vendors.length > 0) apiFilters.vendors = vendors[0].values.map(function(vendor) {
        return {
            label: vendor.label,
            count: vendor.count
        };
    });
    // add the tags to the api filters
    if (tags.length > 0) apiFilters.tags = tags[0].values.map(function(tag) {
        return {
            label: tag.label,
            count: tag.count
        };
    });
    // add the price to the api filters
    if (price) apiFilters.prices = {
        min: price.min_value,
        max: price.range_max / 100
    };
    return apiFilters;
};

},{"@swc/helpers/src/_async_to_generator.mjs":"7nC9G","@swc/helpers/src/_ts_generator.mjs":"cT4KU","@shopify/hydrogen-react":"io37g","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"io37g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddToCartButton", function() {
    return 0, _addToCartButtonMjs.AddToCartButton;
});
parcelHelpers.export(exports, "AnalyticsEventName", function() {
    return 0, _analyticsConstantsMjs.AnalyticsEventName;
});
parcelHelpers.export(exports, "AnalyticsPageType", function() {
    return 0, _analyticsConstantsMjs.AnalyticsPageType;
});
parcelHelpers.export(exports, "BuyNowButton", function() {
    return 0, _buyNowButtonMjs.BuyNowButton;
});
parcelHelpers.export(exports, "CartCheckoutButton", function() {
    return 0, _cartCheckoutButtonMjs.CartCheckoutButton;
});
parcelHelpers.export(exports, "CartCost", function() {
    return 0, _cartCostMjs.CartCost;
});
parcelHelpers.export(exports, "CartLineProvider", function() {
    return 0, _cartLineProviderMjs.CartLineProvider;
});
parcelHelpers.export(exports, "CartLineQuantity", function() {
    return 0, _cartLineQuantityMjs.CartLineQuantity;
});
parcelHelpers.export(exports, "CartLineQuantityAdjustButton", function() {
    return 0, _cartLineQuantityAdjustButtonMjs.CartLineQuantityAdjustButton;
});
parcelHelpers.export(exports, "CartProvider", function() {
    return 0, _cartProviderMjs.CartProvider;
});
parcelHelpers.export(exports, "ExternalVideo", function() {
    return 0, _externalVideoMjs.ExternalVideo;
});
parcelHelpers.export(exports, "IMAGE_FRAGMENT", function() {
    return 0, _imageMjs.IMAGE_FRAGMENT;
});
parcelHelpers.export(exports, "Image", function() {
    return 0, _imageMjs.Image;
});
parcelHelpers.export(exports, "MediaFile", function() {
    return 0, _mediaFileMjs.MediaFile;
});
parcelHelpers.export(exports, "ModelViewer", function() {
    return 0, _modelViewerMjs.ModelViewer;
});
parcelHelpers.export(exports, "Money", function() {
    return 0, _moneyMjs.Money;
});
parcelHelpers.export(exports, "ProductPrice", function() {
    return 0, _productPriceMjs.ProductPrice;
});
parcelHelpers.export(exports, "ProductProvider", function() {
    return 0, _productProviderMjs.ProductProvider;
});
parcelHelpers.export(exports, "SHOPIFY_S", function() {
    return 0, _cartConstantsMjs.SHOPIFY_S;
});
parcelHelpers.export(exports, "SHOPIFY_STOREFRONT_ID_HEADER", function() {
    return 0, _cartConstantsMjs.SHOPIFY_STOREFRONT_ID_HEADER;
});
parcelHelpers.export(exports, "SHOPIFY_STOREFRONT_S_HEADER", function() {
    return 0, _cartConstantsMjs.SHOPIFY_STOREFRONT_S_HEADER;
});
parcelHelpers.export(exports, "SHOPIFY_STOREFRONT_Y_HEADER", function() {
    return 0, _cartConstantsMjs.SHOPIFY_STOREFRONT_Y_HEADER;
});
parcelHelpers.export(exports, "SHOPIFY_Y", function() {
    return 0, _cartConstantsMjs.SHOPIFY_Y;
});
parcelHelpers.export(exports, "ShopPayButton", function() {
    return 0, _shopPayButtonMjs.ShopPayButton;
});
parcelHelpers.export(exports, "ShopifyProvider", function() {
    return 0, _shopifyProviderMjs.ShopifyProvider;
});
parcelHelpers.export(exports, "ShopifySalesChannel", function() {
    return 0, _analyticsConstantsMjs.ShopifySalesChannel;
});
parcelHelpers.export(exports, "Video", function() {
    return 0, _videoMjs.Video;
});
parcelHelpers.export(exports, "createStorefrontClient", function() {
    return 0, _storefrontClientMjs.createStorefrontClient;
});
parcelHelpers.export(exports, "flattenConnection", function() {
    return 0, _flattenConnectionMjs.flattenConnection;
});
parcelHelpers.export(exports, "getClientBrowserParameters", function() {
    return 0, _analyticsMjs.getClientBrowserParameters;
});
parcelHelpers.export(exports, "getShopifyCookies", function() {
    return 0, _cookiesUtilsMjs.getShopifyCookies;
});
parcelHelpers.export(exports, "parseGid", function() {
    return 0, _analyticsUtilsMjs.parseGid;
});
parcelHelpers.export(exports, "parseMetafield", function() {
    return 0, _parseMetafieldMjs.parseMetafield;
});
parcelHelpers.export(exports, "sendShopifyAnalytics", function() {
    return 0, _analyticsMjs.sendShopifyAnalytics;
});
parcelHelpers.export(exports, "storefrontApiCustomScalars", function() {
    return 0, _codegenHelpersMjs.storefrontApiCustomScalars;
});
parcelHelpers.export(exports, "useCart", function() {
    return 0, _cartProviderMjs.useCart;
});
parcelHelpers.export(exports, "useCartLine", function() {
    return 0, _cartLineProviderMjs.useCartLine;
});
parcelHelpers.export(exports, "useMoney", function() {
    return 0, _useMoneyMjs.useMoney;
});
parcelHelpers.export(exports, "useProduct", function() {
    return 0, _productProviderMjs.useProduct;
});
parcelHelpers.export(exports, "useShop", function() {
    return 0, _shopifyProviderMjs.useShop;
});
parcelHelpers.export(exports, "useShopifyCookies", function() {
    return 0, _useShopifyCookiesMjs.useShopifyCookies;
});
var _addToCartButtonMjs = require("./AddToCartButton.mjs");
var _analyticsMjs = require("./analytics.mjs");
var _analyticsConstantsMjs = require("./analytics-constants.mjs");
var _analyticsUtilsMjs = require("./analytics-utils.mjs");
var _buyNowButtonMjs = require("./BuyNowButton.mjs");
var _cartConstantsMjs = require("./cart-constants.mjs");
var _cartCheckoutButtonMjs = require("./CartCheckoutButton.mjs");
var _cartCostMjs = require("./CartCost.mjs");
var _cartLineProviderMjs = require("./CartLineProvider.mjs");
var _cartLineQuantityMjs = require("./CartLineQuantity.mjs");
var _cartLineQuantityAdjustButtonMjs = require("./CartLineQuantityAdjustButton.mjs");
var _cartProviderMjs = require("./CartProvider.mjs");
var _codegenHelpersMjs = require("./codegen.helpers.mjs");
var _cookiesUtilsMjs = require("./cookies-utils.mjs");
var _externalVideoMjs = require("./ExternalVideo.mjs");
var _flattenConnectionMjs = require("./flatten-connection.mjs");
var _imageMjs = require("./Image.mjs");
var _mediaFileMjs = require("./MediaFile.mjs");
var _modelViewerMjs = require("./ModelViewer.mjs");
var _moneyMjs = require("./Money.mjs");
var _parseMetafieldMjs = require("./parse-metafield.mjs");
var _productPriceMjs = require("./ProductPrice.mjs");
var _productProviderMjs = require("./ProductProvider.mjs");
var _shopifyProviderMjs = require("./ShopifyProvider.mjs");
var _shopPayButtonMjs = require("./ShopPayButton.mjs");
var _storefrontClientMjs = require("./storefront-client.mjs");
var _useMoneyMjs = require("./useMoney.mjs");
var _useShopifyCookiesMjs = require("./useShopifyCookies.mjs");
var _videoMjs = require("./Video.mjs");

},{"./AddToCartButton.mjs":"9NGh6","./analytics.mjs":"bnCSJ","./analytics-constants.mjs":"bOr3s","./analytics-utils.mjs":"4XHNQ","./BuyNowButton.mjs":"1CHrx","./cart-constants.mjs":"f5ldq","./CartCheckoutButton.mjs":"bQ7WY","./CartCost.mjs":"hqS97","./CartLineProvider.mjs":"3VQni","./CartLineQuantity.mjs":"gkrFb","./CartLineQuantityAdjustButton.mjs":"3qCDb","./CartProvider.mjs":"6UehF","./codegen.helpers.mjs":"mHiEd","./cookies-utils.mjs":"gGHAO","./ExternalVideo.mjs":"aPDkn","./flatten-connection.mjs":"9iJRk","./Image.mjs":"4CaGJ","./MediaFile.mjs":"5rKxn","./ModelViewer.mjs":"alQI0","./Money.mjs":"juuRs","./parse-metafield.mjs":"jfBCM","./ProductPrice.mjs":"huCji","./ProductProvider.mjs":"8WO5h","./ShopifyProvider.mjs":"6TpGm","./ShopPayButton.mjs":"fSZOY","./storefront-client.mjs":"5uSEd","./useMoney.mjs":"aitQA","./useShopifyCookies.mjs":"axIHV","./Video.mjs":"bqkiw","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"9NGh6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddToCartButton", function() {
    return AddToCartButton;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _objectWithoutPropertiesMjs = require("@swc/helpers/src/_object_without_properties.mjs");
var _objectWithoutPropertiesMjsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesMjs);
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _cartProviderMjs = require("./CartProvider.mjs");
var _productProviderMjs = require("./ProductProvider.mjs");
var _baseButtonMjs = require("./BaseButton.mjs");
function AddToCartButton(props) {
    var _useState = (0, _slicedToArrayMjsDefault.default)((0, _react.useState)(false), 2), addingItem = _useState[0], setAddingItem = _useState[1];
    var explicitVariantId = props.variantId, _props_quantity = props.quantity, quantity = _props_quantity === void 0 ? 1 : _props_quantity, attributes = props.attributes, sellingPlanId = props.sellingPlanId, onClick = props.onClick, children = props.children, accessibleAddingToCartLabel = props.accessibleAddingToCartLabel, passthroughProps = (0, _objectWithoutPropertiesMjsDefault.default)(props, [
        "variantId",
        "quantity",
        "attributes",
        "sellingPlanId",
        "onClick",
        "children",
        "accessibleAddingToCartLabel"
    ]);
    var _useCart = (0, _cartProviderMjs.useCart)(), status = _useCart.status, linesAdd = _useCart.linesAdd;
    var selectedVariant = (0, _productProviderMjs.useProduct)().selectedVariant;
    var _ref;
    var variantId = (_ref = explicitVariantId !== null && explicitVariantId !== void 0 ? explicitVariantId : selectedVariant == null ? void 0 : selectedVariant.id) !== null && _ref !== void 0 ? _ref : "";
    var disabled = explicitVariantId === null || variantId === "" || selectedVariant === null || addingItem || passthroughProps.disabled;
    (0, _react.useEffect)(function() {
        if (addingItem && status === "idle") setAddingItem(false);
    }, [
        status,
        addingItem
    ]);
    var handleAddItem = (0, _react.useCallback)(function() {
        setAddingItem(true);
        linesAdd([
            {
                quantity: quantity,
                merchandiseId: variantId || "",
                attributes: attributes,
                sellingPlanId: sellingPlanId
            }
        ]);
    }, [
        linesAdd,
        quantity,
        variantId,
        attributes,
        sellingPlanId
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _baseButtonMjs.BaseButton), (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, passthroughProps), {
                disabled: disabled,
                onClick: onClick,
                defaultOnClick: handleAddItem,
                children: children
            })),
            accessibleAddingToCartLabel ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("p", {
                style: {
                    position: "absolute",
                    width: "1px",
                    height: "1px",
                    padding: "0",
                    margin: "-1px",
                    overflow: "hidden",
                    clip: "rect(0, 0, 0, 0)",
                    whiteSpace: "nowrap",
                    borderWidth: "0"
                },
                role: "alert",
                "aria-live": "assertive",
                children: addingItem ? accessibleAddingToCartLabel : null
            }) : null
        ]
    });
}

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","@swc/helpers/src/_object_without_properties.mjs":"d0eOZ","@swc/helpers/src/_sliced_to_array.mjs":"l34hS","react/jsx-runtime":"ebSqZ","react":"ihebA","./CartProvider.mjs":"6UehF","./ProductProvider.mjs":"8WO5h","./BaseButton.mjs":"fb2fP","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"ihebA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Component", function() {
    return 0, _preact.Component;
});
parcelHelpers.export(exports, "Fragment", function() {
    return 0, _preact.Fragment;
});
parcelHelpers.export(exports, "createContext", function() {
    return 0, _preact.createContext;
});
parcelHelpers.export(exports, "createElement", function() {
    return 0, _preact.createElement;
});
parcelHelpers.export(exports, "createRef", function() {
    return 0, _preact.createRef;
});
parcelHelpers.export(exports, "Children", function() {
    return O;
});
parcelHelpers.export(exports, "PureComponent", function() {
    return w;
});
parcelHelpers.export(exports, "StrictMode", function() {
    return vn;
});
parcelHelpers.export(exports, "Suspense", function() {
    return D;
});
parcelHelpers.export(exports, "SuspenseList", function() {
    return V;
});
parcelHelpers.export(exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function() {
    return rn;
});
parcelHelpers.export(exports, "cloneElement", function() {
    return cn;
});
parcelHelpers.export(exports, "createFactory", function() {
    return on;
});
parcelHelpers.export(exports, "createPortal", function() {
    return j;
});
parcelHelpers.export(exports, "default", function() {
    return bn;
});
parcelHelpers.export(exports, "findDOMNode", function() {
    return an;
});
parcelHelpers.export(exports, "flushSync", function() {
    return hn;
});
parcelHelpers.export(exports, "forwardRef", function() {
    return k;
});
parcelHelpers.export(exports, "hydrate", function() {
    return q;
});
parcelHelpers.export(exports, "isValidElement", function() {
    return ln;
});
parcelHelpers.export(exports, "lazy", function() {
    return M;
});
parcelHelpers.export(exports, "memo", function() {
    return R;
});
parcelHelpers.export(exports, "render", function() {
    return Y;
});
parcelHelpers.export(exports, "startTransition", function() {
    return dn;
});
parcelHelpers.export(exports, "unmountComponentAtNode", function() {
    return fn;
});
parcelHelpers.export(exports, "unstable_batchedUpdates", function() {
    return sn;
});
parcelHelpers.export(exports, "useDeferredValue", function() {
    return pn;
});
parcelHelpers.export(exports, "useInsertionEffect", function() {
    return yn;
});
parcelHelpers.export(exports, "useSyncExternalStore", function() {
    return _n;
});
parcelHelpers.export(exports, "useTransition", function() {
    return mn;
});
parcelHelpers.export(exports, "version", function() {
    return un;
});
var _typeOfMjs = require("@swc/helpers/src/_type_of.mjs");
var _typeOfMjsDefault = parcelHelpers.interopDefault(_typeOfMjs);
var _preact = require("preact");
var _hooks = require("preact/hooks");
parcelHelpers.exportAll(_hooks, exports);
function g(n, t) {
    for(var _$e in t)n[_$e] = t[_$e];
    return n;
}
function C(n, t) {
    for(var _$e in n)if ("__source" !== _$e && !(_$e in t)) return !0;
    for(var _$r in t)if ("__source" !== _$r && n[_$r] !== t[_$r]) return !0;
    return !1;
}
function E(n, t) {
    return n === t && (0 !== n || 1 / n == 1 / t) || n != n && t != t;
}
function w(n) {
    this.props = n;
}
function R(n, e) {
    var _$r = function _$r(n) {
        var _$t = this.props.ref, _$r = _$t == n.ref;
        return !_$r && _$t && (_$t.call ? _$t(null) : _$t.current = null), e ? !e(this.props, n) || !_$r : C(this.props, n);
    };
    var _$u = function _$u(e) {
        return this.shouldComponentUpdate = _$r, (0, _preact.createElement)(n, e);
    };
    return _$u.displayName = "Memo(" + (n.displayName || n.name) + ")", _$u.prototype.isReactComponent = !0, _$u.__f = !0, _$u;
}
(w.prototype = new (0, _preact.Component)).isPureReactComponent = !0, w.prototype.shouldComponentUpdate = function(n, t) {
    return C(this.props, n) || C(this.state, t);
};
var x = (0, _preact.options).__b;
(0, _preact.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), x && x(n);
};
var N = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function k(n) {
    var _$t = function _$t(t) {
        var _$e = g({}, t);
        return delete _$e.ref, n(_$e, t.ref || null);
    };
    return _$t.$$typeof = N, _$t.render = _$t, _$t.prototype.isReactComponent = _$t.__f = !0, _$t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", _$t;
}
var A = function A(n, t) {
    return null == n ? null : (0, _preact.toChildArray)((0, _preact.toChildArray)(n).map(t));
}, O = {
    map: A,
    forEach: A,
    count: function count(n) {
        return n ? (0, _preact.toChildArray)(n).length : 0;
    },
    only: function only(n) {
        var _$t = (0, _preact.toChildArray)(n);
        if (1 !== _$t.length) throw "Children.only";
        return _$t[0];
    },
    toArray: (0, _preact.toChildArray)
}, T = (0, _preact.options).__e;
(0, _preact.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var _$u, o = t; o = o.__;)if ((_$u = o.__c) && _$u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), _$u.__c(n, t);
    }
    T(n, t, e, r);
};
var I = (0, _preact.options).unmount;
function L(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return L(n, t, e);
    })), n;
}
function U(n, t, e) {
    return n && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return U(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.insertBefore(n.__e, n.__d), n.__c.__e = !0, n.__c.__P = e)), n;
}
function D() {
    this.__u = 0, this.t = null, this.__b = null;
}
function F(n) {
    var _$t = n.__.__c;
    return _$t && _$t.__a && _$t.__a(n);
}
function M(n) {
    var o = function o(_o) {
        if (_$e || (_$e = n()).then(function(n) {
            _$r = n.default || n;
        }, function(n) {
            _$u = n;
        }), _$u) throw _$u;
        if (!_$r) throw _$e;
        return (0, _preact.createElement)(_$r, _o);
    };
    var _$e, _$r, _$u;
    return o.displayName = "Lazy", o.__f = !0, o;
}
function V() {
    this.u = null, this.o = null;
}
(0, _preact.options).unmount = function(n) {
    var _$t = n.__c;
    _$t && _$t.__R && _$t.__R(), _$t && !0 === n.__h && (n.type = null), I && I(n);
}, (D.prototype = new (0, _preact.Component)).__c = function(n, t) {
    var _$e = t.__c, _$r = this;
    null == _$r.t && (_$r.t = []), _$r.t.push(_$e);
    var _$u = F(_$r.__v), o = !1, i = function i() {
        o || (o = !0, _$e.__R = null, _$u ? _$u(_$l) : _$l());
    };
    _$e.__R = i;
    var _$l = function l() {
        if (!--_$r.__u) {
            if (_$r.state.__a) {
                var _$n = _$r.state.__a;
                _$r.__v.__k[0] = U(_$n, _$n.__c.__P, _$n.__c.__O);
            }
            var _$t;
            for(_$r.setState({
                __a: _$r.__b = null
            }); _$t = _$r.t.pop();)_$t.forceUpdate();
        }
    }, _$c = !0 === t.__h;
    _$r.__u++ || _$c || _$r.setState({
        __a: _$r.__b = _$r.__v.__k[0]
    }), n.then(i, i);
}, D.prototype.componentWillUnmount = function() {
    this.t = [];
}, D.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var _$r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = L(this.__b, _$r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, _preact.createElement)((0, _preact.Fragment), null, n.fallback);
    return i && (i.__h = null), [
        (0, _preact.createElement)((0, _preact.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var W = function W(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function P(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $(n) {
    var _$e = this, _$r = n.i;
    _$e.componentWillUnmount = function() {
        (0, _preact.render)(null, _$e.l), _$e.l = null, _$e.i = null;
    }, _$e.i && _$e.i !== _$r && _$e.componentWillUnmount(), n.__v ? (_$e.l || (_$e.i = _$r, _$e.l = {
        nodeType: 1,
        parentNode: _$r,
        childNodes: [],
        appendChild: function appendChild(n) {
            this.childNodes.push(n), _$e.i.appendChild(n);
        },
        insertBefore: function insertBefore(n, t) {
            this.childNodes.push(n), _$e.i.appendChild(n);
        },
        removeChild: function removeChild(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), _$e.i.removeChild(n);
        }
    }), (0, _preact.render)((0, _preact.createElement)(P, {
        context: _$e.context
    }, n.__v), _$e.l)) : _$e.l && _$e.componentWillUnmount();
}
function j(n, e) {
    var _$r = (0, _preact.createElement)($, {
        __v: n,
        i: e
    });
    return _$r.containerInfo = e, _$r;
}
(V.prototype = new (0, _preact.Component)).__a = function(n) {
    var _$t = this, _$e = F(_$t.__v), _$r = _$t.o.get(n);
    return _$r[0]++, function(u) {
        var o = function o() {
            _$t.props.revealOrder ? (_$r.push(u), W(_$t, n, _$r)) : u();
        };
        _$e ? _$e(o) : o();
    };
}, V.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var _$t = (0, _preact.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && _$t.reverse();
    for(var _$e = _$t.length; _$e--;)this.o.set(_$t[_$e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, V.prototype.componentDidUpdate = V.prototype.componentDidMount = function() {
    var _$n = this;
    this.o.forEach(function(t, e) {
        W(_$n, e, t);
    });
};
var z = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, B = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, H = "undefined" != typeof document, Z = function Z(n) {
    return ("undefined" != typeof Symbol && "symbol" == (0, _typeOfMjsDefault.default)(Symbol()) ? /fil|che|rad/i : /fil|che|ra/i).test(n);
};
function Y(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, _preact.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function q(n, t, e) {
    return (0, _preact.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, _preact.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, _preact.Component).prototype, t, {
        configurable: !0,
        get: function get() {
            return this["UNSAFE_" + t];
        },
        set: function set(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var G = (0, _preact.options).event;
function J() {}
function K() {
    return this.cancelBubble;
}
function Q() {
    return this.defaultPrevented;
}
(0, _preact.options).event = function(n) {
    return G && (n = G(n)), n.persist = J, n.isPropagationStopped = K, n.isDefaultPrevented = Q, n.nativeEvent = n;
};
var X, nn = {
    configurable: !0,
    get: function get() {
        return this.class;
    }
}, tn = (0, _preact.options).vnode;
(0, _preact.options).vnode = function(n) {
    var _$t = n.type, _$e = n.props, _$u = _$e;
    if ("string" == typeof _$t) {
        var o = -1 === _$t.indexOf("-");
        for(var i in _$u = {}, _$e){
            var _$l = _$e[i];
            H && "children" === i && "noscript" === _$t || "value" === i && "defaultValue" in _$e && null == _$l || ("defaultValue" === i && "value" in _$e && null == _$e.value ? i = "value" : "download" === i && !0 === _$l ? _$l = "" : /ondoubleclick/i.test(i) ? i = "ondblclick" : /^onchange(textarea|input)/i.test(i + _$t) && !Z(_$e.type) ? i = "oninput" : /^onfocus$/i.test(i) ? i = "onfocusin" : /^onblur$/i.test(i) ? i = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(i) ? i = i.toLowerCase() : o && B.test(i) ? i = i.replace(/[A-Z0-9]/g, "-$&").toLowerCase() : null === _$l && (_$l = void 0), /^oninput$/i.test(i) && (i = i.toLowerCase(), _$u[i] && (i = "oninputCapture")), _$u[i] = _$l);
        }
        "select" == _$t && _$u.multiple && Array.isArray(_$u.value) && (_$u.value = (0, _preact.toChildArray)(_$e.children).forEach(function(n) {
            n.props.selected = -1 != _$u.value.indexOf(n.props.value);
        })), "select" == _$t && null != _$u.defaultValue && (_$u.value = (0, _preact.toChildArray)(_$e.children).forEach(function(n) {
            n.props.selected = _$u.multiple ? -1 != _$u.defaultValue.indexOf(n.props.value) : _$u.defaultValue == n.props.value;
        })), n.props = _$u, _$e.class != _$e.className && (nn.enumerable = "className" in _$e, null != _$e.className && (_$u.class = _$e.className), Object.defineProperty(_$u, "className", nn));
    }
    n.$$typeof = z, tn && tn(n);
};
var en = (0, _preact.options).__r;
(0, _preact.options).__r = function(n) {
    en && en(n), X = n.__c;
};
var rn = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function readContext(n) {
                return X.__n[n.__c].props.value;
            }
        }
    }
}, un = "17.0.2";
function on(n) {
    return (0, _preact.createElement).bind(null, n);
}
function ln(n) {
    return !!n && n.$$typeof === z;
}
function cn(n) {
    return ln(n) ? (0, _preact.cloneElement).apply(null, arguments) : n;
}
function fn(n) {
    return !!n.__k && ((0, _preact.render)(null, n), !0);
}
function an(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var sn = function sn(n, t) {
    return n(t);
}, hn = function hn(n, t) {
    return n(t);
}, vn = (0, _preact.Fragment);
function dn(n) {
    n();
}
function pn(n) {
    return n;
}
function mn() {
    return [
        !1,
        dn
    ];
}
var yn = (0, _hooks.useLayoutEffect);
function _n(n, t) {
    var _$e = t(), _$r = (0, _hooks.useState)({
        h: {
            __: _$e,
            v: t
        }
    }), _$u = _$r[0].h, o = _$r[1];
    return (0, _hooks.useLayoutEffect)(function() {
        _$u.__ = _$e, _$u.v = t, E(_$u.__, t()) || o({
            h: _$u
        });
    }, [
        n,
        _$e,
        t
    ]), (0, _hooks.useEffect)(function() {
        return E(_$u.__, _$u.v()) || o({
            h: _$u
        }), n(function() {
            E(_$u.__, _$u.v()) || o({
                h: _$u
            });
        });
    }, [
        n
    ]), _$e;
}
var bn = {
    useState: (0, _hooks.useState),
    useId: (0, _hooks.useId),
    useReducer: (0, _hooks.useReducer),
    useEffect: (0, _hooks.useEffect),
    useLayoutEffect: (0, _hooks.useLayoutEffect),
    useInsertionEffect: yn,
    useTransition: mn,
    useDeferredValue: pn,
    useSyncExternalStore: _n,
    startTransition: dn,
    useRef: (0, _hooks.useRef),
    useImperativeHandle: (0, _hooks.useImperativeHandle),
    useMemo: (0, _hooks.useMemo),
    useCallback: (0, _hooks.useCallback),
    useContext: (0, _hooks.useContext),
    useDebugValue: (0, _hooks.useDebugValue),
    version: "17.0.2",
    Children: O,
    render: Y,
    hydrate: q,
    unmountComponentAtNode: fn,
    createPortal: j,
    createElement: (0, _preact.createElement),
    createContext: (0, _preact.createContext),
    createFactory: on,
    cloneElement: cn,
    createRef: (0, _preact.createRef),
    Fragment: (0, _preact.Fragment),
    isValidElement: ln,
    findDOMNode: an,
    Component: (0, _preact.Component),
    PureComponent: w,
    memo: R,
    forwardRef: k,
    flushSync: hn,
    unstable_batchedUpdates: sn,
    StrictMode: vn,
    Suspense: D,
    SuspenseList: V,
    lazy: M,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: rn
};

},{"@swc/helpers/src/_type_of.mjs":"52Yae","preact":"fiBpF","preact/hooks":"fdDeA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"6UehF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartContext", function() {
    return CartContext;
});
parcelHelpers.export(exports, "CartProvider", function() {
    return CartProvider;
});
parcelHelpers.export(exports, "storageAvailable", function() {
    return storageAvailable;
});
parcelHelpers.export(exports, "useCart", function() {
    return useCart;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useCartAPIStateMachineMjs = require("./useCartAPIStateMachine.mjs");
var _cartConstantsMjs = require("./cart-constants.mjs");
var _cartQueriesMjs = require("./cart-queries.mjs");
var _shopifyProviderMjs = require("./ShopifyProvider.mjs");
var CartContext = (0, _react.createContext)(null);
function useCart() {
    var context = (0, _react.useContext)(CartContext);
    if (!context) throw new Error("Expected a Cart Context, but no Cart Context was found");
    return context;
}
function CartProvider(param) {
    var children = param.children, numCartLines = param.numCartLines, onCreate = param.onCreate, onLineAdd = param.onLineAdd, onLineRemove = param.onLineRemove, onLineUpdate = param.onLineUpdate, onNoteUpdate = param.onNoteUpdate, onBuyerIdentityUpdate = param.onBuyerIdentityUpdate, onAttributesUpdate = param.onAttributesUpdate, onDiscountCodesUpdate = param.onDiscountCodesUpdate, onCreateComplete = param.onCreateComplete, onLineAddComplete = param.onLineAddComplete, onLineRemoveComplete = param.onLineRemoveComplete, onLineUpdateComplete = param.onLineUpdateComplete, onNoteUpdateComplete = param.onNoteUpdateComplete, onBuyerIdentityUpdateComplete = param.onBuyerIdentityUpdateComplete, onAttributesUpdateComplete = param.onAttributesUpdateComplete, onDiscountCodesUpdateComplete = param.onDiscountCodesUpdateComplete, cart = param.data, _param_cartFragment = param.cartFragment, cartFragment = _param_cartFragment === void 0 ? (0, _cartQueriesMjs.defaultCartFragment) : _param_cartFragment, customerAccessToken = param.customerAccessToken, countryCode = param.countryCode;
    var _a, _b, _c, _d, _e, _f, _g;
    var shop = (0, _shopifyProviderMjs.useShop)();
    if (!shop) throw new Error("<CartProvider> needs to be a descendant of <ShopifyProvider>");
    var _ref;
    countryCode = ((_ref = countryCode !== null && countryCode !== void 0 ? countryCode : shop.countryIsoCode) !== null && _ref !== void 0 ? _ref : "US").toUpperCase();
    if (countryCode) countryCode = countryCode.toUpperCase();
    var _useState = (0, _slicedToArrayMjsDefault.default)((0, _react.useState)(countryCode), 2), prevCountryCode = _useState[0], setPrevCountryCode = _useState[1];
    var _useState1 = (0, _slicedToArrayMjsDefault.default)((0, _react.useState)(customerAccessToken), 2), prevCustomerAccessToken = _useState1[0], setPrevCustomerAccessToken = _useState1[1];
    var customerOverridesCountryCode = (0, _react.useRef)(false);
    if (prevCountryCode !== countryCode || prevCustomerAccessToken !== customerAccessToken) {
        setPrevCountryCode(countryCode);
        setPrevCustomerAccessToken(customerAccessToken);
        customerOverridesCountryCode.current = false;
    }
    var _useCartAPIStateMachine = (0, _slicedToArrayMjsDefault.default)((0, _useCartAPIStateMachineMjs.useCartAPIStateMachine)({
        numCartLines: numCartLines,
        data: cart,
        cartFragment: cartFragment,
        countryCode: countryCode,
        onCartActionEntry: function(_, event) {
            try {
                switch(event.type){
                    case "CART_CREATE":
                        return onCreate == null ? void 0 : onCreate();
                    case "CARTLINE_ADD":
                        return onLineAdd == null ? void 0 : onLineAdd();
                    case "CARTLINE_REMOVE":
                        return onLineRemove == null ? void 0 : onLineRemove();
                    case "CARTLINE_UPDATE":
                        return onLineUpdate == null ? void 0 : onLineUpdate();
                    case "NOTE_UPDATE":
                        return onNoteUpdate == null ? void 0 : onNoteUpdate();
                    case "BUYER_IDENTITY_UPDATE":
                        return onBuyerIdentityUpdate == null ? void 0 : onBuyerIdentityUpdate();
                    case "CART_ATTRIBUTES_UPDATE":
                        return onAttributesUpdate == null ? void 0 : onAttributesUpdate();
                    case "DISCOUNT_CODES_UPDATE":
                        return onDiscountCodesUpdate == null ? void 0 : onDiscountCodesUpdate();
                }
            } catch (error) {
                console.error("Cart entry action failed", error);
            }
        },
        onCartActionOptimisticUI: function(context, event) {
            var _a2, _b2, _c2, _d2;
            if (!context.cart) return (0, _objectSpreadMjsDefault.default)({}, context);
            switch(event.type){
                case "CARTLINE_REMOVE":
                    return (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, context), {
                        cart: (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, context.cart), {
                            lines: (_b2 = (_a2 = context == null ? void 0 : context.cart) == null ? void 0 : _a2.lines) == null ? void 0 : _b2.filter(function(line) {
                                return (line == null ? void 0 : line.id) && !event.payload.lines.includes(line == null ? void 0 : line.id);
                            })
                        })
                    });
                case "CARTLINE_UPDATE":
                    return (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, context), {
                        cart: (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, context.cart), {
                            lines: (_d2 = (_c2 = context == null ? void 0 : context.cart) == null ? void 0 : _c2.lines) == null ? void 0 : _d2.map(function(line) {
                                var updatedLine = event.payload.lines.find(function(param) {
                                    var id = param.id;
                                    return id === (line == null ? void 0 : line.id);
                                });
                                if (updatedLine && updatedLine.quantity) return (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, line), {
                                    quantity: updatedLine.quantity
                                });
                                return line;
                            })
                        })
                    });
            }
            return (0, _objectSpreadMjsDefault.default)({}, context);
        },
        onCartActionComplete: function(context, event) {
            var cartActionEvent = event.payload.cartActionEvent;
            try {
                switch(event.type){
                    case "RESOLVE":
                        switch(cartActionEvent.type){
                            case "CART_CREATE":
                                return onCreateComplete == null ? void 0 : onCreateComplete();
                            case "CARTLINE_ADD":
                                return onLineAddComplete == null ? void 0 : onLineAddComplete();
                            case "CARTLINE_REMOVE":
                                return onLineRemoveComplete == null ? void 0 : onLineRemoveComplete();
                            case "CARTLINE_UPDATE":
                                return onLineUpdateComplete == null ? void 0 : onLineUpdateComplete();
                            case "NOTE_UPDATE":
                                return onNoteUpdateComplete == null ? void 0 : onNoteUpdateComplete();
                            case "BUYER_IDENTITY_UPDATE":
                                if (countryCodeNotUpdated(context, cartActionEvent)) customerOverridesCountryCode.current = true;
                                return onBuyerIdentityUpdateComplete == null ? void 0 : onBuyerIdentityUpdateComplete();
                            case "CART_ATTRIBUTES_UPDATE":
                                return onAttributesUpdateComplete == null ? void 0 : onAttributesUpdateComplete();
                            case "DISCOUNT_CODES_UPDATE":
                                return onDiscountCodesUpdateComplete == null ? void 0 : onDiscountCodesUpdateComplete();
                        }
                }
            } catch (error) {
                console.error("onCartActionComplete failed", error);
            }
        }
    }), 2), cartState = _useCartAPIStateMachine[0], cartSend = _useCartAPIStateMachine[1];
    var cartReady = (0, _react.useRef)(false);
    var cartCompleted = cartState.matches("cartCompleted");
    var countryChanged = (cartState.value === "idle" || cartState.value === "error" || cartState.value === "cartCompleted") && countryCode !== ((_c = (_b = (_a = cartState == null ? void 0 : cartState.context) == null ? void 0 : _a.cart) == null ? void 0 : _b.buyerIdentity) == null ? void 0 : _c.countryCode) && !cartState.context.errors;
    var fetchingFromStorage = (0, _react.useRef)(false);
    (0, _react.useEffect)(function() {
        if (!cartReady.current && !fetchingFromStorage.current) {
            if (!cart && storageAvailable("localStorage")) {
                fetchingFromStorage.current = true;
                try {
                    var cartId = window.localStorage.getItem((0, _cartConstantsMjs.CART_ID_STORAGE_KEY));
                    if (cartId) cartSend({
                        type: "CART_FETCH",
                        payload: {
                            cartId: cartId
                        }
                    });
                } catch (error) {
                    console.warn("error fetching cartId");
                    console.warn(error);
                }
            }
            cartReady.current = true;
        }
    }, [
        cart,
        cartReady,
        cartSend
    ]);
    (0, _react.useEffect)(function() {
        if (!countryChanged || customerOverridesCountryCode.current) return;
        cartSend({
            type: "BUYER_IDENTITY_UPDATE",
            payload: {
                buyerIdentity: {
                    countryCode: countryCode,
                    customerAccessToken: customerAccessToken
                }
            }
        });
    }, [
        countryCode,
        customerAccessToken,
        countryChanged,
        customerOverridesCountryCode,
        cartSend
    ]);
    var onCartReadySend = (0, _react.useCallback)(function(cartEvent) {
        if (!cartReady.current) return console.warn("Cart isn't ready yet");
        cartSend(cartEvent);
    }, [
        cartSend
    ]);
    (0, _react.useEffect)(function() {
        var _a2, _b2, _c2;
        if (((_b2 = (_a2 = cartState == null ? void 0 : cartState.context) == null ? void 0 : _a2.cart) == null ? void 0 : _b2.id) && storageAvailable("localStorage")) try {
            window.localStorage.setItem((0, _cartConstantsMjs.CART_ID_STORAGE_KEY), (_c2 = cartState.context.cart) == null ? void 0 : _c2.id);
        } catch (error) {
            console.warn("Failed to save cartId to localStorage", error);
        }
    }, [
        (_e = (_d = cartState == null ? void 0 : cartState.context) == null ? void 0 : _d.cart) == null ? void 0 : _e.id
    ]);
    (0, _react.useEffect)(function() {
        if (cartCompleted && storageAvailable("localStorage")) try {
            window.localStorage.removeItem((0, _cartConstantsMjs.CART_ID_STORAGE_KEY));
        } catch (error) {
            console.warn("Failed to delete cartId from localStorage", error);
        }
    }, [
        cartCompleted
    ]);
    var cartCreate = (0, _react.useCallback)(function(cartInput) {
        var _a2, _b2;
        if (countryCode && !((_a2 = cartInput.buyerIdentity) == null ? void 0 : _a2.countryCode)) {
            if (cartInput.buyerIdentity == null) cartInput.buyerIdentity = {};
            cartInput.buyerIdentity.countryCode = countryCode;
        }
        if (customerAccessToken && !((_b2 = cartInput.buyerIdentity) == null ? void 0 : _b2.customerAccessToken)) {
            if (cartInput.buyerIdentity == null) cartInput.buyerIdentity = {};
            cartInput.buyerIdentity.customerAccessToken = customerAccessToken;
        }
        onCartReadySend({
            type: "CART_CREATE",
            payload: cartInput
        });
    }, [
        countryCode,
        customerAccessToken,
        onCartReadySend
    ]);
    var cartDisplayState = useDelayedStateUntilHydration(cartState);
    var cartContextValue = (0, _react.useMemo)(function() {
        var _a2, _b2, _c2, _d2;
        var _ref, _ref1;
        return (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, (_ref = (_a2 = cartDisplayState == null ? void 0 : cartDisplayState.context) == null ? void 0 : _a2.cart) !== null && _ref !== void 0 ? _ref : {
            lines: [],
            attributes: []
        }), {
            status: transposeStatus(cartDisplayState.value),
            error: (_b2 = cartDisplayState == null ? void 0 : cartDisplayState.context) == null ? void 0 : _b2.errors,
            totalQuantity: (_ref1 = (_d2 = (_c2 = cartDisplayState == null ? void 0 : cartDisplayState.context) == null ? void 0 : _c2.cart) == null ? void 0 : _d2.totalQuantity) !== null && _ref1 !== void 0 ? _ref1 : 0,
            cartCreate: cartCreate,
            linesAdd: function(lines) {
                var _a3, _b3;
                if ((_b3 = (_a3 = cartDisplayState == null ? void 0 : cartDisplayState.context) == null ? void 0 : _a3.cart) == null ? void 0 : _b3.id) onCartReadySend({
                    type: "CARTLINE_ADD",
                    payload: {
                        lines: lines
                    }
                });
                else cartCreate({
                    lines: lines
                });
            },
            linesRemove: function(lines) {
                onCartReadySend({
                    type: "CARTLINE_REMOVE",
                    payload: {
                        lines: lines
                    }
                });
            },
            linesUpdate: function(lines) {
                onCartReadySend({
                    type: "CARTLINE_UPDATE",
                    payload: {
                        lines: lines
                    }
                });
            },
            noteUpdate: function(note) {
                onCartReadySend({
                    type: "NOTE_UPDATE",
                    payload: {
                        note: note
                    }
                });
            },
            buyerIdentityUpdate: function(buyerIdentity) {
                onCartReadySend({
                    type: "BUYER_IDENTITY_UPDATE",
                    payload: {
                        buyerIdentity: buyerIdentity
                    }
                });
            },
            cartAttributesUpdate: function(attributes) {
                onCartReadySend({
                    type: "CART_ATTRIBUTES_UPDATE",
                    payload: {
                        attributes: attributes
                    }
                });
            },
            discountCodesUpdate: function(discountCodes) {
                onCartReadySend({
                    type: "DISCOUNT_CODES_UPDATE",
                    payload: {
                        discountCodes: discountCodes
                    }
                });
            },
            cartFragment: cartFragment
        });
    }, [
        cartCreate,
        (_f = cartDisplayState == null ? void 0 : cartDisplayState.context) == null ? void 0 : _f.cart,
        (_g = cartDisplayState == null ? void 0 : cartDisplayState.context) == null ? void 0 : _g.errors,
        cartDisplayState.value,
        cartFragment,
        onCartReadySend
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CartContext.Provider, {
        value: cartContextValue,
        children: children
    });
}
function transposeStatus(status) {
    switch(status){
        case "uninitialized":
        case "initializationError":
            return "uninitialized";
        case "idle":
        case "cartCompleted":
        case "error":
            return "idle";
        case "cartFetching":
            return "fetching";
        case "cartCreating":
            return "creating";
        case "cartLineAdding":
        case "cartLineRemoving":
        case "cartLineUpdating":
        case "noteUpdating":
        case "buyerIdentityUpdating":
        case "cartAttributesUpdating":
        case "discountCodesUpdating":
            return "updating";
    }
}
function useDelayedStateUntilHydration(state) {
    var _useTransition = (0, _slicedToArrayMjsDefault.default)((0, _react.useTransition)(), 2), isPending = _useTransition[0], startTransition = _useTransition[1];
    var _useState = (0, _slicedToArrayMjsDefault.default)((0, _react.useState)(state), 2), delayedState = _useState[0], setDelayedState = _useState[1];
    var firstTimePending = (0, _react.useRef)(false);
    if (isPending) firstTimePending.current = true;
    var firstTimePendingFinished = (0, _react.useRef)(false);
    if (!isPending && firstTimePending.current) firstTimePendingFinished.current = true;
    (0, _react.useEffect)(function() {
        startTransition(function() {
            if (!firstTimePendingFinished.current) setDelayedState(state);
        });
    }, [
        state
    ]);
    var displayState = firstTimePendingFinished.current ? state : delayedState;
    return displayState;
}
function storageAvailable(type) {
    var storage;
    try {
        storage = window[type];
        var x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return !!(e instanceof DOMException && // everything except Firefox
        (e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === "QuotaExceededError" || // Firefox
        e.name === "NS_ERROR_DOM_QUOTA_REACHED") && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0);
    }
}
function countryCodeNotUpdated(context, event) {
    var _a, _b;
    return !!(event.payload.buyerIdentity.countryCode && ((_b = (_a = context.cart) == null ? void 0 : _a.buyerIdentity) == null ? void 0 : _b.countryCode) !== event.payload.buyerIdentity.countryCode);
}

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","@swc/helpers/src/_sliced_to_array.mjs":"l34hS","react/jsx-runtime":"ebSqZ","react":"ihebA","./useCartAPIStateMachine.mjs":"jdBdS","./cart-constants.mjs":"f5ldq","./cart-queries.mjs":"e976l","./ShopifyProvider.mjs":"6TpGm","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"jdBdS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cartFromGraphQL", function() {
    return cartFromGraphQL;
});
parcelHelpers.export(exports, "useCartAPIStateMachine", function() {
    return useCartAPIStateMachine;
});
var _asyncToGeneratorMjs = require("@swc/helpers/src/_async_to_generator.mjs");
var _asyncToGeneratorMjsDefault = parcelHelpers.interopDefault(_asyncToGeneratorMjs);
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _toConsumableArrayMjs = require("@swc/helpers/src/_to_consumable_array.mjs");
var _toConsumableArrayMjsDefault = parcelHelpers.interopDefault(_toConsumableArrayMjs);
var _tsGeneratorMjs = require("@swc/helpers/src/_ts_generator.mjs");
var _tsGeneratorMjsDefault = parcelHelpers.interopDefault(_tsGeneratorMjs);
var _fsmMjs = require("./node_modules/@xstate/react/es/fsm.mjs");
var _indexMjs = require("./node_modules/@xstate/fsm/es/index.mjs");
var _flattenConnectionMjs = require("./flatten-connection.mjs");
var _useCartActionsMjs = require("./useCartActions.mjs");
var _react = require("react");
function invokeCart(action, options) {
    return {
        entry: (0, _toConsumableArrayMjsDefault.default)((options == null ? void 0 : options.entryActions) || []).concat([
            (0, _indexMjs.assign)({
                lastValidCart: function(context) {
                    return context == null ? void 0 : context.cart;
                }
            }),
            "onCartActionEntry",
            "onCartActionOptimisticUI",
            action
        ]),
        on: {
            RESOLVE: {
                target: (options == null ? void 0 : options.resolveTarget) || "idle",
                actions: [
                    (0, _indexMjs.assign)({
                        prevCart: function(context) {
                            return context == null ? void 0 : context.lastValidCart;
                        },
                        cart: function(_, event) {
                            var _a;
                            return (_a = event == null ? void 0 : event.payload) == null ? void 0 : _a.cart;
                        },
                        rawCartResult: function(_, event) {
                            var _a;
                            return (_a = event == null ? void 0 : event.payload) == null ? void 0 : _a.rawCartResult;
                        },
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        errors: function(_) {
                            return void 0;
                        }
                    })
                ]
            },
            ERROR: {
                target: (options == null ? void 0 : options.errorTarget) || "error",
                actions: [
                    (0, _indexMjs.assign)({
                        prevCart: function(context) {
                            return context == null ? void 0 : context.lastValidCart;
                        },
                        cart: function(context) {
                            return context == null ? void 0 : context.lastValidCart;
                        },
                        errors: function(_, event) {
                            var _a;
                            return (_a = event == null ? void 0 : event.payload) == null ? void 0 : _a.errors;
                        }
                    })
                ]
            },
            CART_COMPLETED: {
                target: "cartCompleted",
                actions: (0, _indexMjs.assign)({
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    prevCart: function(_) {
                        return void 0;
                    },
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    cart: function(_) {
                        return void 0;
                    },
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    lastValidCart: function(_) {
                        return void 0;
                    },
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    rawCartResult: function(_) {
                        return void 0;
                    },
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    errors: function(_) {
                        return void 0;
                    }
                })
            }
        },
        exit: [
            "onCartActionComplete"
        ].concat((0, _toConsumableArrayMjsDefault.default)((options == null ? void 0 : options.exitActions) || []))
    };
}
var INITIALIZING_CART_EVENTS = {
    CART_FETCH: {
        target: "cartFetching"
    },
    CART_CREATE: {
        target: "cartCreating"
    },
    CART_SET: {
        target: "idle",
        actions: [
            (0, _indexMjs.assign)({
                rawCartResult: function(_, event) {
                    return event.payload.cart;
                },
                cart: function(_, event) {
                    return cartFromGraphQL(event.payload.cart);
                }
            })
        ]
    }
};
var UPDATING_CART_EVENTS = {
    CARTLINE_ADD: {
        target: "cartLineAdding"
    },
    CARTLINE_UPDATE: {
        target: "cartLineUpdating"
    },
    CARTLINE_REMOVE: {
        target: "cartLineRemoving"
    },
    NOTE_UPDATE: {
        target: "noteUpdating"
    },
    BUYER_IDENTITY_UPDATE: {
        target: "buyerIdentityUpdating"
    },
    CART_ATTRIBUTES_UPDATE: {
        target: "cartAttributesUpdating"
    },
    DISCOUNT_CODES_UPDATE: {
        target: "discountCodesUpdating"
    }
};
function createCartMachine(initialCart) {
    return (0, _indexMjs.createMachine)({
        id: "Cart",
        initial: initialCart ? "idle" : "uninitialized",
        context: {
            cart: initialCart && cartFromGraphQL(initialCart)
        },
        states: {
            uninitialized: {
                on: INITIALIZING_CART_EVENTS
            },
            cartCompleted: {
                on: INITIALIZING_CART_EVENTS
            },
            initializationError: {
                on: INITIALIZING_CART_EVENTS
            },
            idle: {
                on: (0, _objectSpreadMjsDefault.default)({}, INITIALIZING_CART_EVENTS, UPDATING_CART_EVENTS)
            },
            error: {
                on: (0, _objectSpreadMjsDefault.default)({}, INITIALIZING_CART_EVENTS, UPDATING_CART_EVENTS)
            },
            cartFetching: invokeCart("cartFetchAction", {
                errorTarget: "initializationError"
            }),
            cartCreating: invokeCart("cartCreateAction", {
                errorTarget: "initializationError"
            }),
            cartLineRemoving: invokeCart("cartLineRemoveAction"),
            cartLineUpdating: invokeCart("cartLineUpdateAction"),
            cartLineAdding: invokeCart("cartLineAddAction"),
            noteUpdating: invokeCart("noteUpdateAction"),
            buyerIdentityUpdating: invokeCart("buyerIdentityUpdateAction"),
            cartAttributesUpdating: invokeCart("cartAttributesUpdateAction"),
            discountCodesUpdating: invokeCart("discountCodesUpdateAction")
        }
    });
}
function useCartAPIStateMachine(param) {
    var numCartLines = param.numCartLines, onCartActionEntry = param.onCartActionEntry, onCartActionOptimisticUI = param.onCartActionOptimisticUI, onCartActionComplete = param.onCartActionComplete, cart = param.data, cartFragment = param.cartFragment, countryCode = param.countryCode;
    var _useCartActions = (0, _useCartActionsMjs.useCartActions)({
        numCartLines: numCartLines,
        cartFragment: cartFragment,
        countryCode: countryCode
    }), cartFetch = _useCartActions.cartFetch, cartCreate = _useCartActions.cartCreate, cartLineAdd = _useCartActions.cartLineAdd, cartLineUpdate = _useCartActions.cartLineUpdate, cartLineRemove = _useCartActions.cartLineRemove, noteUpdate = _useCartActions.noteUpdate, buyerIdentityUpdate = _useCartActions.buyerIdentityUpdate, cartAttributesUpdate = _useCartActions.cartAttributesUpdate, discountCodesUpdate = _useCartActions.discountCodesUpdate;
    var cartMachine = (0, _react.useMemo)(function() {
        return createCartMachine(cart);
    }, [
        cart
    ]);
    var _useMachine = (0, _slicedToArrayMjsDefault.default)((0, _fsmMjs.useMachine)(cartMachine, {
        actions: (0, _objectSpreadMjsDefault.default)({
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            cartFetchAction: function() {
                var _ref = (0, _asyncToGeneratorMjsDefault.default)(function(_, event) {
                    var _a, _ref, data, errors, resultEvent;
                    return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (event.type !== "CART_FETCH") return [
                                    2
                                ];
                                return [
                                    4,
                                    cartFetch((_a = event == null ? void 0 : event.payload) == null ? void 0 : _a.cartId)
                                ];
                            case 1:
                                _ref = _state.sent(), data = _ref.data, errors = _ref.errors;
                                resultEvent = eventFromFetchResult(event, data == null ? void 0 : data.cart, errors);
                                send(resultEvent);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(_, event) {
                    return _ref.apply(this, arguments);
                };
            }(),
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            cartCreateAction: function() {
                var _ref = (0, _asyncToGeneratorMjsDefault.default)(function(_, event) {
                    var _a, _ref, data, errors, resultEvent;
                    return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (event.type !== "CART_CREATE") return [
                                    2
                                ];
                                return [
                                    4,
                                    cartCreate(event == null ? void 0 : event.payload)
                                ];
                            case 1:
                                _ref = _state.sent(), data = _ref.data, errors = _ref.errors;
                                resultEvent = eventFromFetchResult(event, (_a = data == null ? void 0 : data.cartCreate) == null ? void 0 : _a.cart, errors);
                                send(resultEvent);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(_, event) {
                    return _ref.apply(this, arguments);
                };
            }(),
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            cartLineAddAction: function() {
                var _ref = (0, _asyncToGeneratorMjsDefault.default)(function(context, event) {
                    var _a, _b, _ref, data, errors, resultEvent;
                    return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (event.type !== "CARTLINE_ADD" || !((_a = context == null ? void 0 : context.cart) == null ? void 0 : _a.id)) return [
                                    2
                                ];
                                return [
                                    4,
                                    cartLineAdd(context.cart.id, event.payload.lines)
                                ];
                            case 1:
                                _ref = _state.sent(), data = _ref.data, errors = _ref.errors;
                                resultEvent = eventFromFetchResult(event, (_b = data == null ? void 0 : data.cartLinesAdd) == null ? void 0 : _b.cart, errors);
                                send(resultEvent);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(context, event) {
                    return _ref.apply(this, arguments);
                };
            }(),
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            cartLineUpdateAction: function() {
                var _ref = (0, _asyncToGeneratorMjsDefault.default)(function(context, event) {
                    var _a, _b, _ref, data, errors, resultEvent;
                    return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (event.type !== "CARTLINE_UPDATE" || !((_a = context == null ? void 0 : context.cart) == null ? void 0 : _a.id)) return [
                                    2
                                ];
                                return [
                                    4,
                                    cartLineUpdate(context.cart.id, event.payload.lines)
                                ];
                            case 1:
                                _ref = _state.sent(), data = _ref.data, errors = _ref.errors;
                                resultEvent = eventFromFetchResult(event, (_b = data == null ? void 0 : data.cartLinesUpdate) == null ? void 0 : _b.cart, errors);
                                send(resultEvent);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(context, event) {
                    return _ref.apply(this, arguments);
                };
            }(),
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            cartLineRemoveAction: function() {
                var _ref = (0, _asyncToGeneratorMjsDefault.default)(function(context, event) {
                    var _a, _b, _ref, data, errors, resultEvent;
                    return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (event.type !== "CARTLINE_REMOVE" || !((_a = context == null ? void 0 : context.cart) == null ? void 0 : _a.id)) return [
                                    2
                                ];
                                return [
                                    4,
                                    cartLineRemove(context.cart.id, event.payload.lines)
                                ];
                            case 1:
                                _ref = _state.sent(), data = _ref.data, errors = _ref.errors;
                                resultEvent = eventFromFetchResult(event, (_b = data == null ? void 0 : data.cartLinesRemove) == null ? void 0 : _b.cart, errors);
                                send(resultEvent);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(context, event) {
                    return _ref.apply(this, arguments);
                };
            }(),
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            noteUpdateAction: function() {
                var _ref = (0, _asyncToGeneratorMjsDefault.default)(function(context, event) {
                    var _a, _b, _ref, data, errors, resultEvent;
                    return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (event.type !== "NOTE_UPDATE" || !((_a = context == null ? void 0 : context.cart) == null ? void 0 : _a.id)) return [
                                    2
                                ];
                                return [
                                    4,
                                    noteUpdate(context.cart.id, event.payload.note)
                                ];
                            case 1:
                                _ref = _state.sent(), data = _ref.data, errors = _ref.errors;
                                resultEvent = eventFromFetchResult(event, (_b = data == null ? void 0 : data.cartNoteUpdate) == null ? void 0 : _b.cart, errors);
                                send(resultEvent);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(context, event) {
                    return _ref.apply(this, arguments);
                };
            }(),
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            buyerIdentityUpdateAction: function() {
                var _ref = (0, _asyncToGeneratorMjsDefault.default)(function(context, event) {
                    var _a, _b, _ref, data, errors, resultEvent;
                    return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (event.type !== "BUYER_IDENTITY_UPDATE" || !((_a = context == null ? void 0 : context.cart) == null ? void 0 : _a.id)) return [
                                    2
                                ];
                                return [
                                    4,
                                    buyerIdentityUpdate(context.cart.id, event.payload.buyerIdentity)
                                ];
                            case 1:
                                _ref = _state.sent(), data = _ref.data, errors = _ref.errors;
                                resultEvent = eventFromFetchResult(event, (_b = data == null ? void 0 : data.cartBuyerIdentityUpdate) == null ? void 0 : _b.cart, errors);
                                send(resultEvent);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(context, event) {
                    return _ref.apply(this, arguments);
                };
            }(),
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            cartAttributesUpdateAction: function() {
                var _ref = (0, _asyncToGeneratorMjsDefault.default)(function(context, event) {
                    var _a, _b, _ref, data, errors, resultEvent;
                    return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (event.type !== "CART_ATTRIBUTES_UPDATE" || !((_a = context == null ? void 0 : context.cart) == null ? void 0 : _a.id)) return [
                                    2
                                ];
                                return [
                                    4,
                                    cartAttributesUpdate(context.cart.id, event.payload.attributes)
                                ];
                            case 1:
                                _ref = _state.sent(), data = _ref.data, errors = _ref.errors;
                                resultEvent = eventFromFetchResult(event, (_b = data == null ? void 0 : data.cartAttributesUpdate) == null ? void 0 : _b.cart, errors);
                                send(resultEvent);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(context, event) {
                    return _ref.apply(this, arguments);
                };
            }(),
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            discountCodesUpdateAction: function() {
                var _ref = (0, _asyncToGeneratorMjsDefault.default)(function(context, event) {
                    var _a, _b, _ref, data, errors, resultEvent;
                    return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (event.type !== "DISCOUNT_CODES_UPDATE" || !((_a = context == null ? void 0 : context.cart) == null ? void 0 : _a.id)) return [
                                    2
                                ];
                                return [
                                    4,
                                    discountCodesUpdate(context.cart.id, event.payload.discountCodes)
                                ];
                            case 1:
                                _ref = _state.sent(), data = _ref.data, errors = _ref.errors;
                                resultEvent = eventFromFetchResult(event, (_b = data == null ? void 0 : data.cartDiscountCodesUpdate) == null ? void 0 : _b.cart, errors);
                                send(resultEvent);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(context, event) {
                    return _ref.apply(this, arguments);
                };
            }()
        }, onCartActionEntry && {
            onCartActionEntry: function(context, event) {
                if (isCartActionEvent(event)) onCartActionEntry(context, event);
            }
        }, onCartActionOptimisticUI && {
            onCartActionOptimisticUI: (0, _indexMjs.assign)(function(context, event) {
                return onCartActionOptimisticUI(context, event);
            })
        }, onCartActionComplete && {
            onCartActionComplete: function(context, event) {
                if (isCartFetchResultEvent(event)) onCartActionComplete(context, event);
            }
        })
    }), 3), state = _useMachine[0], send = _useMachine[1], service = _useMachine[2];
    return (0, _react.useMemo)(function() {
        return [
            state,
            send,
            service
        ];
    }, [
        state,
        send,
        service
    ]);
}
function cartFromGraphQL(cart) {
    var _cart_note;
    return (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, cart), {
        lines: (0, _flattenConnectionMjs.flattenConnection)(cart == null ? void 0 : cart.lines),
        note: (_cart_note = cart.note) !== null && _cart_note !== void 0 ? _cart_note : void 0
    });
}
function eventFromFetchResult(cartActionEvent, cart, errors) {
    if (errors) return {
        type: "ERROR",
        payload: {
            errors: errors,
            cartActionEvent: cartActionEvent
        }
    };
    if (!cart) return {
        type: "CART_COMPLETED",
        payload: {
            cartActionEvent: cartActionEvent
        }
    };
    return {
        type: "RESOLVE",
        payload: {
            cart: cartFromGraphQL(cart),
            rawCartResult: cart,
            cartActionEvent: cartActionEvent
        }
    };
}
function isCartActionEvent(event) {
    return event.type === "CART_CREATE" || event.type === "CARTLINE_ADD" || event.type === "CARTLINE_UPDATE" || event.type === "CARTLINE_REMOVE" || event.type === "NOTE_UPDATE" || event.type === "BUYER_IDENTITY_UPDATE" || event.type === "CART_ATTRIBUTES_UPDATE" || event.type === "DISCOUNT_CODES_UPDATE";
}
function isCartFetchResultEvent(event) {
    return event.type === "RESOLVE" || event.type === "ERROR" || event.type === "CART_COMPLETED";
}

},{"@swc/helpers/src/_async_to_generator.mjs":"7nC9G","@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","@swc/helpers/src/_sliced_to_array.mjs":"l34hS","@swc/helpers/src/_to_consumable_array.mjs":"11hUU","@swc/helpers/src/_ts_generator.mjs":"cT4KU","./node_modules/@xstate/react/es/fsm.mjs":"ePQyq","./node_modules/@xstate/fsm/es/index.mjs":"btsOY","./flatten-connection.mjs":"9iJRk","./useCartActions.mjs":"50yQG","react":"ihebA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"ePQyq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMachine", function() {
    return useMachine;
});
parcelHelpers.export(exports, "useService", function() {
    return useService;
});
var _indexMjs = require("../../fsm/es/index.mjs");
var _react = require("react");
var _useIsomorphicLayoutEffectBrowserEsmMjs = require("../../../use-isomorphic-layout-effect/dist/use-isomorphic-layout-effect.browser.esm.mjs");
var _useIsomorphicLayoutEffectBrowserEsmMjsDefault = parcelHelpers.interopDefault(_useIsomorphicLayoutEffectBrowserEsmMjs);
var _withSelectorMjs = require("../../../use-sync-external-store/shim/with-selector.mjs");
var _useConstantMjs = require("./useConstant.mjs");
var _useConstantMjsDefault = parcelHelpers.interopDefault(_useConstantMjs);
var _withSelectorMjs1 = require("../../../../_virtual/with-selector.mjs");
var __read = globalThis && globalThis.__read || function(o, n2) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n2 === void 0 || n2-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function identity(a) {
    return a;
}
var getServiceState = function getServiceState(service) {
    var currentValue;
    service.subscribe(function(state) {
        currentValue = state;
    }).unsubscribe();
    return currentValue;
};
function useMachine(stateMachine, options) {
    var persistedStateRef = (0, _react.useRef)();
    var _a, initialMachine;
    var _b = __read((0, _useConstantMjsDefault.default)(function() {
        var queue2 = [];
        var service2 = (0, _indexMjs.interpret)((0, _indexMjs.createMachine)(stateMachine.config, options ? options : stateMachine._options));
        var send = service2.send;
        service2.send = function(event) {
            if (service2.status === (0, _indexMjs.InterpreterStatus).NotStarted) {
                queue2.push(event);
                return;
            }
            send(event);
            persistedStateRef.current = service2.state;
        };
        return [
            service2,
            queue2
        ];
    }), 2), service = _b[0], queue = _b[1];
    (0, _useIsomorphicLayoutEffectBrowserEsmMjsDefault.default)(function() {
        if (options) service._machine._options = options;
    });
    var useServiceResult = useService(service);
    (0, _react.useEffect)(function() {
        service.start(persistedStateRef.current);
        queue.forEach(service.send);
        persistedStateRef.current = service.state;
        return function() {
            service.stop();
        };
    }, []);
    return useServiceResult;
}
var isEqual = function isEqual(_prevState, nextState) {
    return nextState.changed === false;
};
function useService(service) {
    var getSnapshot = (0, _react.useCallback)(function() {
        return getServiceState(service);
    }, [
        service
    ]);
    var subscribe = (0, _react.useCallback)(function(handleStoreChange) {
        var unsubscribe = service.subscribe(handleStoreChange).unsubscribe;
        return unsubscribe;
    }, [
        service
    ]);
    var storeSnapshot = (0, _withSelectorMjs1.exports).useSyncExternalStoreWithSelector(subscribe, getSnapshot, getSnapshot, identity, isEqual);
    return [
        storeSnapshot,
        service.send,
        service
    ];
}

},{"../../fsm/es/index.mjs":"btsOY","react":"ihebA","../../../use-isomorphic-layout-effect/dist/use-isomorphic-layout-effect.browser.esm.mjs":"6NWnj","../../../use-sync-external-store/shim/with-selector.mjs":"4HD2H","./useConstant.mjs":"5PbLf","../../../../_virtual/with-selector.mjs":"6tTRR","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"btsOY":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InterpreterStatus", function() {
    return n;
});
parcelHelpers.export(exports, "assign", function() {
    return i;
});
parcelHelpers.export(exports, "createMachine", function() {
    return s;
});
parcelHelpers.export(exports, "interpret", function() {
    return v;
});
function t(t2, n2) {
    var e2 = "function" == typeof Symbol && t2[Symbol.iterator];
    if (!e2) return t2;
    var r2, i2, o2 = e2.call(t2), a2 = [];
    try {
        for(; (void 0 === n2 || n2-- > 0) && !(r2 = o2.next()).done;)a2.push(r2.value);
    } catch (t3) {
        i2 = {
            error: t3
        };
    } finally{
        try {
            r2 && !r2.done && (e2 = o2.return) && e2.call(o2);
        } finally{
            if (i2) throw i2.error;
        }
    }
    return a2;
}
var n;
!function(t2) {
    t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
}(n || (n = {}));
var e = {
    type: "xstate.init"
};
function r(t2) {
    return void 0 === t2 ? [] : [].concat(t2);
}
function i(t2) {
    return {
        type: "xstate.assign",
        assignment: t2
    };
}
function o(t2, n2) {
    return "string" == typeof (t2 = "string" == typeof t2 && n2 && n2[t2] ? n2[t2] : t2) ? {
        type: t2
    } : "function" == typeof t2 ? {
        type: t2.name,
        exec: t2
    } : t2;
}
function a(t2) {
    return function(n2) {
        return t2 === n2;
    };
}
function u(t2) {
    return "string" == typeof t2 ? {
        type: t2
    } : t2;
}
function c(t2, n2) {
    return {
        value: t2,
        context: n2,
        actions: [],
        changed: false,
        matches: a(t2)
    };
}
function f(t2, n2, e2) {
    var r2 = n2, i2 = false;
    return [
        t2.filter(function(t3) {
            if ("xstate.assign" === t3.type) {
                i2 = true;
                var n3 = Object.assign({}, r2);
                return "function" == typeof t3.assignment ? n3 = t3.assignment(r2, e2) : Object.keys(t3.assignment).forEach(function(i3) {
                    n3[i3] = "function" == typeof t3.assignment[i3] ? t3.assignment[i3](r2, e2) : t3.assignment[i3];
                }), r2 = n3, false;
            }
            return true;
        }),
        r2,
        i2
    ];
}
function s(n2, i2) {
    void 0 === i2 && (i2 = {});
    var s2 = t(f(r(n2.states[n2.initial].entry).map(function(t2) {
        return o(t2, i2.actions);
    }), n2.context, e), 2), l2 = s2[0], v2 = s2[1], y = {
        config: n2,
        _options: i2,
        initialState: {
            value: n2.initial,
            actions: l2,
            context: v2,
            matches: a(n2.initial)
        },
        transition: function transition(e2, i3) {
            var s3, l3, v3 = "string" == typeof e2 ? {
                value: e2,
                context: n2.context
            } : e2, p = v3.value, g = v3.context, d = u(i3), x = n2.states[p];
            if (x.on) {
                var m = r(x.on[d.type]);
                try {
                    for(var h = function(t2) {
                        var n3 = "function" == typeof Symbol && Symbol.iterator, e3 = n3 && t2[n3], r2 = 0;
                        if (e3) return e3.call(t2);
                        if (t2 && "number" == typeof t2.length) return {
                            next: function next() {
                                return t2 && r2 >= t2.length && (t2 = void 0), {
                                    value: t2 && t2[r2++],
                                    done: !t2
                                };
                            }
                        };
                        throw new TypeError(n3 ? "Object is not iterable." : "Symbol.iterator is not defined.");
                    }(m), b = h.next(); !b.done; b = h.next()){
                        var S = b.value;
                        if (void 0 === S) return c(p, g);
                        var w = "string" == typeof S ? {
                            target: S
                        } : S, j = w.target, E = w.actions, R = void 0 === E ? [] : E, N = w.cond, O = void 0 === N ? function O() {
                            return true;
                        } : N, _ = void 0 === j, k = null != j ? j : p, T = n2.states[k];
                        if (O(g, d)) {
                            var q = t(f((_ ? r(R) : [].concat(x.exit, R, T.entry).filter(function(t2) {
                                return t2;
                            })).map(function(t2) {
                                return o(t2, y._options.actions);
                            }), g, d), 3), z = q[0], A = q[1], B = q[2], C = null != j ? j : p;
                            return {
                                value: C,
                                context: A,
                                actions: z,
                                changed: j !== p || z.length > 0 || B,
                                matches: a(C)
                            };
                        }
                    }
                } catch (t2) {
                    s3 = {
                        error: t2
                    };
                } finally{
                    try {
                        b && !b.done && (l3 = h.return) && l3.call(h);
                    } finally{
                        if (s3) throw s3.error;
                    }
                }
            }
            return c(p, g);
        }
    };
    return y;
}
var l = function l(t2, n2) {
    return t2.actions.forEach(function(e2) {
        var r2 = e2.exec;
        return r2 && r2(t2.context, n2);
    });
};
function v(t2) {
    var r2 = t2.initialState, i2 = n.NotStarted, o2 = /* @__PURE__ */ new Set(), c2 = {
        _machine: t2,
        send: function send(e2) {
            i2 === n.Running && (r2 = t2.transition(r2, e2), l(r2, u(e2)), o2.forEach(function(t3) {
                return t3(r2);
            }));
        },
        subscribe: function subscribe(t3) {
            return o2.add(t3), t3(r2), {
                unsubscribe: function unsubscribe() {
                    return o2.delete(t3);
                }
            };
        },
        start: function start(o3) {
            if (o3) {
                var u2 = "object" == typeof o3 ? o3 : {
                    context: t2.config.context,
                    value: o3
                };
                r2 = {
                    value: u2.value,
                    actions: [],
                    context: u2.context,
                    matches: a(u2.value)
                };
            } else r2 = t2.initialState;
            return i2 = n.Running, l(r2, e), c2;
        },
        stop: function stop() {
            return i2 = n.Stopped, o2.clear(), c2;
        },
        get state () {
            return r2;
        },
        get status () {
            return i2;
        }
    };
    return c2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"6NWnj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return index;
});
var _react = require("react");
var index = (0, _react.useLayoutEffect);

},{"react":"ihebA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"4HD2H":[function(require,module,exports) {
var _withSelectorMjs = require("../../../_virtual/with-selector.mjs");
var _withSelectorProductionMinMjs = require("../cjs/use-sync-external-store-shim/with-selector.production.min.mjs");
var _withSelectorDevelopmentMjs = require("../cjs/use-sync-external-store-shim/with-selector.development.mjs");
(function(module) {
    module.exports = (0, _withSelectorProductionMinMjs.__require)();
})((0, _withSelectorMjs.__module));

},{"../../../_virtual/with-selector.mjs":"6tTRR","../cjs/use-sync-external-store-shim/with-selector.production.min.mjs":"ku0Uk","../cjs/use-sync-external-store-shim/with-selector.development.mjs":"5s8hj"}],"6tTRR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__module", function() {
    return withSelector;
});
parcelHelpers.export(exports, "exports", function() {
    return withSelectorExports;
});
var withSelectorExports = {};
var withSelector = {
    get exports () {
        return withSelectorExports;
    },
    set exports (v){
        withSelectorExports = v;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"ku0Uk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__require", function() {
    return requireWithSelector_production_min;
});
var _withSelectorProductionMinMjs = require("../../../../_virtual/with-selector.production.min.mjs");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexMjs = require("../../shim/index.mjs");
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var hasRequiredWithSelector_production_min;
function requireWithSelector_production_min() {
    var p = function p(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    };
    if (hasRequiredWithSelector_production_min) return 0, _withSelectorProductionMinMjs.__exports;
    hasRequiredWithSelector_production_min = 1;
    var h = (0, _reactDefault.default), n = (0, _indexMjs.__require)();
    var q = "function" === typeof Object.is ? Object.is : p, r = n.useSyncExternalStore, t = h.useRef, u = h.useEffect, v = h.useMemo, w = h.useDebugValue;
    (0, _withSelectorProductionMinMjs.__exports).useSyncExternalStoreWithSelector = function(a, b, e, l, g) {
        var c = t(null);
        if (null === c.current) {
            var f = {
                hasValue: false,
                value: null
            };
            c.current = f;
        } else f = c.current;
        c = v(function() {
            var a2 = function a2(a3) {
                if (!c2) {
                    c2 = true;
                    d2 = a3;
                    a3 = l(a3);
                    if (void 0 !== g && f.hasValue) {
                        var b2 = f.value;
                        if (g(b2, a3)) return k = b2;
                    }
                    return k = a3;
                }
                b2 = k;
                if (q(d2, a3)) return b2;
                var e2 = l(a3);
                if (void 0 !== g && g(b2, e2)) return b2;
                d2 = a3;
                return k = e2;
            };
            var c2 = false, d2, k, m = void 0 === e ? null : e;
            return [
                function() {
                    return a2(b());
                },
                null === m ? void 0 : function() {
                    return a2(m());
                }
            ];
        }, [
            b,
            e,
            l,
            g
        ]);
        var d = r(a, c[0], c[1]);
        u(function() {
            f.hasValue = true;
            f.value = d;
        }, [
            d
        ]);
        w(d);
        return d;
    };
    return 0, _withSelectorProductionMinMjs.__exports;
}

},{"../../../../_virtual/with-selector.production.min.mjs":"ehTNo","react":"ihebA","../../shim/index.mjs":"anE7B","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"ehTNo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__exports", function() {
    return withSelector_production_min;
});
var withSelector_production_min = {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"anE7B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__require", function() {
    return requireShim;
});
var _indexMjs = require("../../../_virtual/index.mjs");
var _useSyncExternalStoreShimProductionMinMjs = require("../cjs/use-sync-external-store-shim.production.min.mjs");
var _useSyncExternalStoreShimDevelopmentMjs = require("../cjs/use-sync-external-store-shim.development.mjs");
var hasRequiredShim;
function requireShim() {
    if (hasRequiredShim) return 0, _indexMjs.exports;
    hasRequiredShim = 1;
    (function(module) {
        module.exports = (0, _useSyncExternalStoreShimProductionMinMjs.__require)();
    })((0, _indexMjs.__module));
    return 0, _indexMjs.exports;
}

},{"../../../_virtual/index.mjs":"6dk0Y","../cjs/use-sync-external-store-shim.production.min.mjs":"fsIn6","../cjs/use-sync-external-store-shim.development.mjs":"V1qHe","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"6dk0Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__module", function() {
    return shim;
});
parcelHelpers.export(exports, "exports", function() {
    return shimExports;
});
var shimExports = {};
var shim = {
    get exports () {
        return shimExports;
    },
    set exports (v){
        shimExports = v;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"fsIn6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__require", function() {
    return requireUseSyncExternalStoreShim_production_min;
});
var _useSyncExternalStoreShimProductionMinMjs = require("../../../_virtual/use-sync-external-store-shim.production.min.mjs");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var hasRequiredUseSyncExternalStoreShim_production_min;
function requireUseSyncExternalStoreShim_production_min() {
    var h = function h(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    };
    var q = function q(a, b) {
        var d = b(), f = l({
            inst: {
                value: d,
                getSnapshot: b
            }
        }), c = f[0].inst, g = f[1];
        n(function() {
            c.value = d;
            c.getSnapshot = b;
            r(c) && g({
                inst: c
            });
        }, [
            a,
            d,
            b
        ]);
        m(function() {
            r(c) && g({
                inst: c
            });
            return a(function() {
                r(c) && g({
                    inst: c
                });
            });
        }, [
            a
        ]);
        p(d);
        return d;
    };
    var r = function r(a) {
        var b = a.getSnapshot;
        a = a.value;
        try {
            var d = b();
            return !k(a, d);
        } catch (f) {
            return true;
        }
    };
    var t = function t(a, b) {
        return b();
    };
    if (hasRequiredUseSyncExternalStoreShim_production_min) return 0, _useSyncExternalStoreShimProductionMinMjs.__exports;
    hasRequiredUseSyncExternalStoreShim_production_min = 1;
    var e = (0, _reactDefault.default);
    var k = "function" === typeof Object.is ? Object.is : h, l = e.useState, m = e.useEffect, n = e.useLayoutEffect, p = e.useDebugValue;
    var u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? t : q;
    (0, _useSyncExternalStoreShimProductionMinMjs.__exports).useSyncExternalStore = void 0 !== e.useSyncExternalStore ? e.useSyncExternalStore : u;
    return 0, _useSyncExternalStoreShimProductionMinMjs.__exports;
}

},{"../../../_virtual/use-sync-external-store-shim.production.min.mjs":"1161l","react":"ihebA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"1161l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__exports", function() {
    return useSyncExternalStoreShim_production_min;
});
var useSyncExternalStoreShim_production_min = {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"V1qHe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__require", function() {
    return requireUseSyncExternalStoreShim_development;
});
var _useSyncExternalStoreShimDevelopmentMjs = require("../../../_virtual/use-sync-external-store-shim.development.mjs");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
    if (hasRequiredUseSyncExternalStoreShim_development) return 0, _useSyncExternalStoreShimDevelopmentMjs.__exports;
    hasRequiredUseSyncExternalStoreShim_development = 1;
    var React, ReactSharedInternals, error, format, _len2, args, _key2, printWarning, level, format1, args1, ReactDebugCurrentFrame, stack, argsWithFormat, item, is, x, y, objectIs, useState, useEffect, useLayoutEffect, useDebugValue, didWarnOld18Alpha, didWarnUncachedGetSnapshot, useSyncExternalStore, subscribe, getSnapshot, getServerSnapshot, value, cachedValue, _useState, inst, forceUpdate, handleStoreChange, checkIfSnapshotChanged, inst1, latestGetSnapshot, prevValue, nextValue, error2, useSyncExternalStore$1, subscribe1, getSnapshot1, getServerSnapshot1, canUseDOM, isServerEnvironment, shim, useSyncExternalStore$2;
    return 0, _useSyncExternalStoreShimDevelopmentMjs.__exports;
}

},{"../../../_virtual/use-sync-external-store-shim.development.mjs":"YPpRy","react":"ihebA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"YPpRy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__exports", function() {
    return useSyncExternalStoreShim_development;
});
var useSyncExternalStoreShim_development = {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"5s8hj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__require", function() {
    return requireWithSelector_development;
});
var _withSelectorDevelopmentMjs = require("../../../../_virtual/with-selector.development.mjs");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexMjs = require("../../shim/index.mjs");
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var hasRequiredWithSelector_development;
function requireWithSelector_development() {
    if (hasRequiredWithSelector_development) return 0, _withSelectorDevelopmentMjs.__exports;
    hasRequiredWithSelector_development = 1;
    var React, shim, is, x, y, objectIs, useSyncExternalStore, useRef, useEffect, useMemo, useDebugValue, useSyncExternalStoreWithSelector, subscribe, getSnapshot, getServerSnapshot, selector, isEqual, instRef, inst, _useMemo, hasMemo, memoizedSnapshot, memoizedSelection, memoizedSelector, nextSnapshot, _nextSelection, currentSelection, prevSnapshot, prevSelection, nextSelection, maybeGetServerSnapshot, getSnapshotWithSelector, getServerSnapshotWithSelector, getSelection, getServerSelection, value;
    return 0, _withSelectorDevelopmentMjs.__exports;
}

},{"../../../../_virtual/with-selector.development.mjs":"dG1AN","react":"ihebA","../../shim/index.mjs":"anE7B","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"dG1AN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__exports", function() {
    return withSelector_development;
});
var withSelector_development = {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"5PbLf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useConstant;
});
var _react = require("react");
function useConstant(fn) {
    var ref = _react.useRef();
    if (!ref.current) ref.current = {
        v: fn()
    };
    return ref.current.v;
}

},{"react":"ihebA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"9iJRk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flattenConnection", function() {
    return flattenConnection;
});
function flattenConnection(connection) {
    if (!connection) {
        var noConnectionErr = "flattenConnection(): needs a 'connection' to flatten, but received '".concat(connection !== null && connection !== void 0 ? connection : "", "' instead.");
        console.error(noConnectionErr + " Returning an empty array");
        return [];
    }
    if ("nodes" in connection) return connection.nodes;
    if ("edges" in connection && Array.isArray(connection.edges)) return connection.edges.map(function(edge) {
        if (!(edge == null ? void 0 : edge.node)) throw new Error("flattenConnection(): Connection edges must contain nodes");
        return edge.node;
    });
    return [];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"50yQG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCartActions", function() {
    return useCartActions;
});
var _react = require("react");
var _cartQueriesMjs = require("./cart-queries.mjs");
var _cartHooksMjs = require("./cart-hooks.mjs");
function useCartActions(param) {
    var numCartLines = param.numCartLines, cartFragment = param.cartFragment, _param_countryCode = param.countryCode, countryCode = _param_countryCode === void 0 ? "US" : _param_countryCode;
    var fetchCart = (0, _cartHooksMjs.useCartFetch)();
    var cartFetch = (0, _react.useCallback)(function(cartId) {
        return fetchCart({
            query: (0, _cartQueriesMjs.CartQuery)(cartFragment),
            variables: {
                id: cartId,
                numCartLines: numCartLines,
                country: countryCode
            }
        });
    }, [
        fetchCart,
        cartFragment,
        numCartLines,
        countryCode
    ]);
    var cartCreate = (0, _react.useCallback)(function(cart) {
        return fetchCart({
            query: (0, _cartQueriesMjs.CartCreate)(cartFragment),
            variables: {
                input: cart,
                numCartLines: numCartLines,
                country: countryCode
            }
        });
    }, [
        cartFragment,
        countryCode,
        fetchCart,
        numCartLines
    ]);
    var cartLineAdd = (0, _react.useCallback)(function(cartId, lines) {
        return fetchCart({
            query: (0, _cartQueriesMjs.CartLineAdd)(cartFragment),
            variables: {
                cartId: cartId,
                lines: lines,
                numCartLines: numCartLines,
                country: countryCode
            }
        });
    }, [
        cartFragment,
        countryCode,
        fetchCart,
        numCartLines
    ]);
    var cartLineUpdate = (0, _react.useCallback)(function(cartId, lines) {
        return fetchCart({
            query: (0, _cartQueriesMjs.CartLineUpdate)(cartFragment),
            variables: {
                cartId: cartId,
                lines: lines,
                numCartLines: numCartLines,
                country: countryCode
            }
        });
    }, [
        cartFragment,
        countryCode,
        fetchCart,
        numCartLines
    ]);
    var cartLineRemove = (0, _react.useCallback)(function(cartId, lines) {
        return fetchCart({
            query: (0, _cartQueriesMjs.CartLineRemove)(cartFragment),
            variables: {
                cartId: cartId,
                lines: lines,
                numCartLines: numCartLines,
                country: countryCode
            }
        });
    }, [
        cartFragment,
        countryCode,
        fetchCart,
        numCartLines
    ]);
    var noteUpdate = (0, _react.useCallback)(function(cartId, note) {
        return fetchCart({
            query: (0, _cartQueriesMjs.CartNoteUpdate)(cartFragment),
            variables: {
                cartId: cartId,
                note: note,
                numCartLines: numCartLines,
                country: countryCode
            }
        });
    }, [
        fetchCart,
        cartFragment,
        numCartLines,
        countryCode
    ]);
    var buyerIdentityUpdate = (0, _react.useCallback)(function(cartId, buyerIdentity) {
        return fetchCart({
            query: (0, _cartQueriesMjs.CartBuyerIdentityUpdate)(cartFragment),
            variables: {
                cartId: cartId,
                buyerIdentity: buyerIdentity,
                numCartLines: numCartLines,
                country: countryCode
            }
        });
    }, [
        cartFragment,
        countryCode,
        fetchCart,
        numCartLines
    ]);
    var cartAttributesUpdate = (0, _react.useCallback)(function(cartId, attributes) {
        return fetchCart({
            query: (0, _cartQueriesMjs.CartAttributesUpdate)(cartFragment),
            variables: {
                cartId: cartId,
                attributes: attributes,
                numCartLines: numCartLines,
                country: countryCode
            }
        });
    }, [
        cartFragment,
        countryCode,
        fetchCart,
        numCartLines
    ]);
    var discountCodesUpdate = (0, _react.useCallback)(function(cartId, discountCodes) {
        return fetchCart({
            query: (0, _cartQueriesMjs.CartDiscountCodesUpdate)(cartFragment),
            variables: {
                cartId: cartId,
                discountCodes: discountCodes,
                numCartLines: numCartLines,
                country: countryCode
            }
        });
    }, [
        cartFragment,
        countryCode,
        fetchCart,
        numCartLines
    ]);
    return (0, _react.useMemo)(function() {
        return {
            cartFetch: cartFetch,
            cartCreate: cartCreate,
            cartLineAdd: cartLineAdd,
            cartLineUpdate: cartLineUpdate,
            cartLineRemove: cartLineRemove,
            noteUpdate: noteUpdate,
            buyerIdentityUpdate: buyerIdentityUpdate,
            cartAttributesUpdate: cartAttributesUpdate,
            discountCodesUpdate: discountCodesUpdate,
            cartFragment: cartFragment
        };
    }, [
        cartFetch,
        cartCreate,
        cartLineAdd,
        cartLineUpdate,
        cartLineRemove,
        noteUpdate,
        buyerIdentityUpdate,
        cartAttributesUpdate,
        discountCodesUpdate,
        cartFragment
    ]);
}

},{"react":"ihebA","./cart-queries.mjs":"e976l","./cart-hooks.mjs":"izKMy","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"e976l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartAttributesUpdate", function() {
    return CartAttributesUpdate;
});
parcelHelpers.export(exports, "CartBuyerIdentityUpdate", function() {
    return CartBuyerIdentityUpdate;
});
parcelHelpers.export(exports, "CartCreate", function() {
    return CartCreate;
});
parcelHelpers.export(exports, "CartDiscountCodesUpdate", function() {
    return CartDiscountCodesUpdate;
});
parcelHelpers.export(exports, "CartLineAdd", function() {
    return CartLineAdd;
});
parcelHelpers.export(exports, "CartLineRemove", function() {
    return CartLineRemove;
});
parcelHelpers.export(exports, "CartLineUpdate", function() {
    return CartLineUpdate;
});
parcelHelpers.export(exports, "CartNoteUpdate", function() {
    return CartNoteUpdate;
});
parcelHelpers.export(exports, "CartQuery", function() {
    return CartQuery;
});
parcelHelpers.export(exports, "defaultCartFragment", function() {
    return defaultCartFragment;
});
var CartLineAdd = function(cartFragment) {
    return /* GraphQL */ "\n  mutation CartLineAdd(\n    $cartId: ID!\n    $lines: [CartLineInput!]!\n    $numCartLines: Int = 250\n    $country: CountryCode = ZZ\n  ) @inContext(country: $country) {\n    cartLinesAdd(cartId: $cartId, lines: $lines) {\n      cart {\n        ...CartFragment\n      }\n    }\n  }\n\n  ".concat(cartFragment, "\n");
};
var CartCreate = function(cartFragment) {
    return /* GraphQL */ "\n  mutation CartCreate(\n    $input: CartInput!\n    $numCartLines: Int = 250\n    $country: CountryCode = ZZ\n  ) @inContext(country: $country) {\n    cartCreate(input: $input) {\n      cart {\n        ...CartFragment\n      }\n    }\n  }\n\n  ".concat(cartFragment, "\n");
};
var CartLineRemove = function(cartFragment) {
    return /* GraphQL */ "\n  mutation CartLineRemove(\n    $cartId: ID!\n    $lines: [ID!]!\n    $numCartLines: Int = 250\n    $country: CountryCode = ZZ\n  ) @inContext(country: $country) {\n    cartLinesRemove(cartId: $cartId, lineIds: $lines) {\n      cart {\n        ...CartFragment\n      }\n    }\n  }\n\n  ".concat(cartFragment, "\n");
};
var CartLineUpdate = function(cartFragment) {
    return /* GraphQL */ "\n  mutation CartLineUpdate(\n    $cartId: ID!\n    $lines: [CartLineUpdateInput!]!\n    $numCartLines: Int = 250\n    $country: CountryCode = ZZ\n  ) @inContext(country: $country) {\n    cartLinesUpdate(cartId: $cartId, lines: $lines) {\n      cart {\n        ...CartFragment\n      }\n    }\n  }\n\n  ".concat(cartFragment, "\n");
};
var CartNoteUpdate = function(cartFragment) {
    return /* GraphQL */ "\n  mutation CartNoteUpdate(\n    $cartId: ID!\n    $note: String\n    $numCartLines: Int = 250\n    $country: CountryCode = ZZ\n  ) @inContext(country: $country) {\n    cartNoteUpdate(cartId: $cartId, note: $note) {\n      cart {\n        ...CartFragment\n      }\n    }\n  }\n\n  ".concat(cartFragment, "\n");
};
var CartBuyerIdentityUpdate = function(cartFragment) {
    return /* GraphQL */ "\n  mutation CartBuyerIdentityUpdate(\n    $cartId: ID!\n    $buyerIdentity: CartBuyerIdentityInput!\n    $numCartLines: Int = 250\n    $country: CountryCode = ZZ\n  ) @inContext(country: $country) {\n    cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {\n      cart {\n        ...CartFragment\n      }\n    }\n  }\n\n  ".concat(cartFragment, "\n");
};
var CartAttributesUpdate = function(cartFragment) {
    return /* GraphQL */ "\n  mutation CartAttributesUpdate(\n    $attributes: [AttributeInput!]!\n    $cartId: ID!\n    $numCartLines: Int = 250\n    $country: CountryCode = ZZ\n  ) @inContext(country: $country) {\n    cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {\n      cart {\n        ...CartFragment\n      }\n    }\n  }\n\n  ".concat(cartFragment, "\n");
};
var CartDiscountCodesUpdate = function(cartFragment) {
    return /* GraphQL */ "\n  mutation CartDiscountCodesUpdate(\n    $cartId: ID!\n    $discountCodes: [String!]\n    $numCartLines: Int = 250\n    $country: CountryCode = ZZ\n  ) @inContext(country: $country) {\n    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {\n      cart {\n        ...CartFragment\n      }\n    }\n  }\n\n  ".concat(cartFragment, "\n");
};
var CartQuery = function(cartFragment) {
    return /* GraphQL */ "\n  query CartQuery(\n    $id: ID!\n    $numCartLines: Int = 250\n    $country: CountryCode = ZZ\n  ) @inContext(country: $country) {\n    cart(id: $id) {\n      ...CartFragment\n    }\n  }\n\n  ".concat(cartFragment, "\n");
};
var defaultCartFragment = "\n  fragment CartFragment on Cart {\n    id\n    checkoutUrl\n    totalQuantity\n    buyerIdentity {\n      countryCode\n      customer {\n        id\n        email\n        firstName\n        lastName\n        displayName\n      }\n      email\n      phone\n    }\n    lines(first: $numCartLines) {\n      edges {\n        node {\n          id\n          quantity\n          attributes {\n            key\n            value\n          }\n          cost {\n            totalAmount {\n              amount\n              currencyCode\n            }\n            compareAtAmountPerQuantity {\n              amount\n              currencyCode\n            }\n          }\n          merchandise {\n            ... on ProductVariant {\n              id\n              availableForSale\n              compareAtPrice {\n                ...MoneyFragment\n              }\n              price {\n                ...MoneyFragment\n              }\n              requiresShipping\n              title\n              image {\n                ...ImageFragment\n              }\n              product {\n                handle\n                title\n                id\n              }\n              selectedOptions {\n                name\n                value\n              }\n            }\n          }\n        }\n      }\n    }\n    cost {\n      subtotalAmount {\n        ...MoneyFragment\n      }\n      totalAmount {\n        ...MoneyFragment\n      }\n      totalDutyAmount {\n        ...MoneyFragment\n      }\n      totalTaxAmount {\n        ...MoneyFragment\n      }\n    }\n    note\n    attributes {\n      key\n      value\n    }\n    discountCodes {\n      code\n    }\n  }\n\n  fragment MoneyFragment on MoneyV2 {\n    currencyCode\n    amount\n  }\n  fragment ImageFragment on Image {\n    id\n    url\n    altText\n    width\n    height\n  }\n";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"izKMy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCartFetch", function() {
    return useCartFetch;
});
var _react = require("react");
var _shopifyProviderMjs = require("./ShopifyProvider.mjs");
var _cartConstantsMjs = require("./cart-constants.mjs");
var _cookiesUtilsMjs = require("./cookies-utils.mjs");
function useCartFetch() {
    var _useShop = (0, _shopifyProviderMjs.useShop)(), storefrontId = _useShop.storefrontId, getPublicTokenHeaders = _useShop.getPublicTokenHeaders, getStorefrontApiUrl = _useShop.getStorefrontApiUrl;
    return (0, _react.useCallback)(function(param) {
        var query = param.query, variables = param.variables;
        var headers = getPublicTokenHeaders({
            contentType: "json"
        });
        if (storefrontId) headers[0, _cartConstantsMjs.SHOPIFY_STOREFRONT_ID_HEADER] = storefrontId;
        var cookieData = (0, _cookiesUtilsMjs.getShopifyCookies)(document.cookie);
        headers[0, _cartConstantsMjs.SHOPIFY_STOREFRONT_Y_HEADER] = cookieData[0, _cartConstantsMjs.SHOPIFY_Y];
        headers[0, _cartConstantsMjs.SHOPIFY_STOREFRONT_S_HEADER] = cookieData[0, _cartConstantsMjs.SHOPIFY_S];
        return fetch(getStorefrontApiUrl(), {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                query: query.toString(),
                variables: variables
            })
        }).then(function(res) {
            return res.json();
        }).catch(function(error) {
            return {
                data: void 0,
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
                errors: error == null ? void 0 : error.toString()
            };
        });
    }, [
        getPublicTokenHeaders,
        storefrontId,
        getStorefrontApiUrl
    ]);
}

},{"react":"ihebA","./ShopifyProvider.mjs":"6TpGm","./cart-constants.mjs":"f5ldq","./cookies-utils.mjs":"gGHAO","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"6TpGm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ShopifyProvider", function() {
    return ShopifyProvider;
});
parcelHelpers.export(exports, "defaultShopifyContext", function() {
    return defaultShopifyContext;
});
parcelHelpers.export(exports, "useShop", function() {
    return useShop;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _objectWithoutPropertiesMjs = require("@swc/helpers/src/_object_without_properties.mjs");
var _objectWithoutPropertiesMjsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _storefrontApiConstantsMjs = require("./storefront-api-constants.mjs");
var _storefrontClientMjs = require("./storefront-client.mjs");
var defaultShopifyContext = {
    storeDomain: "test",
    storefrontToken: "abc123",
    storefrontApiVersion: (0, _storefrontApiConstantsMjs.SFAPI_VERSION),
    countryIsoCode: "US",
    languageIsoCode: "EN",
    getStorefrontApiUrl: function() {
        return "";
    },
    getPublicTokenHeaders: function() {
        return {};
    },
    getShopifyDomain: function() {
        return "";
    }
};
var ShopifyContext = (0, _react.createContext)(defaultShopifyContext);
function ShopifyProvider(_param) {
    var children = _param.children, shopifyConfig = (0, _objectWithoutPropertiesMjsDefault.default)(_param, [
        "children"
    ]);
    if (!shopifyConfig.countryIsoCode || !shopifyConfig.languageIsoCode || !shopifyConfig.storeDomain || !shopifyConfig.storefrontToken || !shopifyConfig.storefrontApiVersion) throw new Error("Please provide the necessary props to '<ShopifyProvider/>'");
    if (shopifyConfig.storefrontApiVersion !== (0, _storefrontApiConstantsMjs.SFAPI_VERSION)) console.warn("<ShopifyProvider/>: This version of Hydrogen React is built for Shopify's Storefront API version ".concat((0, _storefrontApiConstantsMjs.SFAPI_VERSION), ", but it looks like you're using version ").concat(shopifyConfig.storefrontApiVersion, ". There may be issues or bugs if you use a mismatched version of Hydrogen React and the Storefront API."));
    var finalConfig = (0, _react.useMemo)(function() {
        var getShopifyDomain = function getShopifyDomain(overrideProps) {
            var _ref;
            return (_ref = overrideProps == null ? void 0 : overrideProps.storeDomain) !== null && _ref !== void 0 ? _ref : shopifyConfig.storeDomain;
        };
        return (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, shopifyConfig), {
            getPublicTokenHeaders: function(overrideProps) {
                var _overrideProps_storefrontToken;
                return (0, _storefrontClientMjs.getPublicTokenHeadersRaw)(overrideProps.contentType, shopifyConfig.storefrontApiVersion, (_overrideProps_storefrontToken = overrideProps.storefrontToken) !== null && _overrideProps_storefrontToken !== void 0 ? _overrideProps_storefrontToken : shopifyConfig.storefrontToken);
            },
            getShopifyDomain: getShopifyDomain,
            getStorefrontApiUrl: function(overrideProps) {
                var _ref;
                var finalDomainUrl = getShopifyDomain({
                    storeDomain: (_ref = overrideProps == null ? void 0 : overrideProps.storeDomain) !== null && _ref !== void 0 ? _ref : shopifyConfig.storeDomain
                });
                var _ref1;
                return "".concat(finalDomainUrl).concat(finalDomainUrl.endsWith("/") ? "" : "/", "api/").concat((_ref1 = overrideProps == null ? void 0 : overrideProps.storefrontApiVersion) !== null && _ref1 !== void 0 ? _ref1 : shopifyConfig.storefrontApiVersion, "/graphql.json");
            }
        });
    }, [
        shopifyConfig
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(ShopifyContext.Provider, {
        value: finalConfig,
        children: children
    });
}
function useShop() {
    var shopContext = (0, _react.useContext)(ShopifyContext);
    if (!shopContext) throw new Error("'useShop()' must be a descendent of <ShopifyProvider/>");
    return shopContext;
}

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","@swc/helpers/src/_object_without_properties.mjs":"d0eOZ","react/jsx-runtime":"ebSqZ","react":"ihebA","./storefront-api-constants.mjs":"fKpD6","./storefront-client.mjs":"5uSEd","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"fKpD6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SFAPI_VERSION", function() {
    return SFAPI_VERSION;
});
var SFAPI_VERSION = "2023-04";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"5uSEd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStorefrontClient", function() {
    return createStorefrontClient;
});
parcelHelpers.export(exports, "getPublicTokenHeadersRaw", function() {
    return getPublicTokenHeadersRaw;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _storefrontApiConstantsMjs = require("./storefront-api-constants.mjs");
function createStorefrontClient(props) {
    var storeDomain = props.storeDomain, privateStorefrontToken = props.privateStorefrontToken, publicStorefrontToken = props.publicStorefrontToken, _props_storefrontApiVersion = props.storefrontApiVersion, storefrontApiVersion = _props_storefrontApiVersion === void 0 ? (0, _storefrontApiConstantsMjs.SFAPI_VERSION) : _props_storefrontApiVersion, contentType = props.contentType;
    if (storefrontApiVersion !== (0, _storefrontApiConstantsMjs.SFAPI_VERSION)) warnOnce("StorefrontClient: The Storefront API version that you're using is different than the version this build of Hydrogen React is targeting. You may run into unexpected errors if these versions don't match. Received verion: \"".concat(storefrontApiVersion, '"; expected version "').concat((0, _storefrontApiConstantsMjs.SFAPI_VERSION), '"'));
    var isMockShop = function(domain) {
        return domain.includes("mock.shop");
    };
    var getShopifyDomain = function(overrideProps) {
        var _ref;
        var domain = (_ref = overrideProps == null ? void 0 : overrideProps.storeDomain) !== null && _ref !== void 0 ? _ref : storeDomain;
        return domain.includes("://") ? domain : "https://".concat(domain);
    };
    return {
        getShopifyDomain: getShopifyDomain,
        getStorefrontApiUrl: function(overrideProps) {
            var domain = getShopifyDomain(overrideProps);
            var apiUrl = domain + (domain.endsWith("/") ? "api" : "/api");
            if (isMockShop(domain)) return apiUrl;
            var _ref;
            return "".concat(apiUrl, "/").concat((_ref = overrideProps == null ? void 0 : overrideProps.storefrontApiVersion) !== null && _ref !== void 0 ? _ref : storefrontApiVersion, "/graphql.json");
        },
        getPrivateTokenHeaders: function(overrideProps) {
            if (!privateStorefrontToken && !(overrideProps == null ? void 0 : overrideProps.privateStorefrontToken) && !isMockShop(storeDomain)) throw new Error("StorefrontClient: You did not pass in a 'privateStorefrontToken' while using 'getPrivateTokenHeaders()'");
            var _ref;
            var finalContentType = (_ref = overrideProps == null ? void 0 : overrideProps.contentType) !== null && _ref !== void 0 ? _ref : contentType;
            var _ref1, _ref2;
            return (0, _objectSpreadMjsDefault.default)({
                // default to json
                "content-type": finalContentType === "graphql" ? "application/graphql" : "application/json",
                "X-SDK-Variant": "hydrogen-react",
                "X-SDK-Variant-Source": "react",
                "X-SDK-Version": storefrontApiVersion,
                "Shopify-Storefront-Private-Token": (_ref2 = (_ref1 = overrideProps == null ? void 0 : overrideProps.privateStorefrontToken) !== null && _ref1 !== void 0 ? _ref1 : privateStorefrontToken) !== null && _ref2 !== void 0 ? _ref2 : ""
            }, (overrideProps == null ? void 0 : overrideProps.buyerIp) ? {
                "Shopify-Storefront-Buyer-IP": overrideProps.buyerIp
            } : {});
        },
        getPublicTokenHeaders: function(overrideProps) {
            if (!publicStorefrontToken && !(overrideProps == null ? void 0 : overrideProps.publicStorefrontToken) && !isMockShop(storeDomain)) throw new Error("StorefrontClient: You did not pass in a 'publicStorefrontToken' while using 'getPublicTokenHeaders()'");
            var _ref, _ref1;
            var finalContentType = (_ref1 = (_ref = overrideProps == null ? void 0 : overrideProps.contentType) !== null && _ref !== void 0 ? _ref : contentType) !== null && _ref1 !== void 0 ? _ref1 : "json";
            var _ref2, _ref3;
            return getPublicTokenHeadersRaw(finalContentType, storefrontApiVersion, (_ref3 = (_ref2 = overrideProps == null ? void 0 : overrideProps.publicStorefrontToken) !== null && _ref2 !== void 0 ? _ref2 : publicStorefrontToken) !== null && _ref3 !== void 0 ? _ref3 : "");
        }
    };
}
function getPublicTokenHeadersRaw(contentType, storefrontApiVersion, accessToken) {
    return {
        // default to json
        "content-type": contentType === "graphql" ? "application/graphql" : "application/json",
        "X-SDK-Variant": "hydrogen-react",
        "X-SDK-Variant-Source": "react",
        "X-SDK-Version": storefrontApiVersion,
        "X-Shopify-Storefront-Access-Token": accessToken
    };
}
var warnings = /* @__PURE__ */ new Set();
var warnOnce = function(string) {
    if (!warnings.has(string)) {
        console.warn(string);
        warnings.add(string);
    }
};

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","./storefront-api-constants.mjs":"fKpD6","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"f5ldq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CART_ID_STORAGE_KEY", function() {
    return CART_ID_STORAGE_KEY;
});
parcelHelpers.export(exports, "SHOPIFY_S", function() {
    return SHOPIFY_S;
});
parcelHelpers.export(exports, "SHOPIFY_STOREFRONT_ID_HEADER", function() {
    return SHOPIFY_STOREFRONT_ID_HEADER;
});
parcelHelpers.export(exports, "SHOPIFY_STOREFRONT_S_HEADER", function() {
    return SHOPIFY_STOREFRONT_S_HEADER;
});
parcelHelpers.export(exports, "SHOPIFY_STOREFRONT_Y_HEADER", function() {
    return SHOPIFY_STOREFRONT_Y_HEADER;
});
parcelHelpers.export(exports, "SHOPIFY_Y", function() {
    return SHOPIFY_Y;
});
var CART_ID_STORAGE_KEY = "shopifyCartId";
var SHOPIFY_STOREFRONT_ID_HEADER = "Shopify-Storefront-Id";
var SHOPIFY_STOREFRONT_Y_HEADER = "Shopify-Storefront-Y";
var SHOPIFY_STOREFRONT_S_HEADER = "Shopify-Storefront-S";
var SHOPIFY_Y = "_shopify_y";
var SHOPIFY_S = "_shopify_s";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"gGHAO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildUUID", function() {
    return buildUUID;
});
parcelHelpers.export(exports, "getShopifyCookies", function() {
    return getShopifyCookies;
});
parcelHelpers.export(exports, "hexTime", function() {
    return hexTime;
});
var _definePropertyMjs = require("@swc/helpers/src/_define_property.mjs");
var _definePropertyMjsDefault = parcelHelpers.interopDefault(_definePropertyMjs);
var _cookie = require("worktop/cookie");
var _cartConstantsMjs = require("./cart-constants.mjs");
var tokenHash = "xxxx-4xxx-xxxx-xxxxxxxxxxxx";
function buildUUID() {
    var hash = "";
    try {
        var crypto = window.crypto;
        var randomValuesArray = new Uint16Array(31);
        crypto.getRandomValues(randomValuesArray);
        var i = 0;
        hash = tokenHash.replace(/[x]/g, function(c) {
            var r = randomValuesArray[i] % 16;
            var v = c === "x" ? r : r & 3 | 8;
            i++;
            return v.toString(16);
        }).toUpperCase();
    } catch (err) {
        hash = tokenHash.replace(/[x]/g, function(c) {
            var r = Math.random() * 16 | 0;
            var v = c === "x" ? r : r & 3 | 8;
            return v.toString(16);
        }).toUpperCase();
    }
    return "".concat(hexTime(), "-").concat(hash);
}
function hexTime() {
    var dateNumber = 0;
    var perfNumber = 0;
    dateNumber = new Date().getTime() >>> 0;
    try {
        perfNumber = performance.now() >>> 0;
    } catch (err) {
        perfNumber = 0;
    }
    var output = Math.abs(dateNumber + perfNumber).toString(16).toLowerCase();
    return output.padStart(8 - output.length, "0");
}
function getShopifyCookies(cookies) {
    var cookieData = (0, _cookie.parse)(cookies);
    var _obj;
    return _obj = {}, (0, _definePropertyMjsDefault.default)(_obj, (0, _cartConstantsMjs.SHOPIFY_Y), cookieData[0, _cartConstantsMjs.SHOPIFY_Y] || ""), (0, _definePropertyMjsDefault.default)(_obj, (0, _cartConstantsMjs.SHOPIFY_S), cookieData[0, _cartConstantsMjs.SHOPIFY_S] || ""), _obj;
}

},{"@swc/helpers/src/_define_property.mjs":"eI7TS","worktop/cookie":"7S9xN","./cart-constants.mjs":"f5ldq","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"7S9xN":[function(require,module,exports) {
// src/cookie.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parse", function() {
    return u;
});
parcelHelpers.export(exports, "stringify", function() {
    return l;
});
var g = new Set([
    "domain",
    "path",
    "max-age",
    "expires",
    "samesite",
    "secure",
    "httponly"
]);
function u(a) {
    var r = {}, e, t, n = 0, m = a.split(/;\s*/g), s, i;
    for(; n < m.length; n++)if (t = m[n], e = t.indexOf("="), ~e) {
        if (s = t.substring(0, e++).trim(), i = t.substring(e).trim(), i[0] === '"' && (i = i.substring(1, i.length - 1)), ~i.indexOf("%")) try {
            i = decodeURIComponent(i);
        } catch (f) {}
        g.has(t = s.toLowerCase()) ? t === "expires" ? r.expires = new Date(i) : t === "max-age" ? r.maxage = +i : r[t] = i : r[s] = i;
    } else (s = t.trim().toLowerCase()) && (s === "httponly" || s === "secure") && (r[s] = !0);
    return r;
}
function l(a, r) {
    var e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var t = a + "=" + encodeURIComponent(r);
    return e.expires && (t += "; Expires=" + new Date(e.expires).toUTCString()), e.maxage != null && e.maxage >= 0 && (t += "; Max-Age=" + (e.maxage | 0)), e.domain && (t += "; Domain=" + e.domain), e.path && (t += "; Path=" + e.path), e.samesite && (t += "; SameSite=" + e.samesite), (e.secure || e.samesite === "None") && (t += "; Secure"), e.httponly && (t += "; HttpOnly"), t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"8WO5h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProductProvider", function() {
    return ProductProvider;
});
parcelHelpers.export(exports, "useProduct", function() {
    return useProduct;
});
var _definePropertyMjs = require("@swc/helpers/src/_define_property.mjs");
var _definePropertyMjsDefault = parcelHelpers.interopDefault(_definePropertyMjs);
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _flattenConnectionMjs = require("./flatten-connection.mjs");
var ProductOptionsContext = (0, _react.createContext)(null);
function ProductProvider(param) {
    var children = param.children, product = param.data, explicitVariantId = param.initialVariantId;
    var _product_variants;
    var variants = (0, _react.useMemo)(function() {
        return (0, _flattenConnectionMjs.flattenConnection)((_product_variants = product.variants) !== null && _product_variants !== void 0 ? _product_variants : {});
    }, [
        product.variants
    ]);
    if (!isProductVariantArray(variants)) throw new Error("<ProductProvider/> requires 'product.variants.nodes' or 'product.variants.edges'");
    var options = (0, _react.useMemo)(function() {
        return getOptions(variants);
    }, [
        variants
    ]);
    var _useState = (0, _slicedToArrayMjsDefault.default)((0, _react.useState)(function() {
        return getVariantBasedOnIdProp(explicitVariantId, variants);
    }), 2), selectedVariant = _useState[0], setSelectedVariant = _useState[1];
    var _useState1 = (0, _slicedToArrayMjsDefault.default)((0, _react.useState)(function() {
        return getSelectedOptions(selectedVariant);
    }), 2), selectedOptions = _useState1[0], setSelectedOptions = _useState1[1];
    (0, _react.useEffect)(function() {
        var newSelectedVariant = getVariantBasedOnIdProp(explicitVariantId, variants);
        setSelectedVariant(newSelectedVariant);
        setSelectedOptions(getSelectedOptions(newSelectedVariant));
    }, [
        explicitVariantId,
        variants
    ]);
    var setSelectedOption = (0, _react.useCallback)(function(name, value2) {
        setSelectedOptions(function(selectedOptions2) {
            var opts = (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, selectedOptions2), (0, _definePropertyMjsDefault.default)({}, name, value2));
            setSelectedVariant(getSelectedVariant(variants, opts));
            return opts;
        });
    }, [
        setSelectedOptions,
        variants
    ]);
    var isOptionInStock = (0, _react.useCallback)(function(option, value2) {
        var proposedVariant = getSelectedVariant(variants, (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, selectedOptions), (0, _definePropertyMjsDefault.default)({}, option, value2)));
        var _ref;
        return (_ref = proposedVariant == null ? void 0 : proposedVariant.availableForSale) !== null && _ref !== void 0 ? _ref : true;
    }, [
        selectedOptions,
        variants
    ]);
    var _product_sellingPlanGroups, _ref;
    var sellingPlanGroups = (0, _react.useMemo)(function() {
        return (0, _flattenConnectionMjs.flattenConnection)((_product_sellingPlanGroups = product.sellingPlanGroups) !== null && _product_sellingPlanGroups !== void 0 ? _product_sellingPlanGroups : {}).map(function(sellingPlanGroup) {
            return (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, sellingPlanGroup), {
                sellingPlans: (0, _flattenConnectionMjs.flattenConnection)((_ref = sellingPlanGroup == null ? void 0 : sellingPlanGroup.sellingPlans) !== null && _ref !== void 0 ? _ref : {})
            });
        });
    }, [
        product.sellingPlanGroups
    ]);
    var _useState2 = (0, _slicedToArrayMjsDefault.default)((0, _react.useState)(void 0), 2), selectedSellingPlan = _useState2[0], setSelectedSellingPlan = _useState2[1];
    var selectedSellingPlanAllocation = (0, _react.useMemo)(function() {
        var _a, _b;
        if (!selectedVariant || !selectedSellingPlan) return;
        if (!((_a = selectedVariant.sellingPlanAllocations) == null ? void 0 : _a.nodes) && !((_b = selectedVariant.sellingPlanAllocations) == null ? void 0 : _b.edges)) throw new Error("<ProductProvider/>: You must include 'sellingPlanAllocations.nodes' or 'sellingPlanAllocations.edges' in your variants in order to calculate selectedSellingPlanAllocation");
        return (0, _flattenConnectionMjs.flattenConnection)(selectedVariant.sellingPlanAllocations).find(function(allocation) {
            var _a2;
            return ((_a2 = allocation == null ? void 0 : allocation.sellingPlan) == null ? void 0 : _a2.id) === selectedSellingPlan.id;
        });
    }, [
        selectedVariant,
        selectedSellingPlan
    ]);
    var value = (0, _react.useMemo)(function() {
        return {
            product: product,
            variants: variants,
            variantsConnection: product.variants,
            options: options,
            selectedVariant: selectedVariant,
            setSelectedVariant: setSelectedVariant,
            selectedOptions: selectedOptions,
            setSelectedOption: setSelectedOption,
            setSelectedOptions: setSelectedOptions,
            isOptionInStock: isOptionInStock,
            selectedSellingPlan: selectedSellingPlan,
            setSelectedSellingPlan: setSelectedSellingPlan,
            selectedSellingPlanAllocation: selectedSellingPlanAllocation,
            sellingPlanGroups: sellingPlanGroups,
            sellingPlanGroupsConnection: product.sellingPlanGroups
        };
    }, [
        product,
        isOptionInStock,
        options,
        selectedOptions,
        selectedSellingPlan,
        selectedSellingPlanAllocation,
        selectedVariant,
        sellingPlanGroups,
        setSelectedOption,
        variants
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(ProductOptionsContext.Provider, {
        value: value,
        children: children
    });
}
function useProduct() {
    var context = (0, _react.useContext)(ProductOptionsContext);
    if (!context) throw new Error("'useProduct' must be a child of <ProductProvider />");
    return context;
}
function getSelectedVariant(variants, choices) {
    var _a, _b;
    if (!variants.length || ((_b = (_a = variants == null ? void 0 : variants[0]) == null ? void 0 : _a.selectedOptions) == null ? void 0 : _b.length) !== Object.keys(choices).length) return;
    return variants == null ? void 0 : variants.find(function(variant) {
        return Object.entries(choices).every(function(param) {
            var _param = (0, _slicedToArrayMjsDefault.default)(param, 2), name = _param[0], value = _param[1];
            var _a2;
            return (_a2 = variant == null ? void 0 : variant.selectedOptions) == null ? void 0 : _a2.some(function(option) {
                return (option == null ? void 0 : option.name) === name && (option == null ? void 0 : option.value) === value;
            });
        });
    });
}
function getOptions(variants) {
    var map = variants.reduce(function(memo, variant) {
        var _a;
        if (!variant.selectedOptions) throw new Error("'getOptions' requires 'variant.selectedOptions'");
        (_a = variant == null ? void 0 : variant.selectedOptions) == null || _a.forEach(function(opt) {
            var _ref, _ref1;
            memo[(_ref = opt == null ? void 0 : opt.name) !== null && _ref !== void 0 ? _ref : ""] = memo[(_ref1 = opt == null ? void 0 : opt.name) !== null && _ref1 !== void 0 ? _ref1 : ""] || /* @__PURE__ */ new Set();
            var _ref2, _ref3;
            memo[(_ref2 = opt == null ? void 0 : opt.name) !== null && _ref2 !== void 0 ? _ref2 : ""].add((_ref3 = opt == null ? void 0 : opt.value) !== null && _ref3 !== void 0 ? _ref3 : "");
        });
        return memo;
    }, {});
    return Object.keys(map).map(function(option) {
        return {
            name: option,
            values: Array.from(map[option])
        };
    });
}
function getVariantBasedOnIdProp(explicitVariantId, variants) {
    if (explicitVariantId) {
        var foundVariant = variants.find(function(variant) {
            return (variant == null ? void 0 : variant.id) === explicitVariantId;
        });
        if (!foundVariant) console.warn("<ProductProvider/> received a 'initialVariantId' prop, but could not actually find a variant with that ID");
        return foundVariant;
    }
    if (explicitVariantId === null) return null;
    if (explicitVariantId === void 0) return variants.find(function(variant) {
        return variant == null ? void 0 : variant.availableForSale;
    }) || variants[0];
}
function getSelectedOptions(selectedVariant) {
    return (selectedVariant == null ? void 0 : selectedVariant.selectedOptions) ? selectedVariant.selectedOptions.reduce(function(memo, optionSet) {
        var _ref, _ref1;
        memo[(_ref = optionSet == null ? void 0 : optionSet.name) !== null && _ref !== void 0 ? _ref : ""] = (_ref1 = optionSet == null ? void 0 : optionSet.value) !== null && _ref1 !== void 0 ? _ref1 : "";
        return memo;
    }, {}) : {};
}
function isProductVariantArray(maybeVariantArray) {
    if (!maybeVariantArray || !Array.isArray(maybeVariantArray)) return false;
    return true;
}

},{"@swc/helpers/src/_define_property.mjs":"eI7TS","@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","@swc/helpers/src/_sliced_to_array.mjs":"l34hS","react/jsx-runtime":"ebSqZ","react":"ihebA","./flatten-connection.mjs":"9iJRk","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"fb2fP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseButton", function() {
    return BaseButton;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _objectWithoutPropertiesMjs = require("@swc/helpers/src/_object_without_properties.mjs");
var _objectWithoutPropertiesMjsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
function BaseButton(props) {
    var as = props.as, onClick = props.onClick, defaultOnClick = props.defaultOnClick, children = props.children, buttonRef = props.buttonRef, passthroughProps = (0, _objectWithoutPropertiesMjsDefault.default)(props, [
        "as",
        "onClick",
        "defaultOnClick",
        "children",
        "buttonRef"
    ]);
    var handleOnClick = (0, _react.useCallback)(function(event) {
        if (onClick) {
            var clickShouldContinue = onClick(event);
            if (typeof clickShouldContinue === "boolean" && clickShouldContinue === false || (event == null ? void 0 : event.defaultPrevented)) return;
        }
        defaultOnClick == null || defaultOnClick(event);
    }, [
        defaultOnClick,
        onClick
    ]);
    var Component = as || "button";
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Component, (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({
        ref: buttonRef,
        onClick: handleOnClick
    }, passthroughProps), {
        children: children
    }));
}

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","@swc/helpers/src/_object_without_properties.mjs":"d0eOZ","react/jsx-runtime":"ebSqZ","react":"ihebA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"bnCSJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getClientBrowserParameters", function() {
    return getClientBrowserParameters;
});
parcelHelpers.export(exports, "sendShopifyAnalytics", function() {
    return sendShopifyAnalytics;
});
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _cartConstantsMjs = require("./cart-constants.mjs");
var _analyticsConstantsMjs = require("./analytics-constants.mjs");
var _analyticsUtilsMjs = require("./analytics-utils.mjs");
var _cookiesUtilsMjs = require("./cookies-utils.mjs");
var _analyticsSchemaTrekkieStorefrontPageViewMjs = require("./analytics-schema-trekkie-storefront-page-view.mjs");
var _analyticsSchemaCustomStorefrontCustomerTrackingMjs = require("./analytics-schema-custom-storefront-customer-tracking.mjs");
function sendShopifyAnalytics(event, shopDomain) {
    var eventName = event.eventName, payload = event.payload;
    if (!payload.hasUserConsent) return Promise.resolve();
    var events = [];
    if (eventName === (0, _analyticsConstantsMjs.AnalyticsEventName).PAGE_VIEW) {
        var pageViewPayload = payload;
        events = events.concat((0, _analyticsSchemaTrekkieStorefrontPageViewMjs.pageView)(pageViewPayload), (0, _analyticsSchemaCustomStorefrontCustomerTrackingMjs.pageView)(pageViewPayload));
    } else if (eventName === (0, _analyticsConstantsMjs.AnalyticsEventName).ADD_TO_CART) events = events.concat((0, _analyticsSchemaCustomStorefrontCustomerTrackingMjs.addToCart)(payload));
    if (events.length) return sendToShopify(events, shopDomain);
    else return Promise.resolve();
}
var ERROR_MESSAGE = "sendShopifyAnalytics request is unsuccessful";
function sendToShopify(events, shopDomain) {
    var eventsToBeSent = {
        events: events,
        metadata: {
            event_sent_at_ms: Date.now()
        }
    };
    try {
        return fetch(shopDomain ? "https://".concat(shopDomain, "/.well-known/shopify/monorail/unstable/produce_batch") : "https://monorail-edge.shopifysvc.com/unstable/produce_batch", {
            method: "post",
            headers: {
                "content-type": "text/plain"
            },
            body: JSON.stringify(eventsToBeSent)
        }).then(function(response) {
            if (!response.ok) throw new Error("Response failed");
            return response.text();
        }).then(function(data) {
            if (data) {
                var jsonResponse = JSON.parse(data);
                jsonResponse.result.forEach(function(eventResponse) {
                    if (eventResponse.status !== 200) console.error(ERROR_MESSAGE, "\n\n", eventResponse.message);
                });
            }
        }).catch(function(err) {
            console.error(ERROR_MESSAGE, err);
        });
    } catch (error) {
        return Promise.resolve();
    }
}
function getClientBrowserParameters() {
    if ((0, _analyticsUtilsMjs.errorIfServer)("getClientBrowserParameters")) return {
        uniqueToken: "",
        visitToken: "",
        url: "",
        path: "",
        search: "",
        referrer: "",
        title: "",
        userAgent: "",
        navigationType: "",
        navigationApi: ""
    };
    var _getNavigationType = (0, _slicedToArrayMjsDefault.default)(getNavigationType(), 2), navigationType = _getNavigationType[0], navigationApi = _getNavigationType[1];
    var cookies = (0, _cookiesUtilsMjs.getShopifyCookies)(document.cookie);
    return {
        uniqueToken: cookies[0, _cartConstantsMjs.SHOPIFY_Y],
        visitToken: cookies[0, _cartConstantsMjs.SHOPIFY_S],
        url: location.href,
        path: location.pathname,
        search: location.search,
        referrer: document.referrer,
        title: document.title,
        userAgent: navigator.userAgent,
        navigationType: navigationType,
        navigationApi: navigationApi
    };
}
function getNavigationTypeExperimental() {
    try {
        var navigationEntries = (performance == null ? void 0 : performance.getEntriesByType) && (performance == null ? void 0 : performance.getEntriesByType("navigation"));
        if (navigationEntries && navigationEntries[0]) {
            var rawType = window.performance.getEntriesByType("navigation")[0]["type"];
            var navType = rawType && rawType.toString();
            return navType;
        }
    } catch (err) {}
    return void 0;
}
function getNavigationTypeLegacy() {
    var _a, _b;
    try {
        if (PerformanceNavigation && ((_a = performance == null ? void 0 : performance.navigation) == null ? void 0 : _a.type) !== null && ((_b = performance == null ? void 0 : performance.navigation) == null ? void 0 : _b.type) !== void 0) {
            var rawType = performance.navigation.type;
            switch(rawType){
                case PerformanceNavigation.TYPE_NAVIGATE:
                    return "navigate";
                case PerformanceNavigation.TYPE_RELOAD:
                    return "reload";
                case PerformanceNavigation.TYPE_BACK_FORWARD:
                    return "back_forward";
                default:
                    return "unknown: ".concat(rawType);
            }
        }
    } catch (err) {}
    return void 0;
}
function getNavigationType() {
    try {
        var navApi = "PerformanceNavigationTiming";
        var navType = getNavigationTypeExperimental();
        if (!navType) {
            navType = getNavigationTypeLegacy();
            navApi = "performance.navigation";
        }
        if (navType) return [
            navType,
            navApi
        ];
        else return [
            "unknown",
            "unknown"
        ];
    } catch (err) {}
    return [
        "error",
        "error"
    ];
}

},{"@swc/helpers/src/_sliced_to_array.mjs":"l34hS","./cart-constants.mjs":"f5ldq","./analytics-constants.mjs":"bOr3s","./analytics-utils.mjs":"4XHNQ","./cookies-utils.mjs":"gGHAO","./analytics-schema-trekkie-storefront-page-view.mjs":"1We0S","./analytics-schema-custom-storefront-customer-tracking.mjs":"6s57D","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"bOr3s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnalyticsEventName", function() {
    return AnalyticsEventName;
});
parcelHelpers.export(exports, "AnalyticsPageType", function() {
    return AnalyticsPageType;
});
parcelHelpers.export(exports, "ShopifyAppId", function() {
    return ShopifyAppId;
});
parcelHelpers.export(exports, "ShopifySalesChannel", function() {
    return ShopifySalesChannel;
});
var AnalyticsEventName = {
    PAGE_VIEW: "PAGE_VIEW",
    ADD_TO_CART: "ADD_TO_CART"
};
var AnalyticsPageType = {
    article: "article",
    blog: "blog",
    captcha: "captcha",
    cart: "cart",
    collection: "collection",
    customersAccount: "customers/account",
    customersActivateAccount: "customers/activate_account",
    customersAddresses: "customers/addresses",
    customersLogin: "customers/login",
    customersOrder: "customers/order",
    customersRegister: "customers/register",
    customersResetPassword: "customers/reset_password",
    giftCard: "gift_card",
    home: "index",
    listCollections: "list-collections",
    forbidden: "403",
    notFound: "404",
    page: "page",
    password: "password",
    product: "product",
    policy: "policy",
    search: "search"
};
var ShopifySalesChannel = {
    hydrogen: "hydrogen",
    headless: "headless"
};
var ShopifyAppId = {
    hydrogen: "6167201",
    headless: "12875497473"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"4XHNQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addDataIf", function() {
    return addDataIf;
});
parcelHelpers.export(exports, "errorIfServer", function() {
    return errorIfServer;
});
parcelHelpers.export(exports, "parseGid", function() {
    return parseGid;
});
parcelHelpers.export(exports, "schemaWrapper", function() {
    return schemaWrapper;
});
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
function schemaWrapper(schemaId, payload) {
    return {
        schema_id: schemaId,
        payload: payload,
        metadata: {
            event_created_at_ms: Date.now()
        }
    };
}
function parseGid(gid) {
    var defaultReturn = {
        id: "",
        resource: null
    };
    if (typeof gid !== "string") return defaultReturn;
    var matches = gid.match(/^gid:\/\/shopify\/(\w+)\/([^/]+)/);
    if (!matches || matches.length === 1) return defaultReturn;
    var _matches_;
    var id = (_matches_ = matches[2]) !== null && _matches_ !== void 0 ? _matches_ : null;
    var _matches_1;
    var resource = (_matches_1 = matches[1]) !== null && _matches_1 !== void 0 ? _matches_1 : null;
    return {
        id: id,
        resource: resource
    };
}
function addDataIf(keyValuePairs, formattedData) {
    if (typeof keyValuePairs !== "object") return {};
    Object.entries(keyValuePairs).forEach(function(param) {
        var _param = (0, _slicedToArrayMjsDefault.default)(param, 2), key = _param[0], value = _param[1];
        if (value) formattedData[key] = value;
    });
    return formattedData;
}
function errorIfServer(fnName) {
    if (typeof document === "undefined") {
        console.error("".concat(fnName, " should only be used within the useEffect callback or event handlers"));
        return true;
    }
    return false;
}

},{"@swc/helpers/src/_sliced_to_array.mjs":"l34hS","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"1We0S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pageView", function() {
    return pageView;
});
var _analyticsConstantsMjs = require("./analytics-constants.mjs");
var _analyticsUtilsMjs = require("./analytics-utils.mjs");
var _cookiesUtilsMjs = require("./cookies-utils.mjs");
var SCHEMA_ID = "trekkie_storefront_page_view/1.4";
var OXYGEN_DOMAIN = "myshopify.dev";
function pageView(payload) {
    var pageViewPayload = payload;
    var _parseGid = (0, _analyticsUtilsMjs.parseGid)(pageViewPayload.resourceId), id = _parseGid.id, resource = _parseGid.resource;
    var resourceType = resource ? resource.toLowerCase() : void 0;
    return [
        (0, _analyticsUtilsMjs.schemaWrapper)(SCHEMA_ID, (0, _analyticsUtilsMjs.addDataIf)({
            pageType: pageViewPayload.pageType,
            customerId: pageViewPayload.customerId,
            resourceType: resourceType,
            resourceId: parseInt(id)
        }, formatPayload(pageViewPayload)))
    ];
}
function formatPayload(payload) {
    return {
        appClientId: payload.shopifySalesChannel ? (0, _analyticsConstantsMjs.ShopifyAppId)[payload.shopifySalesChannel] : (0, _analyticsConstantsMjs.ShopifyAppId).headless,
        isMerchantRequest: isMerchantRequest(payload.url),
        hydrogenSubchannelId: payload.storefrontId || "0",
        isPersistentCookie: payload.hasUserConsent,
        uniqToken: payload.uniqueToken,
        visitToken: payload.visitToken,
        microSessionId: (0, _cookiesUtilsMjs.buildUUID)(),
        microSessionCount: 1,
        url: payload.url,
        path: payload.path,
        search: payload.search,
        referrer: payload.referrer,
        title: payload.title,
        shopId: parseInt((0, _analyticsUtilsMjs.parseGid)(payload.shopId).id),
        currency: payload.currency,
        contentLanguage: payload.acceptedLanguage || "en"
    };
}
function isMerchantRequest(url) {
    if (typeof url !== "string") return false;
    var hostname = new URL(url).hostname;
    if (hostname.indexOf(OXYGEN_DOMAIN) !== -1 || hostname === "localhost") return true;
    return false;
}

},{"./analytics-constants.mjs":"bOr3s","./analytics-utils.mjs":"4XHNQ","./cookies-utils.mjs":"gGHAO","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"6s57D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addToCart", function() {
    return addToCart;
});
parcelHelpers.export(exports, "pageView", function() {
    return pageView;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _analyticsConstantsMjs = require("./analytics-constants.mjs");
var _analyticsUtilsMjs = require("./analytics-utils.mjs");
var _cookiesUtilsMjs = require("./cookies-utils.mjs");
var SCHEMA_ID = "custom_storefront_customer_tracking/1.0";
var PAGE_RENDERED_EVENT_NAME = "page_rendered";
var COLLECTION_PAGE_RENDERED_EVENT_NAME = "collection_page_rendered";
var PRODUCT_PAGE_RENDERED_EVENT_NAME = "product_page_rendered";
var PRODUCT_ADDED_TO_CART_EVENT_NAME = "product_added_to_cart";
var SEARCH_SUBMITTED_EVENT_NAME = "search_submitted";
function pageView(payload) {
    var pageViewPayload = payload;
    var additionalPayload = {
        canonical_url: pageViewPayload.canonicalUrl || pageViewPayload.url,
        customer_id: pageViewPayload.customerId
    };
    var pageType = pageViewPayload.pageType;
    var pageViewEvents = [];
    pageViewEvents.push((0, _analyticsUtilsMjs.schemaWrapper)(SCHEMA_ID, (0, _analyticsUtilsMjs.addDataIf)((0, _objectSpreadMjsDefault.default)({
        event_name: PAGE_RENDERED_EVENT_NAME
    }, additionalPayload), formatPayload(pageViewPayload))));
    switch(pageType){
        case (0, _analyticsConstantsMjs.AnalyticsPageType).collection:
            pageViewEvents.push((0, _analyticsUtilsMjs.schemaWrapper)(SCHEMA_ID, (0, _analyticsUtilsMjs.addDataIf)((0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({
                event_name: COLLECTION_PAGE_RENDERED_EVENT_NAME
            }, additionalPayload), {
                collection_name: pageViewPayload.collectionHandle
            }), formatPayload(pageViewPayload))));
            break;
        case (0, _analyticsConstantsMjs.AnalyticsPageType).product:
            pageViewEvents.push((0, _analyticsUtilsMjs.schemaWrapper)(SCHEMA_ID, (0, _analyticsUtilsMjs.addDataIf)((0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({
                event_name: PRODUCT_PAGE_RENDERED_EVENT_NAME
            }, additionalPayload), {
                products: formatProductPayload(pageViewPayload.products),
                total_value: pageViewPayload.totalValue
            }), formatPayload(pageViewPayload))));
            break;
        case (0, _analyticsConstantsMjs.AnalyticsPageType).search:
            pageViewEvents.push((0, _analyticsUtilsMjs.schemaWrapper)(SCHEMA_ID, (0, _analyticsUtilsMjs.addDataIf)((0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({
                event_name: SEARCH_SUBMITTED_EVENT_NAME
            }, additionalPayload), {
                search_string: pageViewPayload.searchString
            }), formatPayload(pageViewPayload))));
            break;
    }
    return pageViewEvents;
}
function addToCart(payload) {
    var addToCartPayload = payload;
    var cartToken = (0, _analyticsUtilsMjs.parseGid)(addToCartPayload.cartId);
    var cart_token = (cartToken == null ? void 0 : cartToken.id) ? "".concat(cartToken.id) : null;
    return [
        (0, _analyticsUtilsMjs.schemaWrapper)(SCHEMA_ID, (0, _analyticsUtilsMjs.addDataIf)({
            event_name: PRODUCT_ADDED_TO_CART_EVENT_NAME,
            customerId: addToCartPayload.customerId,
            cart_token: cart_token,
            total_value: addToCartPayload.totalValue,
            products: formatProductPayload(addToCartPayload.products)
        }, formatPayload(addToCartPayload)))
    ];
}
function formatPayload(payload) {
    return {
        source: payload.shopifySalesChannel || (0, _analyticsConstantsMjs.ShopifySalesChannel).headless,
        hydrogenSubchannelId: payload.storefrontId || "0",
        is_persistent_cookie: payload.hasUserConsent,
        ccpa_enforced: false,
        gdpr_enforced: false,
        unique_token: payload.uniqueToken,
        event_time: Date.now(),
        event_id: (0, _cookiesUtilsMjs.buildUUID)(),
        event_source_url: payload.url,
        referrer: payload.referrer,
        user_agent: payload.userAgent,
        navigation_type: payload.navigationType,
        navigation_api: payload.navigationApi,
        shop_id: parseInt((0, _analyticsUtilsMjs.parseGid)(payload.shopId).id),
        currency: payload.currency
    };
}
function formatProductPayload(products) {
    return products ? products.map(function(p) {
        var product = (0, _analyticsUtilsMjs.addDataIf)({
            variant_gid: p.variantGid,
            category: p.category,
            sku: p.sku,
            product_id: parseInt((0, _analyticsUtilsMjs.parseGid)(p.productGid).id),
            variant_id: parseInt((0, _analyticsUtilsMjs.parseGid)(p.variantGid).id)
        }, {
            product_gid: p.productGid,
            name: p.name,
            variant: p.variantName || "",
            brand: p.brand,
            price: p.price,
            quantity: Number(p.quantity || 0)
        });
        return JSON.stringify(product);
    }) : [];
}

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","./analytics-constants.mjs":"bOr3s","./analytics-utils.mjs":"4XHNQ","./cookies-utils.mjs":"gGHAO","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"1CHrx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuyNowButton", function() {
    return BuyNowButton;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _objectWithoutPropertiesMjs = require("@swc/helpers/src/_object_without_properties.mjs");
var _objectWithoutPropertiesMjsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesMjs);
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _cartProviderMjs = require("./CartProvider.mjs");
var _baseButtonMjs = require("./BaseButton.mjs");
function BuyNowButton(props) {
    var _useCart = (0, _cartProviderMjs.useCart)(), cartCreate = _useCart.cartCreate, checkoutUrl = _useCart.checkoutUrl;
    var _useState = (0, _slicedToArrayMjsDefault.default)((0, _react.useState)(false), 2), loading = _useState[0], setLoading = _useState[1];
    var quantity = props.quantity, variantId = props.variantId, onClick = props.onClick, attributes = props.attributes, children = props.children, passthroughProps = (0, _objectWithoutPropertiesMjsDefault.default)(props, [
        "quantity",
        "variantId",
        "onClick",
        "attributes",
        "children"
    ]);
    (0, _react.useEffect)(function() {
        if (loading && checkoutUrl) window.location.href = checkoutUrl;
    }, [
        loading,
        checkoutUrl
    ]);
    var handleBuyNow = (0, _react.useCallback)(function() {
        setLoading(true);
        cartCreate({
            lines: [
                {
                    quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
                    merchandiseId: variantId,
                    attributes: attributes
                }
            ]
        });
    }, [
        cartCreate,
        quantity,
        variantId,
        attributes
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _baseButtonMjs.BaseButton), (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({
        disabled: loading !== null && loading !== void 0 ? loading : passthroughProps.disabled
    }, passthroughProps), {
        onClick: onClick,
        defaultOnClick: handleBuyNow,
        children: children
    }));
}

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","@swc/helpers/src/_object_without_properties.mjs":"d0eOZ","@swc/helpers/src/_sliced_to_array.mjs":"l34hS","react/jsx-runtime":"ebSqZ","react":"ihebA","./CartProvider.mjs":"6UehF","./BaseButton.mjs":"fb2fP","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"bQ7WY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartCheckoutButton", function() {
    return CartCheckoutButton;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _objectWithoutPropertiesMjs = require("@swc/helpers/src/_object_without_properties.mjs");
var _objectWithoutPropertiesMjsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesMjs);
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _cartProviderMjs = require("./CartProvider.mjs");
var _baseButtonMjs = require("./BaseButton.mjs");
function CartCheckoutButton(props) {
    var _useState = (0, _slicedToArrayMjsDefault.default)((0, _react.useState)(false), 2), requestedCheckout = _useState[0], setRequestedCheckout = _useState[1];
    var _useCart = (0, _cartProviderMjs.useCart)(), status = _useCart.status, checkoutUrl = _useCart.checkoutUrl;
    var children = props.children, passthroughProps = (0, _objectWithoutPropertiesMjsDefault.default)(props, [
        "children"
    ]);
    (0, _react.useEffect)(function() {
        if (requestedCheckout && checkoutUrl && status === "idle") window.location.href = checkoutUrl;
    }, [
        requestedCheckout,
        status,
        checkoutUrl
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _baseButtonMjs.BaseButton), (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, passthroughProps), {
        disabled: requestedCheckout || passthroughProps.disabled,
        onClick: function() {
            return setRequestedCheckout(true);
        },
        children: children
    }));
}

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","@swc/helpers/src/_object_without_properties.mjs":"d0eOZ","@swc/helpers/src/_sliced_to_array.mjs":"l34hS","react/jsx-runtime":"ebSqZ","react":"ihebA","./CartProvider.mjs":"6UehF","./BaseButton.mjs":"fb2fP","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"hqS97":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartCost", function() {
    return CartCost;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _objectWithoutPropertiesMjs = require("@swc/helpers/src/_object_without_properties.mjs");
var _objectWithoutPropertiesMjsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _moneyMjs = require("./Money.mjs");
var _cartProviderMjs = require("./CartProvider.mjs");
function CartCost(props) {
    var cost = (0, _cartProviderMjs.useCart)().cost;
    var _props_amountType = props.amountType, amountType = _props_amountType === void 0 ? "total" : _props_amountType, children = props.children, passthroughProps = (0, _objectWithoutPropertiesMjsDefault.default)(props, [
        "amountType",
        "children"
    ]);
    var amount;
    if (amountType == "total") amount = cost == null ? void 0 : cost.totalAmount;
    else if (amountType == "subtotal") amount = cost == null ? void 0 : cost.subtotalAmount;
    else if (amountType == "tax") amount = cost == null ? void 0 : cost.totalTaxAmount;
    else if (amountType == "duty") amount = cost == null ? void 0 : cost.totalDutyAmount;
    if (amount == null) return null;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _moneyMjs.Money), (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, passthroughProps), {
        data: amount,
        children: children
    }));
}

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","@swc/helpers/src/_object_without_properties.mjs":"d0eOZ","react/jsx-runtime":"ebSqZ","./Money.mjs":"juuRs","./CartProvider.mjs":"6UehF","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"juuRs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Money", function() {
    return Money;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _objectWithoutPropertiesMjs = require("@swc/helpers/src/_object_without_properties.mjs");
var _objectWithoutPropertiesMjsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _useMoneyMjs = require("./useMoney.mjs");
function Money(_param) {
    var data = _param.data, as = _param.as, withoutCurrency = _param.withoutCurrency, withoutTrailingZeros = _param.withoutTrailingZeros, measurement = _param.measurement, _param_measurementSeparator = _param.measurementSeparator, measurementSeparator = _param_measurementSeparator === void 0 ? "/" : _param_measurementSeparator, passthroughProps = (0, _objectWithoutPropertiesMjsDefault.default)(_param, [
        "data",
        "as",
        "withoutCurrency",
        "withoutTrailingZeros",
        "measurement",
        "measurementSeparator"
    ]);
    if (!isMoney(data)) throw new Error("<Money/> needs a valid 'data' prop that has 'amount' and 'currencyCode'");
    var moneyObject = (0, _useMoneyMjs.useMoney)(data);
    var Wrapper = as !== null && as !== void 0 ? as : "div";
    var output = moneyObject.localizedString;
    if (withoutCurrency || withoutTrailingZeros) {
        if (withoutCurrency && !withoutTrailingZeros) output = moneyObject.amount;
        else if (!withoutCurrency && withoutTrailingZeros) output = moneyObject.withoutTrailingZeros;
        else output = moneyObject.withoutTrailingZerosAndCurrency;
    }
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)(Wrapper, (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, passthroughProps), {
        children: [
            output,
            measurement && measurement.referenceUnit && /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    measurementSeparator,
                    measurement.referenceUnit
                ]
            })
        ]
    }));
}
function isMoney(maybeMoney) {
    return typeof maybeMoney.amount === "string" && !!maybeMoney.amount && typeof maybeMoney.currencyCode === "string" && !!maybeMoney.currencyCode;
}

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","@swc/helpers/src/_object_without_properties.mjs":"d0eOZ","react/jsx-runtime":"ebSqZ","./useMoney.mjs":"aitQA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"aitQA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMoney", function() {
    return useMoney;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _react = require("react");
var _shopifyProviderMjs = require("./ShopifyProvider.mjs");
function useMoney(money) {
    var _useShop = (0, _shopifyProviderMjs.useShop)(), countryIsoCode = _useShop.countryIsoCode, languageIsoCode = _useShop.languageIsoCode;
    var locale = "".concat(languageIsoCode, "-").concat(countryIsoCode);
    if (!locale) throw new Error("useMoney(): Unable to get 'locale' from 'useShop()', which means that 'locale' was not passed to '<ShopifyProvider/>'. 'locale' is required for 'useMoney()' to work");
    var amount = parseFloat(money.amount);
    var options = (0, _react.useMemo)(function() {
        return {
            style: "currency",
            currency: money.currencyCode
        };
    }, [
        money.currencyCode
    ]);
    var defaultFormatter = useLazyFormatter(locale, options);
    var nameFormatter = useLazyFormatter(locale, (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, options), {
        currencyDisplay: "name"
    }));
    var narrowSymbolFormatter = useLazyFormatter(locale, (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, options), {
        currencyDisplay: "narrowSymbol"
    }));
    var withoutTrailingZerosFormatter = useLazyFormatter(locale, (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, options), {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }));
    var withoutCurrencyFormatter = useLazyFormatter(locale);
    var withoutTrailingZerosOrCurrencyFormatter = useLazyFormatter(locale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
    var isPartCurrency = function(part) {
        return part.type === "currency";
    };
    var lazyFormatters = (0, _react.useMemo)(function() {
        return {
            original: function() {
                return money;
            },
            currencyCode: function() {
                return money.currencyCode;
            },
            localizedString: function() {
                return defaultFormatter().format(amount);
            },
            parts: function() {
                return defaultFormatter().formatToParts(amount);
            },
            withoutTrailingZeros: function() {
                return amount % 1 === 0 ? withoutTrailingZerosFormatter().format(amount) : defaultFormatter().format(amount);
            },
            withoutTrailingZerosAndCurrency: function() {
                return amount % 1 === 0 ? withoutTrailingZerosOrCurrencyFormatter().format(amount) : withoutCurrencyFormatter().format(amount);
            },
            currencyName: function() {
                var _a;
                var _ref;
                return (_ref = (_a = nameFormatter().formatToParts(amount).find(isPartCurrency)) == null ? void 0 : _a.value) !== null && _ref !== void 0 ? _ref : money.currencyCode;
            },
            // e.g. "US dollars"
            currencySymbol: function() {
                var _a;
                var _ref;
                return (_ref = (_a = defaultFormatter().formatToParts(amount).find(isPartCurrency)) == null ? void 0 : _a.value) !== null && _ref !== void 0 ? _ref : money.currencyCode;
            },
            // e.g. "USD"
            currencyNarrowSymbol: function() {
                var _a;
                var _ref;
                return (_ref = (_a = narrowSymbolFormatter().formatToParts(amount).find(isPartCurrency)) == null ? void 0 : _a.value) !== null && _ref !== void 0 ? _ref : "";
            },
            // e.g. "$"
            amount: function() {
                return defaultFormatter().formatToParts(amount).filter(function(part) {
                    return [
                        "decimal",
                        "fraction",
                        "group",
                        "integer",
                        "literal"
                    ].includes(part.type);
                }).map(function(part) {
                    return part.value;
                }).join("");
            }
        };
    }, [
        money,
        amount,
        nameFormatter,
        defaultFormatter,
        narrowSymbolFormatter,
        withoutCurrencyFormatter,
        withoutTrailingZerosFormatter,
        withoutTrailingZerosOrCurrencyFormatter
    ]);
    return (0, _react.useMemo)(function() {
        return new Proxy(lazyFormatters, {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            get: function(target, key) {
                var _a;
                return (_a = Reflect.get(target, key)) == null ? void 0 : _a.call(null);
            }
        });
    }, [
        lazyFormatters
    ]);
}
function useLazyFormatter(locale, options) {
    return (0, _react.useMemo)(function() {
        var memoized;
        return function() {
            return memoized !== null && memoized !== void 0 ? memoized : memoized = new Intl.NumberFormat(locale, options);
        };
    }, [
        locale,
        options
    ]);
}

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","react":"ihebA","./ShopifyProvider.mjs":"6TpGm","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"3VQni":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartLineContext", function() {
    return CartLineContext;
});
parcelHelpers.export(exports, "CartLineProvider", function() {
    return CartLineProvider;
});
parcelHelpers.export(exports, "useCartLine", function() {
    return useCartLine;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var CartLineContext = (0, _react.createContext)(null);
function useCartLine() {
    var context = (0, _react.useContext)(CartLineContext);
    if (context == null) throw new Error("Expected a cart line context but none was found");
    return context;
}
function CartLineProvider(param) {
    var children = param.children, line = param.line;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CartLineContext.Provider, {
        value: line,
        children: children
    });
}

},{"react/jsx-runtime":"ebSqZ","react":"ihebA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"gkrFb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartLineQuantity", function() {
    return CartLineQuantity;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _objectWithoutPropertiesMjs = require("@swc/helpers/src/_object_without_properties.mjs");
var _objectWithoutPropertiesMjsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _cartLineProviderMjs = require("./CartLineProvider.mjs");
function CartLineQuantity(props) {
    var cartLine = (0, _cartLineProviderMjs.useCartLine)();
    var as = props.as, passthroughProps = (0, _objectWithoutPropertiesMjsDefault.default)(props, [
        "as"
    ]);
    var Wrapper = as ? as : "span";
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Wrapper, (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, passthroughProps), {
        children: cartLine.quantity
    }));
}

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","@swc/helpers/src/_object_without_properties.mjs":"d0eOZ","react/jsx-runtime":"ebSqZ","./CartLineProvider.mjs":"3VQni","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"3qCDb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartLineQuantityAdjustButton", function() {
    return CartLineQuantityAdjustButton;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _objectWithoutPropertiesMjs = require("@swc/helpers/src/_object_without_properties.mjs");
var _objectWithoutPropertiesMjsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _cartProviderMjs = require("./CartProvider.mjs");
var _cartLineProviderMjs = require("./CartLineProvider.mjs");
var _baseButtonMjs = require("./BaseButton.mjs");
function CartLineQuantityAdjustButton(props) {
    var _useCart = (0, _cartProviderMjs.useCart)(), status = _useCart.status, linesRemove = _useCart.linesRemove, linesUpdate = _useCart.linesUpdate;
    var cartLine = (0, _cartLineProviderMjs.useCartLine)();
    var children = props.children, adjust = props.adjust, onClick = props.onClick, passthroughProps = (0, _objectWithoutPropertiesMjsDefault.default)(props, [
        "children",
        "adjust",
        "onClick"
    ]);
    var handleAdjust = (0, _react.useCallback)(function() {
        if (adjust === "remove") {
            var _ref;
            linesRemove([
                (_ref = cartLine == null ? void 0 : cartLine.id) !== null && _ref !== void 0 ? _ref : ""
            ]);
            return;
        }
        var _ref1, _ref2;
        var quantity = adjust === "decrease" ? ((_ref1 = cartLine == null ? void 0 : cartLine.quantity) !== null && _ref1 !== void 0 ? _ref1 : 0) - 1 : ((_ref2 = cartLine == null ? void 0 : cartLine.quantity) !== null && _ref2 !== void 0 ? _ref2 : 0) + 1;
        if (quantity <= 0) {
            var _ref3;
            linesRemove([
                (_ref3 = cartLine == null ? void 0 : cartLine.id) !== null && _ref3 !== void 0 ? _ref3 : ""
            ]);
            return;
        }
        var _ref4, _ref5;
        var lineUpdate = {
            id: (_ref4 = cartLine == null ? void 0 : cartLine.id) !== null && _ref4 !== void 0 ? _ref4 : "",
            quantity: quantity,
            attributes: (_ref5 = cartLine == null ? void 0 : cartLine.attributes) !== null && _ref5 !== void 0 ? _ref5 : []
        };
        linesUpdate([
            lineUpdate
        ]);
    }, [
        adjust,
        cartLine == null ? void 0 : cartLine.attributes,
        cartLine == null ? void 0 : cartLine.id,
        cartLine == null ? void 0 : cartLine.quantity,
        linesRemove,
        linesUpdate
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _baseButtonMjs.BaseButton), (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, passthroughProps), {
        onClick: onClick,
        defaultOnClick: handleAdjust,
        disabled: typeof passthroughProps.disabled !== "undefined" ? passthroughProps.disabled : status !== "idle",
        children: children
    }));
}

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","@swc/helpers/src/_object_without_properties.mjs":"d0eOZ","react/jsx-runtime":"ebSqZ","react":"ihebA","./CartProvider.mjs":"6UehF","./CartLineProvider.mjs":"3VQni","./BaseButton.mjs":"fb2fP","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"mHiEd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "storefrontApiCustomScalars", function() {
    return storefrontApiCustomScalars;
});
var storefrontApiCustomScalars = {
    // Keep in sync with the definitions in the app/nextjs/codegen.ts!
    DateTime: "string",
    Decimal: "string",
    HTML: "string",
    URL: "string",
    Color: "string",
    UnsignedInt64: "string"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"aPDkn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExternalVideo", function() {
    return ExternalVideo;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _objectWithoutPropertiesMjs = require("@swc/helpers/src/_object_without_properties.mjs");
var _objectWithoutPropertiesMjsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesMjs);
var _jsxRuntime = require("react/jsx-runtime");
function ExternalVideo(props) {
    var data = props.data, options = props.options, _props_id = props.id, id = _props_id === void 0 ? data.id : _props_id, _props_frameBorder = props.frameBorder, frameBorder = _props_frameBorder === void 0 ? "0" : _props_frameBorder, _props_allow = props.allow, allow = _props_allow === void 0 ? "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" : _props_allow, _props_allowFullScreen = props.allowFullScreen, allowFullScreen = _props_allowFullScreen === void 0 ? true : _props_allowFullScreen, _props_loading = props.loading, loading = _props_loading === void 0 ? "lazy" : _props_loading, passthroughProps = (0, _objectWithoutPropertiesMjsDefault.default)(props, [
        "data",
        "options",
        "id",
        "frameBorder",
        "allow",
        "allowFullScreen",
        "loading"
    ]);
    if (!data.embedUrl) throw new Error("<ExternalVideo/> requires the 'embedUrl' property");
    var finalUrl = data.embedUrl;
    if (options) {
        var urlObject = new URL(data.embedUrl);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(options)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                urlObject.searchParams.set(key, options[key]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        finalUrl = urlObject.toString();
    }
    var _data_alt, _ref;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("iframe", (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, passthroughProps), {
        id: id !== null && id !== void 0 ? id : data.embedUrl,
        title: (_ref = (_data_alt = data.alt) !== null && _data_alt !== void 0 ? _data_alt : data.id) !== null && _ref !== void 0 ? _ref : "external video",
        frameBorder: frameBorder,
        allow: allow,
        allowFullScreen: allowFullScreen,
        src: finalUrl,
        loading: loading
    }));
}

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","@swc/helpers/src/_object_without_properties.mjs":"d0eOZ","react/jsx-runtime":"ebSqZ","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"4CaGJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IMAGE_FRAGMENT", function() {
    return IMAGE_FRAGMENT;
});
parcelHelpers.export(exports, "Image", function() {
    return Image;
});
parcelHelpers.export(exports, "generateImageWidths", function() {
    return generateImageWidths;
});
parcelHelpers.export(exports, "generateSizes", function() {
    return generateSizes;
});
parcelHelpers.export(exports, "generateSrcSet", function() {
    return generateSrcSet;
});
parcelHelpers.export(exports, "parseAspectRatio", function() {
    return parseAspectRatio;
});
parcelHelpers.export(exports, "shopifyLoader", function() {
    return shopifyLoader;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _objectWithoutPropertiesMjs = require("@swc/helpers/src/_object_without_properties.mjs");
var _objectWithoutPropertiesMjsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesMjs);
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var IMAGE_FRAGMENT = "#graphql\n  fragment Image on Image {\n    altText\n    url\n    width\n    height\n  }\n";
var Image = _react.forwardRef(function(_param, ref) {
    var alt = _param.alt, aspectRatio = _param.aspectRatio, _param_crop = _param.crop, crop = _param_crop === void 0 ? "center" : _param_crop, data = _param.data, _param_decoding = _param.decoding, decoding = _param_decoding === void 0 ? "async" : _param_decoding, _param_height = _param.height, height = _param_height === void 0 ? "auto" : _param_height, _param_loader = _param.loader, loader = _param_loader === void 0 ? shopifyLoader : _param_loader, loaderOptions = _param.loaderOptions, _param_loading = _param.loading, loading = _param_loading === void 0 ? "lazy" : _param_loading, sizes = _param.sizes, src = _param.src, _param_srcSetOptions = _param.srcSetOptions, srcSetOptions = _param_srcSetOptions === void 0 ? {
        intervals: 15,
        startingWidth: 200,
        incrementSize: 200,
        placeholderWidth: 100
    } : _param_srcSetOptions, _param_width = _param.width, width = _param_width === void 0 ? "100%" : _param_width, widths = _param.widths, passthroughProps = (0, _objectWithoutPropertiesMjsDefault.default)(_param, [
        "alt",
        "aspectRatio",
        "crop",
        "data",
        "decoding",
        "height",
        "loader",
        "loaderOptions",
        "loading",
        "sizes",
        "src",
        "srcSetOptions",
        "width",
        "widths"
    ]);
    var normalizedData = _react.useMemo(function() {
        var dataWidth = (data == null ? void 0 : data.width) && (data == null ? void 0 : data.height) ? data == null ? void 0 : data.width : void 0;
        var dataHeight = (data == null ? void 0 : data.width) && (data == null ? void 0 : data.height) ? data == null ? void 0 : data.height : void 0;
        return {
            width: dataWidth,
            height: dataHeight,
            unitsMatch: Boolean(unitsMatch(dataWidth, dataHeight))
        };
    }, [
        data
    ]);
    var normalizedProps = _react.useMemo(function() {
        var nWidthProp = width || "100%";
        var widthParts = getUnitValueParts(nWidthProp.toString());
        var nWidth = "".concat(widthParts.number).concat(widthParts.unit);
        var autoHeight = height === void 0 || height === null;
        var heightParts = autoHeight ? null : getUnitValueParts(height.toString());
        var fixedHeight = heightParts ? "".concat(heightParts.number).concat(heightParts.unit) : "";
        var nHeight = autoHeight ? "auto" : fixedHeight;
        var nSrc = src || (data == null ? void 0 : data.url);
        var nAlt = (data == null ? void 0 : data.altText) && !alt ? data == null ? void 0 : data.altText : alt || "";
        var nAspectRatio = aspectRatio ? aspectRatio : normalizedData.unitsMatch ? [
            getNormalizedFixedUnit(normalizedData.width),
            getNormalizedFixedUnit(normalizedData.height)
        ].join("/") : void 0;
        return {
            width: nWidth,
            height: nHeight,
            src: nSrc,
            alt: nAlt,
            aspectRatio: nAspectRatio
        };
    }, [
        width,
        height,
        src,
        data,
        alt,
        aspectRatio,
        normalizedData,
        passthroughProps == null ? void 0 : passthroughProps.key
    ]);
    var intervals = srcSetOptions.intervals, startingWidth = srcSetOptions.startingWidth, incrementSize = srcSetOptions.incrementSize, placeholderWidth = srcSetOptions.placeholderWidth;
    var imageWidths = _react.useMemo(function() {
        return generateImageWidths(width, intervals, startingWidth, incrementSize);
    }, [
        width,
        intervals,
        startingWidth,
        incrementSize
    ]);
    var fixedWidth = isFixedWidth(normalizedProps.width);
    if (fixedWidth) return /* @__PURE__ */ (0, _jsxRuntime.jsx)(FixedWidthImage, {
        aspectRatio: aspectRatio,
        crop: crop,
        decoding: decoding,
        height: height,
        imageWidths: imageWidths,
        loader: loader,
        loading: loading,
        normalizedProps: normalizedProps,
        passthroughProps: passthroughProps,
        ref: ref,
        width: width
    });
    else return /* @__PURE__ */ (0, _jsxRuntime.jsx)(FluidImage, {
        aspectRatio: aspectRatio,
        crop: crop,
        decoding: decoding,
        imageWidths: imageWidths,
        loader: loader,
        loading: loading,
        normalizedProps: normalizedProps,
        passthroughProps: passthroughProps,
        placeholderWidth: placeholderWidth,
        ref: ref,
        sizes: sizes
    });
});
function FixedWidthImage(param) {
    var aspectRatio = param.aspectRatio, crop = param.crop, decoding = param.decoding, height = param.height, imageWidths = param.imageWidths, _param_loader = param.loader, loader = _param_loader === void 0 ? shopifyLoader : _param_loader, loading = param.loading, normalizedProps = param.normalizedProps, passthroughProps = param.passthroughProps, ref = param.ref, width = param.width;
    var fixed = _react.useMemo(function() {
        var intWidth = getNormalizedFixedUnit(width);
        var intHeight = getNormalizedFixedUnit(height);
        var fixedAspectRatio = aspectRatio ? aspectRatio : unitsMatch(normalizedProps.width, normalizedProps.height) ? [
            intWidth,
            intHeight
        ].join("/") : normalizedProps.aspectRatio ? normalizedProps.aspectRatio : void 0;
        var sizesArray = imageWidths === void 0 ? void 0 : generateSizes(imageWidths, fixedAspectRatio, crop);
        var _parseAspectRatio;
        var fixedHeight = intHeight ? intHeight : fixedAspectRatio && intWidth ? intWidth * ((_parseAspectRatio = parseAspectRatio(fixedAspectRatio)) !== null && _parseAspectRatio !== void 0 ? _parseAspectRatio : 1) : void 0;
        var srcSet = generateSrcSet(normalizedProps.src, sizesArray, loader);
        var src = loader({
            src: normalizedProps.src,
            width: intWidth,
            height: fixedHeight,
            crop: normalizedProps.height === "auto" ? void 0 : crop
        });
        return {
            width: intWidth,
            aspectRatio: fixedAspectRatio,
            height: fixedHeight,
            srcSet: srcSet,
            src: src
        };
    }, [
        aspectRatio,
        crop,
        height,
        imageWidths,
        loader,
        normalizedProps,
        width
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("img", (0, _objectSpreadMjsDefault.default)({
        ref: ref,
        alt: normalizedProps.alt,
        decoding: decoding,
        height: fixed.height,
        loading: loading,
        src: fixed.src,
        srcSet: fixed.srcSet,
        width: fixed.width,
        style: (0, _objectSpreadMjsDefault.default)({
            aspectRatio: fixed.aspectRatio
        }, passthroughProps.style)
    }, passthroughProps));
}
function FluidImage(param) {
    var crop = param.crop, decoding = param.decoding, imageWidths = param.imageWidths, _param_loader = param.loader, loader = _param_loader === void 0 ? shopifyLoader : _param_loader, loading = param.loading, normalizedProps = param.normalizedProps, passthroughProps = param.passthroughProps, placeholderWidth = param.placeholderWidth, ref = param.ref, sizes = param.sizes;
    var fluid = _react.useMemo(function() {
        var sizesArray = imageWidths === void 0 ? void 0 : generateSizes(imageWidths, normalizedProps.aspectRatio, crop);
        var _parseAspectRatio;
        var placeholderHeight = normalizedProps.aspectRatio && placeholderWidth ? placeholderWidth * ((_parseAspectRatio = parseAspectRatio(normalizedProps.aspectRatio)) !== null && _parseAspectRatio !== void 0 ? _parseAspectRatio : 1) : void 0;
        var srcSet = generateSrcSet(normalizedProps.src, sizesArray, loader);
        var src = loader({
            src: normalizedProps.src,
            width: placeholderWidth,
            height: placeholderHeight,
            crop: crop
        });
        return {
            placeholderHeight: placeholderHeight,
            srcSet: srcSet,
            src: src
        };
    }, [
        crop,
        imageWidths,
        loader,
        normalizedProps,
        placeholderWidth
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("img", (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({
        ref: ref,
        alt: normalizedProps.alt,
        decoding: decoding,
        height: fluid.placeholderHeight,
        loading: loading,
        sizes: sizes,
        src: fluid.src,
        srcSet: fluid.srcSet,
        width: placeholderWidth
    }, passthroughProps), {
        style: (0, _objectSpreadMjsDefault.default)({
            width: normalizedProps.width,
            aspectRatio: normalizedProps.aspectRatio
        }, passthroughProps.style)
    }));
}
function shopifyLoader(param) {
    var src = param.src, width = param.width, height = param.height, crop = param.crop;
    if (!src) return "";
    var url = new URL(src);
    if (width) url.searchParams.append("width", Math.round(width).toString());
    if (height) url.searchParams.append("height", Math.round(height).toString());
    if (crop) url.searchParams.append("crop", crop);
    return url.href;
}
function unitsMatch() {
    var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "100%", height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "auto";
    return getUnitValueParts(width.toString()).unit === getUnitValueParts(height.toString()).unit;
}
function getUnitValueParts(value) {
    var unit = value.replace(/[0-9.]/g, "");
    var number = parseFloat(value.replace(unit, ""));
    return {
        unit: unit === "" ? number === void 0 ? "auto" : "px" : unit,
        number: number
    };
}
function getNormalizedFixedUnit(value) {
    if (value === void 0) return;
    var _getUnitValueParts = getUnitValueParts(value.toString()), unit = _getUnitValueParts.unit, number = _getUnitValueParts.number;
    switch(unit){
        case "em":
            return number * 16;
        case "rem":
            return number * 16;
        case "px":
            return number;
        case "":
            return number;
        default:
            return;
    }
}
function isFixedWidth(width) {
    var fixedEndings = /\d(px|em|rem)$/;
    return typeof width === "number" || typeof width === "string" && fixedEndings.test(width);
}
function generateSrcSet(src, sizesArray) {
    var loader = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : shopifyLoader;
    if (!src) return "";
    if ((sizesArray == null ? void 0 : sizesArray.length) === 0 || !sizesArray) return src;
    var _size_width;
    return sizesArray.map(function(size, i) {
        return "".concat(loader({
            src: src,
            width: size.width,
            height: size.height,
            crop: size.crop
        }), " ").concat(sizesArray.length === 3 ? "".concat(i + 1, "x") : "".concat((_size_width = size.width) !== null && _size_width !== void 0 ? _size_width : 0, "w"));
    }).join(", ");
}
function generateImageWidths() {
    var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "100%", intervals = arguments.length > 1 ? arguments[1] : void 0, startingWidth = arguments.length > 2 ? arguments[2] : void 0, incrementSize = arguments.length > 3 ? arguments[3] : void 0;
    var responsive = Array.from({
        length: intervals
    }, function(_, i) {
        return i * incrementSize + startingWidth;
    });
    var _getNormalizedFixedUnit;
    var fixed = Array.from({
        length: 3
    }, function(_, i) {
        return (i + 1) * ((_getNormalizedFixedUnit = getNormalizedFixedUnit(width)) !== null && _getNormalizedFixedUnit !== void 0 ? _getNormalizedFixedUnit : 0);
    });
    return isFixedWidth(width) ? fixed : responsive;
}
function parseAspectRatio(aspectRatio) {
    if (!aspectRatio) return;
    var _aspectRatio_split = (0, _slicedToArrayMjsDefault.default)(aspectRatio.split("/"), 2), width = _aspectRatio_split[0], height = _aspectRatio_split[1];
    return 1 / (Number(width) / Number(height));
}
function generateSizes(imageWidths, aspectRatio) {
    var crop = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "center";
    if (!imageWidths) return;
    var sizes = imageWidths.map(function(width) {
        var _parseAspectRatio;
        return {
            width: width,
            height: aspectRatio ? width * ((_parseAspectRatio = parseAspectRatio(aspectRatio)) !== null && _parseAspectRatio !== void 0 ? _parseAspectRatio : 1) : void 0,
            crop: crop
        };
    });
    return sizes;
}

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","@swc/helpers/src/_object_without_properties.mjs":"d0eOZ","@swc/helpers/src/_sliced_to_array.mjs":"l34hS","react/jsx-runtime":"ebSqZ","react":"ihebA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"5rKxn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MediaFile", function() {
    return MediaFile;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _objectWithoutPropertiesMjs = require("@swc/helpers/src/_object_without_properties.mjs");
var _objectWithoutPropertiesMjsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _imageMjs = require("./Image.mjs");
var _videoMjs = require("./Video.mjs");
var _externalVideoMjs = require("./ExternalVideo.mjs");
var _modelViewerMjs = require("./ModelViewer.mjs");
function MediaFile(_param) {
    var data = _param.data, mediaOptions = _param.mediaOptions, passthroughProps = (0, _objectWithoutPropertiesMjsDefault.default)(_param, [
        "data",
        "mediaOptions"
    ]);
    switch(data.__typename){
        case "MediaImage":
            if (!data.image) {
                var noDataImage = "<MediaFile/>: 'data.image' does not exist for __typename of 'MediaImage'; rendering 'null' by default.";
                console.warn(noDataImage);
                return null;
            }
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _imageMjs.Image), (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, passthroughProps, mediaOptions == null ? void 0 : mediaOptions.image), {
                data: data.image
            }));
        case "Video":
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _videoMjs.Video), (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, passthroughProps, mediaOptions == null ? void 0 : mediaOptions.video), {
                data: data
            }));
        case "ExternalVideo":
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _externalVideoMjs.ExternalVideo), (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, passthroughProps, mediaOptions == null ? void 0 : mediaOptions.externalVideo), {
                data: data
            }));
        case "Model3d":
            return(// @ts-expect-error There are issues with the inferred HTML attribute types here for ModelViewer (and contentEditable), but I think that's a little bit beyond me at the moment
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _modelViewerMjs.ModelViewer), (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, passthroughProps, mediaOptions == null ? void 0 : mediaOptions.modelViewer), {
                data: data
            })));
        default:
            {
                var typenameMissingMessage = "<MediaFile /> requires the '__typename' property to exist on the 'data' prop in order to render the matching sub-component for this type of media.";
                console.error("".concat(typenameMissingMessage, "  Rendering 'null' by default"));
                return null;
            }
    }
}

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","@swc/helpers/src/_object_without_properties.mjs":"d0eOZ","react/jsx-runtime":"ebSqZ","./Image.mjs":"4CaGJ","./Video.mjs":"bqkiw","./ExternalVideo.mjs":"aPDkn","./ModelViewer.mjs":"alQI0","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"bqkiw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Video", function() {
    return Video;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _objectWithoutPropertiesMjs = require("@swc/helpers/src/_object_without_properties.mjs");
var _objectWithoutPropertiesMjsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _imageMjs = require("./Image.mjs");
function Video(props) {
    var _a;
    var data = props.data, previewImageOptions = props.previewImageOptions, _props_id = props.id, id = _props_id === void 0 ? data.id : _props_id, _props_playsInline = props.playsInline, playsInline = _props_playsInline === void 0 ? true : _props_playsInline, _props_controls = props.controls, controls = _props_controls === void 0 ? true : _props_controls, _props_sourceProps = props.sourceProps, sourceProps = _props_sourceProps === void 0 ? {} : _props_sourceProps, passthroughProps = (0, _objectWithoutPropertiesMjsDefault.default)(props, [
        "data",
        "previewImageOptions",
        "id",
        "playsInline",
        "controls",
        "sourceProps"
    ]);
    var _ref;
    var posterUrl = (0, _imageMjs.shopifyLoader)((0, _objectSpreadMjsDefault.default)({
        src: (_ref = (_a = data.previewImage) == null ? void 0 : _a.url) !== null && _ref !== void 0 ? _ref : ""
    }, previewImageOptions));
    if (!data.sources) throw new Error("<Video/> requires a 'data.sources' array");
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /* @__PURE__ */ (0, _jsxRuntime.jsx)("video", (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, passthroughProps), {
        id: id,
        playsInline: playsInline,
        controls: controls,
        poster: posterUrl,
        children: data.sources.map(function(source) {
            if (!((source == null ? void 0 : source.url) && (source == null ? void 0 : source.mimeType))) throw new Error("<Video/> needs 'source.url' and 'source.mimeType'");
            return /* @__PURE__ */ (0, _react.createElement)("source", (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, sourceProps), {
                key: source.url,
                src: source.url,
                type: source.mimeType
            }));
        })
    })));
}

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","@swc/helpers/src/_object_without_properties.mjs":"d0eOZ","react/jsx-runtime":"ebSqZ","react":"ihebA","./Image.mjs":"4CaGJ","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"alQI0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModelViewer", function() {
    return ModelViewer;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _objectWithoutPropertiesMjs = require("@swc/helpers/src/_object_without_properties.mjs");
var _objectWithoutPropertiesMjsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesMjs);
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _loadScriptMjs = require("./load-script.mjs");
function ModelViewer(props) {
    var _a, _b, _c;
    var _useState = (0, _slicedToArrayMjsDefault.default)((0, _react.useState)(void 0), 2), modelViewer = _useState[0], setModelViewer = _useState[1];
    var callbackRef = (0, _react.useCallback)(function(node) {
        setModelViewer(node);
    }, []);
    var data = props.data, children = props.children, className = props.className, passthroughProps = (0, _objectWithoutPropertiesMjsDefault.default)(props, [
        "data",
        "children",
        "className"
    ]);
    var modelViewerLoadedStatus = (0, _loadScriptMjs.useLoadScript)("https://unpkg.com/@google/model-viewer@v1.12.1/dist/model-viewer.min.js", {
        module: true
    });
    (0, _react.useEffect)(function() {
        if (!modelViewer) return;
        if (passthroughProps.onError) modelViewer.addEventListener("error", passthroughProps.onError);
        if (passthroughProps.onLoad) modelViewer.addEventListener("load", passthroughProps.onLoad);
        if (passthroughProps.onPreload) modelViewer.addEventListener("preload", passthroughProps.onPreload);
        if (passthroughProps.onModelVisibility) modelViewer.addEventListener("model-visibility", passthroughProps.onModelVisibility);
        if (passthroughProps.onProgress) modelViewer.addEventListener("progress", passthroughProps.onProgress);
        if (passthroughProps.onArStatus) modelViewer.addEventListener("ar-status", passthroughProps.onArStatus);
        if (passthroughProps.onArTracking) modelViewer.addEventListener("ar-tracking", passthroughProps.onArTracking);
        if (passthroughProps.onQuickLookButtonTapped) modelViewer.addEventListener("quick-look-button-tapped", passthroughProps.onQuickLookButtonTapped);
        if (passthroughProps.onCameraChange) modelViewer.addEventListener("camera-change", passthroughProps.onCameraChange);
        if (passthroughProps.onEnvironmentChange) modelViewer.addEventListener("environment-change", passthroughProps.onEnvironmentChange);
        if (passthroughProps.onPlay) modelViewer.addEventListener("play", passthroughProps.onPlay);
        if (passthroughProps.onPause) modelViewer.addEventListener("ar-status", passthroughProps.onPause);
        if (passthroughProps.onSceneGraphReady) modelViewer.addEventListener("scene-graph-ready", passthroughProps.onSceneGraphReady);
        return function() {
            if (modelViewer == null) return;
            if (passthroughProps.onError) modelViewer.removeEventListener("error", passthroughProps.onError);
            if (passthroughProps.onLoad) modelViewer.removeEventListener("load", passthroughProps.onLoad);
            if (passthroughProps.onPreload) modelViewer.removeEventListener("preload", passthroughProps.onPreload);
            if (passthroughProps.onModelVisibility) modelViewer.removeEventListener("model-visibility", passthroughProps.onModelVisibility);
            if (passthroughProps.onProgress) modelViewer.removeEventListener("progress", passthroughProps.onProgress);
            if (passthroughProps.onArStatus) modelViewer.removeEventListener("ar-status", passthroughProps.onArStatus);
            if (passthroughProps.onArTracking) modelViewer.removeEventListener("ar-tracking", passthroughProps.onArTracking);
            if (passthroughProps.onQuickLookButtonTapped) modelViewer.removeEventListener("quick-look-button-tapped", passthroughProps.onQuickLookButtonTapped);
            if (passthroughProps.onCameraChange) modelViewer.removeEventListener("camera-change", passthroughProps.onCameraChange);
            if (passthroughProps.onEnvironmentChange) modelViewer.removeEventListener("environment-change", passthroughProps.onEnvironmentChange);
            if (passthroughProps.onPlay) modelViewer.removeEventListener("play", passthroughProps.onPlay);
            if (passthroughProps.onPause) modelViewer.removeEventListener("ar-status", passthroughProps.onPause);
            if (passthroughProps.onSceneGraphReady) modelViewer.removeEventListener("scene-graph-ready", passthroughProps.onSceneGraphReady);
        };
    }, [
        modelViewer,
        passthroughProps.onArStatus,
        passthroughProps.onArTracking,
        passthroughProps.onCameraChange,
        passthroughProps.onEnvironmentChange,
        passthroughProps.onError,
        passthroughProps.onLoad,
        passthroughProps.onModelVisibility,
        passthroughProps.onPause,
        passthroughProps.onPlay,
        passthroughProps.onPreload,
        passthroughProps.onProgress,
        passthroughProps.onQuickLookButtonTapped,
        passthroughProps.onSceneGraphReady
    ]);
    if (modelViewerLoadedStatus !== "done") return null;
    if (!((_b = (_a = data.sources) == null ? void 0 : _a[0]) == null ? void 0 : _b.url)) {
        var sourcesUrlError = "<ModelViewer/> requires 'data.sources' prop to be an array, with an object that has a property 'url' on it. Rendering 'null'";
        console.error(sourcesUrlError);
        return null;
    }
    var _passthroughProps_id, _data_alt, _passthroughProps_cameraControls, _ref, _passthroughProps_autoplay, _passthroughProps_interpolationDecay, _passthroughProps_shadowIntensity, _passthroughProps_shadowSoftness;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("model-viewer", (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({
        ref: callbackRef
    }, passthroughProps), {
        class: className,
        id: (_passthroughProps_id = passthroughProps.id) !== null && _passthroughProps_id !== void 0 ? _passthroughProps_id : data.id,
        src: data.sources[0].url,
        alt: (_data_alt = data.alt) !== null && _data_alt !== void 0 ? _data_alt : null,
        "camera-controls": (_passthroughProps_cameraControls = passthroughProps.cameraControls) !== null && _passthroughProps_cameraControls !== void 0 ? _passthroughProps_cameraControls : true,
        poster: (_ref = passthroughProps.poster || ((_c = data.previewImage) == null ? void 0 : _c.url)) !== null && _ref !== void 0 ? _ref : null,
        autoplay: (_passthroughProps_autoplay = passthroughProps.autoplay) !== null && _passthroughProps_autoplay !== void 0 ? _passthroughProps_autoplay : true,
        loading: passthroughProps.loading,
        reveal: passthroughProps.reveal,
        ar: passthroughProps.ar,
        "ar-modes": passthroughProps.arModes,
        "ar-scale": passthroughProps.arScale,
        "ar-placement": passthroughProps.arPlacement,
        "ios-src": passthroughProps.iosSrc,
        "touch-action": passthroughProps.touchAction,
        "disable-zoom": passthroughProps.disableZoom,
        "orbit-sensitivity": passthroughProps.orbitSensitivity,
        "auto-rotate": passthroughProps.autoRotate,
        "auto-rotate-delay": passthroughProps.autoRotateDelay,
        "rotation-per-second": passthroughProps.rotationPerSecond,
        "interaction-policy": passthroughProps.interactionPolicy,
        "interaction-prompt": passthroughProps.interactionPrompt,
        "interaction-prompt-style": passthroughProps.interactionPromptStyle,
        "interaction-prompt-threshold": passthroughProps.interactionPromptThreshold,
        "camera-orbit": passthroughProps.cameraOrbit,
        "camera-target": passthroughProps.cameraTarget,
        "field-of-view": passthroughProps.fieldOfView,
        "max-camera-orbit": passthroughProps.maxCameraOrbit,
        "min-camera-orbit": passthroughProps.minCameraOrbit,
        "max-field-of-view": passthroughProps.maxFieldOfView,
        "min-field-of-view": passthroughProps.minFieldOfView,
        bounds: passthroughProps.bounds,
        "interpolation-decay": (_passthroughProps_interpolationDecay = passthroughProps.interpolationDecay) !== null && _passthroughProps_interpolationDecay !== void 0 ? _passthroughProps_interpolationDecay : 100,
        "skybox-image": passthroughProps.skyboxImage,
        "environment-image": passthroughProps.environmentImage,
        exposure: passthroughProps.exposure,
        "shadow-intensity": (_passthroughProps_shadowIntensity = passthroughProps.shadowIntensity) !== null && _passthroughProps_shadowIntensity !== void 0 ? _passthroughProps_shadowIntensity : 0,
        "shadow-softness": (_passthroughProps_shadowSoftness = passthroughProps.shadowSoftness) !== null && _passthroughProps_shadowSoftness !== void 0 ? _passthroughProps_shadowSoftness : 0,
        "animation-name": passthroughProps.animationName,
        "animation-crossfade-duration": passthroughProps.animationCrossfadeDuration,
        "variant-name": passthroughProps.variantName,
        orientation: passthroughProps.orientation,
        scale: passthroughProps.scale,
        children: children
    }));
}

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","@swc/helpers/src/_object_without_properties.mjs":"d0eOZ","@swc/helpers/src/_sliced_to_array.mjs":"l34hS","react/jsx-runtime":"ebSqZ","react":"ihebA","./load-script.mjs":"9fc7p","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"9fc7p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadScript", function() {
    return loadScript;
});
parcelHelpers.export(exports, "useLoadScript", function() {
    return useLoadScript;
});
var _asyncToGeneratorMjs = require("@swc/helpers/src/_async_to_generator.mjs");
var _asyncToGeneratorMjsDefault = parcelHelpers.interopDefault(_asyncToGeneratorMjs);
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _tsGeneratorMjs = require("@swc/helpers/src/_ts_generator.mjs");
var _tsGeneratorMjsDefault = parcelHelpers.interopDefault(_tsGeneratorMjs);
var _react = require("react");
var SCRIPTS_LOADED = {};
function loadScript(src, options) {
    var isScriptLoaded = SCRIPTS_LOADED[src];
    if (isScriptLoaded) return isScriptLoaded;
    var promise = new Promise(function(resolve, reject) {
        var script = document.createElement("script");
        if (options == null ? void 0 : options.module) script.type = "module";
        else script.type = "text/javascript";
        script.src = src;
        script.onload = function() {
            resolve(true);
        };
        script.onerror = function() {
            reject(false);
        };
        if ((options == null ? void 0 : options.in) === "head") document.head.appendChild(script);
        else document.body.appendChild(script);
    });
    SCRIPTS_LOADED[src] = promise;
    return promise;
}
function useLoadScript(url, options) {
    var _useState = (0, _slicedToArrayMjsDefault.default)((0, _react.useState)("loading"), 2), status = _useState[0], setStatus = _useState[1];
    var stringifiedOptions = JSON.stringify(options);
    (0, _react.useEffect)(function() {
        function loadScriptWrapper() {
            return _loadScriptWrapper.apply(this, arguments);
        }
        function _loadScriptWrapper() {
            _loadScriptWrapper = (0, _asyncToGeneratorMjsDefault.default)(function() {
                var error;
                return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            setStatus("loading");
                            return [
                                4,
                                loadScript(url, options)
                            ];
                        case 1:
                            _state.sent();
                            setStatus("done");
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            setStatus("error");
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return _loadScriptWrapper.apply(this, arguments);
        }
        loadScriptWrapper().catch(function() {
            setStatus("error");
        });
    }, [
        url,
        stringifiedOptions,
        options
    ]);
    return status;
}

},{"@swc/helpers/src/_async_to_generator.mjs":"7nC9G","@swc/helpers/src/_sliced_to_array.mjs":"l34hS","@swc/helpers/src/_ts_generator.mjs":"cT4KU","react":"ihebA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"jfBCM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseJSON", function() {
    return parseJSON;
});
parcelHelpers.export(exports, "parseMetafield", function() {
    return parseMetafield;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _flattenConnectionMjs = require("./flatten-connection.mjs");
function parseMetafield(metafield) {
    if (!metafield.type) {
        var noTypeError = "parseMetafield(): The 'type' field is required in order to parse the Metafield.";
        console.error("".concat(noTypeError, " Returning 'parsedValue' of 'null'"));
        return (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, metafield), {
            parsedValue: null
        });
    }
    switch(metafield.type){
        case "boolean":
            return (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, metafield), {
                parsedValue: metafield.value === "true"
            });
        case "collection_reference":
        case "file_reference":
        case "page_reference":
        case "product_reference":
        case "variant_reference":
            return (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, metafield), {
                parsedValue: metafield.reference
            });
        case "color":
        case "multi_line_text_field":
        case "single_line_text_field":
        case "url":
            return (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, metafield), {
                parsedValue: metafield.value
            });
        case "dimension":
        case "money":
        case "json":
        case "rating":
        case "volume":
        case "weight":
        case "list.color":
        case "list.dimension":
        case "list.number_integer":
        case "list.number_decimal":
        case "list.rating":
        case "list.single_line_text_field":
        case "list.url":
        case "list.volume":
        case "list.weight":
            {
                var parsedValue = null;
                try {
                    var _metafield_value;
                    parsedValue = parseJSON((_metafield_value = metafield.value) !== null && _metafield_value !== void 0 ? _metafield_value : "");
                } catch (err) {
                    var parseError = "parseMetafield(): attempted to JSON.parse the 'metafield.value' property, but failed.";
                    console.error("".concat(parseError, " Returning 'null' for 'parsedValue'"));
                    parsedValue = null;
                }
                return (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, metafield), {
                    parsedValue: parsedValue
                });
            }
        case "date":
        case "date_time":
            var _metafield_value1;
            return (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, metafield), {
                parsedValue: new Date((_metafield_value1 = metafield.value) !== null && _metafield_value1 !== void 0 ? _metafield_value1 : "")
            });
        case "list.date":
        case "list.date_time":
            {
                var _ref;
                var jsonParseValue = parseJSON((_ref = metafield == null ? void 0 : metafield.value) !== null && _ref !== void 0 ? _ref : "");
                return (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, metafield), {
                    parsedValue: jsonParseValue.map(function(dateString) {
                        return new Date(dateString);
                    })
                });
            }
        case "number_decimal":
        case "number_integer":
            return (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, metafield), {
                parsedValue: Number(metafield.value)
            });
        case "list.collection_reference":
        case "list.file_reference":
        case "list.page_reference":
        case "list.product_reference":
        case "list.variant_reference":
            var _metafield_references;
            return (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, metafield), {
                parsedValue: (0, _flattenConnectionMjs.flattenConnection)((_metafield_references = metafield.references) !== null && _metafield_references !== void 0 ? _metafield_references : void 0)
            });
        default:
            {
                var typeNotFoundError = "parseMetafield(): the 'metafield.type' you passed in is not supported. Your type: \"".concat(metafield.type, '". If you believe this is an error, please open an issue on GitHub.');
                console.error("".concat(typeNotFoundError, "  Returning 'parsedValue' of 'null'"));
                return (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, metafield), {
                    parsedValue: null
                });
            }
    }
}
function parseJSON(json) {
    if (String(json).includes("__proto__")) return JSON.parse(json, function(k, v) {
        if (k !== "__proto__") return v;
    });
    return JSON.parse(json);
}

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","./flatten-connection.mjs":"9iJRk","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"huCji":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProductPrice", function() {
    return ProductPrice;
});
var _objectSpreadMjs = require("@swc/helpers/src/_object_spread.mjs");
var _objectSpreadMjsDefault = parcelHelpers.interopDefault(_objectSpreadMjs);
var _objectSpreadPropsMjs = require("@swc/helpers/src/_object_spread_props.mjs");
var _objectSpreadPropsMjsDefault = parcelHelpers.interopDefault(_objectSpreadPropsMjs);
var _objectWithoutPropertiesMjs = require("@swc/helpers/src/_object_without_properties.mjs");
var _objectWithoutPropertiesMjsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _moneyMjs = require("./Money.mjs");
var _flattenConnectionMjs = require("./flatten-connection.mjs");
function ProductPrice(props) {
    var _a, _b, _c, _d, _e, _f;
    var _props_priceType = props.priceType, priceType = _props_priceType === void 0 ? "regular" : _props_priceType, variantId = props.variantId, _props_valueType = props.valueType, valueType = _props_valueType === void 0 ? "min" : _props_valueType, product = props.data, passthroughProps = (0, _objectWithoutPropertiesMjsDefault.default)(props, [
        "priceType",
        "variantId",
        "valueType",
        "data"
    ]);
    if (product == null) throw new Error("<ProductPrice/> requires a product as the 'data' prop");
    var price;
    var measurement;
    var _ref, _flattenConnection_find;
    var variant = variantId ? (_flattenConnection_find = (0, _flattenConnectionMjs.flattenConnection)((_ref = product == null ? void 0 : product.variants) !== null && _ref !== void 0 ? _ref : {}).find(function(variant2) {
        return (variant2 == null ? void 0 : variant2.id) === variantId;
    })) !== null && _flattenConnection_find !== void 0 ? _flattenConnection_find : null : null;
    if (priceType === "compareAt") {
        if (variantId && variant) {
            if (((_a = variant.compareAtPriceV2) == null ? void 0 : _a.amount) === ((_b = variant.priceV2) == null ? void 0 : _b.amount)) return null;
            price = variant.compareAtPriceV2;
        } else if (valueType === "max") price = (_c = product == null ? void 0 : product.compareAtPriceRange) == null ? void 0 : _c.maxVariantPrice;
        else price = (_d = product == null ? void 0 : product.compareAtPriceRange) == null ? void 0 : _d.minVariantPrice;
    } else {
        if (variantId && variant) {
            price = variant.priceV2;
            if (valueType === "unit") {
                price = variant.unitPrice;
                measurement = variant.unitPriceMeasurement;
            }
        } else if (valueType === "max") price = (_e = product.priceRange) == null ? void 0 : _e.maxVariantPrice;
        else price = (_f = product.priceRange) == null ? void 0 : _f.minVariantPrice;
    }
    if (!price) return null;
    if (measurement) return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _moneyMjs.Money), (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, passthroughProps), {
        data: price,
        measurement: measurement
    }));
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _moneyMjs.Money), (0, _objectSpreadPropsMjsDefault.default)((0, _objectSpreadMjsDefault.default)({}, passthroughProps), {
        data: price
    }));
}

},{"@swc/helpers/src/_object_spread.mjs":"kTy2G","@swc/helpers/src/_object_spread_props.mjs":"ia8HR","@swc/helpers/src/_object_without_properties.mjs":"d0eOZ","react/jsx-runtime":"ebSqZ","./Money.mjs":"juuRs","./flatten-connection.mjs":"9iJRk","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"fSZOY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DoublePropsErrorMessage", function() {
    return DoublePropsErrorMessage;
});
parcelHelpers.export(exports, "InvalidPropsErrorMessage", function() {
    return InvalidPropsErrorMessage;
});
parcelHelpers.export(exports, "MissingPropsErrorMessage", function() {
    return MissingPropsErrorMessage;
});
parcelHelpers.export(exports, "MissingStoreDomainErrorMessage", function() {
    return MissingStoreDomainErrorMessage;
});
parcelHelpers.export(exports, "ShopPayButton", function() {
    return ShopPayButton;
});
var _jsxRuntime = require("react/jsx-runtime");
var _shopifyProviderMjs = require("./ShopifyProvider.mjs");
var _loadScriptMjs = require("./load-script.mjs");
var _analyticsUtilsMjs = require("./analytics-utils.mjs");
var SHOPJS_URL = "https://cdn.shopify.com/shopifycloud/shop-js/v1.0/client.js";
function ShopPayButton(param) {
    var variantIds = param.variantIds, className = param.className, variantIdsAndQuantities = param.variantIdsAndQuantities, width = param.width, _storeDomain = param.storeDomain;
    var shop = (0, _shopifyProviderMjs.useShop)();
    var storeDomain = _storeDomain || (shop == null ? void 0 : shop.storeDomain);
    var shopPayLoadedStatus = (0, _loadScriptMjs.useLoadScript)(SHOPJS_URL);
    var ids = [];
    if (!storeDomain || storeDomain === (0, _shopifyProviderMjs.defaultShopifyContext).storeDomain) throw new Error(MissingStoreDomainErrorMessage);
    if (variantIds && variantIdsAndQuantities) throw new Error(DoublePropsErrorMessage);
    if (!variantIds && !variantIdsAndQuantities) throw new Error(MissingPropsErrorMessage);
    if (variantIds) ids = variantIds.reduce(function(prev, curr) {
        var bareId = (0, _analyticsUtilsMjs.parseGid)(curr).id;
        if (bareId) prev.push(bareId);
        return prev;
    }, []);
    else if (variantIdsAndQuantities) ids = variantIdsAndQuantities.reduce(function(prev, curr) {
        var bareId = (0, _analyticsUtilsMjs.parseGid)(curr == null ? void 0 : curr.id).id;
        var _ref;
        if (bareId) prev.push("".concat(bareId, ":").concat((_ref = curr == null ? void 0 : curr.quantity) !== null && _ref !== void 0 ? _ref : 1));
        return prev;
    }, []);
    else throw new Error(MissingPropsErrorMessage);
    if (ids.length === 0) throw new Error(InvalidPropsErrorMessage);
    var style = width ? {
        "--shop-pay-button-width": width
    } : void 0;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        className: className,
        style: style,
        children: shopPayLoadedStatus === "done" && /* @__PURE__ */ (0, _jsxRuntime.jsx)("shop-pay-button", {
            "store-url": storeDomain,
            variants: ids.join(",")
        })
    });
}
var MissingStoreDomainErrorMessage = 'You must pass a "storeDomain" prop to the "ShopPayButton" component, or wrap it in a "ShopifyProvider" component.';
var InvalidPropsErrorMessage = 'You must pass in "variantIds" in the form of ["gid://shopify/ProductVariant/1"]';
var MissingPropsErrorMessage = 'You must pass in either "variantIds" or "variantIdsAndQuantities" to ShopPayButton';
var DoublePropsErrorMessage = "You must provide either a variantIds or variantIdsAndQuantities prop, but not both in the ShopPayButton component";

},{"react/jsx-runtime":"ebSqZ","./ShopifyProvider.mjs":"6TpGm","./load-script.mjs":"9fc7p","./analytics-utils.mjs":"4XHNQ","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"axIHV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useShopifyCookies", function() {
    return useShopifyCookies;
});
var _react = require("react");
var _cookie = require("worktop/cookie");
var _cartConstantsMjs = require("./cart-constants.mjs");
var _cookiesUtilsMjs = require("./cookies-utils.mjs");
var longTermLength = 31104000;
var shortTermLength = 1800;
function useShopifyCookies(options) {
    var _ref = options || {}, _ref_hasUserConsent = _ref.hasUserConsent, hasUserConsent = _ref_hasUserConsent === void 0 ? false : _ref_hasUserConsent, _ref_domain = _ref.domain, domain = _ref_domain === void 0 ? "" : _ref_domain;
    (0, _react.useEffect)(function() {
        var cookies = (0, _cookiesUtilsMjs.getShopifyCookies)(document.cookie);
        if (hasUserConsent) {
            setCookie((0, _cartConstantsMjs.SHOPIFY_Y), cookies[0, _cartConstantsMjs.SHOPIFY_Y] || (0, _cookiesUtilsMjs.buildUUID)(), longTermLength, domain);
            setCookie((0, _cartConstantsMjs.SHOPIFY_S), cookies[0, _cartConstantsMjs.SHOPIFY_S] || (0, _cookiesUtilsMjs.buildUUID)(), shortTermLength, domain);
        } else {
            setCookie((0, _cartConstantsMjs.SHOPIFY_Y), "", 0, domain);
            setCookie((0, _cartConstantsMjs.SHOPIFY_S), "", 0, domain);
        }
    });
}
function setCookie(name, value, maxage, domain) {
    document.cookie = (0, _cookie.stringify)(name, value, {
        maxage: maxage,
        domain: domain,
        samesite: "Lax",
        path: "/"
    });
}

},{"react":"ihebA","worktop/cookie":"7S9xN","./cart-constants.mjs":"f5ldq","./cookies-utils.mjs":"gGHAO","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"khrlc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sortSizeOptions", function() {
    return sortSizeOptions;
});
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _toConsumableArrayMjs = require("@swc/helpers/src/_to_consumable_array.mjs");
var _toConsumableArrayMjsDefault = parcelHelpers.interopDefault(_toConsumableArrayMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _config = require("../config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _preact = require("preact");
var _preactDefault = parcelHelpers.interopDefault(_preact);
var _hooks = require("preact/hooks");
var classes = (0, _configDefault.default).classes;
function FilterForm(param) {
    var filterContext = param.filterContext, collectionView = param.collectionView;
    if (!filterContext.filters) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {});
    var handleSubmit = function(e) {
        e.preventDefault();
    // filterContext.applyFilters()
    };
    var reOrderAndRenderFilters = function(filters) {
        var order = [
            "Sort by",
            "Type",
            "Colour",
            "Size",
            "Style",
            "Length",
            "Sleeve Length",
            "Brand",
            "Price"
        ];
        var orderedFilters = filters.sort(function(a, b) {
            var aOrder = order.indexOf(a.category);
            var bOrder = order.indexOf(b.category);
            return aOrder - bOrder;
        });
        // take all filters that appear before the Sort by filter and add them to the end
        var sortByFilter = orderedFilters.find(function(f) {
            return f.key === "sort";
        });
        if (sortByFilter) {
            var _orderedFilters;
            var sortByFilterIndex = orderedFilters.indexOf(sortByFilter);
            var filtersBeforeSortBy = orderedFilters.slice(0, sortByFilterIndex);
            orderedFilters.splice(0, sortByFilterIndex);
            (_orderedFilters = orderedFilters).push.apply(_orderedFilters, (0, _toConsumableArrayMjsDefault.default)(filtersBeforeSortBy));
        }
        // get brand and add it to the end
        var brandFilter = orderedFilters.find(function(f) {
            return f.key === "vendor";
        });
        if (brandFilter) {
            orderedFilters.splice(orderedFilters.indexOf(brandFilter), 1);
            orderedFilters.push(brandFilter);
        }
        // re-order the options in the sort filter
        var sortFilter = orderedFilters.find(function(f) {
            return f.key === "sort";
        });
        if (sortFilter) {
            var order1 = [
                "Relevance",
                "Price (low-to-high)",
                "Price (high-to-low)",
                "Date (old-to-new)",
                "Date (new-to-old)",
                "Name (A-Z)",
                "Name (Z-A)"
            ];
            sortFilter.options = sortFilter.options.sort(function(a, b) {
                var aOrder = order1.indexOf(a.label);
                var bOrder = order1.indexOf(b.label);
                return aOrder - bOrder;
            });
        }
        return orderedFilters.map(function(filter) {
            return !!filter.options.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)(FilterCategory, {
                filter: filter
            }, filter.key + filter.operator);
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            class: classes.filterFormWrapper,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                class: "".concat(classes.filterForm).concat(collectionView.expanded ? " " + classes.filterFormExpanded : ""),
                onReset: filterContext.reset,
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        class: classes.filterFormHeader,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                class: classes.filterFormTitle,
                                children: "Filters / Sort By"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                class: "filters__close-button",
                                onClick: collectionView.toggleExpanded,
                                type: "button",
                                children: "Close"
                            })
                        ]
                    }),
                    reOrderAndRenderFilters(filterContext.filters),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PriceSlider, {
                        minFilter: filterContext.filters.find(function(f) {
                            return f.key === "price" && f.operator === ">";
                        }),
                        maxFilter: filterContext.filters.find(function(f) {
                            return f.key === "price" && f.operator === "<";
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        class: classes.filterFormApplyButton,
                        onClick: collectionView.toggleExpanded,
                        type: "submit",
                        children: "Apply"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        class: classes.filterFormClearButton,
                        type: "reset",
                        children: "Clear"
                    })
                ]
            })
        })
    });
}
exports.default = FilterForm;
var sortSizeOptions = function(options) {
    var sizeOrder = {
        "1YR-2YR": 701,
        "3YR-4YR": 702,
        "5YR-6YR": 703,
        "7YR-8YR": 704,
        "1": 201,
        "2": 202,
        "3": 203,
        "4": 204,
        "5": 205,
        "6": 1,
        "7": 2,
        "8": 3,
        "10": 4,
        "12": 5,
        "14": 6,
        "16": 7,
        "18": 8,
        "20": 9,
        "22": 10,
        "24": 11,
        "26": 12,
        "14/16": 301,
        "16/18": 302,
        "18/20": 303,
        "20/22": 304,
        "22/24": 305,
        "24/26": 306,
        "One": 401,
        "XS": 501,
        "S": 502,
        "M": 503,
        "L": 504,
        "Xl": 505,
        "XL": 506,
        "XXL": 507,
        "XXXL": 508,
        "S/M": 601,
        "M/L": 602,
        "L/XL": 603
    };
    var sortedOptions = options.sort(function(a, b) {
        var aOrder = sizeOrder[a.label] || 0;
        var bOrder = sizeOrder[b.label] || 0;
        return aOrder - bOrder;
    });
    return sortedOptions;
};
function FilterCategory(param) {
    var filter = param.filter;
    // console.log('****** FilterCategory', filter)
    if (filter.key === "option:Size") // sort filter options by size
    // console.log('SIZE OPTIONS', filter.options)
    filter.options = sortSizeOptions(filter.options);
    var _useState = (0, _slicedToArrayMjsDefault.default)((0, _hooks.useState)(false), 2), expanded = _useState[0], setExpanded = _useState[1];
    var visibleOptions = filter.options.slice(0, expanded ? filter.options.length : 10);
    var toggleExpanded = function() {
        return setExpanded(!expanded);
    };
    var getHandleInputChange = function(filter) {
        return function(e) {
            var target = e.target;
            // console.warn('[TODO] New logic for setting filter values array')
            if (target.type === "checkbox") // console.log('checkbox')
            return filter.setValues(toggleArrayItem(filter.values, target.value));
            // console.log('not checkbox')
            filter.setValues([
                target.value
            ]);
        };
    };
    // [TODO] Can we change this in the API? -DAN
    var changeOptionLabel = function(optionLabel) {
        switch(optionLabel){
            case "Price (low-to-high)":
                return "Price: Low - High";
            case "Price (high-to-low)":
                return "Price: High - Low";
            case "Name (A-Z)":
                return "A - Z";
            case "Name (Z-A)":
                return "Z - A";
            case "Date (old-to-new)":
                return "Date: Old - New";
            case "Date (new-to-old)":
                return "Date: New - Old";
            default:
                return optionLabel;
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
        class: classes.filterFormFieldset,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                children: filter.key === "option:Sleeve Length" ? "Sleeve Length - Tops" : filter.category
            }),
            visibleOptions.map(function(option) {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    class: "count-" + option.value.count,
                    children: filter.key === "sort" ? /* Special rendering for the "sort" filter */ /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                onChange: getHandleInputChange(filter),
                                name: filter.key,
                                type: filter.multiple ? "checkbox" : "radio",
                                value: option.value,
                                checked: filter.values.includes(option.value)
                            }),
                            changeOptionLabel(option.label)
                        ]
                    }) : /* Rendering for other filters */ /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                onChange: getHandleInputChange(filter),
                                name: filter.key,
                                type: filter.multiple ? "checkbox" : "radio",
                                value: option.value.label,
                                checked: filter.values.includes(option.value.label)
                            }),
                            changeOptionLabel(option.value.label),
                            " \xa0(",
                            option.value.count,
                            ")"
                        ]
                    })
                }, option.value.label);
            }),
            filter.options.length > 10 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                class: classes.filterFormMoreButton,
                onClick: toggleExpanded,
                type: "button",
                children: expanded ? "Less" : "More"
            })
        ]
    });
}
function PriceSlider(param) {
    var minFilter = param.minFilter, maxFilter = param.maxFilter;
    // const min = minFilter.min!
    // const max = minFilter.max!
    // Keep the initial value to avoid it changing when the product results
    // change, [TODO] do this more elegantly.
    var _useState = (0, _slicedToArrayMjsDefault.default)((0, _hooks.useState)(minFilter.min), 1), min = _useState[0];
    var _useState1 = (0, _slicedToArrayMjsDefault.default)((0, _hooks.useState)(minFilter.max), 1), max = _useState1[0];
    var _minFilter_values_;
    var minValue = (_minFilter_values_ = minFilter.values[0]) !== null && _minFilter_values_ !== void 0 ? _minFilter_values_ : min;
    var _maxFilter_values_;
    var maxValue = (_maxFilter_values_ = maxFilter.values[0]) !== null && _maxFilter_values_ !== void 0 ? _maxFilter_values_ : max;
    var setMin = function(newValue) {
        return minFilter.setValues([
            Math.min(newValue, maxValue)
        ]);
    };
    var setMax = function(newValue) {
        return maxFilter.setValues([
            Math.max(newValue, minValue)
        ]);
    };
    var _useState2 = (0, _slicedToArrayMjsDefault.default)((0, _hooks.useState)(minValue), 2), draggingValueMin = _useState2[0], _setDraggingValueMin = _useState2[1];
    var _useState3 = (0, _slicedToArrayMjsDefault.default)((0, _hooks.useState)(maxValue), 2), draggingValueMax = _useState3[0], _setDraggingValueMax = _useState3[1];
    var setDraggingValueMin = function(newValue) {
        return _setDraggingValueMin(Math.min(newValue, maxValue));
    };
    var setDraggingValueMax = function(newValue) {
        return _setDraggingValueMax(Math.max(newValue, minValue));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                class: "price-slider",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SliderKnob, {
                        min: min,
                        max: max,
                        value: minValue,
                        setValue: setMin,
                        draggingValue: draggingValueMin,
                        setDraggingValue: setDraggingValueMin
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SliderKnob, {
                        min: min,
                        max: max,
                        value: maxValue,
                        setValue: setMax,
                        draggingValue: draggingValueMax,
                        setDraggingValue: setDraggingValueMax
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "€".concat(draggingValueMin.toFixed(2), " to €").concat(draggingValueMax.toFixed(2))
            })
        ]
    });
}
function SliderKnob(param) {
    var min = param.min, max = param.max, value = param.value, setValue = param.setValue, draggingValue = param.draggingValue, setDraggingValue = param.setDraggingValue;
    var range = max - min;
    var _useState = (0, _slicedToArrayMjsDefault.default)((0, _hooks.useState)(false), 2), isDragging = _useState[0], setIsDragging = _useState[1];
    var handlePointerDown = function(e) {
        // e.preventDefault()
        setDraggingValue(value);
        setIsDragging(true);
        window.addEventListener("pointerup", function() {
            setIsDragging(false);
        // setValue(draggingValue!)
        }, {
            once: true
        });
    };
    var handlePointerUp = function() {
        setValue(draggingValue);
        setIsDragging(false);
    };
    (0, _hooks.useEffect)(function() {
        if (!isDragging) return;
        window.addEventListener("pointermove", handlePointerMove);
        window.addEventListener("pointerup", handlePointerUp);
        return function() {
            window.removeEventListener("pointermove", handlePointerMove);
            window.removeEventListener("pointerup", handlePointerUp);
        };
    }, [
        isDragging,
        draggingValue
    ]);
    var handlePointerMove = function(e) {
        if (!isDragging) return;
        var slider = e.target.parentElement;
        var sliderDimensions = slider.getBoundingClientRect();
        var movementPercent = e.movementX / sliderDimensions.width;
        var movementAmount = movementPercent * range;
        var newValue = draggingValue + movementAmount;
        var newValueWithinRange = Math.min(Math.max(min, newValue), max);
        setDraggingValue(newValueWithinRange);
    };
    var offsetPercent = ((isDragging ? draggingValue : value) - min) / range * 100;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        onPointerDown: handlePointerDown,
        class: "price-slider__thumb",
        tabIndex: -1,
        role: "slider",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": isDragging ? draggingValue : value,
        style: {
            insetInlineStart: "".concat(offsetPercent, "%")
        }
    });
}
function toggleArrayItem(array, item) {
    var existingIndex = array.indexOf(item);
    if (existingIndex === -1) return (0, _toConsumableArrayMjsDefault.default)(array).concat([
        item
    ]);
    return (0, _toConsumableArrayMjsDefault.default)(array.slice(0, existingIndex)).concat((0, _toConsumableArrayMjsDefault.default)(array.slice(existingIndex + 1)));
}
function removeFromArray(array, value) {
    var existingIndex = array.indexOf(value);
    if (existingIndex === -1) return array;
    return (0, _toConsumableArrayMjsDefault.default)(array.slice(0, existingIndex)).concat((0, _toConsumableArrayMjsDefault.default)(array.slice(existingIndex + 1)));
}

},{"@swc/helpers/src/_sliced_to_array.mjs":"l34hS","@swc/helpers/src/_to_consumable_array.mjs":"11hUU","react/jsx-runtime":"ebSqZ","../config":"1C44m","preact":"fiBpF","preact/hooks":"fdDeA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"6tpxS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _config = require("../config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _preact = require("preact");
var _preactDefault = parcelHelpers.interopDefault(_preact);
var _productCard = require("./ProductCard");
var _productCardDefault = parcelHelpers.interopDefault(_productCard);
var _hooks = require("preact/hooks");
var classes = (0, _configDefault.default).classes;
function ProductGrid(param) {
    var filterContext = param.filterContext, collectionView = param.collectionView;
    var _filterContext_results;
    // const [lastProductElement, setLastProductElement] = useState<HTMLElement | null>(null)
    var lastElementRef = (0, _hooks.useRef)(null);
    // useInfiniteScroll(lastElementRef.current, filterContext.incrementPage)
    var lastSeenElementRef;
    var _useState = (0, _slicedToArrayMjsDefault.default)((0, _hooks.useState)(false), 2), isScrolled = _useState[0], setIsScrolled = _useState[1];
    (0, _hooks.useEffect)(function() {
        var scrollHandler = function(e) {
            var threshold = 5200;
            if (window.innerWidth < 767) threshold = 8000;
            var scrollPosition = window.scrollY;
            var hasScrolledFarEnough = scrollPosition > threshold;
            setIsScrolled(hasScrolledFarEnough);
        };
        document.addEventListener("scroll", scrollHandler);
        return function() {
            return document.removeEventListener("scroll", scrollHandler);
        };
    }, []);
    var showBackToTop = filterContext.results && isScrolled && filterContext.results.length >= 55;
    var backToTop = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    (0, _hooks.useEffect)(function() {
        var scrollHandler = function(e) {
            if (lastElementRef.current == null) return;
            var lastElementPosition = lastElementRef.current.getBoundingClientRect().top;
            var bottomOfViewport = window.innerHeight;
            var hasScrolledFarEnough = lastElementPosition < bottomOfViewport + 500;
            if (hasScrolledFarEnough) {
                console.log("INCREMENTING PAGE");
                document.removeEventListener("scroll", scrollHandler);
                filterContext.incrementPage();
            }
        };
        document.addEventListener("scroll", scrollHandler);
        return function() {
            return document.removeEventListener("scroll", scrollHandler);
        };
    }, [
        filterContext.results
    ]);
    // watch for changes to lastElementRef - this indicates a "page" load has completed
    (0, _hooks.useEffect)(function() {
        if (lastElementRef.current !== lastSeenElementRef) {
            lastSeenElementRef = lastElementRef.current;
            document.dispatchEvent(new CustomEvent("infinitescroll:filtercontext:finished"));
        }
    }, [
        filterContext.results
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        class: classes.productGridContainer,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                class: classes.productGrid,
                children: (_filterContext_results = filterContext.results) === null || _filterContext_results === void 0 ? void 0 : _filterContext_results.map(function(product, index) {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _productCardDefault.default), {
                        product: product,
                        filterContext: filterContext,
                        nodeRef: lastElementRef
                    }, product.handle);
                })
            }),
            showBackToTop && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                href: "#",
                onClick: backToTop,
                class: classes.backToTopButton,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                        width: "32",
                        height: "32",
                        viewBox: "0 0 32 32",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                width: "32",
                                height: "32"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M7.64645 15.6464C7.45119 15.8417 7.45119 16.1583 7.64645 16.3536L10.8284 19.5355C11.0237 19.7308 11.3403 19.7308 11.5355 19.5355C11.7308 19.3403 11.7308 19.0237 11.5355 18.8284L8.70711 16L11.5355 13.1716C11.7308 12.9763 11.7308 12.6597 11.5355 12.4645C11.3403 12.2692 11.0237 12.2692 10.8284 12.4645L7.64645 15.6464ZM24 15.5L8 15.5L8 16.5L24 16.5L24 15.5Z",
                                fill: "white"
                            })
                        ]
                    }),
                    "Back to top"
                ]
            })
        ]
    });
}
exports.default = ProductGrid;
function useInfiniteScroll(lastElement, callback) {
    // At the moment you can't change the callback once the hook has been called, but it may
    // be useful to implement this in the future. It's not required right now. --GAD
    var onIntersection = function(entries) {
        if (!entries[0].isIntersecting) return;
        callback();
    };
    var _useState = (0, _slicedToArrayMjsDefault.default)((0, _hooks.useState)(new IntersectionObserver(onIntersection, {
        rootMargin: "0px 0px 50% 0px"
    })), 1), observer = _useState[0];
    // This observer will fire when the element is 100px below the bottom of the viewport.
    var _useState1 = (0, _slicedToArrayMjsDefault.default)((0, _hooks.useState)(null), 2), observedElement = _useState1[0], setObservedElement = _useState1[1];
    (0, _hooks.useEffect)(function() {
        if (lastElement === observedElement) return;
        if (observedElement) observer.unobserve(observedElement);
        if (!lastElement) return setObservedElement(null);
        observer.observe(lastElement);
        setObservedElement(lastElement);
    }, [
        lastElement,
        observedElement
    ]);
}

},{"@swc/helpers/src/_sliced_to_array.mjs":"l34hS","react/jsx-runtime":"ebSqZ","../config":"1C44m","preact":"fiBpF","./ProductCard":"d2v0Y","preact/hooks":"fdDeA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"d2v0Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _config = require("../config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _preact = require("preact");
var _preactDefault = parcelHelpers.interopDefault(_preact);
var _quickshop = require("../../../framework/_quickshop");
var _hooks = require("preact/hooks");
function ProductCard(param) {
    var product = param.product, filterContext = param.filterContext, nodeRef = param.nodeRef;
    var getSwatches = function getSwatches(product) {
        var isMobile = window.innerWidth <= 768;
        var maxSwatches = isMobile ? 3 : 6;
        var swatchesToShow = showAllSwatches ? product.linked_products : product.linked_products.slice(0, maxSwatches);
        var moreSwatches = product.linked_products.length > maxSwatches;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "prod-card__swatches",
            children: [
                product.swatch && /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    href: productURL,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        class: "prod-card__swatch selected",
                        src: product.swatch,
                        alt: product.title
                    })
                }),
                swatchesToShow.map(function(swatch, index) {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: swatch.linked_url,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            onClick: selectedSwatch(),
                            className: "prod-card__swatch",
                            src: swatch.linked_swatch,
                            alt: product.title
                        })
                    }, index);
                }),
                moreSwatches && !showAllSwatches && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    class: "show-more-swatches",
                    onClick: function() {
                        return setShowAllSwatches(true);
                    },
                    children: "+"
                })
            ]
        });
    };
    var _product_images_, _product_images_1, _product_images_2, _product_images_3;
    // nodeRef is used to attach an IntersectionObserver to allow for infinite scrolling without
    // messy viewport scroll position arithmetic. If this is adapted for future projects that
    // require infinite scrolling, ensure that nodeRef is set as a ref on the outer element of
    // this component. --GAD
    var collection = filterContext.collection;
    // [TODO] This is a mess and needs refactoring, as it has been copied almost verbatim from
    // imperative code.
    // console.log('HAS PRODCUT BADGES', product.product_badges)
    var handleQuickshopClick = function(handle) {
        return function() {
            (0, _quickshop.Quickshop).createQuickshop(handle);
        };
    };
    var _useState = (0, _slicedToArrayMjsDefault.default)((0, _hooks.useState)(false), 2), showAllSwatches = _useState[0], setShowAllSwatches = _useState[1];
    // check for an element in the DOM with ID 'InitialProducts' and remove it
    (0, _hooks.useEffect)(function() {
        var initialProducts = document.getElementById("InitialProducts");
        if (initialProducts) initialProducts.remove();
    }, []);
    var _config_themeVars_site_wide_sale;
    var site_wide_sale = (_config_themeVars_site_wide_sale = (0, _configDefault.default).themeVars.site_wide_sale) !== null && _config_themeVars_site_wide_sale !== void 0 ? _config_themeVars_site_wide_sale : {};
    var _config_themeVars_theme_accent_color;
    var site_wide_accent_color = (_config_themeVars_theme_accent_color = (0, _configDefault.default).themeVars.theme.accent_color) !== null && _config_themeVars_theme_accent_color !== void 0 ? _config_themeVars_theme_accent_color : "";
    // console.log(product)
    var compare_at_price = String(product.compare_at_price);
    var price = String(product.price);
    var saleText = "SALE";
    var saleBannerColor = "#CE0E2D";
    var notifyMe = product.tags.includes("back-in-stock");
    var outOfStock = product.variants.filter(function(variant) {
        return variant.inventory_quantity === 0;
    }).length === product.variants.length;
    var showNotifyMe = outOfStock && notifyMe;
    var customLabel = product.customLabel;
    var customLabelColor = product.customLabelColor;
    var customLabelTextColor = product.customLabelTextColor;
    if (site_wide_sale.activated == true) {
        var promoTag = site_wide_sale.promotion_tag;
        var tags = product.tags;
        var discount = (100 - site_wide_sale.promotion_percentage) / 100.0;
        tags.map(function(tag) {
            if (tag === promoTag) {
                compare_at_price = price;
                price = (Number(price) * discount).toFixed(2);
                saleText = site_wide_sale.banner_text;
                saleBannerColor = site_wide_sale.banner_color;
            }
        });
    }
    var onSale = +compare_at_price > +price;
    var labelText = getLabelTagText(product.tags);
    var labelBackgroundColor = getLabelBackgroundColor(product.tags);
    var productURL = collection ? "".concat(collection, "/products/").concat(product.handle) : "/products/".concat(product.handle);
    var freeGift = "";
    if (product.tags.includes("free-gift-product")) freeGift = "free-gift-hide";
    (0, _hooks.useEffect)(function() {
        try {
            if (window._swat) window._swat.initializeActionButtons("#productID-".concat(product.id));
            else {
                window.SwymCallbacks = window.SwymCallbacks || [];
                window.SwymCallbacks.push(function() {
                    window._swat.initializeActionButtons("#productID-".concat(product.id));
                });
            }
        } catch (error) {
            console.log(error);
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        class: "prod-card ".concat(freeGift),
        ref: nodeRef,
        id: "productID-".concat(product.id),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                class: "prod-card__image-container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        class: "prod-card__rollover-images",
                        children: [
                            product.images[1] && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                class: "prod-card__alternate-image",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: productURL,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            width: "295",
                                            // onError="this.style.visibility='hidden'"
                                            height: "443",
                                            src: "".concat((_product_images_ = product.images[1]) === null || _product_images_ === void 0 ? void 0 : _product_images_.src, "&width=400"),
                                            alt: (_product_images_1 = product.images[1]) === null || _product_images_1 === void 0 ? void 0 : _product_images_1.alt,
                                            class: "prod-card__image"
                                        })
                                    }),
                                    window.themeSettings.enable_quickview ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        class: "prod-card__quick-view prod-card__quick-view-".concat(product.handle),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            class: "prod-card__quick-view__button",
                                            onClick: handleQuickshopClick(product.handle),
                                            children: "+ View"
                                        })
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                class: "prod-card__original-image",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: productURL,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        width: "295",
                                        height: "443",
                                        src: "".concat((_product_images_2 = product.images[0]) === null || _product_images_2 === void 0 ? void 0 : _product_images_2.src, "&width=400"),
                                        alt: "".concat((_product_images_3 = product.images[0]) === null || _product_images_3 === void 0 ? void 0 : _product_images_3.alt),
                                        class: "prod-card__image"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        class: "prod-card__badges",
                        children: [
                            isNew(product) && !onSale && !showNotifyMe && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                class: "prod-card__tag",
                                style: "background-color: ".concat(site_wide_accent_color),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    class: "prod-card__tag__text",
                                    children: "New In"
                                })
                            }),
                            showNotifyMe && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                class: "prod-card__tag",
                                style: "background-color: ".concat(site_wide_accent_color),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    class: "prod-card__tag__text",
                                    children: "Notify Me"
                                })
                            }),
                            product.product_badges && // map the product  badges
                            product.product_badges.map(function(badge) {
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    class: "prod-card__tag",
                                    style: "background-color: ".concat(badge.colour),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        class: "prod-card__tag__text",
                                        children: badge.text
                                    })
                                });
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        class: "prod-card__wishlist-heart prod-card__wishlist-heart-".concat(product.handle),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            "data-with-epi": "true",
                            class: "swym-button swym-add-to-wishlist-view-product product_".concat(product.id),
                            "data-swaction": "addToWishlist",
                            "data-product-id": product.id,
                            "data-variant-id": product.variants[0].id,
                            "data-product-url": "https://www.carraigdonn.com/products/".concat(product.handle)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "prod-card__banner",
                children: customLabel ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "prod-card__label-banner custom",
                    style: {
                        backgroundColor: customLabelColor
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        style: {
                            color: customLabelTextColor
                        },
                        className: "prod-card__banner__text",
                        children: customLabel
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        onSale && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "prod-card__sale-banner",
                            style: {
                                backgroundColor: saleBannerColor
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "prod-card__banner__text",
                                children: saleText
                            })
                        }),
                        labelText && !onSale && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "prod-card__label-banner",
                            style: {
                                backgroundColor: labelBackgroundColor
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "prod-card__banner__text",
                                children: labelText.toUpperCase()
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                class: "prod-card__info",
                style: {
                    flexDirection: "column",
                    flexWrap: "nowrap"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        class: "prod-card__info__details",
                        style: {
                            flex: "none"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "".concat(window.location.origin, "/products/").concat(product.handle),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                class: "prod-card__title",
                                dangerouslySetInnerHTML: {
                                    __html: product.title
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        class: "prod-card__vendor",
                        children: product.vendor
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        class: "yotpolink",
                        href: "".concat(productURL, "#goToYotpo"),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            class: "yotpo-widget-instance",
                            "data-yotpo-instance-id": "574878",
                            "data-yotpo-product-id": product.id,
                            "data-yotpo-cart-product-id": product.id,
                            "data-yotpo-section-id": "product-card"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        class: "prod-card__info__price",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                class: "prod-card__price__container",
                                children: [
                                    onSale && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        class: "prod-card__compare-at-price",
                                        children: "".concat((0, _configDefault.default).currencySymbol).concat(Number(compare_at_price).toFixed(2))
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        class: "prod-card__price ".concat(onSale ? "prod-card__price__sale" : ""),
                                        children: "".concat((0, _configDefault.default).currencySymbol).concat(Number(price).toFixed(2))
                                    })
                                ]
                            }),
                            Array.isArray(product.linked_products) && product.linked_products.length > 0 && getSwatches(product)
                        ]
                    })
                ]
            })
        ]
    });
}
exports.default = ProductCard;
function isNew(product) {
    var proper_date = "";
    var proper_date_parts = product.published_at.toString().split(" ");
    if (proper_date_parts.length < 1) return 0;
    proper_date = proper_date_parts[0] + "T" + proper_date_parts[1];
    var createdAtDate = new Date(proper_date);
    var now = new Date();
    var daysSinceCreation = Math.floor((now.valueOf() - createdAtDate.valueOf()) / 86400000);
    return daysSinceCreation <= 14;
}
function getSwatches(product) {
    return product.linked_products.map(function(swatch) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
            href: swatch.linked_url,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                onClick: selectedSwatch(),
                class: "prod-card__swatch",
                src: swatch.linked_swatch,
                alt: product.title
            })
        });
    });
}
function selectedSwatch() {
    return function(event) {
        var swatches = document.querySelectorAll(".prod-card__swatch");
        swatches.forEach(function(swatch) {
            swatch.classList.remove("selected");
        });
        var target = event.target;
        target.classList.add("selected");
    };
}
function getLabelTagText(tags) {
    // [TODO] Refactor
    var labelTagText = null;
    tags.forEach(function(tag) {
        var splitTag = tag.split("-");
        if (splitTag[0] == "label" && splitTag.length == 2) labelTagText = tag.split("-")[1];
        else if (splitTag[0] == "label" && splitTag.length == 3) labelTagText = "".concat(splitTag[1], " ").concat(splitTag[2]);
        else if (splitTag[0] == "label" && splitTag.length == 4) labelTagText = "".concat(splitTag[1], " ").concat(splitTag[2], " ").concat(splitTag[3]);
    });
    return labelTagText;
}
function getLabelBackgroundColor(tags) {
    var labelBackgroundColor = null;
    tags.forEach(function(tag) {
        // console.log('tag', tag)
        var splitTag = tag.split("-");
        if (splitTag[0] == "label" && splitTag[1] == "background") labelBackgroundColor = splitTag[2];
    });
    return labelBackgroundColor;
}

},{"@swc/helpers/src/_sliced_to_array.mjs":"l34hS","react/jsx-runtime":"ebSqZ","../config":"1C44m","preact":"fiBpF","../../../framework/_quickshop":"dZwOO","preact/hooks":"fdDeA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"6KiBe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _preact = require("preact");
var _preactDefault = parcelHelpers.interopDefault(_preact);
var _config = require("../config");
var _configDefault = parcelHelpers.interopDefault(_config);
var classes = (0, _configDefault.default).classes;
function CollectionHeader(param) {
    var collectionView = param.collectionView, filterContext = param.filterContext;
    // [TODO] This has become kind of an ugly way of doing this. --GAD
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        class: classes.productGridHeader,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: collectionView.toggleExpanded,
                class: "filters__button",
                children: "Filters / Sort By"
            }),
            (filterContext === null || filterContext === void 0 ? void 0 : filterContext.count) !== null && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                class: "filters__product-count",
                children: [
                    filterContext === null || filterContext === void 0 ? void 0 : filterContext.count,
                    " products"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                class: "filters__toggles filters__toggles--show",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        class: "filters__toggles-title",
                        children: "View"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ViewToggle, {
                        gridView: collectionView,
                        minColumns: true,
                        classSuffix: "small"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ViewToggle, {
                        gridView: collectionView,
                        minColumns: false,
                        classSuffix: "large"
                    })
                ]
            })
        ]
    });
}
exports.default = CollectionHeader;
function ViewToggle(param) {
    var minColumns = param.minColumns, gridView = param.gridView, classSuffix = param.classSuffix;
    var isActive = minColumns === gridView.minColumns;
    var buttonClass = [
        classes.gridViewToggle,
        classes.gridViewToggle + "--" + (isActive ? "active" : "inactive"),
        classes.gridViewToggle + "--" + classSuffix
    ].join(" ");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        class: buttonClass,
        onClick: function() {
            return gridView.setMinColumns(minColumns);
        }
    });
}

},{"react/jsx-runtime":"ebSqZ","preact":"fiBpF","../config":"1C44m","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"dEqmu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _typeOfMjs = require("@swc/helpers/src/_type_of.mjs");
var _typeOfMjsDefault = parcelHelpers.interopDefault(_typeOfMjs);
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg === "undefined" ? "undefined" : (0, _typeOfMjsDefault.default)(arg);
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{"@swc/helpers/src/_type_of.mjs":"52Yae","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"7z4FV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _asyncToGeneratorMjs = require("@swc/helpers/src/_async_to_generator.mjs");
var _asyncToGeneratorMjsDefault = parcelHelpers.interopDefault(_asyncToGeneratorMjs);
var _tsGeneratorMjs = require("@swc/helpers/src/_ts_generator.mjs");
var _tsGeneratorMjsDefault = parcelHelpers.interopDefault(_tsGeneratorMjs);
var ThemeVars = window.ThemeVars;
var currencySymbol = window.ThemeVars.currency.symbol;
var queries = {
    productGridParent: "#uwpfilters",
    quickSearchCloseResults: "[data-action=close-quick-search-results]",
    quickSearchContainer: "[data-search-results-grid],#quick-search",
    quickSearchForm: "[data-uwpf=search-form]",
    quickSearchInput: "[data-search-input]",
    quickSearchQuerySlot: ".quick-search__query",
    quickSearchViewMore: ".quick-search__view-more",
    themeFiltersJson: "#filter-data"
};
if (ThemeVars.search.pSearchShowProducts) queries.quickSearchProducts = ".quick-search__search-grid--products";
if (ThemeVars.search.pSearchShowArticles) queries.quickSearchArticles = ".quick-search__search-grid--articles";
if (ThemeVars.search.pSearchShowArticles) queries.quickSearchCollections = ".quick-search__search-grid--collections";
function renderQuickSearchGrid(template, query, results) {
    var articles = results.articles, collections = results.collections, pages = results.pages, products = results.products;
    var quickSearch = template.content.cloneNode(true);
    if (queries.quickSearchProducts) var productSearchGrid = quickSearch.querySelector(queries.quickSearchProducts);
    if (queries.quickSearchArticles) var articleSearchGrid = quickSearch.querySelector(queries.quickSearchArticles);
    if (queries.quickSearchCollections) var collectionSearchGrid = quickSearch.querySelector(queries.quickSearchCollections);
    var querySlot = quickSearch.querySelector(queries.quickSearchQuerySlot);
    var viewMore = quickSearch.querySelector(queries.quickSearchViewMore);
    viewMore.href = "/search?q=".concat(query);
    querySlot.textContent = query;
    var existingSearchGrid = document.querySelectorAll(queries.quickSearchContainer);
    if (queries.quickSearchProducts) {
        var productCards = products.map(createProductSuggestionCard);
        productCards.forEach(function(renderCardInParent) {
            return renderCardInParent(productSearchGrid);
        });
    }
    if (queries.quickSearchArticles) {
        var articleCards = articles.map(createArticleSuggestionCard);
        articleCards.forEach(function(renderCardInParent) {
            return renderCardInParent(articleSearchGrid);
        });
    }
    if (queries.quickSearchCollections) {
        var alphabeticalCollections = collections.sort(function(a, b) {
            return a.title.localeCompare(b.title);
        });
        var collectionCards = alphabeticalCollections.map(createCollectionSuggestionCard);
        collectionCards.forEach(function(renderCardInParent) {
            return renderCardInParent(collectionSearchGrid);
        });
    }
    existingSearchGrid === null || existingSearchGrid === void 0 ? void 0 : existingSearchGrid.forEach(function(el) {
        return el.remove();
    });
    quickSearch.children[0].dataset.searchResultsGrid = true;
    template.after(quickSearch);
    document.querySelectorAll(queries.quickSearchCloseResults).forEach(function(closeButton) {
        return closeButton.addEventListener("click", closeQuickSearchResults);
    });
}
function handleSearchQueryChanged(query, searchGridTemplate) {
    return _handleSearchQueryChanged.apply(this, arguments);
}
function _handleSearchQueryChanged() {
    _handleSearchQueryChanged = (0, _asyncToGeneratorMjsDefault.default)(function(query, searchGridTemplate) {
        var results;
        return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getSearchSuggestions(query)
                    ];
                case 1:
                    results = _state.sent();
                    if (!results) return [
                        2
                    ];
                    if (results.redirect) window.location = results.redirect;
                    // [TODO] Handle network error
                    renderQuickSearchGrid(searchGridTemplate, query, results);
                    return [
                        2
                    ];
            }
        });
    });
    return _handleSearchQueryChanged.apply(this, arguments);
}
function closeQuickSearchResults() {
    var existingSearchGrid = document.querySelectorAll(queries.quickSearchContainer);
    var searchInput = document.querySelectorAll(queries.quickSearchInput);
    var searchForms = document.querySelectorAll(queries.quickSearchForm);
    if (!existingSearchGrid[0]) return;
    searchInput.forEach(function(el) {
        return el.value = "";
    });
    existingSearchGrid.forEach(function(el) {
        return el.remove();
    });
    searchForms.forEach(function(el) {
        return el.blur();
    });
}
function getSearchSuggestions(searchQuery) {
    return _getSearchSuggestions.apply(this, arguments);
}
function _getSearchSuggestions() {
    _getSearchSuggestions = (0, _asyncToGeneratorMjsDefault.default)(function(searchQuery) {
        var searchTypes, searchParamTypes, tagNew, combinedSearchQuery, encodedQuery, searchUrl, searchResponse, searchResults, productsOnlySearch, searchResultProductCount, encodedOriginalQuery, reFetchUrl, additionalResults;
        return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
            switch(_state.label){
                case 0:
                    /* 
   * This function is a refactored version of _predictive-search.js (without config and rendering)
   * to fulfill last-minute requirements for functionality that isn't yet present in UWPFilters
   * by using the Shopify search API. Once tracking of blog posts and collections is incorporated
   * into UWPFilters, it will be replaced by getResults(). --GAD
   */ if (!searchQuery || typeof searchQuery !== "string" || searchQuery.length < 3) return [
                        2,
                        null
                    ]; // Return null for invalid queries
                    searchTypes = [];
                    if (ThemeVars.search.pSearchShowProducts) searchTypes.push("product");
                    if (ThemeVars.search.pSearchShowCollections) searchTypes.push("collection");
                    if (ThemeVars.search.pSearchShowArticles) searchTypes.push("article");
                    searchParamTypes = "&".concat(encodeURIComponent("resources[type]"), "=").concat(searchTypes.join());
                    tagNew = "tag:NEW";
                    combinedSearchQuery = "".concat(searchQuery, " ").concat(tagNew);
                    encodedQuery = encodeURIComponent(combinedSearchQuery);
                    searchUrl = "/search/suggest.json?q=".concat(encodedQuery).concat(searchParamTypes, "&resources[limit]=10&resources[unavailable_products]=last&resources[fields]=title,tag,product_type,variants.title,vendor,variants.barcode,variants.sku");
                    return [
                        4,
                        fetch(searchUrl)
                    ];
                case 1:
                    searchResponse = _state.sent();
                    return [
                        4,
                        searchResponse.json()
                    ];
                case 2:
                    searchResults = _state.sent().resources.results;
                    productsOnlySearch = ThemeVars.search.pSearchShowProducts && !ThemeVars.search.pSearchShowArticles && !ThemeVars.search.pSearchShowCollections;
                    searchResultProductCount = 10 - searchResults.products.length;
                    if (!(productsOnlySearch && searchResultProductCount < 10)) return [
                        3,
                        5
                    ];
                    encodedOriginalQuery = encodeURIComponent(searchQuery);
                    reFetchUrl = "/search/suggest.json?q=".concat(encodedOriginalQuery).concat(searchParamTypes, "&resources[limit]=").concat(searchResultProductCount, "&resources[unavailable_products]=last&resources[fields]=title,tag,product_type,variants.title,vendor,variants.barcode,variants.sku");
                    return [
                        4,
                        fetch(reFetchUrl)
                    ];
                case 3:
                    searchResponse = _state.sent();
                    return [
                        4,
                        searchResponse.json()
                    ];
                case 4:
                    additionalResults = _state.sent().resources.results;
                    // Combine initial and additional results
                    if (searchResults.products) searchResults.products = searchResults.products.concat(additionalResults.products).slice(0, 10);
                    _state.label = 5;
                case 5:
                    return [
                        2,
                        searchResults
                    ];
            }
        });
    });
    return _getSearchSuggestions.apply(this, arguments);
}
function handleSearchFocusIn(e) {
    var _e_currentTarget_querySelector;
    if (e.target.className == "quick-search__close") return;
    var form = e.currentTarget;
    var query = (_e_currentTarget_querySelector = e.currentTarget.querySelector(".header__search-input")) === null || _e_currentTarget_querySelector === void 0 ? void 0 : _e_currentTarget_querySelector.value;
    var searchGridTemplate = form.querySelector("template");
    if (query) handleSearchQueryChanged(query, searchGridTemplate);
}
function handleSearchInput(e) {
    var input = e.target;
    var searchGridTemplate = input.form.querySelector("template");
    var query = input.value;
    handleSearchQueryChanged(query, searchGridTemplate);
}
function getCompareAtPrice(product) {
    if (product.compare_at_price_min == "0.00" && product.compare_at_price_max == "0.00") return null;
    return Math.max(+product.compare_at_price_min, +product.compare_at_price_max).toFixed(2);
}
function createProductSuggestionCard(product) {
    /*
   * This is temporary - see comment on getSearchSuggestions(). --GAD
   */ var compareAtPrice = getCompareAtPrice(product);
    var price = product.price;
    var onSale = !!compareAtPrice;
    var promoTag = ThemeVars.site_wide_sale.promotion_tag;
    if (ThemeVars.site_wide_sale.activated == true) {
        var tags = product.tags;
        var discount = (100 - ThemeVars.site_wide_sale.promotion_percentage) / 100.0;
        tags.map(function(tag) {
            if (tag === promoTag) {
                compareAtPrice = price;
                price = (Number(price) * discount).toFixed(2);
            }
        });
    }
    var isNew = false;
    var card = document.createElement("div");
    card.classList.add("prod-card");
    card.innerHTML = '\n    <div class="prod-card__image-container">\n      <div class="prod-card__rollover-images">\n        <div class="prod-card__original-image">\n          <a href="'.concat(window.location.origin, "/products/").concat(product.handle, '">\n            <img width="295" height="443" src="').concat(product.featured_image.url, '&width=400" alt="').concat(product.featured_image.alt, '" class="prod-card__image" />\n          </a>\n        </div>\n      </div>\n      <div class="prod-card__badges">\n        ').concat(isNew ? '\n        <div class="prod-card__tag">\n          <span class="prod-card__tag__text">{{- new_tag_text -}}</span>\n        </div>' : "", '\n      </div>\n      \n    </div>\n    <div class="prod-card__banner">\n      ').concat(ThemeVars.site_wide_sale.activated === true && product.tags.includes(ThemeVars.site_wide_sale.promotion_tag) ? '<div class="prod-card__sale-banner" style="background: '.concat(ThemeVars.site_wide_sale.banner_color, '">\n        <span class="prod-card__banner__text">').concat(ThemeVars.site_wide_sale.banner_text, "</span>\n      </div>") : onSale ? '<div class="prod-card__sale-banner" style="background-color: #CE0E2D !important;">\n        <span class="prod-card__banner__text">SALE</span>\n      </div>' : "", '\n    </div>\n    <div class="prod-card__info">\n      <div class="prod-card__info__details">\n        <a href="').concat(window.location.origin, "/products/").concat(product.handle, '">\n          <h3 class="prod-card__title">\n            ').concat(product.title, '\n          </h3>\n        </a>\n      </div>\n      <div class="prod-card__info__price">\n        <div class="prod-card__price__container">\n          ').concat(compareAtPrice && ThemeVars.site_wide_sale.activated || onSale && parseInt(compareAtPrice) > parseInt(price) ? '\n          <div class="prod-card__compare-at-price">\n          '.concat(currencySymbol).concat(compareAtPrice, "\n          </div>") : "", '\n          <div class="prod-card__price ').concat(compareAtPrice && ThemeVars.site_wide_sale.activated || onSale && parseInt(compareAtPrice) > parseInt(price) ? "prod-card__price__sale" : "", '">\n          ').concat(currencySymbol).concat(price, '\n          </div>\n        </div>\n      </div>\n      <div class="prod-card__vendor">\n        ').concat(product.vendor, "\n      </div>\n    </div>\n  ");
    var renderInParent = function(parent) {
        parent.appendChild(card);
    };
    return renderInParent;
}
function createArticleSuggestionCard(article) {
    // This is temporary - see comment on getSearchSuggestions(). --GAD
    var card = document.createElement("div");
    card.classList.add("prod-card");
    card.innerHTML = '\n    <div class="prod-card__image-container">\n      <div class="prod-card__slider-'.concat(article.handle, ' prod-card__slider swiper" id="ProductCardSwiper-').concat(article.handle, '">\n        <div class="swiper-wrapper">\n          <div class="swiper-slide prod-card__slider__slide swiper-no-swiping">\n            <a href="').concat(article.url, '">\n              <img width="295" height="443" src="').concat(article.image, '" loading="lazy" alt="').concat(article.title, '" class="prod-card__image" />\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class="prod-card__info">\n      <div class="prod-card__info__details">\n        <a href="products/').concat(article.handle, '">\n          <h3 class="prod-card__title">\n            ').concat(article.title, "\n          </h3>\n        </a>\n      </div>\n    </div>\n  ");
    var renderInParent = function(parent) {
        parent.appendChild(card);
    };
    return renderInParent;
}
function createCollectionSuggestionCard(collection) {
    // This is temporary - see comment on getSearchSuggestions(). --GAD
    var card = document.createElement("div");
    card.classList.add("prod-card");
    card.innerHTML = '\n    <div class="prod-card__info">\n      <div class="prod-card__info__details">\n        <a href="'.concat(collection.url, '">\n          <h3 class="prod-card__title">\n            ').concat(collection.title, "\n          </h3>\n        </a>\n      </div>\n    </div>\n  ");
    var renderInParent = function(parent) {
        parent.appendChild(card);
    };
    return renderInParent;
}
document.addEventListener("DOMContentLoaded", function() {
    var searchForms = document.querySelectorAll(queries.quickSearchForm);
    searchForms.forEach(function(f) {
        //f.addEventListener('submit', e => e.preventDefault());
        f.addEventListener("focusin", handleSearchFocusIn);
        f.querySelectorAll(queries.quickSearchInput).forEach(function(i) {
            i.addEventListener("input", handleSearchInput);
        });
    });
});

},{"@swc/helpers/src/_async_to_generator.mjs":"7nC9G","@swc/helpers/src/_ts_generator.mjs":"cT4KU","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"39t2b":[function(require,module,exports) {
var ThemeVars = window.ThemeVars;
var FaqFilters = {
    config: {
        filtersList: "faq-filters__list",
        faqAccordionSection: "faq-accordion",
        faqFilterButton: "faq-filters__button",
        faqPageTitle: "faq-main__title"
    },
    init: function init() {
        var filtersList = document.querySelector(".".concat(this.config.filtersList));
        var faqSections = document.querySelectorAll(".".concat(this.config.faqAccordionSection));
        var filterButtons = document.querySelectorAll(".".concat(this.config.faqFilterButton));
        // If any of the elements above does not exist, throw an error and exit the function
        if (!filtersList) return console.error("FaqFilters: Filters list element not found");
        else if (faqSections.length === 0) return console.error("FaqFilters: FAQ sections elements not found");
        else if (filterButtons.length === 0) return console.error("FaqFilters: Filter buttons elements not found");
        // Toggle FAQ sections
        var activeFilter = filtersList.dataset.activeFilterHandle;
        var urlActiveFilter = this.getActiveFilterFromUrl();
        if (urlActiveFilter) activeFilter = urlActiveFilter;
        this.toggleFaqSections(activeFilter, faqSections);
        this.handleButtons(filterButtons);
    },
    /**
   * Returns the filters from the URL as an object.
   * @returns {Object} The filters from the URL.
   */ getActiveFilterFromUrl: function getActiveFilterFromUrl() {
        var urlParams = new URLSearchParams(window.location.search);
        var activeFilter = urlParams.get("filter");
        return activeFilter;
    },
    /**
   * Toggles visibility of FAQ accordion sections depending on the current active filter
   * @param {String} activeFilter - The current active filter
   * @param {NodeList} sections - A nodelist containing all FAQ accordion sections
   */ toggleFaqSections: function toggleFaqSections(activeFilter, sections) {
        for(var i = 0; i < sections.length; i++)if (sections[i].dataset.filterHandle != activeFilter) sections[i].classList.add("hide");
        else sections[i].classList.remove("hide");
    },
    /**
   * Adds event listeners to all filter buttons
   * @param {NodeList} buttons  - A nodelist containing all fitler buttons for handling the click event
   */ handleButtons: function handleButtons(buttons) {
        var _this = this;
        var faqSections = document.querySelectorAll(".".concat(this.config.faqAccordionSection));
        var urlActiveFilter = this.getActiveFilterFromUrl();
        buttons.forEach(function(button) {
            // If the URL has a filter parameter, toggle active state of the buttons
            if (urlActiveFilter) {
                if (button.dataset.filterHandle === urlActiveFilter) button.classList.add("faq-filters__button--active");
                else button.classList.remove("faq-filters__button--active");
            }
            button.addEventListener("click", function(event) {
                var clickedButton = event.currentTarget;
                var activeFilter = clickedButton.dataset.filterHandle;
                // Toggle buttons active state
                clickedButton.classList.add("faq-filters__button--active");
                for(var i = 0; i < buttons.length; i++)if (buttons[i] !== clickedButton) buttons[i].classList.remove("faq-filters__button--active");
                // Change title
                var faqTitle = document.querySelector(".".concat(_this.config.faqPageTitle));
                if (faqTitle) faqTitle.innerText = clickedButton.innerText.trim();
                else console.error("faqFilters: No page title found");
                // Toggle FAQ sections
                _this.toggleFaqSections(activeFilter, faqSections);
                //scroll down
                console.log("scrolling down");
                var faqAccordion = document.querySelector("#FAQAccordion");
                if (!faqAccordion) return;
                var megaMenu = document.querySelector("#shopify-section-mega-menu");
                var scrollDistance = faqAccordion.getBoundingClientRect().top - ((megaMenu === null || megaMenu === void 0 ? void 0 : megaMenu.getBoundingClientRect().bottom) || 0) - 10;
                window.scrollBy({
                    top: scrollDistance,
                    behavior: "smooth"
                });
            });
        });
    }
};
window.FaqFilters = FaqFilters;
if (ThemeVars && ThemeVars.template.suffix === "faq") FaqFilters.init();

},{}],"kQmsa":[function(require,module,exports) {
(function() {
    var getElement = function getElement(key) {
        var multiple = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return document[multiple ? "querySelectorAll" : "querySelector"](".".concat(classes[key]));
    };
    var applyDimensions = function applyDimensions(element, param) {
        var top = param.top, left = param.left, width = param.width, height = param.height;
        element.style.top = top + "px";
        element.style.left = left + "px";
    // element.style.width = width + 'px';
    // element.style.height = height + 'px';
    };
    var handleSwiperReady = function handleSwiperReady() {
        var thumbsSwiper = new Swiper(".".concat(classes.thumbsSwiper), {
            spaceBetween: 5,
            slidesPerView: 4,
            breakpoints: {
                768: {
                    slidesPerView: 4,
                    spaceBetween: 10
                }
            }
        });
        var pdpSwiper = new Swiper(".".concat(classes.slideshowSwiper), {
            spaceBetween: 5,
            slidesPerView: 1,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 10
                }
            },
            navigation: {
                nextEl: ".".concat(classes.slideshowSwiperNext),
                prevEl: ".".concat(classes.slideshowSwiperPrev)
            },
            thumbs: {
                swiper: thumbsSwiper
            }
        });
        var slideshow = getElement("slideshow");
        if (!slideshow) return;
        function getModalTargetDimensions() {
            var tmpTarget = document.createElement("div");
            tmpTarget.style.opacity = 0;
            tmpTarget.style.pointerEvents = "none";
            tmpTarget.classList.add(classes.slideshowModalZoomed);
            document.body.append(tmpTarget);
            var targetDimensions = tmpTarget.getBoundingClientRect();
            tmpTarget.remove();
            return targetDimensions;
        }
        function handleImageMouseLeave(e) {
            e.currentTarget.children[0].style.transform = "";
        }
        function getTargetSlideWidth(slideElement) {
            var parentDimensions = visualViewport;
            var slideDimensions = slideElement.getBoundingClientRect();
            var aspectRatio = slideDimensions.width / slideDimensions.height;
            var targetWidth = aspectRatio * parentDimensions.height;
            return targetWidth;
        }
        var zoomActive = false;
        function handleZoomSlideshow(e) {
            if (zoomActive) return;
            zoomActive = true;
            if (zoomActive) e.stopPropagation();
            document.body.style.overflow = "hidden";
            var previousSlidesPerView = pdpSwiper.params.slidesPerView;
            pdpSwiper.params.slidesPerView = 1;
            pdpSwiper.update();
            getElement("placeholder", true).forEach(function(p) {
                return p.remove();
            });
            var modal = getElement("slideshowModal");
            var originalDimensions = modal.getBoundingClientRect();
            var targetDimensions = getModalTargetDimensions();
            var placeholder = document.createElement("div");
            placeholder.classList.add(classes.placeholder);
            applyDimensions(placeholder, originalDimensions);
            modal.after(placeholder);
            applyDimensions(modal, originalDimensions);
            modal.classList.add(classes.slideshowModalZoomed);
            var closeButton = document.createElement("button");
            closeButton.innerHTML = '\n      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">\n        <circle cx="17" cy="17" r="17" fill="white" fill-opacity="0.7"/>\n        <line x1="0.75" y1="-0.75" x2="22.9448" y2="-0.75" transform="matrix(0.708581 0.705629 -0.708581 0.705629 8.20996 9.09497)" stroke="black" stroke-width="1.5" stroke-linecap="round"/>\n        <line x1="0.75" y1="-0.75" x2="22.9448" y2="-0.75" transform="matrix(-0.708581 0.705629 -0.708581 -0.705629 25 8.1853)" stroke="black" stroke-width="1.5" stroke-linecap="round"/>\n      </svg>\n      ';
            closeButton.classList.add(classes.closeButton);
            document.querySelector(".product__slideshow__modal").appendChild(closeButton);
            var activeSlide = pdpSwiper.slides[pdpSwiper.activeIndex];
            var targetWidth = getTargetSlideWidth(activeSlide);
            setTimeout(function() {
                applyDimensions(modal, targetDimensions);
            // modal.children[0].style.width = targetWidth + 'px';
            });
            var imageWrappers = getElement("imageWrapper", true);
            imageWrappers.forEach(function(w) {
                w.addEventListener("mouseleave", handleImageMouseLeave);
                w.addEventListener("mousemove", handleImageMouseMove);
            });
            function handleImageMouseMove(e) {
                var clientX = e.clientX, clientY = e.clientY;
                var _e_currentTarget_getBoundingClientRect = e.currentTarget.getBoundingClientRect(), imageX = _e_currentTarget_getBoundingClientRect.x, imageY = _e_currentTarget_getBoundingClientRect.y;
                var xPos = clientX - imageX;
                var yPos = clientY - imageY;
                var img = e.currentTarget.children[0];
                img.style.transformOrigin = "".concat(xPos, "px ").concat(yPos, "px");
                img.style.transform = "scale(3)";
            }
            function handleClose(e) {
                if (e.target !== e.currentTarget) return;
                e.stopPropagation();
                modal.style = "";
                modal.classList.remove(classes.slideshowModalZoomed);
                pdpSwiper.params.slidesPerView = previousSlidesPerView;
                pdpSwiper.update();
                closeButton.remove();
                imageWrappers.forEach(function(w) {
                    w.removeEventListener("mouseleave", handleImageMouseLeave);
                    w.removeEventListener("mousemove", handleImageMouseMove);
                });
                placeholder.remove();
                document.body.style.overflow = null;
                zoomActive = false;
            }
            modal.addEventListener("click", handleClose);
            closeButton.addEventListener("click", handleClose);
        }
        getElement("activateZoom", true).forEach(function(el) {
            return el.addEventListener("click", handleZoomSlideshow);
        });
        var slideShowLoader = document.querySelector(".product__slideshow__loader");
        var slideShowModalContainer = document.querySelector(".product__slideshow__modal-container");
        if (slideShowLoader) slideShowLoader.style.display = "none";
        if (slideShowModalContainer) slideShowModalContainer.style.display = "block";
    };
    if (window.storePage !== "pdp") return;
    var classes = {
        activateZoom: "product__slideshow__slide",
        closeButton: "product__slideshow__close",
        imageWrapper: "product__slideshow__slide",
        placeholder: "product__slideshow__placeholder",
        slideshow: "product__slideshow__wrapper",
        slideshowModal: "product__slideshow__modal-container",
        slideshowModalZoomed: "product__slideshow__modal-container--zoomed",
        slideshowSwiper: "product__slideshow",
        slideshowSwiperNext: "product__slideshow__navigation__button--next",
        slideshowSwiperPrev: "product__slideshow__navigation__button--prev",
        thumbsSwiper: "product__thumbnails__slideshow",
        slideshowModalInner: "product__slideshow__modal"
    };
    document.addEventListener("swiperReady", function() {
        setTimeout(handleSwiperReady, 100);
    });
})();

},{}],"159X2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _asyncToGeneratorMjs = require("@swc/helpers/src/_async_to_generator.mjs");
var _asyncToGeneratorMjsDefault = parcelHelpers.interopDefault(_asyncToGeneratorMjs);
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _tsGeneratorMjs = require("@swc/helpers/src/_ts_generator.mjs");
var _tsGeneratorMjsDefault = parcelHelpers.interopDefault(_tsGeneratorMjs);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactToWebComponent = require("@r2wc/react-to-web-component");
var _reactToWebComponentDefault = parcelHelpers.interopDefault(_reactToWebComponent);
// Core modules imports are same as usual
var _swiper = require("swiper");
// Direct React component imports
var _swiperReactJs = require("swiper/react/swiper-react.js");
// Styles must use direct files imports
var _swiperScss = require("swiper/swiper.scss"); // core Swiper
var _navigationScss = require("swiper/modules/navigation/navigation.scss"); // Navigation module
var _paginationScss = require("swiper/modules/pagination/pagination.scss"); // Pagination module
var _shopboxProductCard = require("./ShopboxProductCard");
var _shopboxProductCardDefault = parcelHelpers.interopDefault(_shopboxProductCard);
var ShopboxComponent = function(props) {
    var clientUUID = props.uuid;
    var sku = props.sku;
    var type = props.type;
    var sectionID = props.sectionid;
    var sectiontype = props.sectiontype;
    var category = props.collectioncategory;
    var mini = props.mini;
    var _useState = (0, _slicedToArrayMjsDefault.default)((0, _react.useState)([]), 2), products = _useState[0], setProducts = _useState[1];
    (0, _react.useEffect)(function() {
        var id;
        if (type === "find-similar") id = sku;
        else if (type === "collection-dynamic") id = clientUUID;
        else id = clientUUID;
        var addProductsToState = function() {
            var _ref = (0, _asyncToGeneratorMjsDefault.default)(function() {
                var products;
                return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getProducts(type, id, category, sku)
                            ];
                        case 1:
                            products = _state.sent();
                            setProducts(products);
                            return [
                                2
                            ];
                    }
                });
            });
            return function addProductsToState() {
                return _ref.apply(this, arguments);
            };
        }();
        addProductsToState();
    }, []);
    var paginationIDclass = "product-slider__pagination product-slider__pagination-".concat(sectionID);
    var navigationNextIDclass = "product-slider__swiper-button-next product-slider__swiper-button-next-".concat(sectionID, " sb-next");
    var navigationPrevIDclass = "product-slider__swiper-button-prev product-slider__swiper-button-prev-".concat(sectionID);
    var slidesPerViewValues = {};
    var spaceBetweenValues = {};
    /* 
        Equivalent mini layout can be found in product-slider.liquid, derived from product-slider-mini.liquid 
        Could be an improvement to bind them to the same values defined somewhere 
    */ if (sectiontype == "minicart") {
        slidesPerViewValues = {
            "base": 3.75,
            "498": 3.75,
            "768": 3.75,
            "1068": 3.75,
            "1268": 3.75
        };
        spaceBetweenValues = {
            "base": 10,
            "498": 10,
            "768": 10,
            "1068": 10,
            "1268": 10
        };
    } else if (mini === "true") {
        slidesPerViewValues = {
            "base": 3,
            "498": 6,
            "768": 6,
            "1068": 8,
            "1268": 8
        };
        spaceBetweenValues = {
            "base": 7,
            "498": 10,
            "768": 10,
            "1068": 10,
            "1268": 10
        };
    } else {
        slidesPerViewValues = {
            "base": 2.2,
            "498": 2.2,
            "768": 2.8,
            "1068": 3.8,
            "1268": 4
        };
        spaceBetweenValues = {
            "base": 10,
            "498": 10,
            "768": 20,
            "1068": 20,
            "1268": 20
        };
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "product-slider",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: paginationIDclass
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: navigationPrevIDclass,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    width: "32",
                    height: "32",
                    viewBox: "0 0 32 32",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: "32",
                            height: "32",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M7.64645 15.6464C7.45119 15.8417 7.45119 16.1583 7.64645 16.3536L10.8284 19.5355C11.0237 19.7308 11.3403 19.7308 11.5355 19.5355C11.7308 19.3403 11.7308 19.0237 11.5355 18.8284L8.70711 16L11.5355 13.1716C11.7308 12.9763 11.7308 12.6597 11.5355 12.4645C11.3403 12.2692 11.0237 12.2692 10.8284 12.4645L7.64645 15.6464ZM24 15.5L8 15.5L8 16.5L24 16.5L24 15.5Z",
                            fill: "black"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: navigationNextIDclass,
                "data-sb-collection": type,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    width: "32",
                    height: "32",
                    viewBox: "0 0 32 32",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: "32",
                            height: "32",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M24.3536 16.3536C24.5488 16.1583 24.5488 15.8417 24.3536 15.6464L21.1716 12.4645C20.9763 12.2692 20.6597 12.2692 20.4645 12.4645C20.2692 12.6597 20.2692 12.9763 20.4645 13.1716L23.2929 16L20.4645 18.8284C20.2692 19.0237 20.2692 19.3403 20.4645 19.5355C20.6597 19.7308 20.9763 19.7308 21.1716 19.5355L24.3536 16.3536ZM8 16.5L24 16.5L24 15.5L8 15.5L8 16.5Z",
                            fill: "black"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _swiperReactJs.Swiper), {
                modules: [
                    (0, _swiper.Pagination),
                    (0, _swiper.Navigation)
                ],
                spaceBetween: spaceBetweenValues["base"],
                slidesOffsetAfter: 30,
                slidesPerView: slidesPerViewValues["base"],
                pagination: {
                    clickable: true,
                    el: ".product-slider__pagination-".concat(sectionID)
                },
                navigation: {
                    nextEl: ".product-slider__swiper-button-next-".concat(sectionID),
                    prevEl: ".product-slider__swiper-button-prev-".concat(sectionID)
                },
                breakpoints: {
                    498: {
                        slidesPerView: slidesPerViewValues["498"],
                        spaceBetween: spaceBetweenValues["498"]
                    },
                    768: {
                        slidesPerView: slidesPerViewValues["768"],
                        spaceBetween: spaceBetweenValues["768"]
                    },
                    1068: {
                        slidesPerView: slidesPerViewValues["1068"],
                        spaceBetween: spaceBetweenValues["1068"]
                    },
                    1268: {
                        slidesPerView: slidesPerViewValues["1268"],
                        spaceBetween: spaceBetweenValues["1268"]
                    }
                },
                children: products.map(function(product) {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _swiperReactJs.SwiperSlide), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shopboxProductCardDefault.default), {
                            product: product,
                            style: sectiontype
                        })
                    });
                })
            })
        ]
    });
};
var getProducts = function() {
    var _ref = (0, _asyncToGeneratorMjsDefault.default)(function(type, id, category, sku) {
        var url, shopboxResponse, response, productTitles, productUrls, queryString, shopifyResponse, shopifyResponseJson, convertShopifyProductToApiProduct, shopifyProducts, CORRECT_ORDER, UNSORTED, sorted;
        return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = type === "recommendations" ? "https://api.shopbox.ai/api/v1/recommendations?uuid=".concat(id) : type === "new-for-you" ? "https://api.shopbox.ai/api/v1/new_for_you?uuid=".concat(id) : type === "top-viewed" ? "https://api.shopbox.ai/api/v1/top_viewed" : type === "frequently_bought_together" ? "https://api.shopbox.ai/api/v1/frequently_bought_together?uuid=".concat(id, "&sku=").concat(sku.replace(/-/g, "")) : type === "collection-dynamic" ? "https://api.shopbox.ai/api/v1/dynamic/recommendations?uuid=".concat(id, "&currency=EUR&page=1&num_products=15&category=").concat(category) // num_products must be less than 20
                     : "https://api.shopbox.ai/api/v1/find_similar?sku=".concat(id.replace(/-/g, ""));
                    return [
                        4,
                        fetch(url, {
                            headers: {
                                "Content-Type": "application/json",
                                "SB-TOKEN": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MDA4MjAzMzIsImNsaWVudF9pZCI6InRxbWZGbEtQSzk3VEJHQldSQ3p0Iiwic3ViIjoiNDg3OTM4YzRjMWMyNDhhMDlkMTlkM2NkYzQyMzk2NjAiLCJ1c2VyX2lkIjoiNDUxNjIzNWQ2YWU4NGJlYjk4NDhlYzI3OTdiNTYxYzciLCJ3ZWJzaXRlIjoiIiwiYXBpIjp0cnVlLCJuYW1lIjoiVVdQIn0.LW0RyzhlDSXooSJ8-oafALN-PvvgSO_tLz_JX3B3Eic"
                            }
                        })
                    ];
                case 1:
                    shopboxResponse = _state.sent();
                    return [
                        4,
                        shopboxResponse.json()
                    ];
                case 2:
                    response = _state.sent();
                    productTitles = response.products.map(function(product) {
                        return product.name;
                    });
                    productUrls = response.products.reduce(function(accumulator, product) {
                        if (product.name && product.url) accumulator[product.name] = product.url; // Assuming 'name' should be used instead of 'title'
                        else console.warn("Product with undefined name or URL:", product);
                        return accumulator;
                    }, {});
                    queryString = productTitles.map(function(title) {
                        return "title:'".concat(title, "'");
                    }).join(" OR ");
                    return [
                        4,
                        fetch("https://www.carraigdonn.com/api/2023-10/graphql.json", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Shopify-Storefront-Access-Token": "68351e5b567ac6aff374648aa19a0e22"
                            },
                            body: JSON.stringify({
                                query: '\n                query {\n                    products(first: 50, query: "'.concat(queryString, '") {\n                        nodes {\n                            handle\n                            id\n                            title\n                            tags\n                            vendor\n                            images(first: 2) {\n                                nodes {\n                                altText\n                                height\n                                id\n                                url\n                                width\n                                }\n                            }\n                            variants(first: 250) {\n                                nodes {\n                                id\n                                }\n                            }\n                            compareAtPriceRange {\n                                maxVariantPrice {\n                                amount\n                                }\n                                minVariantPrice {\n                                amount\n                                }\n                            }\n                            priceRange {\n                                maxVariantPrice {\n                                amount\n                                }\n                                minVariantPrice {\n                                amount\n                                }\n                            }\n                        }\n                    }\n                }\n                ')
                            })
                        })
                    ];
                case 3:
                    shopifyResponse = _state.sent();
                    return [
                        4,
                        shopifyResponse.json()
                    ];
                case 4:
                    shopifyResponseJson = _state.sent();
                    convertShopifyProductToApiProduct = function(shopifyProduct) {
                        var apiProduct = {
                            compare_at_price: shopifyProduct.compareAtPriceRange.maxVariantPrice.amount,
                            handle: shopifyProduct.handle,
                            url: productUrls[shopifyProduct.title],
                            id: shopifyProduct.id.split("/").pop(),
                            images: shopifyProduct.images.nodes.map(function(image) {
                                return {
                                    alt: image.altText,
                                    height: image.height,
                                    src: image.url,
                                    width: image.width
                                };
                            }),
                            price: shopifyProduct.priceRange.maxVariantPrice.amount,
                            tags: shopifyProduct.tags,
                            title: shopifyProduct.title,
                            variants: shopifyProduct.variants.nodes.map(function(variant) {
                                return {
                                    id: variant.id.split("/").pop(),
                                    inventory_quantity: variant.quantityAvailable
                                };
                            }),
                            vendor: shopifyProduct.vendor
                        };
                        return apiProduct;
                    };
                    shopifyProducts = shopifyResponseJson.data.products.nodes.map(function(shopifyProduct) {
                        return convertShopifyProductToApiProduct(shopifyProduct);
                    });
                    CORRECT_ORDER = productTitles;
                    UNSORTED = shopifyProducts;
                    sorted = [];
                    CORRECT_ORDER.forEach(function(k) {
                        var n = UNSORTED.filter(function(obj) {
                            return obj.title === k;
                        });
                        if (n.length > 0) sorted.push(n[0]);
                    });
                    // return shopifyProducts
                    return [
                        2,
                        sorted
                    ];
            }
        });
    });
    return function getProducts(type, id, category, sku) {
        return _ref.apply(this, arguments);
    };
}();
var ShopboxWebComponent = (0, _reactToWebComponentDefault.default)(ShopboxComponent, {
    props: {
        type: "string",
        uuid: "string",
        sku: "string",
        sectionid: "string",
        sectiontype: "string",
        collectioncategory: "string",
        mini: "string"
    }
});
customElements.define("shopbox-component", ShopboxWebComponent);

},{"@swc/helpers/src/_async_to_generator.mjs":"7nC9G","@swc/helpers/src/_sliced_to_array.mjs":"l34hS","@swc/helpers/src/_ts_generator.mjs":"cT4KU","react/jsx-runtime":"ebSqZ","react":"ihebA","@r2wc/react-to-web-component":"2FQZG","swiper":"dBrcy","swiper/react/swiper-react.js":"fG4vm","swiper/swiper.scss":"6DLi3","swiper/modules/navigation/navigation.scss":"2hxeU","swiper/modules/pagination/pagination.scss":"1r6I2","./ShopboxProductCard":"4lAzf","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"2FQZG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return s;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _core = require("@r2wc/core");
var _coreDefault = parcelHelpers.interopDefault(_core);
function f(t, e, r) {
    var n = (0, _client.createRoot)(t), u = (0, _reactDefault.default).createElement(e, r);
    return n.render(u), {
        root: n,
        ReactComponent: e
    };
}
function i(param, r) {
    var t = param.root, e = param.ReactComponent;
    var n = (0, _reactDefault.default).createElement(e, r);
    t.render(n);
}
function a(param) {
    var t = param.root;
    t.unmount();
}
function s(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0, _coreDefault.default)(t, e, {
        mount: f,
        update: i,
        unmount: a
    });
}

},{"react":"ihebA","react-dom/client":"jV3kN","@r2wc/core":"Sj097","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"jV3kN":[function(require,module,exports) {
var _require = require("ae841eec956456dd"), render = _require.render, hydrate = _require.hydrate, unmountComponentAtNode = _require.unmountComponentAtNode;
function createRoot(container) {
    return {
        render: function(children) {
            render(children, container);
        },
        unmount: function() {
            unmountComponentAtNode(container);
        }
    };
}
exports.createRoot = createRoot;
exports.hydrateRoot = function(container, children) {
    hydrate(children, container);
    return createRoot(container);
};

},{"ae841eec956456dd":"ihebA"}],"Sj097":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return z;
});
var _assertThisInitializedMjs = require("@swc/helpers/src/_assert_this_initialized.mjs");
var _assertThisInitializedMjsDefault = parcelHelpers.interopDefault(_assertThisInitializedMjs);
var _classCallCheckMjs = require("@swc/helpers/src/_class_call_check.mjs");
var _classCallCheckMjsDefault = parcelHelpers.interopDefault(_classCallCheckMjs);
var _createClassMjs = require("@swc/helpers/src/_create_class.mjs");
var _createClassMjsDefault = parcelHelpers.interopDefault(_createClassMjs);
var _inheritsMjs = require("@swc/helpers/src/_inherits.mjs");
var _inheritsMjsDefault = parcelHelpers.interopDefault(_inheritsMjs);
var _typeOfMjs = require("@swc/helpers/src/_type_of.mjs");
var _typeOfMjsDefault = parcelHelpers.interopDefault(_typeOfMjs);
var _wrapNativeSuperMjs = require("@swc/helpers/src/_wrap_native_super.mjs");
var _wrapNativeSuperMjsDefault = parcelHelpers.interopDefault(_wrapNativeSuperMjs);
var _createSuperMjs = require("@swc/helpers/src/_create_super.mjs");
var _createSuperMjsDefault = parcelHelpers.interopDefault(_createSuperMjs);
var global = arguments[3];
var j = Object.defineProperty;
var x = function(t, e, r) {
    return e in t ? j(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : t[e] = r;
};
var b = function(t, e, r) {
    return x(t, (typeof e === "undefined" ? "undefined" : (0, _typeOfMjsDefault.default)(e)) != "symbol" ? e + "" : e, r), r;
};
var C = {
    stringify: function(t) {
        return t;
    },
    parse: function(t) {
        return t;
    }
}, T = {
    stringify: function(t) {
        return "".concat(t);
    },
    parse: function(t) {
        return parseFloat(t);
    }
}, V = {
    stringify: function(t) {
        return t ? "true" : "false";
    },
    parse: function(t) {
        return /^[ty1-9]/i.test(t);
    }
}, N = {
    stringify: function(t) {
        return t.name;
    },
    parse: function(t, e) {
        var r = function() {
            if ((typeof window === "undefined" ? "undefined" : (0, _typeOfMjsDefault.default)(window)) < "u" && t in window) return window[t];
            if ((typeof global === "undefined" ? "undefined" : (0, _typeOfMjsDefault.default)(global)) < "u" && t in global) return global[t];
        }();
        return typeof r == "function" ? r.bind(e) : void 0;
    }
}, P = {
    stringify: function(t) {
        return JSON.stringify(t);
    },
    parse: function(t) {
        return JSON.parse(t);
    }
}, w = {
    string: C,
    number: T,
    boolean: V,
    function: N,
    json: P
}, A = Symbol.for("r2wc.render"), h = Symbol.for("r2wc.connected"), p = Symbol.for("r2wc.context"), i = Symbol.for("r2wc.props");
function z(t, e, r) {
    var $, k, O;
    e.props || (e.props = t.propTypes ? Object.keys(t.propTypes) : []);
    var d = (Array.isArray(e.props) ? e.props.slice() : Object.keys(e.props)).filter(function(s) {
        return s !== "container";
    }), f = {}, g = {}, m = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = d[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var s = _step.value;
            f[s] = Array.isArray(e.props) ? "string" : e.props[s];
            var u = J(s);
            g[s] = u, m[u] = s;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var S = /*#__PURE__*/ function(HTMLElement1) {
        "use strict";
        (0, _inheritsMjsDefault.default)(S, HTMLElement1);
        var _super = (0, _createSuperMjsDefault.default)(S);
        function S() {
            (0, _classCallCheckMjsDefault.default)(this, S);
            var _this;
            _this = _super.call(this);
            b((0, _assertThisInitializedMjsDefault.default)(_this), $, !0);
            b((0, _assertThisInitializedMjsDefault.default)(_this), k);
            b((0, _assertThisInitializedMjsDefault.default)(_this), O, {});
            b((0, _assertThisInitializedMjsDefault.default)(_this), "container");
            e.shadow ? _this.container = _this.attachShadow({
                mode: e.shadow
            }) : _this.container = (0, _assertThisInitializedMjsDefault.default)(_this), _this[i].container = _this.container;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = d[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var c = _step.value;
                    var l = g[c], n = _this.getAttribute(l), o = f[c], a = w[o];
                    n && a != null && a.parse && (_this[i][c] = a.parse(n, (0, _assertThisInitializedMjsDefault.default)(_this)));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return _this;
        }
        (0, _createClassMjsDefault.default)(S, [
            {
                key: "connectedCallback",
                value: function connectedCallback() {
                    this[h] = !0, this[A]();
                }
            },
            {
                key: "disconnectedCallback",
                value: function disconnectedCallback() {
                    this[h] = !1, this[p] && r.unmount(this[p]), delete this[p];
                }
            },
            {
                key: "attributeChangedCallback",
                value: function attributeChangedCallback(c, l, n) {
                    var o = m[c], a = f[o], y = w[a];
                    o in f && y != null && y.parse && (this[i][o] = y.parse(n, this), this[A]());
                }
            },
            {
                key: ($ = h, k = p, O = i, A),
                value: function value() {
                    this[h] && (this[p] ? r.update(this[p], this[i]) : this[p] = r.mount(this.container, t, this[i]));
                }
            }
        ], [
            {
                key: "observedAttributes",
                get: function get() {
                    return Object.keys(m);
                }
            }
        ]);
        return S;
    }((0, _wrapNativeSuperMjsDefault.default)(HTMLElement));
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        var _loop = function() {
            var s = _step1.value;
            var u = g[s], c = f[s];
            Object.defineProperty(S.prototype, s, {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return this[i][s];
                },
                set: function(l) {
                    this[i][s] = l;
                    var n = w[c];
                    if (n != null && n.stringify) {
                        var o = n.stringify(l);
                        this.getAttribute(u) !== o && this.setAttribute(u, o);
                    }
                }
            });
        };
        for(var _iterator1 = d[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop();
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return S;
}
function J() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}

},{"@swc/helpers/src/_assert_this_initialized.mjs":"h3RcV","@swc/helpers/src/_class_call_check.mjs":"eguiP","@swc/helpers/src/_create_class.mjs":"14PLJ","@swc/helpers/src/_inherits.mjs":"4jtFW","@swc/helpers/src/_type_of.mjs":"52Yae","@swc/helpers/src/_wrap_native_super.mjs":"jyob2","@swc/helpers/src/_create_super.mjs":"iIIkg","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"h3RcV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
exports.default = _assertThisInitialized;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"4jtFW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setPrototypeOfMjs = require("./_set_prototype_of.mjs");
var _setPrototypeOfMjsDefault = parcelHelpers.interopDefault(_setPrototypeOfMjs);
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, _setPrototypeOfMjsDefault.default)(subClass, superClass);
}
exports.default = _inherits;

},{"./_set_prototype_of.mjs":"bWhKH","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"bWhKH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function setPrototypeOf(o, p) {
    setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return setPrototypeOf(o, p);
}
function _setPrototypeOf(o, p) {
    return setPrototypeOf(o, p);
}
exports.default = _setPrototypeOf;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"jyob2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constructMjs = require("./_construct.mjs");
var _constructMjsDefault = parcelHelpers.interopDefault(_constructMjs);
var _isNativeFunctionMjs = require("./_is_native_function.mjs");
var _isNativeFunctionMjsDefault = parcelHelpers.interopDefault(_isNativeFunctionMjs);
var _getPrototypeOfMjs = require("./_get_prototype_of.mjs");
var _getPrototypeOfMjsDefault = parcelHelpers.interopDefault(_getPrototypeOfMjs);
var _setPrototypeOfMjs = require("./_set_prototype_of.mjs");
var _setPrototypeOfMjsDefault = parcelHelpers.interopDefault(_setPrototypeOfMjs);
function wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    wrapNativeSuper = function wrapNativeSuper(Class) {
        if (Class === null || !(0, _isNativeFunctionMjsDefault.default)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, _constructMjsDefault.default)(Class, arguments, (0, _getPrototypeOfMjsDefault.default)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, _setPrototypeOfMjsDefault.default)(Wrapper, Class);
    };
    return wrapNativeSuper(Class);
}
function _wrapNativeSuper(Class) {
    return wrapNativeSuper(Class);
}
exports.default = _wrapNativeSuper;

},{"./_construct.mjs":"fdEdy","./_is_native_function.mjs":"bxcFp","./_get_prototype_of.mjs":"jb1cg","./_set_prototype_of.mjs":"bWhKH","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"fdEdy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setPrototypeOfMjs = require("./_set_prototype_of.mjs");
var _setPrototypeOfMjsDefault = parcelHelpers.interopDefault(_setPrototypeOfMjs);
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function construct(Parent, args, Class) {
    if (isNativeReflectConstruct()) construct = Reflect.construct;
    else construct = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, _setPrototypeOfMjsDefault.default)(instance, Class.prototype);
        return instance;
    };
    return construct.apply(null, arguments);
}
function _construct(Parent, args, Class) {
    return construct.apply(null, arguments);
}
exports.default = _construct;

},{"./_set_prototype_of.mjs":"bWhKH","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"bxcFp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
exports.default = _isNativeFunction;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"jb1cg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function getPrototypeOf(o) {
    getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return getPrototypeOf(o);
}
function _getPrototypeOf(o) {
    return getPrototypeOf(o);
}
exports.default = _getPrototypeOf;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"iIIkg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isNativeReflectConstructMjs = require("./_is_native_reflect_construct.mjs");
var _isNativeReflectConstructMjsDefault = parcelHelpers.interopDefault(_isNativeReflectConstructMjs);
var _getPrototypeOfMjs = require("./_get_prototype_of.mjs");
var _getPrototypeOfMjsDefault = parcelHelpers.interopDefault(_getPrototypeOfMjs);
var _possibleConstructorReturnMjs = require("./_possible_constructor_return.mjs");
var _possibleConstructorReturnMjsDefault = parcelHelpers.interopDefault(_possibleConstructorReturnMjs);
function _createSuper(Derived) {
    var hasNativeReflectConstruct = (0, _isNativeReflectConstructMjsDefault.default)();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOfMjsDefault.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOfMjsDefault.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturnMjsDefault.default)(this, result);
    };
}
exports.default = _createSuper;

},{"./_is_native_reflect_construct.mjs":"g7qyl","./_get_prototype_of.mjs":"jb1cg","./_possible_constructor_return.mjs":"j4S0Z","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"g7qyl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
exports.default = _isNativeReflectConstruct;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"j4S0Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assertThisInitializedMjs = require("./_assert_this_initialized.mjs");
var _assertThisInitializedMjsDefault = parcelHelpers.interopDefault(_assertThisInitializedMjs);
var _typeOfMjs = require("./_type_of.mjs");
var _typeOfMjsDefault = parcelHelpers.interopDefault(_typeOfMjs);
function _possibleConstructorReturn(self, call) {
    if (call && ((0, _typeOfMjsDefault.default)(call) === "object" || typeof call === "function")) return call;
    return (0, _assertThisInitializedMjsDefault.default)(self);
}
exports.default = _possibleConstructorReturn;

},{"./_assert_this_initialized.mjs":"h3RcV","./_type_of.mjs":"52Yae","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"dBrcy":[function(require,module,exports) {
/**
 * Swiper 7.4.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: December 24, 2021
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Swiper", function() {
    return 0, _coreJsDefault.default;
});
parcelHelpers.export(exports, "default", function() {
    return 0, _coreJsDefault.default;
});
parcelHelpers.export(exports, "Virtual", function() {
    return 0, _virtualJsDefault.default;
});
parcelHelpers.export(exports, "Keyboard", function() {
    return 0, _keyboardJsDefault.default;
});
parcelHelpers.export(exports, "Mousewheel", function() {
    return 0, _mousewheelJsDefault.default;
});
parcelHelpers.export(exports, "Navigation", function() {
    return 0, _navigationJsDefault.default;
});
parcelHelpers.export(exports, "Pagination", function() {
    return 0, _paginationJsDefault.default;
});
parcelHelpers.export(exports, "Scrollbar", function() {
    return 0, _scrollbarJsDefault.default;
});
parcelHelpers.export(exports, "Parallax", function() {
    return 0, _parallaxJsDefault.default;
});
parcelHelpers.export(exports, "Zoom", function() {
    return 0, _zoomJsDefault.default;
});
parcelHelpers.export(exports, "Lazy", function() {
    return 0, _lazyJsDefault.default;
});
parcelHelpers.export(exports, "Controller", function() {
    return 0, _controllerJsDefault.default;
});
parcelHelpers.export(exports, "A11y", function() {
    return 0, _a11YJsDefault.default;
});
parcelHelpers.export(exports, "History", function() {
    return 0, _historyJsDefault.default;
});
parcelHelpers.export(exports, "HashNavigation", function() {
    return 0, _hashNavigationJsDefault.default;
});
parcelHelpers.export(exports, "Autoplay", function() {
    return 0, _autoplayJsDefault.default;
});
parcelHelpers.export(exports, "Thumbs", function() {
    return 0, _thumbsJsDefault.default;
});
parcelHelpers.export(exports, "FreeMode", function() {
    return 0, _freeModeJsDefault.default;
});
parcelHelpers.export(exports, "Grid", function() {
    return 0, _gridJsDefault.default;
});
parcelHelpers.export(exports, "Manipulation", function() {
    return 0, _manipulationJsDefault.default;
});
parcelHelpers.export(exports, "EffectFade", function() {
    return 0, _effectFadeJsDefault.default;
});
parcelHelpers.export(exports, "EffectCube", function() {
    return 0, _effectCubeJsDefault.default;
});
parcelHelpers.export(exports, "EffectFlip", function() {
    return 0, _effectFlipJsDefault.default;
});
parcelHelpers.export(exports, "EffectCoverflow", function() {
    return 0, _effectCoverflowJsDefault.default;
});
parcelHelpers.export(exports, "EffectCreative", function() {
    return 0, _effectCreativeJsDefault.default;
});
parcelHelpers.export(exports, "EffectCards", function() {
    return 0, _effectCardsJsDefault.default;
});
var _coreJs = require("./core/core.js");
var _coreJsDefault = parcelHelpers.interopDefault(_coreJs);
var _virtualJs = require("./modules/virtual/virtual.js");
var _virtualJsDefault = parcelHelpers.interopDefault(_virtualJs);
var _keyboardJs = require("./modules/keyboard/keyboard.js");
var _keyboardJsDefault = parcelHelpers.interopDefault(_keyboardJs);
var _mousewheelJs = require("./modules/mousewheel/mousewheel.js");
var _mousewheelJsDefault = parcelHelpers.interopDefault(_mousewheelJs);
var _navigationJs = require("./modules/navigation/navigation.js");
var _navigationJsDefault = parcelHelpers.interopDefault(_navigationJs);
var _paginationJs = require("./modules/pagination/pagination.js");
var _paginationJsDefault = parcelHelpers.interopDefault(_paginationJs);
var _scrollbarJs = require("./modules/scrollbar/scrollbar.js");
var _scrollbarJsDefault = parcelHelpers.interopDefault(_scrollbarJs);
var _parallaxJs = require("./modules/parallax/parallax.js");
var _parallaxJsDefault = parcelHelpers.interopDefault(_parallaxJs);
var _zoomJs = require("./modules/zoom/zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _lazyJs = require("./modules/lazy/lazy.js");
var _lazyJsDefault = parcelHelpers.interopDefault(_lazyJs);
var _controllerJs = require("./modules/controller/controller.js");
var _controllerJsDefault = parcelHelpers.interopDefault(_controllerJs);
var _a11YJs = require("./modules/a11y/a11y.js");
var _a11YJsDefault = parcelHelpers.interopDefault(_a11YJs);
var _historyJs = require("./modules/history/history.js");
var _historyJsDefault = parcelHelpers.interopDefault(_historyJs);
var _hashNavigationJs = require("./modules/hash-navigation/hash-navigation.js");
var _hashNavigationJsDefault = parcelHelpers.interopDefault(_hashNavigationJs);
var _autoplayJs = require("./modules/autoplay/autoplay.js");
var _autoplayJsDefault = parcelHelpers.interopDefault(_autoplayJs);
var _thumbsJs = require("./modules/thumbs/thumbs.js");
var _thumbsJsDefault = parcelHelpers.interopDefault(_thumbsJs);
var _freeModeJs = require("./modules/free-mode/free-mode.js");
var _freeModeJsDefault = parcelHelpers.interopDefault(_freeModeJs);
var _gridJs = require("./modules/grid/grid.js");
var _gridJsDefault = parcelHelpers.interopDefault(_gridJs);
var _manipulationJs = require("./modules/manipulation/manipulation.js");
var _manipulationJsDefault = parcelHelpers.interopDefault(_manipulationJs);
var _effectFadeJs = require("./modules/effect-fade/effect-fade.js");
var _effectFadeJsDefault = parcelHelpers.interopDefault(_effectFadeJs);
var _effectCubeJs = require("./modules/effect-cube/effect-cube.js");
var _effectCubeJsDefault = parcelHelpers.interopDefault(_effectCubeJs);
var _effectFlipJs = require("./modules/effect-flip/effect-flip.js");
var _effectFlipJsDefault = parcelHelpers.interopDefault(_effectFlipJs);
var _effectCoverflowJs = require("./modules/effect-coverflow/effect-coverflow.js");
var _effectCoverflowJsDefault = parcelHelpers.interopDefault(_effectCoverflowJs);
var _effectCreativeJs = require("./modules/effect-creative/effect-creative.js");
var _effectCreativeJsDefault = parcelHelpers.interopDefault(_effectCreativeJs);
var _effectCardsJs = require("./modules/effect-cards/effect-cards.js");
var _effectCardsJsDefault = parcelHelpers.interopDefault(_effectCardsJs);

},{"./core/core.js":"gAoUK","./modules/virtual/virtual.js":"crsUO","./modules/keyboard/keyboard.js":"eW7Wz","./modules/mousewheel/mousewheel.js":"4PUWs","./modules/navigation/navigation.js":"kNEql","./modules/pagination/pagination.js":"iiV9C","./modules/scrollbar/scrollbar.js":"19mvo","./modules/parallax/parallax.js":"bN1Ux","./modules/zoom/zoom.js":"ffxDf","./modules/lazy/lazy.js":"iVTy7","./modules/controller/controller.js":"lMnB7","./modules/a11y/a11y.js":"fwhQ2","./modules/history/history.js":"7Ni3h","./modules/hash-navigation/hash-navigation.js":"7Met9","./modules/autoplay/autoplay.js":"kGp3O","./modules/thumbs/thumbs.js":"15Kp5","./modules/free-mode/free-mode.js":"lWRkl","./modules/grid/grid.js":"a7HHF","./modules/manipulation/manipulation.js":"lc0m6","./modules/effect-fade/effect-fade.js":"hk8Gh","./modules/effect-cube/effect-cube.js":"LyU98","./modules/effect-flip/effect-flip.js":"gs0zk","./modules/effect-coverflow/effect-coverflow.js":"25hd1","./modules/effect-creative/effect-creative.js":"l5Zfb","./modules/effect-cards/effect-cards.js":"3hPrO","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"gAoUK":[function(require,module,exports) {
/* eslint no-param-reassign: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classCallCheckMjs = require("@swc/helpers/src/_class_call_check.mjs");
var _classCallCheckMjsDefault = parcelHelpers.interopDefault(_classCallCheckMjs);
var _createClassMjs = require("@swc/helpers/src/_create_class.mjs");
var _createClassMjsDefault = parcelHelpers.interopDefault(_createClassMjs);
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _toConsumableArrayMjs = require("@swc/helpers/src/_to_consumable_array.mjs");
var _toConsumableArrayMjsDefault = parcelHelpers.interopDefault(_toConsumableArrayMjs);
var _ssrWindow = require("ssr-window");
var _domJs = require("../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _utilsJs = require("../shared/utils.js");
var _getSupportJs = require("../shared/get-support.js");
var _getDeviceJs = require("../shared/get-device.js");
var _getBrowserJs = require("../shared/get-browser.js");
var _resizeJs = require("./modules/resize/resize.js");
var _resizeJsDefault = parcelHelpers.interopDefault(_resizeJs);
var _observerJs = require("./modules/observer/observer.js");
var _observerJsDefault = parcelHelpers.interopDefault(_observerJs);
var _eventsEmitterJs = require("./events-emitter.js");
var _eventsEmitterJsDefault = parcelHelpers.interopDefault(_eventsEmitterJs);
var _indexJs = require("./update/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./translate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./transition/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./slide/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./loop/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./grab-cursor/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("./events/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("./breakpoints/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("./classes/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("./images/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
var _indexJs10 = require("./check-overflow/index.js");
var _indexJsDefault10 = parcelHelpers.interopDefault(_indexJs10);
var _defaultsJs = require("./defaults.js");
var _defaultsJsDefault = parcelHelpers.interopDefault(_defaultsJs);
var _moduleExtendParamsJs = require("./moduleExtendParams.js");
var _moduleExtendParamsJsDefault = parcelHelpers.interopDefault(_moduleExtendParamsJs);
var prototypes = {
    eventsEmitter: (0, _eventsEmitterJsDefault.default),
    update: (0, _indexJsDefault.default),
    translate: (0, _indexJsDefault1.default),
    transition: (0, _indexJsDefault2.default),
    slide: (0, _indexJsDefault3.default),
    loop: (0, _indexJsDefault4.default),
    grabCursor: (0, _indexJsDefault5.default),
    events: (0, _indexJsDefault6.default),
    breakpoints: (0, _indexJsDefault7.default),
    checkOverflow: (0, _indexJsDefault10.default),
    classes: (0, _indexJsDefault8.default),
    images: (0, _indexJsDefault9.default)
};
var extendedDefaults = {};
var Swiper = /*#__PURE__*/ function() {
    "use strict";
    function Swiper() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _swiper_modules;
        (0, _classCallCheckMjsDefault.default)(this, Swiper);
        var el;
        var params;
        var ref;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else ref = (0, _slicedToArrayMjsDefault.default)(args, 2), el = ref[0], params = ref[1], ref;
        if (!params) params = {};
        params = (0, _utilsJs.extend)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && (0, _domJsDefault.default)(params.el).length > 1) {
            var swipers = [];
            (0, _domJsDefault.default)(params.el).each(function(containerEl) {
                var newParams = (0, _utilsJs.extend)({}, params, {
                    el: containerEl
                });
                swipers.push(new Swiper(newParams));
            });
            return swipers;
        } // Swiper Instance
        var swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, _getSupportJs.getSupport)();
        swiper.device = (0, _getDeviceJs.getDevice)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, _getBrowserJs.getBrowser)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = (0, _toConsumableArrayMjsDefault.default)(swiper.__modules__);
        if (params.modules && Array.isArray(params.modules)) (_swiper_modules = swiper.modules).push.apply(_swiper_modules, (0, _toConsumableArrayMjsDefault.default)(params.modules));
        var allModulesParams = {};
        swiper.modules.forEach(function(mod) {
            mod({
                swiper: swiper,
                extendParams: (0, _moduleExtendParamsJsDefault.default)(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        }); // Extend defaults with modules params
        var swiperParams = (0, _utilsJs.extend)({}, (0, _defaultsJsDefault.default), allModulesParams); // Extend defaults with passed params
        swiper.params = (0, _utilsJs.extend)({}, swiperParams, extendedDefaults, params);
        swiper.originalParams = (0, _utilsJs.extend)({}, swiper.params);
        swiper.passedParams = (0, _utilsJs.extend)({}, params); // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach(function(eventName) {
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
         // Save Dom lib
        swiper.$ = (0, _domJsDefault.default); // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: (0, _domJsDefault.default)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal: function() {
                return swiper.params.direction === "horizontal";
            },
            isVertical: function() {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                var touch = [
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "touchcancel"
                ];
                var desktop = [
                    "pointerdown",
                    "pointermove",
                    "pointerup"
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: (0, _utilsJs.now)(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper"); // Init
        if (swiper.params.init) swiper.init();
         // Return app instance
        return swiper;
    }
    (0, _createClassMjsDefault.default)(Swiper, [
        {
            key: "enable",
            value: function enable() {
                var swiper = this;
                if (swiper.enabled) return;
                swiper.enabled = true;
                if (swiper.params.grabCursor) swiper.setGrabCursor();
                swiper.emit("enable");
            }
        },
        {
            key: "disable",
            value: function disable() {
                var swiper = this;
                if (!swiper.enabled) return;
                swiper.enabled = false;
                if (swiper.params.grabCursor) swiper.unsetGrabCursor();
                swiper.emit("disable");
            }
        },
        {
            key: "setProgress",
            value: function setProgress(progress, speed) {
                var swiper = this;
                progress = Math.min(Math.max(progress, 0), 1);
                var min = swiper.minTranslate();
                var max = swiper.maxTranslate();
                var current = (max - min) * progress + min;
                swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
            }
        },
        {
            key: "emitContainerClasses",
            value: function emitContainerClasses() {
                var swiper = this;
                if (!swiper.params._emitClasses || !swiper.el) return;
                var cls = swiper.el.className.split(" ").filter(function(className) {
                    return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
                });
                swiper.emit("_containerClasses", cls.join(" "));
            }
        },
        {
            key: "getSlideClasses",
            value: function getSlideClasses(slideEl) {
                var swiper = this;
                return slideEl.className.split(" ").filter(function(className) {
                    return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
                }).join(" ");
            }
        },
        {
            key: "emitSlidesClasses",
            value: function emitSlidesClasses() {
                var swiper = this;
                if (!swiper.params._emitClasses || !swiper.el) return;
                var updates = [];
                swiper.slides.each(function(slideEl) {
                    var classNames = swiper.getSlideClasses(slideEl);
                    updates.push({
                        slideEl: slideEl,
                        classNames: classNames
                    });
                    swiper.emit("_slideClass", slideEl, classNames);
                });
                swiper.emit("_slideClasses", updates);
            }
        },
        {
            key: "slidesPerViewDynamic",
            value: function slidesPerViewDynamic() {
                var view = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "current", exact = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var swiper = this;
                var params = swiper.params, slides = swiper.slides, slidesGrid = swiper.slidesGrid, slidesSizesGrid = swiper.slidesSizesGrid, swiperSize = swiper.size, activeIndex = swiper.activeIndex;
                var spv = 1;
                if (params.centeredSlides) {
                    var slideSize = slides[activeIndex].swiperSlideSize;
                    var breakLoop;
                    for(var i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                        slideSize += slides[i].swiperSlideSize;
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                    for(var i1 = activeIndex - 1; i1 >= 0; i1 -= 1)if (slides[i1] && !breakLoop) {
                        slideSize += slides[i1].swiperSlideSize;
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                } else {
                    // eslint-disable-next-line
                    if (view === "current") for(var i2 = activeIndex + 1; i2 < slides.length; i2 += 1){
                        var slideInView = exact ? slidesGrid[i2] + slidesSizesGrid[i2] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i2] - slidesGrid[activeIndex] < swiperSize;
                        if (slideInView) spv += 1;
                    }
                    else // previous
                    for(var i3 = activeIndex - 1; i3 >= 0; i3 -= 1){
                        var slideInView1 = slidesGrid[activeIndex] - slidesGrid[i3] < swiperSize;
                        if (slideInView1) spv += 1;
                    }
                }
                return spv;
            }
        },
        {
            key: "update",
            value: function update() {
                var setTranslate = function setTranslate() {
                    var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
                    var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
                    swiper.setTranslate(newTranslate);
                    swiper.updateActiveIndex();
                    swiper.updateSlidesClasses();
                };
                var swiper = this;
                if (!swiper || swiper.destroyed) return;
                var snapGrid = swiper.snapGrid, params = swiper.params; // Breakpoints
                if (params.breakpoints) swiper.setBreakpoint();
                swiper.updateSize();
                swiper.updateSlides();
                swiper.updateProgress();
                swiper.updateSlidesClasses();
                var translated;
                if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
                    setTranslate();
                    if (swiper.params.autoHeight) swiper.updateAutoHeight();
                } else {
                    if ((swiper.params.slidesPerView === "auto" || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
                    else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
                    if (!translated) setTranslate();
                }
                if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
                swiper.emit("update");
            }
        },
        {
            key: "changeDirection",
            value: function changeDirection(newDirection) {
                var needUpdate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var swiper = this;
                var currentDirection = swiper.params.direction;
                if (!newDirection) // eslint-disable-next-line
                newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
                if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
                swiper.$el.removeClass("".concat(swiper.params.containerModifierClass).concat(currentDirection)).addClass("".concat(swiper.params.containerModifierClass).concat(newDirection));
                swiper.emitContainerClasses();
                swiper.params.direction = newDirection;
                swiper.slides.each(function(slideEl) {
                    if (newDirection === "vertical") slideEl.style.width = "";
                    else slideEl.style.height = "";
                });
                swiper.emit("changeDirection");
                if (needUpdate) swiper.update();
                return swiper;
            }
        },
        {
            key: "mount",
            value: function mount(el) {
                var swiper = this;
                if (swiper.mounted) return true; // Find el
                var $el = (0, _domJsDefault.default)(el || swiper.params.el);
                el = $el[0];
                if (!el) return false;
                el.swiper = swiper;
                var getWrapperSelector = function() {
                    return ".".concat((swiper.params.wrapperClass || "").trim().split(" ").join("."));
                };
                var getWrapper = function() {
                    if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                        var res = (0, _domJsDefault.default)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
                        res.children = function(options) {
                            return $el.children(options);
                        };
                        return res;
                    }
                    return $el.children(getWrapperSelector());
                }; // Find Wrapper
                var $wrapperEl = getWrapper();
                if ($wrapperEl.length === 0 && swiper.params.createElements) {
                    var document = (0, _ssrWindow.getDocument)();
                    var wrapper = document.createElement("div");
                    $wrapperEl = (0, _domJsDefault.default)(wrapper);
                    wrapper.className = swiper.params.wrapperClass;
                    $el.append(wrapper);
                    $el.children(".".concat(swiper.params.slideClass)).each(function(slideEl) {
                        $wrapperEl.append(slideEl);
                    });
                }
                Object.assign(swiper, {
                    $el: $el,
                    el: el,
                    $wrapperEl: $wrapperEl,
                    wrapperEl: $wrapperEl[0],
                    mounted: true,
                    // RTL
                    rtl: el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl",
                    rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl"),
                    wrongRTL: $wrapperEl.css("display") === "-webkit-box"
                });
                return true;
            }
        },
        {
            key: "init",
            value: function init(el) {
                var swiper = this;
                if (swiper.initialized) return swiper;
                var mounted = swiper.mount(el);
                if (mounted === false) return swiper;
                swiper.emit("beforeInit"); // Set breakpoint
                if (swiper.params.breakpoints) swiper.setBreakpoint();
                 // Add Classes
                swiper.addClasses(); // Create loop
                if (swiper.params.loop) swiper.loopCreate();
                 // Update size
                swiper.updateSize(); // Update slides
                swiper.updateSlides();
                if (swiper.params.watchOverflow) swiper.checkOverflow();
                 // Set Grab Cursor
                if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
                if (swiper.params.preloadImages) swiper.preloadImages();
                 // Slide To Initial Slide
                if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
                else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
                 // Attach events
                swiper.attachEvents(); // Init Flag
                swiper.initialized = true; // Emit
                swiper.emit("init");
                swiper.emit("afterInit");
                return swiper;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var deleteInstance = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, cleanStyles = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var swiper = this;
                var params = swiper.params, $el = swiper.$el, $wrapperEl = swiper.$wrapperEl, slides = swiper.slides;
                if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
                swiper.emit("beforeDestroy"); // Init Flag
                swiper.initialized = false; // Detach events
                swiper.detachEvents(); // Destroy loop
                if (params.loop) swiper.loopDestroy();
                 // Cleanup styles
                if (cleanStyles) {
                    swiper.removeClasses();
                    $el.removeAttr("style");
                    $wrapperEl.removeAttr("style");
                    if (slides && slides.length) slides.removeClass([
                        params.slideVisibleClass,
                        params.slideActiveClass,
                        params.slideNextClass,
                        params.slidePrevClass
                    ].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index");
                }
                swiper.emit("destroy"); // Detach emitter events
                Object.keys(swiper.eventsListeners).forEach(function(eventName) {
                    swiper.off(eventName);
                });
                if (deleteInstance !== false) {
                    swiper.$el[0].swiper = null;
                    (0, _utilsJs.deleteProps)(swiper);
                }
                swiper.destroyed = true;
                return null;
            }
        }
    ], [
        {
            key: "extendDefaults",
            value: function extendDefaults(newDefaults) {
                (0, _utilsJs.extend)(extendedDefaults, newDefaults);
            }
        },
        {
            key: "extendedDefaults",
            get: function get() {
                return extendedDefaults;
            }
        },
        {
            key: "defaults",
            get: function get() {
                return 0, _defaultsJsDefault.default;
            }
        },
        {
            key: "installModule",
            value: function installModule(mod) {
                if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
                var modules = Swiper.prototype.__modules__;
                if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (Array.isArray(module)) {
                    module.forEach(function(m) {
                        return Swiper.installModule(m);
                    });
                    return Swiper;
                }
                Swiper.installModule(module);
                return Swiper;
            }
        }
    ]);
    return Swiper;
}();
Object.keys(prototypes).forEach(function(prototypeGroup) {
    Object.keys(prototypes[prototypeGroup]).forEach(function(protoMethod) {
        Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
    });
});
Swiper.use([
    (0, _resizeJsDefault.default),
    (0, _observerJsDefault.default)
]);
exports.default = Swiper;

},{"@swc/helpers/src/_class_call_check.mjs":"eguiP","@swc/helpers/src/_create_class.mjs":"14PLJ","@swc/helpers/src/_sliced_to_array.mjs":"l34hS","@swc/helpers/src/_to_consumable_array.mjs":"11hUU","ssr-window":"5Hbsc","../shared/dom.js":"aVcu8","../shared/utils.js":"hHZfI","../shared/get-support.js":"aSsfJ","../shared/get-device.js":"krkN9","../shared/get-browser.js":"cVSnf","./modules/resize/resize.js":"bIuFL","./modules/observer/observer.js":"eh66E","./events-emitter.js":"6N8CM","./update/index.js":"8THye","./translate/index.js":"dNGDM","./transition/index.js":"cH6zZ","./slide/index.js":"90s6V","./loop/index.js":"9kTyL","./grab-cursor/index.js":"2bPoH","./events/index.js":"71xhJ","./breakpoints/index.js":"5pCoc","./classes/index.js":"igaba","./images/index.js":"7So8v","./check-overflow/index.js":"5kwpO","./defaults.js":"hrwih","./moduleExtendParams.js":"dIXAb","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"5Hbsc":[function(require,module,exports) {
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extend", function() {
    return extend;
});
parcelHelpers.export(exports, "getDocument", function() {
    return getDocument;
});
parcelHelpers.export(exports, "getWindow", function() {
    return getWindow;
});
parcelHelpers.export(exports, "ssrDocument", function() {
    return ssrDocument;
});
parcelHelpers.export(exports, "ssrWindow", function() {
    return ssrWindow;
});
function isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function extend() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, src = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Object.keys(src).forEach(function(key) {
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) extend(target[key], src[key]);
    });
}
var ssrDocument = {
    body: {},
    addEventListener: function() {},
    removeEventListener: function() {},
    activeElement: {
        blur: function() {},
        nodeName: ""
    },
    querySelector: function() {
        return null;
    },
    querySelectorAll: function() {
        return [];
    },
    getElementById: function() {
        return null;
    },
    createEvent: function() {
        return {
            initEvent: function() {}
        };
    },
    createElement: function() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function() {},
            getElementsByTagName: function() {
                return [];
            }
        };
    },
    createElementNS: function() {
        return {};
    },
    importNode: function() {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function getDocument() {
    var doc = typeof document !== "undefined" ? document : {};
    extend(doc, ssrDocument);
    return doc;
}
var ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState: function() {},
        pushState: function() {},
        go: function() {},
        back: function() {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function() {},
    removeEventListener: function() {},
    getComputedStyle: function() {
        return {
            getPropertyValue: function() {
                return "";
            }
        };
    },
    Image: function() {},
    Date: function() {},
    screen: {},
    setTimeout: function() {},
    clearTimeout: function() {},
    matchMedia: function() {
        return {};
    },
    requestAnimationFrame: function(callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function(id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function getWindow() {
    var win = typeof window !== "undefined" ? window : {};
    extend(win, ssrWindow);
    return win;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"aVcu8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dom7 = require("dom7");
var Methods = {
    addClass: (0, _dom7.addClass),
    removeClass: (0, _dom7.removeClass),
    hasClass: (0, _dom7.hasClass),
    toggleClass: (0, _dom7.toggleClass),
    attr: (0, _dom7.attr),
    removeAttr: (0, _dom7.removeAttr),
    transform: (0, _dom7.transform),
    transition: (0, _dom7.transition),
    on: (0, _dom7.on),
    off: (0, _dom7.off),
    trigger: (0, _dom7.trigger),
    transitionEnd: (0, _dom7.transitionEnd),
    outerWidth: (0, _dom7.outerWidth),
    outerHeight: (0, _dom7.outerHeight),
    styles: (0, _dom7.styles),
    offset: (0, _dom7.offset),
    css: (0, _dom7.css),
    each: (0, _dom7.each),
    html: (0, _dom7.html),
    text: (0, _dom7.text),
    is: (0, _dom7.is),
    index: (0, _dom7.index),
    eq: (0, _dom7.eq),
    append: (0, _dom7.append),
    prepend: (0, _dom7.prepend),
    next: (0, _dom7.next),
    nextAll: (0, _dom7.nextAll),
    prev: (0, _dom7.prev),
    prevAll: (0, _dom7.prevAll),
    parent: (0, _dom7.parent),
    parents: (0, _dom7.parents),
    closest: (0, _dom7.closest),
    find: (0, _dom7.find),
    children: (0, _dom7.children),
    filter: (0, _dom7.filter),
    remove: (0, _dom7.remove)
};
Object.keys(Methods).forEach(function(methodName) {
    Object.defineProperty((0, _dom7.$).fn, methodName, {
        value: Methods[methodName],
        writable: true
    });
});
exports.default = (0, _dom7.$);

},{"dom7":"XH8ce","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"XH8ce":[function(require,module,exports) {
/**
 * Dom7 4.0.4
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2022, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: January 11, 2022
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "$", function() {
    return $;
});
parcelHelpers.export(exports, "add", function() {
    return add;
});
parcelHelpers.export(exports, "addClass", function() {
    return addClass;
});
parcelHelpers.export(exports, "animate", function() {
    return animate;
});
parcelHelpers.export(exports, "animationEnd", function() {
    return animationEnd;
});
parcelHelpers.export(exports, "append", function() {
    return append;
});
parcelHelpers.export(exports, "appendTo", function() {
    return appendTo;
});
parcelHelpers.export(exports, "attr", function() {
    return attr;
});
parcelHelpers.export(exports, "blur", function() {
    return blur;
});
parcelHelpers.export(exports, "change", function() {
    return change;
});
parcelHelpers.export(exports, "children", function() {
    return children;
});
parcelHelpers.export(exports, "click", function() {
    return click;
});
parcelHelpers.export(exports, "closest", function() {
    return closest;
});
parcelHelpers.export(exports, "css", function() {
    return css;
});
parcelHelpers.export(exports, "data", function() {
    return data;
});
parcelHelpers.export(exports, "dataset", function() {
    return dataset;
});
parcelHelpers.export(exports, "detach", function() {
    return detach;
});
parcelHelpers.export(exports, "each", function() {
    return each;
});
parcelHelpers.export(exports, "empty", function() {
    return empty;
});
parcelHelpers.export(exports, "eq", function() {
    return eq;
});
parcelHelpers.export(exports, "filter", function() {
    return filter;
});
parcelHelpers.export(exports, "find", function() {
    return find;
});
parcelHelpers.export(exports, "focus", function() {
    return focus;
});
parcelHelpers.export(exports, "focusin", function() {
    return focusin;
});
parcelHelpers.export(exports, "focusout", function() {
    return focusout;
});
parcelHelpers.export(exports, "hasClass", function() {
    return hasClass;
});
parcelHelpers.export(exports, "height", function() {
    return height;
});
parcelHelpers.export(exports, "hide", function() {
    return hide;
});
parcelHelpers.export(exports, "html", function() {
    return html;
});
parcelHelpers.export(exports, "index", function() {
    return index;
});
parcelHelpers.export(exports, "insertAfter", function() {
    return insertAfter;
});
parcelHelpers.export(exports, "insertBefore", function() {
    return insertBefore;
});
parcelHelpers.export(exports, "is", function() {
    return is;
});
parcelHelpers.export(exports, "keydown", function() {
    return keydown;
});
parcelHelpers.export(exports, "keypress", function() {
    return keypress;
});
parcelHelpers.export(exports, "keyup", function() {
    return keyup;
});
parcelHelpers.export(exports, "mousedown", function() {
    return mousedown;
});
parcelHelpers.export(exports, "mouseenter", function() {
    return mouseenter;
});
parcelHelpers.export(exports, "mouseleave", function() {
    return mouseleave;
});
parcelHelpers.export(exports, "mousemove", function() {
    return mousemove;
});
parcelHelpers.export(exports, "mouseout", function() {
    return mouseout;
});
parcelHelpers.export(exports, "mouseover", function() {
    return mouseover;
});
parcelHelpers.export(exports, "mouseup", function() {
    return mouseup;
});
parcelHelpers.export(exports, "next", function() {
    return next;
});
parcelHelpers.export(exports, "nextAll", function() {
    return nextAll;
});
parcelHelpers.export(exports, "off", function() {
    return off;
});
parcelHelpers.export(exports, "offset", function() {
    return offset;
});
parcelHelpers.export(exports, "on", function() {
    return on;
});
parcelHelpers.export(exports, "once", function() {
    return once;
});
parcelHelpers.export(exports, "outerHeight", function() {
    return outerHeight;
});
parcelHelpers.export(exports, "outerWidth", function() {
    return outerWidth;
});
parcelHelpers.export(exports, "parent", function() {
    return parent;
});
parcelHelpers.export(exports, "parents", function() {
    return parents;
});
parcelHelpers.export(exports, "prepend", function() {
    return prepend;
});
parcelHelpers.export(exports, "prependTo", function() {
    return prependTo;
});
parcelHelpers.export(exports, "prev", function() {
    return prev;
});
parcelHelpers.export(exports, "prevAll", function() {
    return prevAll;
});
parcelHelpers.export(exports, "prop", function() {
    return prop;
});
parcelHelpers.export(exports, "remove", function() {
    return remove;
});
parcelHelpers.export(exports, "removeAttr", function() {
    return removeAttr;
});
parcelHelpers.export(exports, "removeClass", function() {
    return removeClass;
});
parcelHelpers.export(exports, "removeData", function() {
    return removeData;
});
parcelHelpers.export(exports, "resize", function() {
    return resize;
});
parcelHelpers.export(exports, "scroll", function() {
    return scroll;
});
parcelHelpers.export(exports, "scrollLeft", function() {
    return scrollLeft;
});
parcelHelpers.export(exports, "scrollTo", function() {
    return scrollTo;
});
parcelHelpers.export(exports, "scrollTop", function() {
    return scrollTop;
});
parcelHelpers.export(exports, "show", function() {
    return show;
});
parcelHelpers.export(exports, "siblings", function() {
    return siblings;
});
parcelHelpers.export(exports, "stop", function() {
    return stop;
});
parcelHelpers.export(exports, "styles", function() {
    return styles;
});
parcelHelpers.export(exports, "submit", function() {
    return submit;
});
parcelHelpers.export(exports, "text", function() {
    return text;
});
parcelHelpers.export(exports, "toggleClass", function() {
    return toggleClass;
});
parcelHelpers.export(exports, "touchend", function() {
    return touchend;
});
parcelHelpers.export(exports, "touchmove", function() {
    return touchmove;
});
parcelHelpers.export(exports, "touchstart", function() {
    return touchstart;
});
parcelHelpers.export(exports, "transform", function() {
    return transform;
});
parcelHelpers.export(exports, "transition", function() {
    return transition;
});
parcelHelpers.export(exports, "transitionEnd", function() {
    return transitionEnd;
});
parcelHelpers.export(exports, "trigger", function() {
    return trigger;
});
parcelHelpers.export(exports, "val", function() {
    return val;
});
parcelHelpers.export(exports, "value", function() {
    return value;
});
parcelHelpers.export(exports, "width", function() {
    return width;
});
var _assertThisInitializedMjs = require("@swc/helpers/src/_assert_this_initialized.mjs");
var _assertThisInitializedMjsDefault = parcelHelpers.interopDefault(_assertThisInitializedMjs);
var _classCallCheckMjs = require("@swc/helpers/src/_class_call_check.mjs");
var _classCallCheckMjsDefault = parcelHelpers.interopDefault(_classCallCheckMjs);
var _inheritsMjs = require("@swc/helpers/src/_inherits.mjs");
var _inheritsMjsDefault = parcelHelpers.interopDefault(_inheritsMjs);
var _possibleConstructorReturnMjs = require("@swc/helpers/src/_possible_constructor_return.mjs");
var _possibleConstructorReturnMjsDefault = parcelHelpers.interopDefault(_possibleConstructorReturnMjs);
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _toConsumableArrayMjs = require("@swc/helpers/src/_to_consumable_array.mjs");
var _toConsumableArrayMjsDefault = parcelHelpers.interopDefault(_toConsumableArrayMjs);
var _wrapNativeSuperMjs = require("@swc/helpers/src/_wrap_native_super.mjs");
var _wrapNativeSuperMjsDefault = parcelHelpers.interopDefault(_wrapNativeSuperMjs);
var _createSuperMjs = require("@swc/helpers/src/_create_super.mjs");
var _createSuperMjsDefault = parcelHelpers.interopDefault(_createSuperMjs);
var _ssrWindow = require("ssr-window");
/* eslint-disable no-proto */ function makeReactive(obj) {
    var proto = obj.__proto__;
    Object.defineProperty(obj, "__proto__", {
        get: function() {
            return proto;
        },
        set: function(value) {
            proto.__proto__ = value;
        }
    });
}
var Dom7 = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, _inheritsMjsDefault.default)(Dom7, Array1);
    var _super = (0, _createSuperMjsDefault.default)(Dom7);
    function Dom7(items) {
        (0, _classCallCheckMjsDefault.default)(this, Dom7);
        var _this;
        if (typeof items === "number") _this = _super.call(this, items);
        else {
            _this = _super.call.apply(_super, [
                this
            ].concat((0, _toConsumableArrayMjsDefault.default)(items || [])));
            makeReactive((0, _assertThisInitializedMjsDefault.default)(_this));
        }
        return (0, _possibleConstructorReturnMjsDefault.default)(_this);
    }
    return Dom7;
}((0, _wrapNativeSuperMjsDefault.default)(Array));
function arrayFlat() {
    var arr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var res = [];
    arr.forEach(function(el) {
        var _res;
        if (Array.isArray(el)) (_res = res).push.apply(_res, (0, _toConsumableArrayMjsDefault.default)(arrayFlat(el)));
        else res.push(el);
    });
    return res;
}
function arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
    var uniqueArray = [];
    for(var i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, function(match, group) {
        return group.toUpperCase();
    });
}
// eslint-disable-next-line
function qsa(selector, context) {
    if (typeof selector !== "string") return [
        selector
    ];
    var a = [];
    var res = context.querySelectorAll(selector);
    for(var i = 0; i < res.length; i += 1)a.push(res[i]);
    return a;
}
function $(selector, context) {
    var window = (0, _ssrWindow.getWindow)();
    var document = (0, _ssrWindow.getDocument)();
    var arr = [];
    if (!context && selector instanceof Dom7) return selector;
    if (!selector) return new Dom7(arr);
    if (typeof selector === "string") {
        var html = selector.trim();
        if (html.indexOf("<") >= 0 && html.indexOf(">") >= 0) {
            var toCreate = "div";
            if (html.indexOf("<li") === 0) toCreate = "ul";
            if (html.indexOf("<tr") === 0) toCreate = "tbody";
            if (html.indexOf("<td") === 0 || html.indexOf("<th") === 0) toCreate = "tr";
            if (html.indexOf("<tbody") === 0) toCreate = "table";
            if (html.indexOf("<option") === 0) toCreate = "select";
            var tempParent = document.createElement(toCreate);
            tempParent.innerHTML = html;
            for(var i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
        } else arr = qsa(selector.trim(), context || document);
         // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) arr.push(selector);
    else if (Array.isArray(selector)) {
        if (selector instanceof Dom7) return selector;
        arr = selector;
    }
    return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;
// eslint-disable-next-line
function addClass() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(" ");
    }));
    this.forEach(function(el) {
        var _el_classList;
        (_el_classList = el.classList).add.apply(_el_classList, (0, _toConsumableArrayMjsDefault.default)(classNames));
    });
    return this;
}
function removeClass() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(" ");
    }));
    this.forEach(function(el) {
        var _el_classList;
        (_el_classList = el.classList).remove.apply(_el_classList, (0, _toConsumableArrayMjsDefault.default)(classNames));
    });
    return this;
}
function toggleClass() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(" ");
    }));
    this.forEach(function(el) {
        classNames.forEach(function(className) {
            el.classList.toggle(className);
        });
    });
}
function hasClass() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(" ");
    }));
    return arrayFilter(this, function(el) {
        return classNames.filter(function(className) {
            return el.classList.contains(className);
        }).length > 0;
    }).length > 0;
}
function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === "string") {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    } // Set attrs
    for(var i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        for(var attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
function removeAttr(attr) {
    for(var i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
function prop(props, value) {
    if (arguments.length === 1 && typeof props === "string") {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(var i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            for(var propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
    return this;
}
function data(key, value) {
    var el;
    if (typeof value === "undefined") {
        el = this[0];
        if (!el) return undefined; // Get value
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
        var dataKey = el.getAttribute("data-".concat(key));
        if (dataKey) return dataKey;
        return undefined;
    } // Set value
    for(var i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function removeData(key) {
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function dataset() {
    var el = this[0];
    if (!el) return undefined;
    var dataset = {}; // eslint-disable-line
    if (el.dataset) for(var dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(var i = 0; i < el.attributes.length; i += 1){
        var attr = el.attributes[i];
        if (attr.name.indexOf("data-") >= 0) dataset[toCamelCase(attr.name.split("data-")[1])] = attr.value;
    }
    for(var key in dataset){
        if (dataset[key] === "false") dataset[key] = false;
        else if (dataset[key] === "true") dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function val(value) {
    if (typeof value === "undefined") {
        // get value
        var el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === "select") {
            var values = [];
            for(var i = 0; i < el.selectedOptions.length; i += 1)values.push(el.selectedOptions[i].value);
            return values;
        }
        return el.value;
    } // set value
    for(var i1 = 0; i1 < this.length; i1 += 1){
        var el1 = this[i1];
        if (Array.isArray(value) && el1.multiple && el1.nodeName.toLowerCase() === "select") for(var j = 0; j < el1.options.length; j += 1)el1.options[j].selected = value.indexOf(el1.options[j].value) >= 0;
        else el1.value = value;
    }
    return this;
}
function value(value) {
    return this.val(value);
}
function transform(transform) {
    for(var i = 0; i < this.length; i += 1)this[i].style.transform = transform;
    return this;
}
function transition(duration) {
    for(var i = 0; i < this.length; i += 1)this[i].style.transitionDuration = typeof duration !== "string" ? "".concat(duration, "ms") : duration;
    return this;
}
function on() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var handleLiveEvent = function handleLiveEvent(e) {
        var target = e.target;
        if (!target) return;
        var eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            var parents = $(target).parents(); // eslint-disable-line
            for(var k = 0; k < parents.length; k += 1)if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
        }
    };
    var handleEvent = function handleEvent(e) {
        var eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    };
    var _args = (0, _slicedToArrayMjsDefault.default)(args, 4), eventType = _args[0], targetSelector = _args[1], listener = _args[2], capture = _args[3];
    if (typeof args[1] === "function") {
        var ref;
        ref = (0, _slicedToArrayMjsDefault.default)(args, 3), eventType = ref[0], listener = ref[1], capture = ref[2], ref;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    var events = eventType.split(" ");
    var j;
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            var event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener: listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            var event1 = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event1]) el.dom7LiveListeners[event1] = [];
            el.dom7LiveListeners[event1].push({
                listener: listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(event1, handleLiveEvent, capture);
        }
    }
    return this;
}
function off() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = (0, _slicedToArrayMjsDefault.default)(args, 4), eventType = _args[0], targetSelector = _args[1], listener = _args[2], capture = _args[3];
    if (typeof args[1] === "function") {
        var ref;
        ref = (0, _slicedToArrayMjsDefault.default)(args, 3), eventType = ref[0], listener = ref[1], capture = ref[2], ref;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    var events = eventType.split(" ");
    for(var i = 0; i < events.length; i += 1){
        var event = events[i];
        for(var j = 0; j < this.length; j += 1){
            var el = this[j];
            var handlers = void 0;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(var k = handlers.length - 1; k >= 0; k -= 1){
                var handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function once() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var dom = this;
    var _args = (0, _slicedToArrayMjsDefault.default)(args, 4), eventName = _args[0], targetSelector = _args[1], listener = _args[2], capture = _args[3];
    if (typeof args[1] === "function") {
        var ref;
        ref = (0, _slicedToArrayMjsDefault.default)(args, 3), eventName = ref[0], listener = ref[1], capture = ref[2], ref;
        targetSelector = undefined;
    }
    function onceHandler() {
        for(var _len = arguments.length, eventArgs = new Array(_len), _key = 0; _key < _len; _key++){
            eventArgs[_key] = arguments[_key];
        }
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var window = (0, _ssrWindow.getWindow)();
    var events = args[0].split(" ");
    var eventData = args[1];
    for(var i = 0; i < events.length; i += 1){
        var event = events[i];
        for(var j = 0; j < this.length; j += 1){
            var el = this[j];
            if (window.CustomEvent) {
                var evt = new window.CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
                el.dom7EventData = args.filter(function(data, dataIndex) {
                    return dataIndex > 0;
                });
                el.dispatchEvent(evt);
                el.dom7EventData = [];
                delete el.dom7EventData;
            }
        }
    }
    return this;
}
function transitionEnd(callback) {
    var dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("transitionend", fireCallBack);
    }
    if (callback) dom.on("transitionend", fireCallBack);
    return this;
}
function animationEnd(callback) {
    var dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("animationend", fireCallBack);
    }
    if (callback) dom.on("animationend", fireCallBack);
    return this;
}
function width() {
    var window = (0, _ssrWindow.getWindow)();
    if (this[0] === window) return window.innerWidth;
    if (this.length > 0) return parseFloat(this.css("width"));
    return null;
}
function outerWidth(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            var styles = this.styles();
            return this[0].offsetWidth + parseFloat(styles.getPropertyValue("margin-right")) + parseFloat(styles.getPropertyValue("margin-left"));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function height() {
    var window = (0, _ssrWindow.getWindow)();
    if (this[0] === window) return window.innerHeight;
    if (this.length > 0) return parseFloat(this.css("height"));
    return null;
}
function outerHeight(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            var styles = this.styles();
            return this[0].offsetHeight + parseFloat(styles.getPropertyValue("margin-top")) + parseFloat(styles.getPropertyValue("margin-bottom"));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function offset() {
    if (this.length > 0) {
        var window = (0, _ssrWindow.getWindow)();
        var document = (0, _ssrWindow.getDocument)();
        var el = this[0];
        var box = el.getBoundingClientRect();
        var body = document.body;
        var clientTop = el.clientTop || body.clientTop || 0;
        var clientLeft = el.clientLeft || body.clientLeft || 0;
        var scrollTop = el === window ? window.scrollY : el.scrollTop;
        var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function hide() {
    for(var i = 0; i < this.length; i += 1)this[i].style.display = "none";
    return this;
}
function show() {
    var window = (0, _ssrWindow.getWindow)();
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (el.style.display === "none") el.style.display = "";
        if (window.getComputedStyle(el, null).getPropertyValue("display") === "none") // Still not visible
        el.style.display = "block";
    }
    return this;
}
function styles() {
    var window = (0, _ssrWindow.getWindow)();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
}
function css(props, value) {
    var window = (0, _ssrWindow.getWindow)();
    var i;
    if (arguments.length === 1) {
        if (typeof props === "string") {
            // .css('width')
            if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            // .css({ width: '100px' })
            for(i = 0; i < this.length; i += 1)for(var prop in props)this[i].style[prop] = props[prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === "string") {
        // .css('width', '100px')
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
function each(callback) {
    if (!callback) return this;
    this.forEach(function(el, index) {
        callback.apply(el, [
            el,
            index
        ]);
    });
    return this;
}
function filter(callback) {
    var result = arrayFilter(this, callback);
    return $(result);
}
function html(html) {
    if (typeof html === "undefined") return this[0] ? this[0].innerHTML : null;
    for(var i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
function text(text) {
    if (typeof text === "undefined") return this[0] ? this[0].textContent.trim() : null;
    for(var i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function is(selector) {
    var window = (0, _ssrWindow.getWindow)();
    var document = (0, _ssrWindow.getDocument)();
    var el = this[0];
    var compareWith;
    var i;
    if (!el || typeof selector === "undefined") return false;
    if (typeof selector === "string") {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    if (selector === document) return el === document;
    if (selector === window) return el === window;
    if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function index() {
    var child = this[0];
    var i;
    if (child) {
        i = 0; // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function eq(index) {
    if (typeof index === "undefined") return this;
    var length = this.length;
    if (index > length - 1) return $([]);
    if (index < 0) {
        var returnIndex = length + index;
        if (returnIndex < 0) return $([]);
        return $([
            this[returnIndex]
        ]);
    }
    return $([
        this[index]
    ]);
}
function append() {
    for(var _len = arguments.length, els = new Array(_len), _key = 0; _key < _len; _key++){
        els[_key] = arguments[_key];
    }
    var newChild;
    var document = (0, _ssrWindow.getDocument)();
    for(var k = 0; k < els.length; k += 1){
        newChild = els[k];
        for(var i = 0; i < this.length; i += 1){
            if (typeof newChild === "string") {
                var tempDiv = document.createElement("div");
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof Dom7) for(var j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
function appendTo(parent) {
    $(parent).append(this);
    return this;
}
function prepend(newChild) {
    var document = (0, _ssrWindow.getDocument)();
    var i;
    var j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === "string") {
            var tempDiv = document.createElement("div");
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
function prependTo(parent) {
    $(parent).prepend(this);
    return this;
}
function insertBefore(selector) {
    var before = $(selector);
    for(var i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(var j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function insertAfter(selector) {
    var after = $(selector);
    for(var i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(var j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function next(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return $([
                this[0].nextElementSibling
            ]);
            return $([]);
        }
        if (this[0].nextElementSibling) return $([
            this[0].nextElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function nextAll(selector) {
    var nextEls = [];
    var el = this[0];
    if (!el) return $([]);
    while(el.nextElementSibling){
        var next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return $(nextEls);
}
function prev(selector) {
    if (this.length > 0) {
        var el = this[0];
        if (selector) {
            if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) return $([
                el.previousElementSibling
            ]);
            return $([]);
        }
        if (el.previousElementSibling) return $([
            el.previousElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function prevAll(selector) {
    var prevEls = [];
    var el = this[0];
    if (!el) return $([]);
    while(el.previousElementSibling){
        var prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return $(prevEls);
}
function siblings(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
    var parents = []; // eslint-disable-line
    for(var i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $(parents);
}
function parents(selector) {
    var parents = []; // eslint-disable-line
    for(var i = 0; i < this.length; i += 1){
        var parent = this[i].parentNode; // eslint-disable-line
        while(parent){
            if (selector) {
                if ($(parent).is(selector)) parents.push(parent);
            } else parents.push(parent);
            parent = parent.parentNode;
        }
    }
    return $(parents);
}
function closest(selector) {
    var closest = this; // eslint-disable-line
    if (typeof selector === "undefined") return $([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function find(selector) {
    var foundElements = [];
    for(var i = 0; i < this.length; i += 1){
        var found = this[i].querySelectorAll(selector);
        for(var j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return $(foundElements);
}
function children(selector) {
    var children = []; // eslint-disable-line
    for(var i = 0; i < this.length; i += 1){
        var childNodes = this[i].children;
        for(var j = 0; j < childNodes.length; j += 1)if (!selector || $(childNodes[j]).is(selector)) children.push(childNodes[j]);
    }
    return $(children);
}
function remove() {
    for(var i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function detach() {
    return this.remove();
}
function add() {
    for(var _len = arguments.length, els = new Array(_len), _key = 0; _key < _len; _key++){
        els[_key] = arguments[_key];
    }
    var dom = this;
    var i;
    var j;
    for(i = 0; i < els.length; i += 1){
        var toAdd = $(els[i]);
        for(j = 0; j < toAdd.length; j += 1)dom.push(toAdd[j]);
    }
    return dom;
}
function empty() {
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (el.nodeType === 1) {
            for(var j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = "";
        }
    }
    return this;
}
// eslint-disable-next-line
function scrollTo() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var window = (0, _ssrWindow.getWindow)();
    var _args = (0, _slicedToArrayMjsDefault.default)(args, 5), left = _args[0], top = _args[1], duration = _args[2], easing = _args[3], callback = _args[4];
    if (args.length === 4 && typeof easing === "function") {
        callback = easing;
        var ref;
        ref = (0, _slicedToArrayMjsDefault.default)(args, 5), left = ref[0], top = ref[1], duration = ref[2], callback = ref[3], easing = ref[4], ref;
    }
    if (typeof easing === "undefined") easing = "swing";
    return this.each(function animate() {
        var el = this;
        var currentTop;
        var currentLeft;
        var maxTop;
        var maxLeft;
        var newTop;
        var newLeft;
        var scrollTop; // eslint-disable-line
        var scrollLeft; // eslint-disable-line
        var animateTop = top > 0 || top === 0;
        var animateLeft = left > 0 || left === 0;
        if (typeof easing === "undefined") easing = "swing";
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        var startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render() {
            var time = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date().getTime();
            if (startTime === null) startTime = time;
            var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            var easeProgress = easing === "linear" ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            var done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
    });
} // scrollTop(top, duration, easing, callback) {
function scrollTop() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = (0, _slicedToArrayMjsDefault.default)(args, 4), top = _args[0], duration = _args[1], easing = _args[2], callback = _args[3];
    var ref;
    if (args.length === 3 && typeof easing === "function") ref = (0, _slicedToArrayMjsDefault.default)(args, 4), top = ref[0], duration = ref[1], callback = ref[2], easing = ref[3], ref;
    var dom = this;
    if (typeof top === "undefined") {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = (0, _slicedToArrayMjsDefault.default)(args, 4), left = _args[0], duration = _args[1], easing = _args[2], callback = _args[3];
    var ref;
    if (args.length === 3 && typeof easing === "function") ref = (0, _slicedToArrayMjsDefault.default)(args, 4), left = ref[0], duration = ref[1], callback = ref[2], easing = ref[3], ref;
    var dom = this;
    if (typeof left === "undefined") {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
// eslint-disable-next-line
function animate(initialProps, initialParams) {
    var window = (0, _ssrWindow.getWindow)();
    var els = this;
    var a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: "swing" // or 'linear'
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress: function(easing, progress) {
            if (easing === "swing") return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === "function") return easing(progress);
            return progress;
        },
        stop: function() {
            if (a.frameId) window.cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each(function(el) {
                var element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done: function(complete) {
            a.animating = false;
            a.elements.each(function(el) {
                var element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                var que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate: function(props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            var elements = []; // Define & Cache Initials & Units
            a.elements.each(function(el, index) {
                var initialFullValue;
                var initialValue;
                var unit;
                var finalValue;
                var finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach(function(prop) {
                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(",", ".");
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, "");
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue: initialFullValue,
                        initialValue: initialValue,
                        unit: unit,
                        finalValue: finalValue,
                        finalFullValue: finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            var startTime = null;
            var time;
            var elementsDone = 0;
            var propsDone = 0;
            var done;
            var began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                var progress;
                var easeProgress; // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach(function(element) {
                    var el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach(function(prop) {
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        var _el_prop = el[prop], initialValue = _el_prop.initialValue, finalValue = _el_prop.finalValue, unit = _el_prop.unit;
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        var currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return; // Then call
                a.frameId = window.requestAnimationFrame(render);
            }
            a.frameId = window.requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    var animateInstance;
    for(var i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === "stop") animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function stop() {
    var els = this;
    for(var i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
var noTrigger = "resize scroll".split(" ");
function shortcut(name) {
    var eventHandler = function eventHandler() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (typeof args[0] === "undefined") {
            for(var i = 0; i < this.length; i += 1)if (noTrigger.indexOf(name) < 0) {
                if (name in this[i]) this[i][name]();
                else $(this[i]).trigger(name);
            }
            return this;
        }
        return this.on.apply(this, [
            name
        ].concat((0, _toConsumableArrayMjsDefault.default)(args)));
    };
    return eventHandler;
}
var click = shortcut("click");
var blur = shortcut("blur");
var focus = shortcut("focus");
var focusin = shortcut("focusin");
var focusout = shortcut("focusout");
var keyup = shortcut("keyup");
var keydown = shortcut("keydown");
var keypress = shortcut("keypress");
var submit = shortcut("submit");
var change = shortcut("change");
var mousedown = shortcut("mousedown");
var mousemove = shortcut("mousemove");
var mouseup = shortcut("mouseup");
var mouseenter = shortcut("mouseenter");
var mouseleave = shortcut("mouseleave");
var mouseout = shortcut("mouseout");
var mouseover = shortcut("mouseover");
var touchstart = shortcut("touchstart");
var touchend = shortcut("touchend");
var touchmove = shortcut("touchmove");
var resize = shortcut("resize");
var scroll = shortcut("scroll");
exports.default = $;

},{"@swc/helpers/src/_assert_this_initialized.mjs":"h3RcV","@swc/helpers/src/_class_call_check.mjs":"eguiP","@swc/helpers/src/_inherits.mjs":"4jtFW","@swc/helpers/src/_possible_constructor_return.mjs":"j4S0Z","@swc/helpers/src/_sliced_to_array.mjs":"l34hS","@swc/helpers/src/_to_consumable_array.mjs":"11hUU","@swc/helpers/src/_wrap_native_super.mjs":"jyob2","@swc/helpers/src/_create_super.mjs":"iIIkg","ssr-window":"5Hbsc","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"hHZfI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateCSSModeScroll", function() {
    return animateCSSModeScroll;
});
parcelHelpers.export(exports, "deleteProps", function() {
    return deleteProps;
});
parcelHelpers.export(exports, "nextTick", function() {
    return nextTick;
});
parcelHelpers.export(exports, "now", function() {
    return now;
});
parcelHelpers.export(exports, "getTranslate", function() {
    return getTranslate;
});
parcelHelpers.export(exports, "isObject", function() {
    return isObject;
});
parcelHelpers.export(exports, "extend", function() {
    return extend;
});
parcelHelpers.export(exports, "getComputedStyle", function() {
    return getComputedStyle;
});
parcelHelpers.export(exports, "setCSSProperty", function() {
    return setCSSProperty;
});
var _definePropertyMjs = require("@swc/helpers/src/_define_property.mjs");
var _definePropertyMjsDefault = parcelHelpers.interopDefault(_definePropertyMjs);
var _ssrWindow = require("ssr-window");
function deleteProps(obj) {
    var object = obj;
    Object.keys(object).forEach(function(key) {
        try {
            object[key] = null;
        } catch (e) {}
        try {
            delete object[key];
        } catch (e1) {}
    });
}
function nextTick(callback) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return setTimeout(callback, delay);
}
function now() {
    return Date.now();
}
function getComputedStyle(el) {
    var window1 = (0, _ssrWindow.getWindow)();
    var style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function getTranslate(el) {
    var axis = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x";
    var window1 = (0, _ssrWindow.getWindow)();
    var matrix;
    var curTransform;
    var transformMatrix;
    var curStyle = getComputedStyle(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map(function(a) {
            return a.replace(",", ".");
        }).join(", ");
         // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function isObject(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend() {
    var _loop = function(i) {
        var nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
            var keysArray = Object.keys(Object(nextSource)).filter(function(key) {
                return noExtend.indexOf(key) < 0;
            });
            for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                var nextKey = keysArray[nextIndex];
                var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else extend(to[nextKey], nextSource[nextKey]);
                    } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else extend(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    };
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var to = Object(args[0]);
    var noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(var i = 1; i < args.length; i += 1)_loop(i);
    return to;
}
function setCSSProperty(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll(param) {
    var swiper = param.swiper, targetPosition = param.targetPosition, side = param.side;
    var window1 = (0, _ssrWindow.getWindow)();
    var startPosition = -swiper.translate;
    var startTime = null;
    var time;
    var duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    var dir = targetPosition > startPosition ? "next" : "prev";
    var isOutOfBound = function(current, target) {
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    var animate = function() {
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        var easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        var currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo((0, _definePropertyMjsDefault.default)({}, side, currentPosition));
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(function() {
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo((0, _definePropertyMjsDefault.default)({}, side, currentPosition));
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}

},{"@swc/helpers/src/_define_property.mjs":"eI7TS","ssr-window":"5Hbsc","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"aSsfJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSupport", function() {
    return getSupport;
});
var _ssrWindow = require("ssr-window");
var support;
function calcSupport() {
    var window = (0, _ssrWindow.getWindow)();
    var document = (0, _ssrWindow.getDocument)();
    return {
        smoothScroll: document.documentElement && "scrollBehavior" in document.documentElement.style,
        touch: !!("ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        passiveListener: function checkPassiveListener() {
            var supportsPassive = false;
            try {
                var opts = Object.defineProperty({}, "passive", {
                    // eslint-disable-next-line
                    get: function() {
                        supportsPassive = true;
                    }
                });
                window.addEventListener("testPassiveListener", null, opts);
            } catch (e) {}
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return "ongesturestart" in window;
        }()
    };
}
function getSupport() {
    if (!support) support = calcSupport();
    return support;
}

},{"ssr-window":"5Hbsc","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"krkN9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDevice", function() {
    return getDevice;
});
var _ssrWindow = require("ssr-window");
var _getSupportJs = require("./get-support.js");
var deviceCached;
function calcDevice() {
    var userAgent = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).userAgent;
    var support = (0, _getSupportJs.getSupport)();
    var window = (0, _ssrWindow.getWindow)();
    var platform = window.navigator.platform;
    var ua = userAgent || window.navigator.userAgent;
    var device = {
        ios: false,
        android: false
    };
    var screenWidth = window.screen.width;
    var screenHeight = window.screen.height;
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    var windows = platform === "Win32";
    var macos = platform === "MacIntel"; // iPadOs 13 fix
    var iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf("".concat(screenWidth, "x").concat(screenHeight)) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    } // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    } // Export object
    return device;
}
function getDevice() {
    var overrides = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!deviceCached) deviceCached = calcDevice(overrides);
    return deviceCached;
}

},{"ssr-window":"5Hbsc","./get-support.js":"aSsfJ","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"cVSnf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBrowser", function() {
    return getBrowser;
});
var _ssrWindow = require("ssr-window");
var browser;
function calcBrowser() {
    var isSafari = function isSafari() {
        var ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    };
    var window = (0, _ssrWindow.getWindow)();
    return {
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function getBrowser() {
    if (!browser) browser = calcBrowser();
    return browser;
}

},{"ssr-window":"5Hbsc","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"bIuFL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssrWindow = require("ssr-window");
function Resize(param) {
    var swiper = param.swiper, on = param.on, emit = param.emit;
    var window = (0, _ssrWindow.getWindow)();
    var observer = null;
    var resizeHandler = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    var createObserver = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver(function(entries) {
            var width = swiper.width, height = swiper.height;
            var newWidth = width;
            var newHeight = height;
            entries.forEach(function(param) {
                var contentBoxSize = param.contentBoxSize, contentRect = param.contentRect, target = param.target;
                if (target && target !== swiper.el) return;
                newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
            });
            if (newWidth !== width || newHeight !== height) resizeHandler();
        });
        observer.observe(swiper.el);
    };
    var removeObserver = function() {
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    var orientationChangeHandler = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", function() {
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window.addEventListener("resize", resizeHandler);
        window.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", function() {
        removeObserver();
        window.removeEventListener("resize", resizeHandler);
        window.removeEventListener("orientationchange", orientationChangeHandler);
    });
}
exports.default = Resize;

},{"ssr-window":"5Hbsc","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"eh66E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssrWindow = require("ssr-window");
function Observer(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var observers = [];
    var window = (0, _ssrWindow.getWindow)();
    var attach = function(target) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        var observer = new ObserverFunc(function(mutations) {
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            var observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    var init = function() {
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            var containerParents = swiper.$el.parents();
            for(var i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        } // Observe container
        attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
        attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    };
    var destroy = function() {
        observers.forEach(function(observer) {
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}
exports.default = Observer;

},{"ssr-window":"5Hbsc","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"6N8CM":[function(require,module,exports) {
/* eslint-disable no-underscore-dangle */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toConsumableArrayMjs = require("@swc/helpers/src/_to_consumable_array.mjs");
var _toConsumableArrayMjsDefault = parcelHelpers.interopDefault(_toConsumableArrayMjs);
exports.default = {
    on: function(events, handler, priority) {
        var self = this;
        if (typeof handler !== "function") return self;
        var method = priority ? "unshift" : "push";
        events.split(" ").forEach(function(event) {
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once: function(events, handler, priority) {
        var self = this;
        if (typeof handler !== "function") return self;
        function onceHandler() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny: function(handler, priority) {
        var self = this;
        if (typeof handler !== "function") return self;
        var method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny: function(handler) {
        var self = this;
        if (!self.eventsAnyListeners) return self;
        var index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off: function(events, handler) {
        var self = this;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach(function(event) {
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler, index) {
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var self = this;
        if (!self.eventsListeners) return self;
        var events;
        var data;
        var context;
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        var eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach(function(event) {
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach(function(eventHandler) {
                eventHandler.apply(context, [
                    event
                ].concat((0, _toConsumableArrayMjsDefault.default)(data)));
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler) {
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};

},{"@swc/helpers/src/_to_consumable_array.mjs":"11hUU","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"8THye":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _updateSizeJs = require("./updateSize.js");
var _updateSizeJsDefault = parcelHelpers.interopDefault(_updateSizeJs);
var _updateSlidesJs = require("./updateSlides.js");
var _updateSlidesJsDefault = parcelHelpers.interopDefault(_updateSlidesJs);
var _updateAutoHeightJs = require("./updateAutoHeight.js");
var _updateAutoHeightJsDefault = parcelHelpers.interopDefault(_updateAutoHeightJs);
var _updateSlidesOffsetJs = require("./updateSlidesOffset.js");
var _updateSlidesOffsetJsDefault = parcelHelpers.interopDefault(_updateSlidesOffsetJs);
var _updateSlidesProgressJs = require("./updateSlidesProgress.js");
var _updateSlidesProgressJsDefault = parcelHelpers.interopDefault(_updateSlidesProgressJs);
var _updateProgressJs = require("./updateProgress.js");
var _updateProgressJsDefault = parcelHelpers.interopDefault(_updateProgressJs);
var _updateSlidesClassesJs = require("./updateSlidesClasses.js");
var _updateSlidesClassesJsDefault = parcelHelpers.interopDefault(_updateSlidesClassesJs);
var _updateActiveIndexJs = require("./updateActiveIndex.js");
var _updateActiveIndexJsDefault = parcelHelpers.interopDefault(_updateActiveIndexJs);
var _updateClickedSlideJs = require("./updateClickedSlide.js");
var _updateClickedSlideJsDefault = parcelHelpers.interopDefault(_updateClickedSlideJs);
exports.default = {
    updateSize: (0, _updateSizeJsDefault.default),
    updateSlides: (0, _updateSlidesJsDefault.default),
    updateAutoHeight: (0, _updateAutoHeightJsDefault.default),
    updateSlidesOffset: (0, _updateSlidesOffsetJsDefault.default),
    updateSlidesProgress: (0, _updateSlidesProgressJsDefault.default),
    updateProgress: (0, _updateProgressJsDefault.default),
    updateSlidesClasses: (0, _updateSlidesClassesJsDefault.default),
    updateActiveIndex: (0, _updateActiveIndexJsDefault.default),
    updateClickedSlide: (0, _updateClickedSlideJsDefault.default)
};

},{"./updateSize.js":"5COug","./updateSlides.js":"huO8a","./updateAutoHeight.js":"8lE66","./updateSlidesOffset.js":"7B5qN","./updateSlidesProgress.js":"ybAaJ","./updateProgress.js":"f4iAd","./updateSlidesClasses.js":"61rMR","./updateActiveIndex.js":"itsgB","./updateClickedSlide.js":"dfB8K","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"5COug":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function updateSize() {
    var swiper = this;
    var width;
    var height;
    var $el = swiper.$el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
     // Subtract paddings
    width = width - parseInt($el.css("padding-left") || 0, 10) - parseInt($el.css("padding-right") || 0, 10);
    height = height - parseInt($el.css("padding-top") || 0, 10) - parseInt($el.css("padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
exports.default = updateSize;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"huO8a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _definePropertyMjs = require("@swc/helpers/src/_define_property.mjs");
var _definePropertyMjsDefault = parcelHelpers.interopDefault(_definePropertyMjs);
var _utilsJs = require("../../shared/utils.js");
function updateSlides() {
    var getDirectionLabel = function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
         // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    };
    var getDirectionPropertyValue = function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    };
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl, swiperSize = swiper.size, rtl = swiper.rtlTranslate, wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = $wrapperEl.children(".".concat(swiper.params.slideClass));
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];
    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.slidesGrid.length;
    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween; // reset margins
    if (rtl) slides.css({
        marginLeft: "",
        marginBottom: "",
        marginTop: ""
    });
    else slides.css({
        marginRight: "",
        marginBottom: "",
        marginTop: ""
    }); // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, _utilsJs.setCSSProperty)(swiper.wrapperEl, "--swiper-centered-offset-before", "");
        (0, _utilsJs.setCSSProperty)(swiper.wrapperEl, "--swiper-centered-offset-after", "");
    }
    var gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
     // Calc slides
    var slideSize;
    var shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter(function(key) {
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(var i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        var slide = slides.eq(i);
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slide.css("display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel("width")] = "";
            var slideStyles = getComputedStyle(slide[0]);
            var currentTransform = slide[0].style.transform;
            var currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = "none";
            if (currentWebKitTransform) slide[0].style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else {
                // eslint-disable-next-line
                var width = getDirectionPropertyValue(slideStyles, "width");
                var paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                var paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                var marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                var marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                var boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    var _slide_ = slide[0], clientWidth = _slide_.clientWidth, offsetWidth = _slide_.offsetWidth;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel("width")] = "".concat(slideSize, "px");
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) $wrapperEl.css({
        width: "".concat(swiper.virtualSize + params.spaceBetween, "px")
    });
    if (params.setWrapperSize) $wrapperEl.css((0, _definePropertyMjsDefault.default)({}, getDirectionLabel("width"), "".concat(swiper.virtualSize + params.spaceBetween, "px")));
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
     // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        var newSlidesGrid = [];
        for(var i1 = 0; i1 < snapGrid.length; i1 += 1){
            var slidesGridItem = snapGrid[i1];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i1] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        var key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
        slides.filter(function(_, slideIndex) {
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).css((0, _definePropertyMjsDefault.default)({}, key, "".concat(spaceBetween, "px")));
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        var allSlidesSize = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        var maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map(function(snap) {
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        var allSlidesSize1 = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize1 += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize1 -= params.spaceBetween;
        if (allSlidesSize1 < swiperSize) {
            var allSlidesOffset = (swiperSize - allSlidesSize1) / 2;
            snapGrid.forEach(function(snap, snapIndex) {
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach(function(snap, snapIndex) {
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, _utilsJs.setCSSProperty)(swiper.wrapperEl, "--swiper-centered-offset-before", "".concat(-snapGrid[0], "px"));
        (0, _utilsJs.setCSSProperty)(swiper.wrapperEl, "--swiper-centered-offset-after", "".concat(swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2, "px"));
        var addToSnapGrid = -swiper.snapGrid[0];
        var addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map(function(v) {
            return v + addToSnapGrid;
        });
        swiper.slidesGrid = swiper.slidesGrid.map(function(v) {
            return v + addToSlidesGrid;
        });
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
}
exports.default = updateSlides;

},{"@swc/helpers/src/_define_property.mjs":"eI7TS","../../shared/utils.js":"hHZfI","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"8lE66":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function updateAutoHeight(speed) {
    var swiper = this;
    var activeSlides = [];
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var newHeight = 0;
    var i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    var getSlideByIndex = function(index) {
        if (isVirtual) return swiper.slides.filter(function(el) {
            return parseInt(el.getAttribute("data-swiper-slide-index"), 10) === index;
        })[0];
        return swiper.slides.eq(index)[0];
    }; // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) swiper.visibleSlides.each(function(slide) {
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            var index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
     // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
     // Update Height
    if (newHeight || newHeight === 0) swiper.$wrapperEl.css("height", "".concat(newHeight, "px"));
}
exports.default = updateAutoHeight;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"7B5qN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function updateSlidesOffset() {
    var swiper = this;
    var slides = swiper.slides;
    for(var i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}
exports.default = updateSlidesOffset;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"ybAaJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function updateSlidesProgress() {
    var translate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this && this.translate || 0;
    var swiper = this;
    var params = swiper.params;
    var slides = swiper.slides, rtl = swiper.rtlTranslate, snapGrid = swiper.snapGrid;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    var offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(var i = 0; i < slides.length; i += 1){
        var slide = slides[i];
        var slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        var originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        var slideBefore = -(offsetCenter - slideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
    swiper.visibleSlides = (0, _domJsDefault.default)(swiper.visibleSlides);
}
exports.default = updateSlidesProgress;

},{"../../shared/dom.js":"aVcu8","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"f4iAd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function updateProgress(translate) {
    var swiper = this;
    if (typeof translate === "undefined") {
        var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    var params = swiper.params;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress, isBeginning = swiper.isBeginning, isEnd = swiper.isEnd;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}
exports.default = updateProgress;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"61rMR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function updateSlidesClasses() {
    var swiper = this;
    var slides = swiper.slides, params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex, realIndex = swiper.realIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass("".concat(params.slideActiveClass, " ").concat(params.slideNextClass, " ").concat(params.slidePrevClass, " ").concat(params.slideDuplicateActiveClass, " ").concat(params.slideDuplicateNextClass, " ").concat(params.slideDuplicatePrevClass));
    var activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find(".".concat(params.slideClass, '[data-swiper-slide-index="').concat(activeIndex, '"]'));
    else activeSlide = slides.eq(activeIndex);
     // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ')[data-swiper-slide-index="').concat(realIndex, '"]')).addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, '[data-swiper-slide-index="').concat(realIndex, '"]')).addClass(params.slideDuplicateActiveClass);
    } // Next Slide
    var nextSlide = activeSlide.nextAll(".".concat(params.slideClass)).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    } // Prev Slide
    var prevSlide = activeSlide.prevAll(".".concat(params.slideClass)).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ')[data-swiper-slide-index="').concat(nextSlide.attr("data-swiper-slide-index"), '"]')).addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, '[data-swiper-slide-index="').concat(nextSlide.attr("data-swiper-slide-index"), '"]')).addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ')[data-swiper-slide-index="').concat(prevSlide.attr("data-swiper-slide-index"), '"]')).addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, '[data-swiper-slide-index="').concat(prevSlide.attr("data-swiper-slide-index"), '"]')).addClass(params.slideDuplicatePrevClass);
    }
    swiper.emitSlidesClasses();
}
exports.default = updateSlidesClasses;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"itsgB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function updateActiveIndex(newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var slidesGrid = swiper.slidesGrid, snapGrid = swiper.snapGrid, params = swiper.params, previousIndex = swiper.activeIndex, previousRealIndex = swiper.realIndex, previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    if (typeof activeIndex === "undefined") {
        for(var i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== "undefined") {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        } // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        return;
    } // Get real index
    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr("data-swiper-slide-index") || activeIndex, 10);
    Object.assign(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit("slideChange");
}
exports.default = updateActiveIndex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"dfB8K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function updateClickedSlide(e) {
    var swiper = this;
    var params = swiper.params;
    var slide = (0, _domJsDefault.default)(e).closest(".".concat(params.slideClass))[0];
    var slideFound = false;
    var slideIndex;
    if (slide) {
        for(var i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, _domJsDefault.default)(slide).attr("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
exports.default = updateClickedSlide;

},{"../../shared/dom.js":"aVcu8","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"dNGDM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getTranslateJs = require("./getTranslate.js");
var _getTranslateJsDefault = parcelHelpers.interopDefault(_getTranslateJs);
var _setTranslateJs = require("./setTranslate.js");
var _setTranslateJsDefault = parcelHelpers.interopDefault(_setTranslateJs);
var _minTranslateJs = require("./minTranslate.js");
var _minTranslateJsDefault = parcelHelpers.interopDefault(_minTranslateJs);
var _maxTranslateJs = require("./maxTranslate.js");
var _maxTranslateJsDefault = parcelHelpers.interopDefault(_maxTranslateJs);
var _translateToJs = require("./translateTo.js");
var _translateToJsDefault = parcelHelpers.interopDefault(_translateToJs);
exports.default = {
    getTranslate: (0, _getTranslateJsDefault.default),
    setTranslate: (0, _setTranslateJsDefault.default),
    minTranslate: (0, _minTranslateJsDefault.default),
    maxTranslate: (0, _maxTranslateJsDefault.default),
    translateTo: (0, _translateToJsDefault.default)
};

},{"./getTranslate.js":"j7QyQ","./setTranslate.js":"1oMF3","./minTranslate.js":"cIkoD","./maxTranslate.js":"fYguc","./translateTo.js":"4AoVY","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"j7QyQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../../shared/utils.js");
function getSwiperTranslate() {
    var axis = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.isHorizontal() ? "x" : "y";
    var swiper = this;
    var params = swiper.params, rtl = swiper.rtlTranslate, translate = swiper.translate, $wrapperEl = swiper.$wrapperEl;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    var currentTranslate = (0, _utilsJs.getTranslate)($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
exports.default = getSwiperTranslate;

},{"../../shared/utils.js":"hHZfI","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"1oMF3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function setTranslate(translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate, params = swiper.params, $wrapperEl = swiper.$wrapperEl, wrapperEl = swiper.wrapperEl, progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) $wrapperEl.transform("translate3d(".concat(x, "px, ").concat(y, "px, ").concat(z, "px)"));
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}
exports.default = setTranslate;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"cIkoD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function minTranslate() {
    return -this.snapGrid[0];
}
exports.default = minTranslate;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"fYguc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
exports.default = maxTranslate;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"4AoVY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _definePropertyMjs = require("@swc/helpers/src/_define_property.mjs");
var _definePropertyMjsDefault = parcelHelpers.interopDefault(_definePropertyMjs);
var _utilsJs = require("../../shared/utils.js");
function translateTo() {
    var translate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, translateBounds = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, internal = arguments.length > 4 ? arguments[4] : void 0;
    var swiper = this;
    var params = swiper.params, wrapperEl = swiper.wrapperEl;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    var minTranslate = swiper.minTranslate();
    var maxTranslate = swiper.maxTranslate();
    var newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate; // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, _utilsJs.animateCSSModeScroll)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            var _obj;
            wrapperEl.scrollTo((_obj = {}, (0, _definePropertyMjsDefault.default)(_obj, isH ? "left" : "top", -newTranslate), (0, _definePropertyMjsDefault.default)(_obj, "behavior", "smooth"), _obj));
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
exports.default = translateTo;

},{"@swc/helpers/src/_define_property.mjs":"eI7TS","../../shared/utils.js":"hHZfI","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"cH6zZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setTransitionJs = require("./setTransition.js");
var _setTransitionJsDefault = parcelHelpers.interopDefault(_setTransitionJs);
var _transitionStartJs = require("./transitionStart.js");
var _transitionStartJsDefault = parcelHelpers.interopDefault(_transitionStartJs);
var _transitionEndJs = require("./transitionEnd.js");
var _transitionEndJsDefault = parcelHelpers.interopDefault(_transitionEndJs);
exports.default = {
    setTransition: (0, _setTransitionJsDefault.default),
    transitionStart: (0, _transitionStartJsDefault.default),
    transitionEnd: (0, _transitionEndJsDefault.default)
};

},{"./setTransition.js":"5I5BT","./transitionStart.js":"5X9Mk","./transitionEnd.js":"2XvbQ","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"5I5BT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function setTransition(duration, byController) {
    var swiper = this;
    if (!swiper.params.cssMode) swiper.$wrapperEl.transition(duration);
    swiper.emit("setTransition", duration, byController);
}
exports.default = setTransition;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"5X9Mk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _transitionEmitJs = require("./transitionEmit.js");
var _transitionEmitJsDefault = parcelHelpers.interopDefault(_transitionEmitJs);
function transitionStart() {
    var runCallbacks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, direction = arguments.length > 1 ? arguments[1] : void 0;
    var swiper = this;
    var params = swiper.params;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    (0, _transitionEmitJsDefault.default)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}
exports.default = transitionStart;

},{"./transitionEmit.js":"mm1ii","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"mm1ii":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function transitionEmit(param) {
    var swiper = param.swiper, runCallbacks = param.runCallbacks, direction = param.direction, step = param.step;
    var activeIndex = swiper.activeIndex, previousIndex = swiper.previousIndex;
    var dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit("transition".concat(step));
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit("slideResetTransition".concat(step));
            return;
        }
        swiper.emit("slideChangeTransition".concat(step));
        if (dir === "next") swiper.emit("slideNextTransition".concat(step));
        else swiper.emit("slidePrevTransition".concat(step));
    }
}
exports.default = transitionEmit;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"2XvbQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _transitionEmitJs = require("./transitionEmit.js");
var _transitionEmitJsDefault = parcelHelpers.interopDefault(_transitionEmitJs);
function transitionEnd() {
    var runCallbacks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, direction = arguments.length > 1 ? arguments[1] : void 0;
    var swiper = this;
    var params = swiper.params;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    (0, _transitionEmitJsDefault.default)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}
exports.default = transitionEnd;

},{"./transitionEmit.js":"mm1ii","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"90s6V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slideToJs = require("./slideTo.js");
var _slideToJsDefault = parcelHelpers.interopDefault(_slideToJs);
var _slideToLoopJs = require("./slideToLoop.js");
var _slideToLoopJsDefault = parcelHelpers.interopDefault(_slideToLoopJs);
var _slideNextJs = require("./slideNext.js");
var _slideNextJsDefault = parcelHelpers.interopDefault(_slideNextJs);
var _slidePrevJs = require("./slidePrev.js");
var _slidePrevJsDefault = parcelHelpers.interopDefault(_slidePrevJs);
var _slideResetJs = require("./slideReset.js");
var _slideResetJsDefault = parcelHelpers.interopDefault(_slideResetJs);
var _slideToClosestJs = require("./slideToClosest.js");
var _slideToClosestJsDefault = parcelHelpers.interopDefault(_slideToClosestJs);
var _slideToClickedSlideJs = require("./slideToClickedSlide.js");
var _slideToClickedSlideJsDefault = parcelHelpers.interopDefault(_slideToClickedSlideJs);
exports.default = {
    slideTo: (0, _slideToJsDefault.default),
    slideToLoop: (0, _slideToLoopJsDefault.default),
    slideNext: (0, _slideNextJsDefault.default),
    slidePrev: (0, _slidePrevJsDefault.default),
    slideReset: (0, _slideResetJsDefault.default),
    slideToClosest: (0, _slideToClosestJsDefault.default),
    slideToClickedSlide: (0, _slideToClickedSlideJsDefault.default)
};

},{"./slideTo.js":"4Tnj7","./slideToLoop.js":"dzNch","./slideNext.js":"1jq34","./slidePrev.js":"72nBQ","./slideReset.js":"4ISta","./slideToClosest.js":"evJuT","./slideToClickedSlide.js":"kxs9S","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"4Tnj7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _definePropertyMjs = require("@swc/helpers/src/_define_property.mjs");
var _definePropertyMjsDefault = parcelHelpers.interopDefault(_definePropertyMjs);
var _typeOfMjs = require("@swc/helpers/src/_type_of.mjs");
var _typeOfMjsDefault = parcelHelpers.interopDefault(_typeOfMjs);
var _utilsJs = require("../../shared/utils.js");
function slideTo() {
    var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, internal = arguments.length > 3 ? arguments[3] : void 0, initial = arguments.length > 4 ? arguments[4] : void 0;
    if (typeof index !== "number" && typeof index !== "string") throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [".concat(typeof index === "undefined" ? "undefined" : (0, _typeOfMjsDefault.default)(index), "] given."));
    if (typeof index === "string") {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ var indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ var isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [".concat(index, "] given."));
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, previousIndex = swiper.previousIndex, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate, wrapperEl = swiper.wrapperEl, enabled = swiper.enabled;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    var translate = -snapGrid[snapIndex]; // Update progress
    swiper.updateProgress(translate); // Normalize slideIndex
    if (params.normalizeSlideIndex) for(var i = 0; i < slidesGrid.length; i += 1){
        var normalizedTranslate = -Math.floor(translate * 100);
        var normalizedGrid = Math.floor(slidesGrid[i] * 100);
        var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
     // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    var direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset"; // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        var t = rtl ? translate : -translate;
        if (speed === 0) {
            var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(function() {
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._swiperImmediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, _utilsJs.animateCSSModeScroll)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            var _obj;
            wrapperEl.scrollTo((_obj = {}, (0, _definePropertyMjsDefault.default)(_obj, isH ? "left" : "top", t), (0, _definePropertyMjsDefault.default)(_obj, "behavior", "smooth"), _obj));
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
exports.default = slideTo;

},{"@swc/helpers/src/_define_property.mjs":"eI7TS","@swc/helpers/src/_type_of.mjs":"52Yae","../../shared/utils.js":"hHZfI","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"dzNch":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function slideToLoop() {
    var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, internal = arguments.length > 3 ? arguments[3] : void 0;
    var swiper = this;
    var newIndex = index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
exports.default = slideToLoop;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"1jq34":[function(require,module,exports) {
/* eslint no-unused-vars: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function slideNext() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var swiper = this;
    var animating = swiper.animating, enabled = swiper.enabled, params = swiper.params;
    if (!enabled) return swiper;
    var perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
exports.default = slideNext;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"72nBQ":[function(require,module,exports) {
/* eslint no-unused-vars: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function slidePrev() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var normalize = function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    };
    var swiper = this;
    var params = swiper.params, animating = swiper.animating, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return swiper;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function(val) {
        return normalize(val);
    });
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        var prevSnapIndex;
        snapGrid.forEach(function(snap, snapIndex) {
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    var prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) return swiper.slideTo(swiper.slides.length - 1, speed, runCallbacks, internal);
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
exports.default = slidePrev;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"4ISta":[function(require,module,exports) {
/* eslint no-unused-vars: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function slideReset() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
exports.default = slideReset;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"evJuT":[function(require,module,exports) {
/* eslint no-unused-vars: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function slideToClosest() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0, threshold = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5;
    var swiper = this;
    var index = swiper.activeIndex;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        var currentSnap = swiper.snapGrid[snapIndex];
        var nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        var prevSnap = swiper.snapGrid[snapIndex - 1];
        var currentSnap1 = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap1 - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
exports.default = slideToClosest;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"kxs9S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _utilsJs = require("../../shared/utils.js");
function slideToClickedSlide() {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl;
    var slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, _domJsDefault.default)(swiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children(".".concat(params.slideClass, '[data-swiper-slide-index="').concat(realIndex, '"]:not(.').concat(params.slideDuplicateClass, ")")).eq(0).index();
                (0, _utilsJs.nextTick)(function() {
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children(".".concat(params.slideClass, '[data-swiper-slide-index="').concat(realIndex, '"]:not(.').concat(params.slideDuplicateClass, ")")).eq(0).index();
            (0, _utilsJs.nextTick)(function() {
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
exports.default = slideToClickedSlide;

},{"../../shared/dom.js":"aVcu8","../../shared/utils.js":"hHZfI","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"9kTyL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loopCreateJs = require("./loopCreate.js");
var _loopCreateJsDefault = parcelHelpers.interopDefault(_loopCreateJs);
var _loopFixJs = require("./loopFix.js");
var _loopFixJsDefault = parcelHelpers.interopDefault(_loopFixJs);
var _loopDestroyJs = require("./loopDestroy.js");
var _loopDestroyJsDefault = parcelHelpers.interopDefault(_loopDestroyJs);
exports.default = {
    loopCreate: (0, _loopCreateJsDefault.default),
    loopFix: (0, _loopFixJsDefault.default),
    loopDestroy: (0, _loopDestroyJsDefault.default)
};

},{"./loopCreate.js":"do9vu","./loopFix.js":"f227a","./loopDestroy.js":"8Nm1S","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"do9vu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function loopCreate() {
    var swiper = this;
    var document = (0, _ssrWindow.getDocument)();
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides
    var $selector = $wrapperEl.children().length > 0 ? (0, _domJsDefault.default)($wrapperEl.children()[0].parentNode) : $wrapperEl;
    $selector.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass)).remove();
    var slides = $selector.children(".".concat(params.slideClass));
    if (params.loopFillGroupWithBlank) {
        var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(var i = 0; i < blankSlidesNum; i += 1){
                var blankNode = (0, _domJsDefault.default)(document.createElement("div")).addClass("".concat(params.slideClass, " ").concat(params.slideBlankClass));
                $selector.append(blankNode);
            }
            slides = $selector.children(".".concat(params.slideClass));
        }
    }
    if (params.slidesPerView === "auto" && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) swiper.loopedSlides = slides.length;
    var prependSlides = [];
    var appendSlides = [];
    slides.each(function(el, index) {
        var slide = (0, _domJsDefault.default)(el);
        if (index < swiper.loopedSlides) appendSlides.push(el);
        if (index < slides.length && index >= slides.length - swiper.loopedSlides) prependSlides.push(el);
        slide.attr("data-swiper-slide-index", index);
    });
    for(var i1 = 0; i1 < appendSlides.length; i1 += 1)$selector.append((0, _domJsDefault.default)(appendSlides[i1].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(var i2 = prependSlides.length - 1; i2 >= 0; i2 -= 1)$selector.prepend((0, _domJsDefault.default)(prependSlides[i2].cloneNode(true)).addClass(params.slideDuplicateClass));
}
exports.default = loopCreate;

},{"ssr-window":"5Hbsc","../../shared/dom.js":"aVcu8","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"f227a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function loopFix() {
    var swiper = this;
    swiper.emit("beforeLoopFix");
    var activeIndex = swiper.activeIndex, slides = swiper.slides, loopedSlides = swiper.loopedSlides, allowSlidePrev = swiper.allowSlidePrev, allowSlideNext = swiper.allowSlideNext, snapGrid = swiper.snapGrid, rtl = swiper.rtlTranslate;
    var newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    var snapTranslate = -snapGrid[activeIndex];
    var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        var slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        var slideChanged1 = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged1 && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit("loopFix");
}
exports.default = loopFix;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"8Nm1S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function loopDestroy() {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params, slides = swiper.slides;
    $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, ",.").concat(params.slideClass, ".").concat(params.slideBlankClass)).remove();
    slides.removeAttr("data-swiper-slide-index");
}
exports.default = loopDestroy;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"2bPoH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setGrabCursorJs = require("./setGrabCursor.js");
var _setGrabCursorJsDefault = parcelHelpers.interopDefault(_setGrabCursorJs);
var _unsetGrabCursorJs = require("./unsetGrabCursor.js");
var _unsetGrabCursorJsDefault = parcelHelpers.interopDefault(_unsetGrabCursorJs);
exports.default = {
    setGrabCursor: (0, _setGrabCursorJsDefault.default),
    unsetGrabCursor: (0, _unsetGrabCursorJsDefault.default)
};

},{"./setGrabCursor.js":"3IVkT","./unsetGrabCursor.js":"7Z15t","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"3IVkT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function setGrabCursor(moving) {
    var swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    var el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    el.style.cursor = "move";
    el.style.cursor = moving ? "-webkit-grabbing" : "-webkit-grab";
    el.style.cursor = moving ? "-moz-grabbin" : "-moz-grab";
    el.style.cursor = moving ? "grabbing" : "grab";
}
exports.default = setGrabCursor;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"7Z15t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function unsetGrabCursor() {
    var swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
}
exports.default = unsetGrabCursor;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"71xhJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssrWindow = require("ssr-window");
var _onTouchStartJs = require("./onTouchStart.js");
var _onTouchStartJsDefault = parcelHelpers.interopDefault(_onTouchStartJs);
var _onTouchMoveJs = require("./onTouchMove.js");
var _onTouchMoveJsDefault = parcelHelpers.interopDefault(_onTouchMoveJs);
var _onTouchEndJs = require("./onTouchEnd.js");
var _onTouchEndJsDefault = parcelHelpers.interopDefault(_onTouchEndJs);
var _onResizeJs = require("./onResize.js");
var _onResizeJsDefault = parcelHelpers.interopDefault(_onResizeJs);
var _onClickJs = require("./onClick.js");
var _onClickJsDefault = parcelHelpers.interopDefault(_onClickJs);
var _onScrollJs = require("./onScroll.js");
var _onScrollJsDefault = parcelHelpers.interopDefault(_onScrollJs);
var dummyEventAttached = false;
function dummyEventListener() {}
var events = function(swiper, method) {
    var document = (0, _ssrWindow.getDocument)();
    var params = swiper.params, touchEvents = swiper.touchEvents, el = swiper.el, wrapperEl = swiper.wrapperEl, device = swiper.device, support = swiper.support;
    var capture = !!params.nested;
    var domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    var swiperMethod = method; // Touch Events
    if (!support.touch) {
        el[domMethod](touchEvents.start, swiper.onTouchStart, false);
        document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
        document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
    } else {
        var passiveListener = touchEvents.start === "touchstart" && support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
        el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
            passive: false,
            capture: capture
        } : capture);
        el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
     // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", (0, _onResizeJsDefault.default), true);
    else swiper[swiperMethod]("observerUpdate", (0, _onResizeJsDefault.default), true);
};
function attachEvents() {
    var swiper = this;
    var document = (0, _ssrWindow.getDocument)();
    var params = swiper.params, support = swiper.support;
    swiper.onTouchStart = (0, _onTouchStartJsDefault.default).bind(swiper);
    swiper.onTouchMove = (0, _onTouchMoveJsDefault.default).bind(swiper);
    swiper.onTouchEnd = (0, _onTouchEndJsDefault.default).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, _onScrollJsDefault.default).bind(swiper);
    swiper.onClick = (0, _onClickJsDefault.default).bind(swiper);
    if (support.touch && !dummyEventAttached) {
        document.addEventListener("touchstart", dummyEventListener);
        dummyEventAttached = true;
    }
    events(swiper, "on");
}
function detachEvents() {
    var swiper = this;
    events(swiper, "off");
}
exports.default = {
    attachEvents: attachEvents,
    detachEvents: detachEvents
};

},{"ssr-window":"5Hbsc","./onTouchStart.js":"9LVtw","./onTouchMove.js":"lFIu7","./onTouchEnd.js":"cK4yk","./onResize.js":"3eFl1","./onClick.js":"kJ0sV","./onScroll.js":"jyCWn","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"9LVtw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _utilsJs = require("../../shared/utils.js"); // Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function closestElement(selector) {
    var base = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
    function __closestFrom(el) {
        if (!el || el === (0, _ssrWindow.getDocument)() || el === (0, _ssrWindow.getWindow)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        var found = el.closest(selector);
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function onTouchStart(event) {
    var swiper = this;
    var document = (0, _ssrWindow.getDocument)();
    var window = (0, _ssrWindow.getWindow)();
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, enabled = swiper.enabled;
    if (!enabled) return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    var $targetEl = (0, _domJsDefault.default)(e.target);
    if (params.touchEventsTarget === "wrapper") {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === "touchstart";
    if (!data.isTouchEvent && "which" in e && e.which === 3) return;
    if (!data.isTouchEvent && "button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component
    var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) $targetEl = (0, _domJsDefault.default)(event.path[0]);
    var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : ".".concat(params.noSwipingClass);
    var isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, e.target) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, _utilsJs.now)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== "touchstart") {
        var preventDefault = true;
        if ($targetEl.is(data.focusableElements)) preventDefault = false;
        if (document.activeElement && (0, _domJsDefault.default)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) document.activeElement.blur();
        var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) e.preventDefault();
    }
    swiper.emit("touchStart", e);
}
exports.default = onTouchStart;

},{"ssr-window":"5Hbsc","../../shared/dom.js":"aVcu8","../../shared/utils.js":"hHZfI","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"lFIu7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _utilsJs = require("../../shared/utils.js");
function onTouchMove(event) {
    var document = (0, _ssrWindow.getDocument)();
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    if (data.isTouchEvent && e.type !== "touchmove") return;
    var targetTouch = e.type === "touchmove" && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    var pageX = e.type === "touchmove" ? targetTouch.pageX : e.pageX;
    var pageY = e.type === "touchmove" ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        // isMoved = true;
        swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, _utilsJs.now)();
        }
        return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && (0, _domJsDefault.default)(e.target).is(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        var touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!data.isMoved) {
        if (params.loop && !params.cssMode) swiper.loopFix();
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger("webkitTransitionEnd transitionend");
        data.allowMomentumBounce = false; // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    var diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    data.currentTranslate = diff + data.startTranslate;
    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
     // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
     // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
     // Update progress
    swiper.updateProgress(data.currentTranslate); // Update translate
    swiper.setTranslate(data.currentTranslate);
}
exports.default = onTouchMove;

},{"ssr-window":"5Hbsc","../../shared/dom.js":"aVcu8","../../shared/utils.js":"hHZfI","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"cK4yk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../../shared/utils.js");
function onTouchEnd(event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, slidesGrid = swiper.slidesGrid, enabled = swiper.enabled;
    if (!enabled) return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    } // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
     // Time diff
    var touchEndTime = (0, _utilsJs.now)();
    var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
    if (swiper.allowClick) {
        var pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, _utilsJs.now)();
    (0, _utilsJs.nextTick)(function() {
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    var currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (swiper.params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    } // Find current slide
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for(var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        var increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    } // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    var increment1 = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment1);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment1);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(stopIndex + increment1);
            if (swiper.swipeDirection === "prev") swiper.slideTo(stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment1);
        else swiper.slideTo(stopIndex);
    }
}
exports.default = onTouchEnd;

},{"../../shared/utils.js":"hHZfI","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"3eFl1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function onResize() {
    var swiper = this;
    var params = swiper.params, el = swiper.el;
    if (el && el.offsetWidth === 0) return; // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
     // Save locks
    var allowSlideNext = swiper.allowSlideNext, allowSlidePrev = swiper.allowSlidePrev, snapGrid = swiper.snapGrid; // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
     // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
exports.default = onResize;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"kJ0sV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function onClick(e) {
    var swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
exports.default = onClick;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"jyCWn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function onScroll() {
    var swiper = this;
    var wrapperEl = swiper.wrapperEl, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
     // eslint-disable-next-line
    if (swiper.translate === -0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}
exports.default = onScroll;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"5pCoc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setBreakpointJs = require("./setBreakpoint.js");
var _setBreakpointJsDefault = parcelHelpers.interopDefault(_setBreakpointJs);
var _getBreakpointJs = require("./getBreakpoint.js");
var _getBreakpointJsDefault = parcelHelpers.interopDefault(_getBreakpointJs);
exports.default = {
    setBreakpoint: (0, _setBreakpointJsDefault.default),
    getBreakpoint: (0, _getBreakpointJsDefault.default)
};

},{"./setBreakpoint.js":"4mg2z","./getBreakpoint.js":"jN0Fm","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"4mg2z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../../shared/utils.js");
var isGridEnabled = function(swiper, params) {
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
    var swiper = this;
    var activeIndex = swiper.activeIndex, initialized = swiper.initialized, _swiper_loopedSlides = swiper.loopedSlides, loopedSlides = _swiper_loopedSlides === void 0 ? 0 : _swiper_loopedSlides, params = swiper.params, $el = swiper.$el;
    var breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    var breakpointParams = breakpointOnlyParams || swiper.originalParams;
    var wasMultiRow = isGridEnabled(swiper, params);
    var isMultiRow = isGridEnabled(swiper, breakpointParams);
    var wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        $el.removeClass("".concat(params.containerModifierClass, "grid ").concat(params.containerModifierClass, "grid-column"));
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        $el.addClass("".concat(params.containerModifierClass, "grid"));
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") $el.addClass("".concat(params.containerModifierClass, "grid-column"));
        swiper.emitContainerClasses();
    }
    var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, _utilsJs.extend)(swiper.params, breakpointParams);
    var isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit("breakpoint", breakpointParams);
}
exports.default = setBreakpoint;

},{"../../shared/utils.js":"hHZfI","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"jN0Fm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssrWindow = require("ssr-window");
function getBreakpoint(breakpoints) {
    var base = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "window", containerEl = arguments.length > 2 ? arguments[2] : void 0;
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    var breakpoint = false;
    var window = (0, _ssrWindow.getWindow)();
    var currentHeight = base === "window" ? window.innerHeight : containerEl.clientHeight;
    var points = Object.keys(breakpoints).map(function(point) {
        if (typeof point === "string" && point.indexOf("@") === 0) {
            var minRatio = parseFloat(point.substr(1));
            var value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort(function(a, b) {
        return parseInt(a.value, 10) - parseInt(b.value, 10);
    });
    for(var i = 0; i < points.length; i += 1){
        var _points_i = points[i], point = _points_i.point, value = _points_i.value;
        if (base === "window") {
            if (window.matchMedia("(min-width: ".concat(value, "px)")).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}
exports.default = getBreakpoint;

},{"ssr-window":"5Hbsc","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"igaba":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _addClassesJs = require("./addClasses.js");
var _addClassesJsDefault = parcelHelpers.interopDefault(_addClassesJs);
var _removeClassesJs = require("./removeClasses.js");
var _removeClassesJsDefault = parcelHelpers.interopDefault(_removeClassesJs);
exports.default = {
    addClasses: (0, _addClassesJsDefault.default),
    removeClasses: (0, _removeClassesJsDefault.default)
};

},{"./addClasses.js":"dEehq","./removeClasses.js":"3m4kn","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"dEehq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toConsumableArrayMjs = require("@swc/helpers/src/_to_consumable_array.mjs");
var _toConsumableArrayMjsDefault = parcelHelpers.interopDefault(_toConsumableArrayMjs);
function prepareClasses(entries, prefix) {
    var resultClasses = [];
    entries.forEach(function(item) {
        if (typeof item === "object") Object.keys(item).forEach(function(classNames) {
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function addClasses() {
    var _classNames;
    var swiper = this;
    var classNames = swiper.classNames, params = swiper.params, rtl = swiper.rtl, $el = swiper.$el, device = swiper.device, support = swiper.support; // prettier-ignore
    var suffixes = prepareClasses([
        "initialized",
        params.direction,
        {
            "pointer-events": !support.touch
        },
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        }
    ], params.containerModifierClass);
    (_classNames = classNames).push.apply(_classNames, (0, _toConsumableArrayMjsDefault.default)(suffixes));
    $el.addClass((0, _toConsumableArrayMjsDefault.default)(classNames).join(" "));
    swiper.emitContainerClasses();
}
exports.default = addClasses;

},{"@swc/helpers/src/_to_consumable_array.mjs":"11hUU","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"3m4kn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function removeClasses() {
    var swiper = this;
    var $el = swiper.$el, classNames = swiper.classNames;
    $el.removeClass(classNames.join(" "));
    swiper.emitContainerClasses();
}
exports.default = removeClasses;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"7So8v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loadImageJs = require("./loadImage.js");
var _loadImageJsDefault = parcelHelpers.interopDefault(_loadImageJs);
var _preloadImagesJs = require("./preloadImages.js");
var _preloadImagesJsDefault = parcelHelpers.interopDefault(_preloadImagesJs);
exports.default = {
    loadImage: (0, _loadImageJsDefault.default),
    preloadImages: (0, _preloadImagesJsDefault.default)
};

},{"./loadImage.js":"jnCjM","./preloadImages.js":"5cp5P","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"jnCjM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
    var onReady = function onReady() {
        if (callback) callback();
    };
    var window = (0, _ssrWindow.getWindow)();
    var image;
    var isPicture = (0, _domJsDefault.default)(imageEl).parent("picture")[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new window.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}
exports.default = loadImage;

},{"ssr-window":"5Hbsc","../../shared/dom.js":"aVcu8","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"5cp5P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function preloadImages() {
    var onReady = function onReady() {
        if (typeof swiper === "undefined" || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit("imagesReady");
        }
    };
    var swiper = this;
    swiper.imagesToLoad = swiper.$el.find("img");
    for(var i = 0; i < swiper.imagesToLoad.length; i += 1){
        var imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute("src"), imageEl.srcset || imageEl.getAttribute("srcset"), imageEl.sizes || imageEl.getAttribute("sizes"), true, onReady);
    }
}
exports.default = preloadImages;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"5kwpO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function checkOverflow() {
    var swiper = this;
    var wasLocked = swiper.isLocked, params = swiper.params;
    var slidesOffsetBefore = params.slidesOffsetBefore;
    if (slidesOffsetBefore) {
        var lastSlideIndex = swiper.slides.length - 1;
        var lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
exports.default = {
    checkOverflow: checkOverflow
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"hrwih":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    init: true,
    direction: "horizontal",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-invisible-blank",
    slideActiveClass: "swiper-slide-active",
    slideDuplicateActiveClass: "swiper-slide-duplicate-active",
    slideVisibleClass: "swiper-slide-visible",
    slideDuplicateClass: "swiper-slide-duplicate",
    slideNextClass: "swiper-slide-next",
    slideDuplicateNextClass: "swiper-slide-duplicate-next",
    slidePrevClass: "swiper-slide-prev",
    slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
    wrapperClass: "swiper-wrapper",
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"dIXAb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../shared/utils.js");
function moduleExtendParams(params, allModulesParams) {
    return function extendParams() {
        var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var moduleParamName = Object.keys(obj)[0];
        var moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, _utilsJs.extend)(allModulesParams, obj);
            return;
        }
        if ([
            "navigation",
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, _utilsJs.extend)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, _utilsJs.extend)(allModulesParams, obj);
    };
}
exports.default = moduleExtendParams;

},{"../shared/utils.js":"hHZfI","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"crsUO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _utilsJs = require("../../shared/utils.js");
function Virtual(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    var renderSlide = function renderSlide(slide, index) {
        var params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        var $slideEl = params.renderSlide ? (0, _domJsDefault.default)(params.renderSlide.call(swiper, slide, index)) : (0, _domJsDefault.default)('<div class="'.concat(swiper.params.slideClass, '" data-swiper-slide-index="').concat(index, '">').concat(slide, "</div>"));
        if (!$slideEl.attr("data-swiper-slide-index")) $slideEl.attr("data-swiper-slide-index", index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    };
    var update = function update(force) {
        var _swiper_params = swiper.params, slidesPerView = _swiper_params.slidesPerView, slidesPerGroup = _swiper_params.slidesPerGroup, centeredSlides = _swiper_params.centeredSlides;
        var _swiper_params_virtual = swiper.params.virtual, addSlidesBefore = _swiper_params_virtual.addSlidesBefore, addSlidesAfter = _swiper_params_virtual.addSlidesAfter;
        var _swiper_virtual = swiper.virtual, previousFrom = _swiper_virtual.from, previousTo = _swiper_virtual.to, slides = _swiper_virtual.slides, previousSlidesGrid = _swiper_virtual.slidesGrid, previousOffset = _swiper_virtual.offset;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        var activeIndex = swiper.activeIndex || 0;
        var offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        var slidesAfter;
        var slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = slidesPerGroup + addSlidesBefore;
        }
        var from = Math.max((activeIndex || 0) - slidesBefore, 0);
        var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.css(offsetProp, "".concat(offset, "px"));
            swiper.updateProgress();
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    var slidesToRender = [];
                    for(var i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            return;
        }
        var prependIndexes = [];
        var appendIndexes = [];
        if (force) swiper.$wrapperEl.find(".".concat(swiper.params.slideClass)).remove();
        else {
            for(var i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) swiper.$wrapperEl.find(".".concat(swiper.params.slideClass, '[data-swiper-slide-index="').concat(i, '"]')).remove();
        }
        for(var i1 = 0; i1 < slides.length; i1 += 1)if (i1 >= from && i1 <= to) {
            if (typeof previousTo === "undefined" || force) appendIndexes.push(i1);
            else {
                if (i1 > previousTo) appendIndexes.push(i1);
                if (i1 < previousFrom) prependIndexes.push(i1);
            }
        }
        appendIndexes.forEach(function(index) {
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort(function(a, b) {
            return b - a;
        }).forEach(function(index) {
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children(".swiper-slide").css(offsetProp, "".concat(offset, "px"));
        onRendered();
    };
    var appendSlide = function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    };
    var prependSlide = function prependSlide(slides) {
        var activeIndex = swiper.activeIndex;
        var newActiveIndex = activeIndex + 1;
        var numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            var cache = swiper.virtual.cache;
            var newCache = {};
            Object.keys(cache).forEach(function(cachedIndex) {
                var $cachedEl = cache[cachedIndex];
                var cachedElIndex = $cachedEl.attr("data-swiper-slide-index");
                if (cachedElIndex) $cachedEl.attr("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    };
    var removeSlide = function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        var activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(var i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    };
    var removeAllSlides = function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    };
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    var cssModeTimeout;
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    on("beforeInit", function() {
        if (!swiper.params.virtual.enabled) return;
        swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass, "virtual"));
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on("setTranslate", function() {
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(function() {
                update();
            }, 100);
        } else update();
    });
    on("init update resize", function() {
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, _utilsJs.setCSSProperty)(swiper.wrapperEl, "--swiper-virtual-size", "".concat(swiper.virtualSize, "px"));
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}
exports.default = Virtual;

},{"../../shared/dom.js":"aVcu8","../../shared/utils.js":"hHZfI","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"eW7Wz":[function(require,module,exports) {
/* eslint-disable consistent-return */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function Keyboard(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var handle = function handle(event) {
        if (!swiper.enabled) return;
        var rtl = swiper.rtlTranslate;
        var e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var kc = e.keyCode || e.charCode;
        var pageUpDown = swiper.params.keyboard.pageUpDown;
        var isPageUp = pageUpDown && kc === 33;
        var isPageDown = pageUpDown && kc === 34;
        var isArrowLeft = kc === 37;
        var isArrowRight = kc === 39;
        var isArrowUp = kc === 38;
        var isArrowDown = kc === 40; // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            var inView = false; // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents(".".concat(swiper.params.slideClass)).length > 0 && swiper.$el.parents(".".concat(swiper.params.slideActiveClass)).length === 0) return undefined;
            var $el = swiper.$el;
            var swiperWidth = $el[0].clientWidth;
            var swiperHeight = $el[0].clientHeight;
            var windowWidth = window.innerWidth;
            var windowHeight = window.innerHeight;
            var swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            var swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(var i = 0; i < swiperCoord.length; i += 1){
                var point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    };
    var enable = function enable() {
        if (swiper.keyboard.enabled) return;
        (0, _domJsDefault.default)(document).on("keydown", handle);
        swiper.keyboard.enabled = true;
    };
    var disable = function disable() {
        if (!swiper.keyboard.enabled) return;
        (0, _domJsDefault.default)(document).off("keydown", handle);
        swiper.keyboard.enabled = false;
    };
    var document = (0, _ssrWindow.getDocument)();
    var window = (0, _ssrWindow.getWindow)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    on("init", function() {
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", function() {
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}
exports.default = Keyboard;

},{"ssr-window":"5Hbsc","../../shared/dom.js":"aVcu8","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"4PUWs":[function(require,module,exports) {
/* eslint-disable consistent-return */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _utilsJs = require("../../shared/utils.js");
function Mousewheel(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var normalize = function normalize(e) {
        // Reasonable defaults
        var PIXEL_STEP = 10;
        var LINE_HEIGHT = 40;
        var PAGE_HEIGHT = 800;
        var sX = 0;
        var sY = 0; // spinX, spinY
        var pX = 0;
        var pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
         // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        } // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    };
    var handleMouseEnter = function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    };
    var handleMouseLeave = function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    };
    var animateSlider = function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, _utilsJs.now)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
         // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, _utilsJs.now)() - lastScrollTime < 60) // Return false as a default
        return true;
         // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime(); // Return false as a default
        return false;
    };
    var releaseScroll = function releaseScroll(newEvent) {
        var params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    };
    var handle = function handle(event1) {
        var e = event1;
        var disableParentSwiper = true;
        if (!swiper.enabled) return;
        var params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        var target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== "container") target = (0, _domJsDefault.default)(swiper.params.mousewheel.eventsTarget);
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var delta = 0;
        var rtlFactor = swiper.rtlTranslate ? -1 : 1;
        var data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions
        var positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            var newEvent = {
                time: (0, _utilsJs.now)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            }; // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
             // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            var newEvent1 = {
                time: (0, _utilsJs.now)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            var ignoreWheelEvents = lastEventBeforeSnap && newEvent1.time < lastEventBeforeSnap.time + 500 && newEvent1.delta <= lastEventBeforeSnap.delta && newEvent1.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                if (swiper.params.loop) swiper.loopFix();
                var position = swiper.getTranslate() + delta * params.sensitivity;
                var wasBeginning = swiper.isBeginning;
                var wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    var prevEvent1 = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    var firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent1);
                    if (prevEvent1 && (newEvent1.delta > prevEvent1.delta || newEvent1.direction !== prevEvent1.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent1.time - firstEvent.time < 500 && firstEvent.delta - newEvent1.delta >= 1 && newEvent1.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        var snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent1;
                        recentWheelEvents.splice(0);
                        timeout = (0, _utilsJs.nextTick)(function() {
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, _utilsJs.nextTick)(function() {
                        var snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent1;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                } // Emit event
                if (!ignoreWheelEvents) emit("scroll", e); // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    };
    var events = function events(method) {
        var target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== "container") target = (0, _domJsDefault.default)(swiper.params.mousewheel.eventsTarget);
        target[method]("mouseenter", handleMouseEnter);
        target[method]("mouseleave", handleMouseLeave);
        target[method]("wheel", handle);
    };
    var enable = function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("on");
        swiper.mousewheel.enabled = true;
        return true;
    };
    var disable = function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("off");
        swiper.mousewheel.enabled = false;
        return true;
    };
    var window = (0, _ssrWindow.getWindow)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    var timeout;
    var lastScrollTime = (0, _utilsJs.now)();
    var lastEventBeforeSnap;
    var recentWheelEvents = [];
    on("init", function() {
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", function() {
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}
exports.default = Mousewheel;

},{"ssr-window":"5Hbsc","../../shared/dom.js":"aVcu8","../../shared/utils.js":"hHZfI","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"kNEql":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createElementIfNotDefinedJs = require("../../shared/create-element-if-not-defined.js");
var _createElementIfNotDefinedJsDefault = parcelHelpers.interopDefault(_createElementIfNotDefinedJs);
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function Navigation(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var getEl = function getEl(el) {
        var $el;
        if (el) {
            $el = (0, _domJsDefault.default)(el);
            if (swiper.params.uniqueNavElements && typeof el === "string" && $el.length > 1 && swiper.$el.find(el).length === 1) $el = swiper.$el.find(el);
        }
        return $el;
    };
    var toggleEl = function toggleEl($el, disabled) {
        var params = swiper.params.navigation;
        if ($el && $el.length > 0) {
            $el[disabled ? "addClass" : "removeClass"](params.disabledClass);
            if ($el[0] && $el[0].tagName === "BUTTON") $el[0].disabled = disabled;
            if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
        }
    };
    var update = function update() {
        // Update Navigation Buttons
        if (swiper.params.loop) return;
        var _swiper_navigation = swiper.navigation, $nextEl = _swiper_navigation.$nextEl, $prevEl = _swiper_navigation.$prevEl;
        toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
    };
    var onPrevClick = function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
    };
    var onNextClick = function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
    };
    var init = function init() {
        var params = swiper.params.navigation;
        swiper.params.navigation = (0, _createElementIfNotDefinedJsDefault.default)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        var $nextEl = getEl(params.nextEl);
        var $prevEl = getEl(params.prevEl);
        if ($nextEl && $nextEl.length > 0) $nextEl.on("click", onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on("click", onPrevClick);
        Object.assign(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
            if ($nextEl) $nextEl.addClass(params.lockClass);
            if ($prevEl) $prevEl.addClass(params.lockClass);
        }
    };
    var destroy = function destroy() {
        var _swiper_navigation = swiper.navigation, $nextEl = _swiper_navigation.$nextEl, $prevEl = _swiper_navigation.$prevEl;
        if ($nextEl && $nextEl.length) {
            $nextEl.off("click", onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off("click", onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    };
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock"
        }
    });
    swiper.navigation = {
        nextEl: null,
        $nextEl: null,
        prevEl: null,
        $prevEl: null
    };
    on("init", function() {
        init();
        update();
    });
    on("toEdge fromEdge lock unlock", function() {
        update();
    });
    on("destroy", function() {
        destroy();
    });
    on("enable disable", function() {
        var _swiper_navigation = swiper.navigation, $nextEl = _swiper_navigation.$nextEl, $prevEl = _swiper_navigation.$prevEl;
        if ($nextEl) $nextEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
        if ($prevEl) $prevEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
    });
    on("click", function(_s, e) {
        var _swiper_navigation = swiper.navigation, $nextEl = _swiper_navigation.$nextEl, $prevEl = _swiper_navigation.$prevEl;
        var targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !(0, _domJsDefault.default)(targetEl).is($prevEl) && !(0, _domJsDefault.default)(targetEl).is($nextEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            var isHidden;
            if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
    });
    Object.assign(swiper.navigation, {
        update: update,
        init: init,
        destroy: destroy
    });
}
exports.default = Navigation;

},{"../../shared/create-element-if-not-defined.js":"aplQ4","../../shared/dom.js":"aVcu8","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"aplQ4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssrWindow = require("ssr-window");
function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
    var document = (0, _ssrWindow.getDocument)();
    if (swiper.params.createElements) Object.keys(checkProps).forEach(function(key) {
        if (!params[key] && params.auto === true) {
            var element = swiper.$el.children(".".concat(checkProps[key]))[0];
            if (!element) {
                element = document.createElement("div");
                element.className = checkProps[key];
                swiper.$el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}
exports.default = createElementIfNotDefined;

},{"ssr-window":"5Hbsc","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"iiV9C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _classesToSelectorJs = require("../../shared/classes-to-selector.js");
var _classesToSelectorJsDefault = parcelHelpers.interopDefault(_classesToSelectorJs);
var _createElementIfNotDefinedJs = require("../../shared/create-element-if-not-defined.js");
var _createElementIfNotDefinedJsDefault = parcelHelpers.interopDefault(_createElementIfNotDefinedJs);
function Pagination(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var isPaginationDisabled = function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
    };
    var setSideBullets = function setSideBullets($bulletEl, position) {
        var bulletActiveClass = swiper.params.pagination.bulletActiveClass;
        $bulletEl[position]().addClass("".concat(bulletActiveClass, "-").concat(position))[position]().addClass("".concat(bulletActiveClass, "-").concat(position, "-").concat(position));
    };
    var update = function update() {
        // Render || Update Pagination bullets/items
        var rtl = swiper.rtl;
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el; // Current/Total
        var current;
        var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== "bullets") current = total + current;
        } else if (typeof swiper.snapIndex !== "undefined") current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
         // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            var bullets = swiper.pagination.bullets;
            var firstIndex;
            var lastIndex;
            var midIndex;
            if (params.dynamicBullets) {
                bulletSize = bullets.eq(0)[swiper.isHorizontal() ? "outerWidth" : "outerHeight"](true);
                $el.css(swiper.isHorizontal() ? "width" : "height", "".concat(bulletSize * (params.dynamicMainBullets + 4), "px"));
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass([
                "",
                "-next",
                "-next-next",
                "-prev",
                "-prev-prev",
                "-main"
            ].map(function(suffix) {
                return "".concat(params.bulletActiveClass).concat(suffix);
            }).join(" "));
            if ($el.length > 1) bullets.each(function(bullet) {
                var $bullet = (0, _domJsDefault.default)(bullet);
                var bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass("".concat(params.bulletActiveClass, "-main"));
                    if (bulletIndex === firstIndex) setSideBullets($bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets($bullet, "next");
                }
            });
            else {
                var $bullet = bullets.eq(current);
                var bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    var $firstDisplayedBullet = bullets.eq(firstIndex);
                    var $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(var i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass("".concat(params.bulletActiveClass, "-main"));
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length) {
                            for(var i1 = params.dynamicMainBullets; i1 >= 0; i1 -= 1)bullets.eq(bullets.length - i1).addClass("".concat(params.bulletActiveClass, "-main"));
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass("".concat(params.bulletActiveClass, "-prev"));
                        } else {
                            setSideBullets($firstDisplayedBullet, "prev");
                            setSideBullets($lastDisplayedBullet, "next");
                        }
                    } else {
                        setSideBullets($firstDisplayedBullet, "prev");
                        setSideBullets($lastDisplayedBullet, "next");
                    }
                }
            }
            if (params.dynamicBullets) {
                var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                var bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                var offsetProp = rtl ? "right" : "left";
                bullets.css(swiper.isHorizontal() ? offsetProp : "top", "".concat(bulletsOffset, "px"));
            }
        }
        if (params.type === "fraction") {
            $el.find((0, _classesToSelectorJsDefault.default)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find((0, _classesToSelectorJsDefault.default)(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === "progressbar") {
            var progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
            else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
            var scale = (current + 1) / total;
            var scaleX = 1;
            var scaleY = 1;
            if (progressbarDirection === "horizontal") scaleX = scale;
            else scaleY = scale;
            $el.find((0, _classesToSelectorJsDefault.default)(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(".concat(scaleX, ") scaleY(").concat(scaleY, ")")).transition(swiper.params.speed);
        }
        if (params.type === "custom" && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            emit("paginationRender", $el[0]);
        } else emit("paginationUpdate", $el[0]);
        if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
    };
    var render = function render() {
        // Render Container
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el;
        var paginationHTML = "";
        if (params.type === "bullets") {
            var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(var i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += "<".concat(params.bulletElement, ' class="').concat(params.bulletClass, '"></').concat(params.bulletElement, ">");
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find((0, _classesToSelectorJsDefault.default)(params.bulletClass));
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = '<span class="'.concat(params.currentClass, '"></span>') + " / " + '<span class="'.concat(params.totalClass, '"></span>');
            $el.html(paginationHTML);
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = '<span class="'.concat(params.progressbarFillClass, '"></span>');
            $el.html(paginationHTML);
        }
        if (params.type !== "custom") emit("paginationRender", swiper.pagination.$el[0]);
    };
    var init = function init() {
        swiper.params.pagination = (0, _createElementIfNotDefinedJsDefault.default)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        var params = swiper.params.pagination;
        if (!params.el) return;
        var $el = (0, _domJsDefault.default)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1) {
            $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper
            if ($el.length > 1) $el = $el.filter(function(el) {
                if ((0, _domJsDefault.default)(el).parents(".swiper")[0] !== swiper.el) return false;
                return true;
            });
        }
        if (params.type === "bullets" && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        $el.addClass(params.modifierClass + swiper.params.direction);
        if (params.type === "bullets" && params.dynamicBullets) {
            $el.addClass("".concat(params.modifierClass).concat(params.type, "-dynamic"));
            dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === "progressbar" && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on("click", (0, _classesToSelectorJsDefault.default)(params.bulletClass), function onClick(e) {
            e.preventDefault();
            var index = (0, _domJsDefault.default)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
        });
        Object.assign(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
        if (!swiper.enabled) $el.addClass(params.lockClass);
    };
    var destroy = function destroy() {
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        $el.removeClass(params.modifierClass + swiper.params.direction);
        if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off("click", (0, _classesToSelectorJsDefault.default)(params.bulletClass));
    };
    var pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: function(number) {
                return number;
            },
            formatFractionTotal: function(number) {
                return number;
            },
            bulletClass: "".concat(pfx, "-bullet"),
            bulletActiveClass: "".concat(pfx, "-bullet-active"),
            modifierClass: "".concat(pfx, "-"),
            currentClass: "".concat(pfx, "-current"),
            totalClass: "".concat(pfx, "-total"),
            hiddenClass: "".concat(pfx, "-hidden"),
            progressbarFillClass: "".concat(pfx, "-progressbar-fill"),
            progressbarOppositeClass: "".concat(pfx, "-progressbar-opposite"),
            clickableClass: "".concat(pfx, "-clickable"),
            lockClass: "".concat(pfx, "-lock"),
            horizontalClass: "".concat(pfx, "-horizontal"),
            verticalClass: "".concat(pfx, "-vertical")
        }
    });
    swiper.pagination = {
        el: null,
        $el: null,
        bullets: []
    };
    var bulletSize;
    var dynamicBulletIndex = 0;
    on("init", function() {
        init();
        render();
        update();
    });
    on("activeIndexChange", function() {
        if (swiper.params.loop) update();
        else if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", function() {
        if (!swiper.params.loop) update();
    });
    on("slidesLengthChange", function() {
        if (swiper.params.loop) {
            render();
            update();
        }
    });
    on("snapGridLengthChange", function() {
        if (!swiper.params.loop) {
            render();
            update();
        }
    });
    on("destroy", function() {
        destroy();
    });
    on("enable disable", function() {
        var $el = swiper.pagination.$el;
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.pagination.lockClass);
    });
    on("lock unlock", function() {
        update();
    });
    on("click", function(_s, e) {
        var targetEl = e.target;
        var $el = swiper.pagination.$el;
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el.length > 0 && !(0, _domJsDefault.default)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            var isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            $el.toggleClass(swiper.params.pagination.hiddenClass);
        }
    });
    Object.assign(swiper.pagination, {
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}
exports.default = Pagination;

},{"../../shared/dom.js":"aVcu8","../../shared/classes-to-selector.js":"lthEo","../../shared/create-element-if-not-defined.js":"aplQ4","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"lthEo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function classesToSelector() {
    var classes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return ".".concat(classes.trim().replace(/([\.:!\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, "."));
}
exports.default = classesToSelector;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"19mvo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _utilsJs = require("../../shared/utils.js");
var _createElementIfNotDefinedJs = require("../../shared/create-element-if-not-defined.js");
var _createElementIfNotDefinedJsDefault = parcelHelpers.interopDefault(_createElementIfNotDefinedJs);
function Scrollbar(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var setTranslate = function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate, progress = swiper.progress;
        var $dragEl = scrollbar.$dragEl, $el = scrollbar.$el;
        var params = swiper.params.scrollbar;
        var newSize = dragSize;
        var newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            $dragEl.transform("translate3d(".concat(newPos, "px, 0, 0)"));
            $dragEl[0].style.width = "".concat(newSize, "px");
        } else {
            $dragEl.transform("translate3d(0px, ".concat(newPos, "px, 0)"));
            $dragEl[0].style.height = "".concat(newSize, "px");
        }
        if (params.hide) {
            clearTimeout(timeout);
            $el[0].style.opacity = 1;
            timeout = setTimeout(function() {
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    };
    var setTransition = function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    };
    var updateSize = function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar;
        var $dragEl = scrollbar.$dragEl, $el = scrollbar.$el;
        $dragEl[0].style.width = "";
        $dragEl[0].style.height = "";
        trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) $dragEl[0].style.width = "".concat(dragSize, "px");
        else $dragEl[0].style.height = "".concat(dragSize, "px");
        if (divider >= 1) $el[0].style.display = "none";
        else $el[0].style.display = "";
        if (swiper.params.scrollbar.hide) $el[0].style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.$el[swiper.isLocked ? "addClass" : "removeClass"](swiper.params.scrollbar.lockClass);
    };
    var getPointerPosition = function getPointerPosition(e) {
        if (swiper.isHorizontal()) return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientX : e.clientX;
        return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientY : e.clientY;
    };
    var setDragPosition = function setDragPosition(e) {
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate;
        var $el = scrollbar.$el;
        var positionRatio;
        positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    };
    var onDragStart = function onDragStart(e) {
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el, $dragEl = scrollbar.$dragEl;
        isTouched = true;
        dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        setDragPosition(e);
        clearTimeout(dragTimeout);
        $el.transition(0);
        if (params.hide) $el.css("opacity", 1);
        if (swiper.params.cssMode) swiper.$wrapperEl.css("scroll-snap-type", "none");
        emit("scrollbarDragStart", e);
    };
    var onDragMove = function onDragMove(e) {
        var scrollbar = swiper.scrollbar, $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el, $dragEl = scrollbar.$dragEl;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        emit("scrollbarDragMove", e);
    };
    var onDragEnd = function onDragEnd(e) {
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css("scroll-snap-type", "");
            $wrapperEl.transition("");
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, _utilsJs.nextTick)(function() {
                $el.css("opacity", 0);
                $el.transition(400);
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    };
    var events = function events(method) {
        var scrollbar = swiper.scrollbar, touchEventsTouch = swiper.touchEventsTouch, touchEventsDesktop = swiper.touchEventsDesktop, params = swiper.params, support = swiper.support;
        var $el = scrollbar.$el;
        var target = $el[0];
        var activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        var passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        var eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        if (!support.touch) {
            target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
            document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
            document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
        } else {
            target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
            target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
            target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
        }
    };
    var enableDraggable = function enableDraggable() {
        if (!swiper.params.scrollbar.el) return;
        events("on");
    };
    var disableDraggable = function disableDraggable() {
        if (!swiper.params.scrollbar.el) return;
        events("off");
    };
    var init = function init() {
        var scrollbar = swiper.scrollbar, $swiperEl = swiper.$el;
        swiper.params.scrollbar = (0, _createElementIfNotDefinedJsDefault.default)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        var params = swiper.params.scrollbar;
        if (!params.el) return;
        var $el = (0, _domJsDefault.default)(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1 && $swiperEl.find(params.el).length === 1) $el = $swiperEl.find(params.el);
        var $dragEl = $el.find(".".concat(swiper.params.scrollbar.dragClass));
        if ($dragEl.length === 0) {
            $dragEl = (0, _domJsDefault.default)('<div class="'.concat(swiper.params.scrollbar.dragClass, '"></div>'));
            $el.append($dragEl);
        }
        Object.assign(scrollbar, {
            $el: $el,
            el: $el[0],
            $dragEl: $dragEl,
            dragEl: $dragEl[0]
        });
        if (params.draggable) enableDraggable();
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
    };
    var destroy = function destroy() {
        disableDraggable();
    };
    var document = (0, _ssrWindow.getDocument)();
    var isTouched = false;
    var timeout = null;
    var dragTimeout = null;
    var dragStartPos;
    var dragSize;
    var trackSize;
    var divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag"
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null,
        $el: null,
        $dragEl: null
    };
    on("init", function() {
        init();
        updateSize();
        setTranslate();
    });
    on("update resize observerUpdate lock unlock", function() {
        updateSize();
    });
    on("setTranslate", function() {
        setTranslate();
    });
    on("setTransition", function(_s, duration) {
        setTransition(duration);
    });
    on("enable disable", function() {
        var $el = swiper.scrollbar.$el;
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
    });
    on("destroy", function() {
        destroy();
    });
    Object.assign(swiper.scrollbar, {
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}
exports.default = Scrollbar;

},{"ssr-window":"5Hbsc","../../shared/dom.js":"aVcu8","../../shared/utils.js":"hHZfI","../../shared/create-element-if-not-defined.js":"aplQ4","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"bN1Ux":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function Parallax(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    var setTransform = function(el, progress) {
        var rtl = swiper.rtl;
        var $el = (0, _domJsDefault.default)(el);
        var rtlFactor = rtl ? -1 : 1;
        var p = $el.attr("data-swiper-parallax") || "0";
        var x = $el.attr("data-swiper-parallax-x");
        var y = $el.attr("data-swiper-parallax-y");
        var scale = $el.attr("data-swiper-parallax-scale");
        var opacity = $el.attr("data-swiper-parallax-opacity");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = "".concat(parseInt(x, 10) * progress * rtlFactor, "%");
        else x = "".concat(x * progress * rtlFactor, "px");
        if (y.indexOf("%") >= 0) y = "".concat(parseInt(y, 10) * progress, "%");
        else y = "".concat(y * progress, "px");
        if (typeof opacity !== "undefined" && opacity !== null) {
            var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === "undefined" || scale === null) $el.transform("translate3d(".concat(x, ", ").concat(y, ", 0px)"));
        else {
            var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform("translate3d(".concat(x, ", ").concat(y, ", 0px) scale(").concat(currentScale, ")"));
        }
    };
    var setTranslate = function() {
        var $el = swiper.$el, slides = swiper.slides, progress = swiper.progress, snapGrid = swiper.snapGrid;
        $el.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function(el) {
            setTransform(el, progress);
        });
        slides.each(function(slideEl, slideIndex) {
            var slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            (0, _domJsDefault.default)(slideEl).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function(el) {
                setTransform(el, slideProgress);
            });
        });
    };
    var setTransition = function() {
        var duration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : swiper.params.speed;
        var $el = swiper.$el;
        $el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function(parallaxEl) {
            var $parallaxEl = (0, _domJsDefault.default)(parallaxEl);
            var parallaxDuration = parseInt($parallaxEl.attr("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    };
    on("beforeInit", function() {
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", function() {
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", function() {
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", function(_swiper, duration) {
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}
exports.default = Parallax;

},{"../../shared/dom.js":"aVcu8","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"ffxDf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _utilsJs = require("../../shared/utils.js");
function Zoom(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var getDistanceBetweenTouches = function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        var x1 = e.targetTouches[0].pageX;
        var y1 = e.targetTouches[0].pageY;
        var x2 = e.targetTouches[1].pageX;
        var y2 = e.targetTouches[1].pageY;
        var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        return distance;
    } // Events
    ;
    var onGestureStart = function onGestureStart(e) {
        var support = swiper.support;
        var params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!support.gestures) {
            if (e.type !== "touchstart" || e.type === "touchstart" && e.targetTouches.length < 2) return;
            fakeGestureTouched = true;
            gesture.scaleStart = getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = (0, _domJsDefault.default)(e.target).closest(".".concat(swiper.params.slideClass));
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(".".concat(params.containerClass)).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
            gesture.maxRatio = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        if (gesture.$imageEl) gesture.$imageEl.transition(0);
        isScaling = true;
    };
    var onGestureChange = function onGestureChange(e) {
        var support = swiper.support;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        if (!support.gestures) {
            if (e.type !== "touchmove" || e.type === "touchmove" && e.targetTouches.length < 2) return;
            fakeGestureMoved = true;
            gesture.scaleMove = getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
            if (e.type === "gesturechange") onGestureStart(e);
            return;
        }
        if (support.gestures) zoom.scale = e.scale * currentScale;
        else zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
        gesture.$imageEl.transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
    };
    var onGestureEnd = function onGestureEnd(e) {
        var device = swiper.device;
        var support = swiper.support;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        if (!support.gestures) {
            if (!fakeGestureTouched || !fakeGestureMoved) return;
            if (e.type !== "touchend" || e.type === "touchend" && e.changedTouches.length < 2 && !device.android) return;
            fakeGestureTouched = false;
            fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    };
    var onTouchStart = function onTouchStart(e) {
        var device = swiper.device;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    };
    var onTouchMove = function onTouchMove(e) {
        var zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = (0, _utilsJs.getTranslate)(gesture.$imageWrapEl[0], "x") || 0;
            image.startY = (0, _utilsJs.getTranslate)(gesture.$imageWrapEl[0], "y") || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
        } // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === "touchmove" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === "touchmove" ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
         // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform("translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)"));
    };
    var onTouchEnd = function onTouchEnd() {
        var zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        var momentumDurationX = 300;
        var momentumDurationY = 300;
        var momentumDistanceX = velocity.x * momentumDurationX;
        var newPositionX = image.currentX + momentumDistanceX;
        var momentumDistanceY = velocity.y * momentumDurationY;
        var newPositionY = image.currentY + momentumDistanceY; // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform("translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)"));
    };
    var onTransitionEnd = function onTransitionEnd() {
        var zoom = swiper.zoom;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            if (gesture.$imageEl) gesture.$imageEl.transform("translate3d(0,0,0) scale(1)");
            if (gesture.$imageWrapEl) gesture.$imageWrapEl.transform("translate3d(0,0,0)");
            zoom.scale = 1;
            currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    };
    var zoomIn = function zoomIn(e) {
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (e && e.target) gesture.$slideEl = (0, _domJsDefault.default)(e.target).closest(".".concat(swiper.params.slideClass));
            if (!gesture.$slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(".".concat(swiper.params.slideActiveClass));
                else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find(".".concat(params.containerClass)).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.$slideEl.addClass("".concat(params.zoomedSlideClass));
        var touchX;
        var touchY;
        var offsetX;
        var offsetY;
        var diffX;
        var diffY;
        var translateX;
        var translateY;
        var imageWidth;
        var imageHeight;
        var scaledWidth;
        var scaledHeight;
        var translateMinX;
        var translateMinY;
        var translateMaxX;
        var translateMaxY;
        var slideWidth;
        var slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.type === "touchend" ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === "touchend" ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        currentScale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left + window.scrollX;
            offsetY = gesture.$slideEl.offset().top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform("translate3d(".concat(translateX, "px, ").concat(translateY, "px,0)"));
        gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
    };
    var zoomOut = function zoomOut() {
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(".".concat(swiper.params.slideActiveClass));
            else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(".".concat(params.containerClass)).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform("translate3d(0,0,0)");
        gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)");
        gesture.$slideEl.removeClass("".concat(params.zoomedSlideClass));
        gesture.$slideEl = undefined;
    } // Toggle Zoom
    ;
    var zoomToggle = function zoomToggle(e) {
        var zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    };
    var getListeners = function getListeners() {
        var support = swiper.support;
        var passiveListener = swiper.touchEvents.start === "touchstart" && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        var activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    };
    var getSlideSelector = function getSlideSelector() {
        return ".".concat(swiper.params.slideClass);
    };
    var toggleGestures = function toggleGestures(method) {
        var passiveListener = getListeners().passiveListener;
        var slideSelector = getSlideSelector();
        swiper.$wrapperEl[method]("gesturestart", slideSelector, onGestureStart, passiveListener);
        swiper.$wrapperEl[method]("gesturechange", slideSelector, onGestureChange, passiveListener);
        swiper.$wrapperEl[method]("gestureend", slideSelector, onGestureEnd, passiveListener);
    };
    var enableGestures = function enableGestures() {
        if (gesturesEnabled) return;
        gesturesEnabled = true;
        toggleGestures("on");
    };
    var disableGestures = function disableGestures() {
        if (!gesturesEnabled) return;
        gesturesEnabled = false;
        toggleGestures("off");
    } // Attach/Detach Events
    ;
    var enable = function enable() {
        var zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        var support = swiper.support;
        var _getListeners = getListeners(), passiveListener = _getListeners.passiveListener, activeListenerWithCapture = _getListeners.activeListenerWithCapture;
        var slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, ".".concat(swiper.params.zoom.containerClass), onTouchMove, activeListenerWithCapture);
    };
    var disable = function disable() {
        var zoom = swiper.zoom;
        if (!zoom.enabled) return;
        var support = swiper.support;
        zoom.enabled = false;
        var _getListeners = getListeners(), passiveListener = _getListeners.passiveListener, activeListenerWithCapture = _getListeners.activeListenerWithCapture;
        var slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, ".".concat(swiper.params.zoom.containerClass), onTouchMove, activeListenerWithCapture);
    };
    var window = (0, _ssrWindow.getWindow)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    var currentScale = 1;
    var isScaling = false;
    var gesturesEnabled;
    var fakeGestureTouched;
    var fakeGestureMoved;
    var gesture = {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
    };
    var image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    var velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    var scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get: function() {
            return scale;
        },
        set: function(value) {
            if (scale !== value) {
                var imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
                var slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    on("init", function() {
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", function() {
        disable();
    });
    on("touchStart", function(_s, e) {
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", function(_s, e) {
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
    });
    on("doubleTap", function(_s, e) {
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", function() {
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", function() {
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}
exports.default = Zoom;

},{"ssr-window":"5Hbsc","../../shared/dom.js":"aVcu8","../../shared/utils.js":"hHZfI","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"iVTy7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function Lazy(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var load = function load() {
        var $wrapperEl = swiper.$wrapperEl, swiperParams = swiper.params, slides = swiper.slides, activeIndex = swiper.activeIndex;
        var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        var params = swiperParams.lazy;
        var slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === "auto") slidesPerView = 0;
        function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children(".".concat(swiperParams.slideClass, '[data-swiper-slide-index="').concat(index, '"]')).length) return true;
            } else if (slides[index]) return true;
            return false;
        }
        function slideIndex(slideEl) {
            if (isVirtual) return (0, _domJsDefault.default)(slideEl).attr("data-swiper-slide-index");
            return (0, _domJsDefault.default)(slideEl).index();
        }
        if (!initialImageLoaded) initialImageLoaded = true;
        if (swiper.params.watchSlidesProgress) $wrapperEl.children(".".concat(swiperParams.slideVisibleClass)).each(function(slideEl) {
            var index = isVirtual ? (0, _domJsDefault.default)(slideEl).attr("data-swiper-slide-index") : (0, _domJsDefault.default)(slideEl).index();
            loadInSlide(index);
        });
        else if (slidesPerView > 1) {
            for(var i = activeIndex; i < activeIndex + slidesPerView; i += 1)if (slideExist(i)) loadInSlide(i);
        } else loadInSlide(activeIndex);
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                var amount = params.loadPrevNextAmount;
                var spv = slidesPerView;
                var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
                for(var i1 = activeIndex + slidesPerView; i1 < maxIndex; i1 += 1)if (slideExist(i1)) loadInSlide(i1);
                 // Prev Slides
                for(var i2 = minIndex; i2 < activeIndex; i2 += 1)if (slideExist(i2)) loadInSlide(i2);
            } else {
                var nextSlide = $wrapperEl.children(".".concat(swiperParams.slideNextClass));
                if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
                var prevSlide = $wrapperEl.children(".".concat(swiperParams.slidePrevClass));
                if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
            }
        }
    };
    extendParams({
        lazy: {
            checkInView: false,
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            scrollingElement: "",
            elementClass: "swiper-lazy",
            loadingClass: "swiper-lazy-loading",
            loadedClass: "swiper-lazy-loaded",
            preloaderClass: "swiper-lazy-preloader"
        }
    });
    swiper.lazy = {};
    var scrollHandlerAttached = false;
    var initialImageLoaded = false;
    function loadInSlide(index) {
        var loadInDuplicate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var params = swiper.params.lazy;
        if (typeof index === "undefined") return;
        if (swiper.slides.length === 0) return;
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var $slideEl = isVirtual ? swiper.$wrapperEl.children(".".concat(swiper.params.slideClass, '[data-swiper-slide-index="').concat(index, '"]')) : swiper.slides.eq(index);
        var $images = $slideEl.find(".".concat(params.elementClass, ":not(.").concat(params.loadedClass, "):not(.").concat(params.loadingClass, ")"));
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) $images.push($slideEl[0]);
        if ($images.length === 0) return;
        $images.each(function(imageEl) {
            var $imageEl = (0, _domJsDefault.default)(imageEl);
            $imageEl.addClass(params.loadingClass);
            var background = $imageEl.attr("data-background");
            var src = $imageEl.attr("data-src");
            var srcset = $imageEl.attr("data-srcset");
            var sizes = $imageEl.attr("data-sizes");
            var $pictureEl = $imageEl.parent("picture");
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, function() {
                if (typeof swiper === "undefined" || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css("background-image", 'url("'.concat(background, '")'));
                    $imageEl.removeAttr("data-background");
                } else {
                    if (srcset) {
                        $imageEl.attr("srcset", srcset);
                        $imageEl.removeAttr("data-srcset");
                    }
                    if (sizes) {
                        $imageEl.attr("sizes", sizes);
                        $imageEl.removeAttr("data-sizes");
                    }
                    if ($pictureEl.length) $pictureEl.children("source").each(function(sourceEl) {
                        var $source = (0, _domJsDefault.default)(sourceEl);
                        if ($source.attr("data-srcset")) {
                            $source.attr("srcset", $source.attr("data-srcset"));
                            $source.removeAttr("data-srcset");
                        }
                    });
                    if (src) {
                        $imageEl.attr("src", src);
                        $imageEl.removeAttr("data-src");
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find(".".concat(params.preloaderClass)).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    var slideOriginalIndex = $slideEl.attr("data-swiper-slide-index");
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        var originalSlide = swiper.$wrapperEl.children('[data-swiper-slide-index="'.concat(slideOriginalIndex, '"]:not(.').concat(swiper.params.slideDuplicateClass, ")"));
                        loadInSlide(originalSlide.index(), false);
                    } else {
                        var duplicatedSlide = swiper.$wrapperEl.children(".".concat(swiper.params.slideDuplicateClass, '[data-swiper-slide-index="').concat(slideOriginalIndex, '"]'));
                        loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                emit("lazyImageReady", $slideEl[0], $imageEl[0]);
                if (swiper.params.autoHeight) swiper.updateAutoHeight();
            });
            emit("lazyImageLoad", $slideEl[0], $imageEl[0]);
        });
    }
    function checkInViewOnLoad() {
        var window = (0, _ssrWindow.getWindow)();
        if (!swiper || swiper.destroyed) return;
        var $scrollElement = swiper.params.lazy.scrollingElement ? (0, _domJsDefault.default)(swiper.params.lazy.scrollingElement) : (0, _domJsDefault.default)(window);
        var isWindow = $scrollElement[0] === window;
        var scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
        var scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
        var swiperOffset = swiper.$el.offset();
        var rtl = swiper.rtlTranslate;
        var inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        var swiperCoord = [
            [
                swiperOffset.left,
                swiperOffset.top
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top
            ],
            [
                swiperOffset.left,
                swiperOffset.top + swiper.height
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top + swiper.height
            ]
        ];
        for(var i = 0; i < swiperCoord.length; i += 1){
            var point = swiperCoord[i];
            if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
                if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                inView = true;
            }
        }
        var passiveListener = swiper.touchEvents.start === "touchstart" && swiper.support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (inView) {
            load();
            $scrollElement.off("scroll", checkInViewOnLoad, passiveListener);
        } else if (!scrollHandlerAttached) {
            scrollHandlerAttached = true;
            $scrollElement.on("scroll", checkInViewOnLoad, passiveListener);
        }
    }
    on("beforeInit", function() {
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) swiper.params.preloadImages = false;
    });
    on("init", function() {
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("scroll", function() {
        if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) load();
    });
    on("scrollbarDragMove resize _freeModeNoMomentumRelease", function() {
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("transitionStart", function() {
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
                if (swiper.params.lazy.checkInView) checkInViewOnLoad();
                else load();
            }
        }
    });
    on("transitionEnd", function() {
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("slideChange", function() {
        var _swiper_params = swiper.params, lazy = _swiper_params.lazy, cssMode = _swiper_params.cssMode, watchSlidesProgress = _swiper_params.watchSlidesProgress, touchReleaseOnEdges = _swiper_params.touchReleaseOnEdges, resistanceRatio = _swiper_params.resistanceRatio;
        if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) load();
    });
    Object.assign(swiper.lazy, {
        load: load,
        loadInSlide: loadInSlide
    });
}
exports.default = Lazy;

},{"ssr-window":"5Hbsc","../../shared/dom.js":"aVcu8","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"lMnB7":[function(require,module,exports) {
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../../shared/utils.js");
function Controller(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    var LinearSpline = function LinearSpline(x, y) {
        var binarySearch = function search() {
            var maxIndex;
            var minIndex;
            var guess;
            return function(array, val) {
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        var i1;
        var i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    } // xxx: for now i will just save one spline function to to
    ;
    var getInterpolateFunction = function getInterpolateFunction(c) {
        if (!swiper.controller.spline) swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    };
    var setTranslate = function setTranslate(_t, byController) {
        var controlled = swiper.controller.control;
        var multiplier;
        var controlledTranslate;
        var Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(var i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    };
    var setTransition = function setTransition(duration, byController) {
        var Swiper = swiper.constructor;
        var controlled = swiper.controller.control;
        var i;
        function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, _utilsJs.nextTick)(function() {
                    c.updateAutoHeight();
                });
                c.$wrapperEl.transitionEnd(function() {
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === "slide") c.loopFix();
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    };
    var removeSpline = function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    };
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    on("beforeInit", function() {
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", function() {
        removeSpline();
    });
    on("resize", function() {
        removeSpline();
    });
    on("observerUpdate", function() {
        removeSpline();
    });
    on("setTranslate", function(_s, translate, byController) {
        if (!swiper.controller.control) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", function(_s, duration, byController) {
        if (!swiper.controller.control) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}
exports.default = Controller;

},{"../../shared/utils.js":"hHZfI","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"fwhQ2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classesToSelectorJs = require("../../shared/classes-to-selector.js");
var _classesToSelectorJsDefault = parcelHelpers.interopDefault(_classesToSelectorJs);
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function A11y(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    var notify = function notify(message) {
        var notification = liveRegion;
        if (notification.length === 0) return;
        notification.html("");
        notification.html(message);
    };
    var getRandomNumber = function getRandomNumber() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 16;
        var randomChar = function() {
            return Math.round(16 * Math.random()).toString(16);
        };
        return "x".repeat(size).replace(/x/g, randomChar);
    };
    var makeElFocusable = function makeElFocusable($el) {
        $el.attr("tabIndex", "0");
    };
    var makeElNotFocusable = function makeElNotFocusable($el) {
        $el.attr("tabIndex", "-1");
    };
    var addElRole = function addElRole($el, role) {
        $el.attr("role", role);
    };
    var addElRoleDescription = function addElRoleDescription($el, description) {
        $el.attr("aria-roledescription", description);
    };
    var addElControls = function addElControls($el, controls) {
        $el.attr("aria-controls", controls);
    };
    var addElLabel = function addElLabel($el, label) {
        $el.attr("aria-label", label);
    };
    var addElId = function addElId($el, id) {
        $el.attr("id", id);
    };
    var addElLive = function addElLive($el, live) {
        $el.attr("aria-live", live);
    };
    var disableEl = function disableEl($el) {
        $el.attr("aria-disabled", true);
    };
    var enableEl = function enableEl($el) {
        $el.attr("aria-disabled", false);
    };
    var onEnterOrSpaceKey = function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        var params = swiper.params.a11y;
        var $targetEl = (0, _domJsDefault.default)(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && $targetEl.is((0, _classesToSelectorJsDefault.default)(swiper.params.pagination.bulletClass))) $targetEl[0].click();
    };
    var updateNavigation = function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        var _swiper_navigation = swiper.navigation, $nextEl = _swiper_navigation.$nextEl, $prevEl = _swiper_navigation.$prevEl;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                disableEl($prevEl);
                makeElNotFocusable($prevEl);
            } else {
                enableEl($prevEl);
                makeElFocusable($prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                disableEl($nextEl);
                makeElNotFocusable($nextEl);
            } else {
                enableEl($nextEl);
                makeElFocusable($nextEl);
            }
        }
    };
    var hasPagination = function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    };
    var hasClickablePagination = function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    };
    var updatePagination = function updatePagination() {
        var params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.each(function(bulletEl) {
            var $bulletEl = (0, _domJsDefault.default)(bulletEl);
            if (swiper.params.pagination.clickable) {
                makeElFocusable($bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole($bulletEl, "button");
                    addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
                }
            }
            if ($bulletEl.is(".".concat(swiper.params.pagination.bulletActiveClass))) $bulletEl.attr("aria-current", "true");
            else $bulletEl.removeAttr("aria-current");
        });
    };
    var init = function init() {
        var params = swiper.params.a11y;
        swiper.$el.append(liveRegion); // Container
        var $containerEl = swiper.$el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel($containerEl, params.containerMessage);
         // Wrapper
        var $wrapperEl = swiper.$wrapperEl;
        var wrapperId = $wrapperEl.attr("id") || "swiper-wrapper-".concat(getRandomNumber(16));
        var live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId($wrapperEl, wrapperId);
        addElLive($wrapperEl, live); // Slide
        if (params.itemRoleDescriptionMessage) addElRoleDescription((0, _domJsDefault.default)(swiper.slides), params.itemRoleDescriptionMessage);
        addElRole((0, _domJsDefault.default)(swiper.slides), params.slideRole);
        var slidesLength = swiper.params.loop ? swiper.slides.filter(function(el) {
            return !el.classList.contains(swiper.params.slideDuplicateClass);
        }).length : swiper.slides.length;
        swiper.slides.each(function(slideEl, index) {
            var $slideEl = (0, _domJsDefault.default)(slideEl);
            var slideIndex = swiper.params.loop ? parseInt($slideEl.attr("data-swiper-slide-index"), 10) : index;
            var ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel($slideEl, ariaLabelMessage);
        }); // Navigation
        var $nextEl;
        var $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl && $nextEl.length) initNavEl($nextEl, wrapperId, params.nextSlideMessage);
        if ($prevEl && $prevEl.length) initNavEl($prevEl, wrapperId, params.prevSlideMessage);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.on("keydown", (0, _classesToSelectorJsDefault.default)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    };
    var destroy = function destroy() {
        if (liveRegion && liveRegion.length > 0) liveRegion.remove();
        var $nextEl;
        var $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) $nextEl.off("keydown", onEnterOrSpaceKey);
        if ($prevEl) $prevEl.off("keydown", onEnterOrSpaceKey);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.off("keydown", (0, _classesToSelectorJsDefault.default)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    };
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group"
        }
    });
    var liveRegion = null;
    var initNavEl = function($el, wrapperId, message) {
        makeElFocusable($el);
        if ($el[0].tagName !== "BUTTON") {
            addElRole($el, "button");
            $el.on("keydown", onEnterOrSpaceKey);
        }
        addElLabel($el, message);
        addElControls($el, wrapperId);
    };
    on("beforeInit", function() {
        liveRegion = (0, _domJsDefault.default)('<span class="'.concat(swiper.params.a11y.notificationClass, '" aria-live="assertive" aria-atomic="true"></span>'));
    });
    on("afterInit", function() {
        if (!swiper.params.a11y.enabled) return;
        init();
        updateNavigation();
    });
    on("toEdge", function() {
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("fromEdge", function() {
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", function() {
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", function() {
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}
exports.default = A11y;

},{"../../shared/classes-to-selector.js":"lthEo","../../shared/dom.js":"aVcu8","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"7Ni3h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssrWindow = require("ssr-window");
function History(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides"
        }
    });
    var initialized = false;
    var paths = {};
    var slugify = function(text) {
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    var getPathValues = function(urlOverride) {
        var window = (0, _ssrWindow.getWindow)();
        var location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        var pathArray = location.pathname.slice(1).split("/").filter(function(part) {
            return part !== "";
        });
        var total = pathArray.length;
        var key = pathArray[total - 2];
        var value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    var setHistory = function(key, index) {
        var window = (0, _ssrWindow.getWindow)();
        if (!initialized || !swiper.params.history.enabled) return;
        var location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        var slide = swiper.slides.eq(index);
        var value = slugify(slide.attr("data-history"));
        if (swiper.params.history.root.length > 0) {
            var root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = "".concat(root, "/").concat(key, "/").concat(value);
        } else if (!location.pathname.includes(key)) value = "".concat(key, "/").concat(value);
        var currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    var scrollToSlide = function(speed, value, runCallbacks) {
        if (value) for(var i = 0, length = swiper.slides.length; i < length; i += 1){
            var slide = swiper.slides.eq(i);
            var slideHistory = slugify(slide.attr("data-history"));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                var index = slide.index();
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    var setHistoryPopState = function() {
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, swiper.paths.value, false);
    };
    var init = function() {
        var window = (0, _ssrWindow.getWindow)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) return;
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    var destroy = function() {
        var window = (0, _ssrWindow.getWindow)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", function() {
        if (swiper.params.history.enabled) init();
    });
    on("destroy", function() {
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", function() {
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", function() {
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}
exports.default = History;

},{"ssr-window":"5Hbsc","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"7Met9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function HashNavigation(param) {
    var swiper = param.swiper, extendParams = param.extendParams, emit = param.emit, on = param.on;
    var initialized = false;
    var document = (0, _ssrWindow.getDocument)();
    var window = (0, _ssrWindow.getWindow)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    });
    var onHashChange = function() {
        emit("hashChange");
        var newHash = document.location.hash.replace("#", "");
        var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr("data-hash");
        if (newHash !== activeSlideHash) {
            var newIndex = swiper.$wrapperEl.children(".".concat(swiper.params.slideClass, '[data-hash="').concat(newHash, '"]')).index();
            if (typeof newIndex === "undefined") return;
            swiper.slideTo(newIndex);
        }
    };
    var setHash = function() {
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, "#".concat(swiper.slides.eq(swiper.activeIndex).attr("data-hash")) || "");
            emit("hashSet");
        } else {
            var slide = swiper.slides.eq(swiper.activeIndex);
            var hash = slide.attr("data-hash") || slide.attr("data-history");
            document.location.hash = hash || "";
            emit("hashSet");
        }
    };
    var init = function() {
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        var hash = document.location.hash.replace("#", "");
        if (hash) {
            var speed = 0;
            for(var i = 0, length = swiper.slides.length; i < length; i += 1){
                var slide = swiper.slides.eq(i);
                var slideHash = slide.attr("data-hash") || slide.attr("data-history");
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    var index = slide.index();
                    swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) (0, _domJsDefault.default)(window).on("hashchange", onHashChange);
    };
    var destroy = function() {
        if (swiper.params.hashNavigation.watchState) (0, _domJsDefault.default)(window).off("hashchange", onHashChange);
    };
    on("init", function() {
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", function() {
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", function() {
        if (initialized) setHash();
    });
    on("slideChange", function() {
        if (initialized && swiper.params.cssMode) setHash();
    });
}
exports.default = HashNavigation;

},{"ssr-window":"5Hbsc","../../shared/dom.js":"aVcu8","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"kGp3O":[function(require,module,exports) {
/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssrWindow = require("ssr-window");
var _utilsJs = require("../../shared/utils.js");
function Autoplay(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var start = function start() {
        if (typeof timeout !== "undefined") return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        emit("autoplayStart");
        run();
        return true;
    };
    var stop = function stop() {
        if (!swiper.autoplay.running) return false;
        if (typeof timeout === "undefined") return false;
        if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
        }
        swiper.autoplay.running = false;
        emit("autoplayStop");
        return true;
    };
    var pause = function pause(speed) {
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (timeout) clearTimeout(timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            run();
        } else [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach(function(event) {
            swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
        });
    };
    var onVisibilityChange = function onVisibilityChange() {
        var document = (0, _ssrWindow.getDocument)();
        if (document.visibilityState === "hidden" && swiper.autoplay.running) pause();
        if (document.visibilityState === "visible" && swiper.autoplay.paused) {
            run();
            swiper.autoplay.paused = false;
        }
    };
    var onMouseEnter = function onMouseEnter() {
        if (swiper.params.autoplay.disableOnInteraction) stop();
        else pause();
        [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach(function(event) {
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
    };
    var onMouseLeave = function onMouseLeave() {
        if (swiper.params.autoplay.disableOnInteraction) return;
        swiper.autoplay.paused = false;
        run();
    };
    var attachMouseEvents = function attachMouseEvents() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.$el.on("mouseenter", onMouseEnter);
            swiper.$el.on("mouseleave", onMouseLeave);
        }
    };
    var detachMouseEvents = function detachMouseEvents() {
        swiper.$el.off("mouseenter", onMouseEnter);
        swiper.$el.off("mouseleave", onMouseLeave);
    };
    var timeout;
    swiper.autoplay = {
        running: false,
        paused: false
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function run() {
        var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        var delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr("data-swiper-autoplay")) delay = $activeSlideEl.attr("data-swiper-autoplay") || swiper.params.autoplay.delay;
        clearTimeout(timeout);
        timeout = (0, _utilsJs.nextTick)(function() {
            var autoplayResult;
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit("autoplay");
                } else if (!swiper.isBeginning) {
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    emit("autoplay");
                } else stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit("autoplay");
            } else if (!swiper.isEnd) {
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit("autoplay");
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                emit("autoplay");
            } else stop();
            if (swiper.params.cssMode && swiper.autoplay.running) run();
            else if (autoplayResult === false) run();
        }, delay);
    }
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach(function(event) {
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) stop();
        else run();
    }
    on("init", function() {
        if (swiper.params.autoplay.enabled) {
            start();
            var document = (0, _ssrWindow.getDocument)();
            document.addEventListener("visibilitychange", onVisibilityChange);
            attachMouseEvents();
        }
    });
    on("beforeTransitionStart", function(_s, speed, internal) {
        if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
            else stop();
        }
    });
    on("sliderFirstMove", function() {
        if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) stop();
            else pause();
        }
    });
    on("touchEnd", function() {
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) run();
    });
    on("destroy", function() {
        detachMouseEvents();
        if (swiper.autoplay.running) stop();
        var document = (0, _ssrWindow.getDocument)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    });
    Object.assign(swiper.autoplay, {
        pause: pause,
        run: run,
        start: start,
        stop: stop
    });
}
exports.default = Autoplay;

},{"ssr-window":"5Hbsc","../../shared/utils.js":"hHZfI","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"15Kp5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../../shared/utils.js");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function Thumb(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    var onThumbClick = function onThumbClick() {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        var clickedIndex = thumbsSwiper.clickedIndex;
        var clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && (0, _domJsDefault.default)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        var slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt((0, _domJsDefault.default)(thumbsSwiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) {
            var currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix(); // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            var prevIndex = swiper.slides.eq(currentIndex).prevAll('[data-swiper-slide-index="'.concat(slideToIndex, '"]')).eq(0).index();
            var nextIndex = swiper.slides.eq(currentIndex).nextAll('[data-swiper-slide-index="'.concat(slideToIndex, '"]')).eq(0).index();
            if (typeof prevIndex === "undefined") slideToIndex = nextIndex;
            else if (typeof nextIndex === "undefined") slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    };
    var init = function init() {
        var _swiper_params = swiper.params, thumbsParams = _swiper_params.thumbs;
        if (initialized) return false;
        initialized = true;
        var SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if ((0, _utilsJs.isObject)(thumbsParams.swiper)) {
            var thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    };
    var update = function update(initial) {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        var slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            var currentThumbsIndex = thumbsSwiper.activeIndex;
            var newThumbsIndex;
            var direction;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix(); // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                } // Find actual thumbs index to slide to
                var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll('[data-swiper-slide-index="'.concat(swiper.realIndex, '"]')).eq(0).index();
                var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll('[data-swiper-slide-index="'.concat(swiper.realIndex, '"]')).eq(0).index();
                if (typeof prevThumbsIndex === "undefined") newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === "undefined") newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        } // Activate thumbs
        var thumbsToActivate = 1;
        var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(var i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.$wrapperEl.children('[data-swiper-slide-index="'.concat(swiper.realIndex + i, '"]')).addClass(thumbActiveClass);
        else for(var i1 = 0; i1 < thumbsToActivate; i1 += 1)thumbsSwiper.slides.eq(swiper.realIndex + i1).addClass(thumbActiveClass);
    };
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    var initialized = false;
    var swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    on("beforeInit", function() {
        var thumbs = swiper.params.thumbs;
        if (!thumbs || !thumbs.swiper) return;
        init();
        update(true);
    });
    on("slideChange update resize observerUpdate", function() {
        if (!swiper.thumbs.swiper) return;
        update();
    });
    on("setTransition", function(_s, duration) {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", function() {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        if (swiperCreated && thumbsSwiper) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}
exports.default = Thumb;

},{"../../shared/utils.js":"hHZfI","../../shared/dom.js":"aVcu8","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"lWRkl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../../shared/utils.js");
function freeMode(param) {
    var swiper = param.swiper, extendParams = param.extendParams, emit = param.emit, once = param.once;
    var onTouchMove = function onTouchMove() {
        var data = swiper.touchEventsData, touches = swiper.touches; // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, _utilsJs.now)()
        });
    };
    var onTouchEnd = function onTouchEnd(param) {
        var currentPos = param.currentPos;
        var params = swiper.params, $wrapperEl = swiper.$wrapperEl, rtl = swiper.rtlTranslate, snapGrid = swiper.snapGrid, data = swiper.touchEventsData; // Time diff
        var touchEndTime = (0, _utilsJs.now)();
        var timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                var lastMoveEvent = data.velocities.pop();
                var velocityEvent = data.velocities.pop();
                var distance = lastMoveEvent.position - velocityEvent.position;
                var time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                 // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, _utilsJs.now)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            var momentumDuration = 1000 * params.freeMode.momentumRatio;
            var momentumDistance = swiper.velocity * momentumDuration;
            var newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            var doBounce = false;
            var afterBouncePosition;
            var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            var needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                var nextSlide;
                for(var j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", function() {
                swiper.loopFix();
            });
             // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(function() {
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(function() {
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(function() {
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(function() {
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    };
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    Object.assign(swiper, {
        freeMode: {
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}
exports.default = freeMode;

},{"../../shared/utils.js":"hHZfI","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"a7HHF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _definePropertyMjs = require("@swc/helpers/src/_define_property.mjs");
var _definePropertyMjsDefault = parcelHelpers.interopDefault(_definePropertyMjs);
var _toConsumableArrayMjs = require("@swc/helpers/src/_to_consumable_array.mjs");
var _toConsumableArrayMjsDefault = parcelHelpers.interopDefault(_toConsumableArrayMjs);
function Grid(param) {
    var swiper = param.swiper, extendParams = param.extendParams;
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    var slidesNumberEvenToRows;
    var slidesPerRow;
    var numFullColumns;
    var initSlides = function(slidesLength) {
        var slidesPerView = swiper.params.slidesPerView;
        var _swiper_params_grid = swiper.params.grid, rows = _swiper_params_grid.rows, fill = _swiper_params_grid.fill;
        slidesPerRow = slidesNumberEvenToRows / rows;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
    };
    var updateSlide = function(i, slide, slidesLength, getDirectionLabel) {
        var _swiper_params = swiper.params, slidesPerGroup = _swiper_params.slidesPerGroup, spaceBetween = _swiper_params.spaceBetween;
        var _swiper_params_grid = swiper.params.grid, rows = _swiper_params_grid.rows, fill = _swiper_params_grid.fill; // Set slides order
        var newSlideOrderIndex;
        var column;
        var row;
        if (fill === "row" && slidesPerGroup > 1) {
            var groupIndex = Math.floor(i / (slidesPerGroup * rows));
            var slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            var columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.css({
                "-webkit-order": newSlideOrderIndex,
                order: newSlideOrderIndex
            });
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.css(getDirectionLabel("margin-top"), row !== 0 ? spaceBetween && "".concat(spaceBetween, "px") : "");
    };
    var updateWrapperSize = function(slideSize, snapGrid, getDirectionLabel) {
        var _swiper_params = swiper.params, spaceBetween = _swiper_params.spaceBetween, centeredSlides = _swiper_params.centeredSlides, roundLengths = _swiper_params.roundLengths;
        var rows = swiper.params.grid.rows;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.$wrapperEl.css((0, _definePropertyMjsDefault.default)({}, getDirectionLabel("width"), "".concat(swiper.virtualSize + spaceBetween, "px")));
        if (centeredSlides) {
            var _snapGrid;
            snapGrid.splice(0, snapGrid.length);
            var newSlidesGrid = [];
            for(var i = 0; i < snapGrid.length; i += 1){
                var slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            (_snapGrid = snapGrid).push.apply(_snapGrid, (0, _toConsumableArrayMjsDefault.default)(newSlidesGrid));
        }
    };
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}
exports.default = Grid;

},{"@swc/helpers/src/_define_property.mjs":"eI7TS","@swc/helpers/src/_to_consumable_array.mjs":"11hUU","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"lc0m6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _appendSlideJs = require("./methods/appendSlide.js");
var _appendSlideJsDefault = parcelHelpers.interopDefault(_appendSlideJs);
var _prependSlideJs = require("./methods/prependSlide.js");
var _prependSlideJsDefault = parcelHelpers.interopDefault(_prependSlideJs);
var _addSlideJs = require("./methods/addSlide.js");
var _addSlideJsDefault = parcelHelpers.interopDefault(_addSlideJs);
var _removeSlideJs = require("./methods/removeSlide.js");
var _removeSlideJsDefault = parcelHelpers.interopDefault(_removeSlideJs);
var _removeAllSlidesJs = require("./methods/removeAllSlides.js");
var _removeAllSlidesJsDefault = parcelHelpers.interopDefault(_removeAllSlidesJs);
function Manipulation(param) {
    var swiper = param.swiper;
    Object.assign(swiper, {
        appendSlide: (0, _appendSlideJsDefault.default).bind(swiper),
        prependSlide: (0, _prependSlideJsDefault.default).bind(swiper),
        addSlide: (0, _addSlideJsDefault.default).bind(swiper),
        removeSlide: (0, _removeSlideJsDefault.default).bind(swiper),
        removeAllSlides: (0, _removeAllSlidesJsDefault.default).bind(swiper)
    });
}
exports.default = Manipulation;

},{"./methods/appendSlide.js":"cTUa5","./methods/prependSlide.js":"f1g5v","./methods/addSlide.js":"4gYAZ","./methods/removeSlide.js":"fSPtF","./methods/removeAllSlides.js":"2p7Q7","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"cTUa5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function appendSlide(slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params;
    if (params.loop) swiper.loopDestroy();
    if (typeof slides === "object" && "length" in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
}
exports.default = appendSlide;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"f1g5v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function prependSlide(slides) {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex;
    if (params.loop) swiper.loopDestroy();
    var newActiveIndex = activeIndex + 1;
    if (typeof slides === "object" && "length" in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
exports.default = prependSlide;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"4gYAZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function addSlide(index, slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(".".concat(params.slideClass));
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    var slidesBuffer = [];
    for(var i = baseLength - 1; i >= index; i -= 1){
        var currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(var i1 = 0; i1 < slides.length; i1 += 1)if (slides[i1]) $wrapperEl.append(slides[i1]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(var i2 = 0; i2 < slidesBuffer.length; i2 += 1)$wrapperEl.append(slidesBuffer[i2]);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
exports.default = addSlide;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"fSPtF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function removeSlide(slidesIndexes) {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(".".concat(params.slideClass));
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(var i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
exports.default = removeSlide;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"2p7Q7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function removeAllSlides() {
    var swiper = this;
    var slidesIndexes = [];
    for(var i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
exports.default = removeAllSlides;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"hk8Gh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _effectInitJs = require("../../shared/effect-init.js");
var _effectInitJsDefault = parcelHelpers.interopDefault(_effectInitJs);
var _effectTargetJs = require("../../shared/effect-target.js");
var _effectTargetJsDefault = parcelHelpers.interopDefault(_effectTargetJs);
var _effectVirtualTransitionEndJs = require("../../shared/effect-virtual-transition-end.js");
var _effectVirtualTransitionEndJsDefault = parcelHelpers.interopDefault(_effectVirtualTransitionEndJs);
function EffectFade(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        fadeEffect: {
            crossFade: false,
            transformEl: null
        }
    });
    var setTranslate = function() {
        var slides = swiper.slides;
        var params = swiper.params.fadeEffect;
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = swiper.slides.eq(i);
            var offset = $slideEl[0].swiperSlideOffset;
            var tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            var $targetEl = (0, _effectTargetJsDefault.default)(params, $slideEl);
            $targetEl.css({
                opacity: slideOpacity
            }).transform("translate3d(".concat(tx, "px, ").concat(ty, "px, 0px)"));
        }
    };
    var setTransition = function(duration) {
        var transformEl = swiper.params.fadeEffect.transformEl;
        var $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration);
        (0, _effectVirtualTransitionEndJsDefault.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, _effectInitJsDefault.default)({
        effect: "fade",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}
exports.default = EffectFade;

},{"../../shared/effect-init.js":"9aLvU","../../shared/effect-target.js":"guayR","../../shared/effect-virtual-transition-end.js":"3AWfO","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"9aLvU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function effectInit(params) {
    var effect = params.effect, swiper = params.swiper, on = params.on, setTranslate = params.setTranslate, setTransition = params.setTransition, overwriteParams = params.overwriteParams, perspective = params.perspective;
    on("beforeInit", function() {
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass).concat(effect));
        if (perspective && perspective()) swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
        var overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate", function() {
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", function(_s, duration) {
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
}
exports.default = effectInit;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"guayR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function effectTarget(effectParams, $slideEl) {
    if (effectParams.transformEl) return $slideEl.find(effectParams.transformEl).css({
        "backface-visibility": "hidden",
        "-webkit-backface-visibility": "hidden"
    });
    return $slideEl;
}
exports.default = effectTarget;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"3AWfO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function effectVirtualTransitionEnd(param) {
    var swiper = param.swiper, duration = param.duration, transformEl = param.transformEl, allSlides = param.allSlides;
    var slides = swiper.slides, activeIndex = swiper.activeIndex, $wrapperEl = swiper.$wrapperEl;
    if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        var $transitionEndTarget;
        if (allSlides) $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
        else $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
        $transitionEndTarget.transitionEnd(function() {
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            eventTriggered = true;
            swiper.animating = false;
            var triggerEvents = [
                "webkitTransitionEnd",
                "transitionend"
            ];
            for(var i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
        });
    }
}
exports.default = effectVirtualTransitionEnd;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"LyU98":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _effectInitJs = require("../../shared/effect-init.js");
var _effectInitJsDefault = parcelHelpers.interopDefault(_effectInitJs);
function EffectCube(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    var setTranslate = function() {
        var $el = swiper.$el, $wrapperEl = swiper.$wrapperEl, slides = swiper.slides, swiperWidth = swiper.width, swiperHeight = swiper.height, rtl = swiper.rtlTranslate, swiperSize = swiper.size, browser = swiper.browser;
        var params = swiper.params.cubeEffect;
        var isHorizontal = swiper.isHorizontal();
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var wrapperRotate = 0;
        var $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, _domJsDefault.default)('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: "".concat(swiperWidth, "px")
                });
            } else {
                $cubeShadowEl = $el.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, _domJsDefault.default)('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = slides.eq(i);
            var slideIndex = i;
            if (isVirtual) slideIndex = parseInt($slideEl.attr("data-swiper-slide-index"), 10);
            var slideAngle = slideIndex * 90;
            var round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            var tx = 0;
            var ty = 0;
            var tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            var transform = "rotateX(".concat(isHorizontal ? 0 : -slideAngle, "deg) rotateY(").concat(isHorizontal ? slideAngle : 0, "deg) translate3d(").concat(tx, "px, ").concat(ty, "px, ").concat(tz, "px)");
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(transform);
            if (params.slideShadows) {
                // Set shadows
                var shadowBefore = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                var shadowAfter = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if (shadowBefore.length === 0) {
                    shadowBefore = (0, _domJsDefault.default)('<div class="swiper-slide-shadow-'.concat(isHorizontal ? "left" : "top", '"></div>'));
                    $slideEl.append(shadowBefore);
                }
                if (shadowAfter.length === 0) {
                    shadowAfter = (0, _domJsDefault.default)('<div class="swiper-slide-shadow-'.concat(isHorizontal ? "right" : "bottom", '"></div>'));
                    $slideEl.append(shadowAfter);
                }
                if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
        }
        $wrapperEl.css({
            "-webkit-transform-origin": "50% 50% -".concat(swiperSize / 2, "px"),
            "transform-origin": "50% 50% -".concat(swiperSize / 2, "px")
        });
        if (params.shadow) {
            if (isHorizontal) $cubeShadowEl.transform("translate3d(0px, ".concat(swiperWidth / 2 + params.shadowOffset, "px, ").concat(-swiperWidth / 2, "px) rotateX(90deg) rotateZ(0deg) scale(").concat(params.shadowScale, ")"));
            else {
                var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                var scale1 = params.shadowScale;
                var scale2 = params.shadowScale / multiplier;
                var offset = params.shadowOffset;
                $cubeShadowEl.transform("scale3d(".concat(scale1, ", 1, ").concat(scale2, ") translate3d(0px, ").concat(swiperHeight / 2 + offset, "px, ").concat(-swiperHeight / 2 / scale2, "px) rotateX(-90deg)"));
            }
        }
        var zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform("translate3d(0px,0,".concat(zFactor, "px) rotateX(").concat(swiper.isHorizontal() ? 0 : wrapperRotate, "deg) rotateY(").concat(swiper.isHorizontal() ? -wrapperRotate : 0, "deg)"));
    };
    var setTransition = function(duration) {
        var $el = swiper.$el, slides = swiper.slides;
        slides.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) $el.find(".swiper-cube-shadow").transition(duration);
    };
    (0, _effectInitJsDefault.default)({
        effect: "cube",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            };
        }
    });
}
exports.default = EffectCube;

},{"../../shared/dom.js":"aVcu8","../../shared/effect-init.js":"9aLvU","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"gs0zk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createShadowJs = require("../../shared/create-shadow.js");
var _createShadowJsDefault = parcelHelpers.interopDefault(_createShadowJs);
var _effectInitJs = require("../../shared/effect-init.js");
var _effectInitJsDefault = parcelHelpers.interopDefault(_effectInitJs);
var _effectTargetJs = require("../../shared/effect-target.js");
var _effectTargetJsDefault = parcelHelpers.interopDefault(_effectTargetJs);
var _effectVirtualTransitionEndJs = require("../../shared/effect-virtual-transition-end.js");
var _effectVirtualTransitionEndJsDefault = parcelHelpers.interopDefault(_effectVirtualTransitionEndJs);
function EffectFlip(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true,
            transformEl: null
        }
    });
    var setTranslate = function() {
        var slides = swiper.slides, rtl = swiper.rtlTranslate;
        var params = swiper.params.flipEffect;
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = slides.eq(i);
            var progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            var offset = $slideEl[0].swiperSlideOffset;
            var rotate = -180 * progress;
            var rotateY = rotate;
            var rotateX = 0;
            var tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) {
                // Set shadows
                var shadowBefore = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                var shadowAfter = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if (shadowBefore.length === 0) shadowBefore = (0, _createShadowJsDefault.default)(params, $slideEl, swiper.isHorizontal() ? "left" : "top");
                if (shadowAfter.length === 0) shadowAfter = (0, _createShadowJsDefault.default)(params, $slideEl, swiper.isHorizontal() ? "right" : "bottom");
                if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
            var transform = "translate3d(".concat(tx, "px, ").concat(ty, "px, 0px) rotateX(").concat(rotateX, "deg) rotateY(").concat(rotateY, "deg)");
            var $targetEl = (0, _effectTargetJsDefault.default)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    var setTransition = function(duration) {
        var transformEl = swiper.params.flipEffect.transformEl;
        var $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        (0, _effectVirtualTransitionEndJsDefault.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, _effectInitJsDefault.default)({
        effect: "flip",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}
exports.default = EffectFlip;

},{"../../shared/create-shadow.js":"ez80b","../../shared/effect-init.js":"9aLvU","../../shared/effect-target.js":"guayR","../../shared/effect-virtual-transition-end.js":"3AWfO","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"ez80b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _domJs = require("./dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function createShadow(params, $slideEl, side) {
    var shadowClass = "swiper-slide-shadow".concat(side ? "-".concat(side) : "");
    var $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
    var $shadowEl = $shadowContainer.children(".".concat(shadowClass));
    if (!$shadowEl.length) {
        $shadowEl = (0, _domJsDefault.default)('<div class="swiper-slide-shadow'.concat(side ? "-".concat(side) : "", '"></div>'));
        $shadowContainer.append($shadowEl);
    }
    return $shadowEl;
}
exports.default = createShadow;

},{"./dom.js":"aVcu8","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"25hd1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createShadowJs = require("../../shared/create-shadow.js");
var _createShadowJsDefault = parcelHelpers.interopDefault(_createShadowJs);
var _effectInitJs = require("../../shared/effect-init.js");
var _effectInitJsDefault = parcelHelpers.interopDefault(_effectInitJs);
var _effectTargetJs = require("../../shared/effect-target.js");
var _effectTargetJsDefault = parcelHelpers.interopDefault(_effectTargetJs);
function EffectCoverflow(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true,
            transformEl: null
        }
    });
    var setTranslate = function() {
        var swiperWidth = swiper.width, swiperHeight = swiper.height, slides = swiper.slides, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.coverflowEffect;
        var isHorizontal = swiper.isHorizontal();
        var transform = swiper.translate;
        var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        var rotate = isHorizontal ? params.rotate : -params.rotate;
        var translate = params.depth; // Each slide offset from center
        for(var i = 0, length = slides.length; i < length; i += 1){
            var $slideEl = slides.eq(i);
            var slideSize = slidesSizesGrid[i];
            var slideOffset = $slideEl[0].swiperSlideOffset;
            var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;
            var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
            var translateZ = -translate * Math.abs(offsetMultiplier);
            var stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            var translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            var translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            var slideTransform = "translate3d(".concat(translateX, "px,").concat(translateY, "px,").concat(translateZ, "px)  rotateX(").concat(rotateX, "deg) rotateY(").concat(rotateY, "deg) scale(").concat(scale, ")");
            var $targetEl = (0, _effectTargetJsDefault.default)(params, $slideEl);
            $targetEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                var $shadowBeforeEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                var $shadowAfterEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if ($shadowBeforeEl.length === 0) $shadowBeforeEl = (0, _createShadowJsDefault.default)(params, $slideEl, isHorizontal ? "left" : "top");
                if ($shadowAfterEl.length === 0) $shadowAfterEl = (0, _createShadowJsDefault.default)(params, $slideEl, isHorizontal ? "right" : "bottom");
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    var setTransition = function(duration) {
        var transformEl = swiper.params.coverflowEffect.transformEl;
        var $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
    };
    (0, _effectInitJsDefault.default)({
        effect: "coverflow",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true
            };
        }
    });
}
exports.default = EffectCoverflow;

},{"../../shared/create-shadow.js":"ez80b","../../shared/effect-init.js":"9aLvU","../../shared/effect-target.js":"guayR","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"l5Zfb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createShadowJs = require("../../shared/create-shadow.js");
var _createShadowJsDefault = parcelHelpers.interopDefault(_createShadowJs);
var _effectInitJs = require("../../shared/effect-init.js");
var _effectInitJsDefault = parcelHelpers.interopDefault(_effectInitJs);
var _effectTargetJs = require("../../shared/effect-target.js");
var _effectTargetJsDefault = parcelHelpers.interopDefault(_effectTargetJs);
var _effectVirtualTransitionEndJs = require("../../shared/effect-virtual-transition-end.js");
var _effectVirtualTransitionEndJsDefault = parcelHelpers.interopDefault(_effectVirtualTransitionEndJs);
function EffectCreative(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        creativeEffect: {
            transformEl: null,
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    var getTranslateValue = function(value) {
        if (typeof value === "string") return value;
        return "".concat(value, "px");
    };
    var setTranslate = function() {
        var _loop = function(i) {
            var $slideEl = slides.eq(i);
            var slideProgress = $slideEl[0].progress;
            var progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
            var originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
            var offset = $slideEl[0].swiperSlideOffset;
            var t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            var r = [
                0,
                0,
                0
            ];
            var custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            var data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            } // set translate
            t.forEach(function(value, index) {
                t[index] = "calc(".concat(value, "px + (").concat(getTranslateValue(data.translate[index]), " * ").concat(Math.abs(progress * multiplier), "))");
            }); // set rotates
            r.forEach(function(value, index) {
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            var translateString = t.join(", ");
            var rotateString = "rotateX(".concat(r[0], "deg) rotateY(").concat(r[1], "deg) rotateZ(").concat(r[2], "deg)");
            var scaleString = originalProgress < 0 ? "scale(".concat(1 + (1 - data.scale) * originalProgress * multiplier, ")") : "scale(".concat(1 - (1 - data.scale) * originalProgress * multiplier, ")");
            var opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            var transform = "translate3d(".concat(translateString, ") ").concat(rotateString, " ").concat(scaleString); // Set shadows
            if (custom && data.shadow || !custom) {
                var $shadowEl = $slideEl.children(".swiper-slide-shadow");
                if ($shadowEl.length === 0 && data.shadow) $shadowEl = (0, _createShadowJsDefault.default)(params, $slideEl);
                if ($shadowEl.length) {
                    var shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            var $targetEl = (0, _effectTargetJsDefault.default)(params, $slideEl);
            $targetEl.transform(transform).css({
                opacity: opacityString
            });
            if (data.origin) $targetEl.css("transform-origin", data.origin);
        };
        var slides = swiper.slides, $wrapperEl = swiper.$wrapperEl, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.creativeEffect;
        var multiplier = params.progressMultiplier;
        var isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            var margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            $wrapperEl.transform("translateX(calc(50% - ".concat(margin, "px))"));
        }
        for(var i = 0; i < slides.length; i += 1)_loop(i);
    };
    var setTransition = function(duration) {
        var transformEl = swiper.params.creativeEffect.transformEl;
        var $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow").transition(duration);
        (0, _effectVirtualTransitionEndJsDefault.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, _effectInitJsDefault.default)({
        effect: "creative",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return swiper.params.creativeEffect.perspective;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}
exports.default = EffectCreative;

},{"../../shared/create-shadow.js":"ez80b","../../shared/effect-init.js":"9aLvU","../../shared/effect-target.js":"guayR","../../shared/effect-virtual-transition-end.js":"3AWfO","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"3hPrO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createShadowJs = require("../../shared/create-shadow.js");
var _createShadowJsDefault = parcelHelpers.interopDefault(_createShadowJs);
var _effectInitJs = require("../../shared/effect-init.js");
var _effectInitJsDefault = parcelHelpers.interopDefault(_effectInitJs);
var _effectTargetJs = require("../../shared/effect-target.js");
var _effectTargetJsDefault = parcelHelpers.interopDefault(_effectTargetJs);
var _effectVirtualTransitionEndJs = require("../../shared/effect-virtual-transition-end.js");
var _effectVirtualTransitionEndJsDefault = parcelHelpers.interopDefault(_effectVirtualTransitionEndJs);
function EffectCards(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            transformEl: null
        }
    });
    var setTranslate = function() {
        var slides = swiper.slides, activeIndex = swiper.activeIndex;
        var params = swiper.params.cardsEffect;
        var _swiper_touchEventsData = swiper.touchEventsData, startTranslate = _swiper_touchEventsData.startTranslate, isTouched = _swiper_touchEventsData.isTouched;
        var currentTranslate = swiper.translate;
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = slides.eq(i);
            var slideProgress = $slideEl[0].progress;
            var progress = Math.min(Math.max(slideProgress, -4), 4);
            var offset = $slideEl[0].swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.$wrapperEl.transform("translateX(".concat(swiper.minTranslate(), "px)"));
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            var tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            var tY = 0;
            var tZ = -100 * Math.abs(progress);
            var scale = 1;
            var rotate = -2 * progress;
            var tXAdd = 8 - Math.abs(progress) * 0.75;
            var isSwipeToNext = (i === activeIndex || i === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            var isSwipeToPrev = (i === activeIndex || i === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                var subProgress = Math.pow(1 - Math.abs((Math.abs(progress) - 0.5) / 0.5), 0.5);
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = "".concat(-25 * subProgress * Math.abs(progress), "%");
            }
            if (progress < 0) // next
            tX = "calc(".concat(tX, "px + (").concat(tXAdd * Math.abs(progress), "%))");
            else if (progress > 0) // prev
            tX = "calc(".concat(tX, "px + (-").concat(tXAdd * Math.abs(progress), "%))");
            else tX = "".concat(tX, "px");
            if (!swiper.isHorizontal()) {
                var prevY = tY;
                tY = tX;
                tX = prevY;
            }
            var scaleString = progress < 0 ? "".concat(1 + (1 - scale) * progress) : "".concat(1 - (1 - scale) * progress);
            var transform = "\n        translate3d(".concat(tX, ", ").concat(tY, ", ").concat(tZ, "px)\n        rotateZ(").concat(rotate, "deg)\n        scale(").concat(scaleString, ")\n      ");
            if (params.slideShadows) {
                // Set shadows
                var $shadowEl = $slideEl.find(".swiper-slide-shadow");
                if ($shadowEl.length === 0) $shadowEl = (0, _createShadowJsDefault.default)(params, $slideEl);
                if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            var $targetEl = (0, _effectTargetJsDefault.default)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    var setTransition = function(duration) {
        var transformEl = swiper.params.cardsEffect.transformEl;
        var $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow").transition(duration);
        (0, _effectVirtualTransitionEndJsDefault.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, _effectInitJsDefault.default)({
        effect: "cards",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}
exports.default = EffectCards;

},{"../../shared/create-shadow.js":"ez80b","../../shared/effect-init.js":"9aLvU","../../shared/effect-target.js":"guayR","../../shared/effect-virtual-transition-end.js":"3AWfO","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"fG4vm":[function(require,module,exports) {
/**
 * Swiper React 7.4.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: December 24, 2021
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Swiper", function() {
    return 0, _swiperJs.Swiper;
});
parcelHelpers.export(exports, "SwiperSlide", function() {
    return 0, _swiperSlideJs.SwiperSlide;
});
var _swiperJs = require("./swiper.js");
var _swiperSlideJs = require("./swiper-slide.js");

},{"./swiper.js":"lxzvY","./swiper-slide.js":"4G4xh","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"lxzvY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Swiper", function() {
    return Swiper;
});
var _objectWithoutPropertiesMjs = require("@swc/helpers/src/_object_without_properties.mjs");
var _objectWithoutPropertiesMjsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesMjs);
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _getParamsJs = require("./get-params.js");
var _initSwiperJs = require("./init-swiper.js");
var _utilsJs = require("./utils.js");
var _loopJs = require("./loop.js");
var _getChangedParamsJs = require("./get-changed-params.js");
var _getChildrenJs = require("./get-children.js");
var _updateSwiperJs = require("./update-swiper.js");
var _virtualJs = require("./virtual.js");
var _useIsomorphicLayoutEffectJs = require("./use-isomorphic-layout-effect.js");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var Swiper = /*#__PURE__*/ (0, _react.forwardRef)(function() {
    var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, externalElRef = arguments.length > 1 ? arguments[1] : void 0;
    var renderSlides = function renderSlides() {
        if (swiperParams.virtual) return (0, _virtualJs.renderVirtual)(swiperRef.current, slides, virtualData);
        if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) return slides.map(function(child) {
            return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(child, {
                swiper: swiperRef.current
            });
        });
        return (0, _loopJs.renderLoop)(swiperRef.current, slides, swiperParams);
    };
    var className = _param.className, tmp = _param.tag, Tag = tmp === void 0 ? "div" : tmp, tmp1 = _param.wrapperTag, WrapperTag = tmp1 === void 0 ? "div" : tmp1, children = _param.children, onSwiper = _param.onSwiper, rest = (0, _objectWithoutPropertiesMjsDefault.default)(_param, [
        "className",
        "tag",
        "wrapperTag",
        "children",
        "onSwiper"
    ]);
    var eventsAssigned = false;
    var _useState = (0, _slicedToArrayMjsDefault.default)((0, _react.useState)("swiper"), 2), containerClasses = _useState[0], setContainerClasses = _useState[1];
    var _useState1 = (0, _slicedToArrayMjsDefault.default)((0, _react.useState)(null), 2), virtualData = _useState1[0], setVirtualData = _useState1[1];
    var _useState2 = (0, _slicedToArrayMjsDefault.default)((0, _react.useState)(false), 2), breakpointChanged = _useState2[0], setBreakpointChanged = _useState2[1];
    var initializedRef = (0, _react.useRef)(false);
    var swiperElRef = (0, _react.useRef)(null);
    var swiperRef = (0, _react.useRef)(null);
    var oldPassedParamsRef = (0, _react.useRef)(null);
    var oldSlides = (0, _react.useRef)(null);
    var nextElRef = (0, _react.useRef)(null);
    var prevElRef = (0, _react.useRef)(null);
    var paginationElRef = (0, _react.useRef)(null);
    var scrollbarElRef = (0, _react.useRef)(null);
    var _getParams = (0, _getParamsJs.getParams)(rest), swiperParams = _getParams.params, passedParams = _getParams.passedParams, restProps = _getParams.rest, events = _getParams.events;
    var _getChildren = (0, _getChildrenJs.getChildren)(children), slides = _getChildren.slides, slots = _getChildren.slots;
    var onBeforeBreakpoint = function() {
        setBreakpointChanged(!breakpointChanged);
    };
    Object.assign(swiperParams.on, {
        _containerClasses: function(swiper, classes) {
            setContainerClasses(classes);
        }
    });
    if (!swiperElRef.current) {
        // init swiper
        Object.assign(swiperParams.on, events);
        eventsAssigned = true;
        swiperRef.current = (0, _initSwiperJs.initSwiper)(swiperParams);
        swiperRef.current.loopCreate = function() {};
        swiperRef.current.loopDestroy = function() {};
        if (swiperParams.loop) swiperRef.current.loopedSlides = (0, _loopJs.calcLoopedSlides)(slides, swiperParams);
        if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
            swiperRef.current.virtual.slides = slides;
            var extendWith = {
                cache: false,
                slides: slides,
                renderExternal: setVirtualData,
                renderExternalUpdate: false
            };
            (0, _utilsJs.extend)(swiperRef.current.params.virtual, extendWith);
            (0, _utilsJs.extend)(swiperRef.current.originalParams.virtual, extendWith);
        }
    } // Listen for breakpoints change
    if (swiperRef.current) swiperRef.current.on("_beforeBreakpoint", onBeforeBreakpoint);
    var attachEvents = function() {
        if (eventsAssigned || !events || !swiperRef.current) return;
        Object.keys(events).forEach(function(eventName) {
            swiperRef.current.on(eventName, events[eventName]);
        });
    };
    var detachEvents = function() {
        if (!events || !swiperRef.current) return;
        Object.keys(events).forEach(function(eventName) {
            swiperRef.current.off(eventName, events[eventName]);
        });
    };
    (0, _react.useEffect)(function() {
        return function() {
            if (swiperRef.current) swiperRef.current.off("_beforeBreakpoint", onBeforeBreakpoint);
        };
    }); // set initialized flag
    (0, _react.useEffect)(function() {
        if (!initializedRef.current && swiperRef.current) {
            swiperRef.current.emitSlidesClasses();
            initializedRef.current = true;
        }
    }); // mount swiper
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(function() {
        if (externalElRef) externalElRef.current = swiperElRef.current;
        if (!swiperElRef.current) return;
        (0, _initSwiperJs.mountSwiper)({
            el: swiperElRef.current,
            nextEl: nextElRef.current,
            prevEl: prevElRef.current,
            paginationEl: paginationElRef.current,
            scrollbarEl: scrollbarElRef.current,
            swiper: swiperRef.current
        }, swiperParams);
        if (onSwiper) onSwiper(swiperRef.current); // eslint-disable-next-line
        return function() {
            if (swiperRef.current && !swiperRef.current.destroyed) swiperRef.current.destroy(true, false);
        };
    }, []); // watch for params change
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(function() {
        attachEvents();
        var changedParams = (0, _getChangedParamsJs.getChangedParams)(passedParams, oldPassedParamsRef.current, slides, oldSlides.current);
        oldPassedParamsRef.current = passedParams;
        oldSlides.current = slides;
        if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) (0, _updateSwiperJs.updateSwiper)({
            swiper: swiperRef.current,
            slides: slides,
            passedParams: passedParams,
            changedParams: changedParams,
            nextEl: nextElRef.current,
            prevEl: prevElRef.current,
            scrollbarEl: scrollbarElRef.current,
            paginationEl: paginationElRef.current
        });
        return function() {
            detachEvents();
        };
    }); // update on virtual update
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(function() {
        (0, _virtualJs.updateOnVirtualData)(swiperRef.current);
    }, [
        virtualData
    ]); // bypass swiper instance to slides
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, _extends({
        ref: swiperElRef,
        className: (0, _utilsJs.uniqueClasses)("".concat(containerClasses).concat(className ? " ".concat(className) : ""))
    }, restProps), slots["container-start"], (0, _utilsJs.needsNavigation)(swiperParams) && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: prevElRef,
        className: "swiper-button-prev"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: nextElRef,
        className: "swiper-button-next"
    })), (0, _utilsJs.needsScrollbar)(swiperParams) && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: scrollbarElRef,
        className: "swiper-scrollbar"
    }), (0, _utilsJs.needsPagination)(swiperParams) && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: paginationElRef,
        className: "swiper-pagination"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(WrapperTag, {
        className: "swiper-wrapper"
    }, slots["wrapper-start"], renderSlides(), slots["wrapper-end"]), slots["container-end"]);
});
Swiper.displayName = "Swiper";

},{"@swc/helpers/src/_object_without_properties.mjs":"d0eOZ","@swc/helpers/src/_sliced_to_array.mjs":"l34hS","react":"ihebA","./get-params.js":"aUa46","./init-swiper.js":"7N8X2","./utils.js":"7e9qr","./loop.js":"4qtVE","./get-changed-params.js":"lGXUm","./get-children.js":"bDr4W","./update-swiper.js":"cZpJ3","./virtual.js":"9doG4","./use-isomorphic-layout-effect.js":"cO17y","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"aUa46":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getParams", function() {
    return getParams;
});
var _swiper = require("swiper");
var _swiperDefault = parcelHelpers.interopDefault(_swiper);
var _utilsJs = require("./utils.js");
var _paramsListJs = require("./params-list.js");
function getParams() {
    var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var params = {
        on: {}
    };
    var events = {};
    var passedParams = {};
    (0, _utilsJs.extend)(params, (0, _swiperDefault.default).defaults);
    (0, _utilsJs.extend)(params, (0, _swiperDefault.default).extendedDefaults);
    params._emitClasses = true;
    params.init = false;
    var rest = {};
    var allowedParams = (0, _paramsListJs.paramsList).map(function(key) {
        return key.replace(/_/, "");
    });
    Object.keys(obj).forEach(function(key) {
        if (allowedParams.indexOf(key) >= 0) {
            if ((0, _utilsJs.isObject)(obj[key])) {
                params[key] = {};
                passedParams[key] = {};
                (0, _utilsJs.extend)(params[key], obj[key]);
                (0, _utilsJs.extend)(passedParams[key], obj[key]);
            } else {
                params[key] = obj[key];
                passedParams[key] = obj[key];
            }
        } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === "function") events["".concat(key[2].toLowerCase()).concat(key.substr(3))] = obj[key];
        else rest[key] = obj[key];
    });
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach(function(key) {
        if (params[key] === true) params[key] = {};
        if (params[key] === false) delete params[key];
    });
    return {
        params: params,
        passedParams: passedParams,
        rest: rest,
        events: events
    };
}

},{"swiper":"dBrcy","./utils.js":"7e9qr","./params-list.js":"dfX5S","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"7e9qr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObject", function() {
    return isObject;
});
parcelHelpers.export(exports, "extend", function() {
    return extend;
});
parcelHelpers.export(exports, "needsNavigation", function() {
    return needsNavigation;
});
parcelHelpers.export(exports, "needsPagination", function() {
    return needsPagination;
});
parcelHelpers.export(exports, "needsScrollbar", function() {
    return needsScrollbar;
});
parcelHelpers.export(exports, "uniqueClasses", function() {
    return uniqueClasses;
});
function isObject(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function extend(target, src) {
    var noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    Object.keys(src).filter(function(key) {
        return noExtend.indexOf(key) < 0;
    }).forEach(function(key) {
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
            if (src[key].__swiper__) target[key] = src[key];
            else extend(target[key], src[key]);
        } else target[key] = src[key];
    });
}
function needsNavigation() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return params.navigation && typeof params.navigation.nextEl === "undefined" && typeof params.navigation.prevEl === "undefined";
}
function needsPagination() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return params.pagination && typeof params.pagination.el === "undefined";
}
function needsScrollbar() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return params.scrollbar && typeof params.scrollbar.el === "undefined";
}
function uniqueClasses() {
    var classNames = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var classes = classNames.split(" ").map(function(c) {
        return c.trim();
    }).filter(function(c) {
        return !!c;
    });
    var unique = [];
    classes.forEach(function(c) {
        if (unique.indexOf(c) < 0) unique.push(c);
    });
    return unique.join(" ");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"dfX5S":[function(require,module,exports) {
/* underscore in name -> watch for changes */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "paramsList", function() {
    return paramsList;
});
var paramsList = [
    "modules",
    "init",
    "_direction",
    "touchEventsTarget",
    "initialSlide",
    "_speed",
    "cssMode",
    "updateOnWindowResize",
    "resizeObserver",
    "nested",
    "focusableElements",
    "_enabled",
    "_width",
    "_height",
    "preventInteractionOnTransition",
    "userAgent",
    "url",
    "_edgeSwipeDetection",
    "_edgeSwipeThreshold",
    "_freeMode",
    "_autoHeight",
    "setWrapperSize",
    "virtualTranslate",
    "_effect",
    "breakpoints",
    "_spaceBetween",
    "_slidesPerView",
    "_grid",
    "_slidesPerGroup",
    "_slidesPerGroupSkip",
    "_slidesPerGroupAuto",
    "_centeredSlides",
    "_centeredSlidesBounds",
    "_slidesOffsetBefore",
    "_slidesOffsetAfter",
    "normalizeSlideIndex",
    "_centerInsufficientSlides",
    "_watchOverflow",
    "roundLengths",
    "touchRatio",
    "touchAngle",
    "simulateTouch",
    "_shortSwipes",
    "_longSwipes",
    "longSwipesRatio",
    "longSwipesMs",
    "_followFinger",
    "allowTouchMove",
    "_threshold",
    "touchMoveStopPropagation",
    "touchStartPreventDefault",
    "touchStartForcePreventDefault",
    "touchReleaseOnEdges",
    "uniqueNavElements",
    "_resistance",
    "_resistanceRatio",
    "_watchSlidesProgress",
    "_grabCursor",
    "preventClicks",
    "preventClicksPropagation",
    "_slideToClickedSlide",
    "_preloadImages",
    "updateOnImagesReady",
    "_loop",
    "_loopAdditionalSlides",
    "_loopedSlides",
    "_loopFillGroupWithBlank",
    "loopPreventsSlide",
    "_rewind",
    "_allowSlidePrev",
    "_allowSlideNext",
    "_swipeHandler",
    "_noSwiping",
    "noSwipingClass",
    "noSwipingSelector",
    "passiveListeners",
    "containerModifierClass",
    "slideClass",
    "slideBlankClass",
    "slideActiveClass",
    "slideDuplicateActiveClass",
    "slideVisibleClass",
    "slideDuplicateClass",
    "slideNextClass",
    "slideDuplicateNextClass",
    "slidePrevClass",
    "slideDuplicatePrevClass",
    "wrapperClass",
    "runCallbacksOnInit",
    "observer",
    "observeParents",
    "observeSlideChildren",
    "a11y",
    "autoplay",
    "_controller",
    "coverflowEffect",
    "cubeEffect",
    "fadeEffect",
    "flipEffect",
    "creativeEffect",
    "cardsEffect",
    "hashNavigation",
    "history",
    "keyboard",
    "lazy",
    "mousewheel",
    "_navigation",
    "_pagination",
    "parallax",
    "_scrollbar",
    "_thumbs",
    "virtual",
    "zoom"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"7N8X2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initSwiper", function() {
    return initSwiper;
});
parcelHelpers.export(exports, "mountSwiper", function() {
    return mountSwiper;
});
var _swiper = require("swiper");
var _swiperDefault = parcelHelpers.interopDefault(_swiper);
var _utilsJs = require("./utils.js");
function initSwiper(swiperParams) {
    return new (0, _swiperDefault.default)(swiperParams);
}
function mountSwiper(param, swiperParams) {
    var el = param.el, nextEl = param.nextEl, prevEl = param.prevEl, paginationEl = param.paginationEl, scrollbarEl = param.scrollbarEl, swiper = param.swiper;
    if ((0, _utilsJs.needsNavigation)(swiperParams) && nextEl && prevEl) {
        swiper.params.navigation.nextEl = nextEl;
        swiper.originalParams.navigation.nextEl = nextEl;
        swiper.params.navigation.prevEl = prevEl;
        swiper.originalParams.navigation.prevEl = prevEl;
    }
    if ((0, _utilsJs.needsPagination)(swiperParams) && paginationEl) {
        swiper.params.pagination.el = paginationEl;
        swiper.originalParams.pagination.el = paginationEl;
    }
    if ((0, _utilsJs.needsScrollbar)(swiperParams) && scrollbarEl) {
        swiper.params.scrollbar.el = scrollbarEl;
        swiper.originalParams.scrollbar.el = scrollbarEl;
    }
    swiper.init(el);
}

},{"swiper":"dBrcy","./utils.js":"7e9qr","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"4qtVE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcLoopedSlides", function() {
    return calcLoopedSlides;
});
parcelHelpers.export(exports, "renderLoop", function() {
    return renderLoop;
});
var _toConsumableArrayMjs = require("@swc/helpers/src/_to_consumable_array.mjs");
var _toConsumableArrayMjsDefault = parcelHelpers.interopDefault(_toConsumableArrayMjs);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _swiper = require("swiper");
var _swiperDefault = parcelHelpers.interopDefault(_swiper);
function calcLoopedSlides(slides, swiperParams) {
    var slidesPerViewParams = swiperParams.slidesPerView;
    if (swiperParams.breakpoints) {
        var breakpoint = (0, _swiperDefault.default).prototype.getBreakpoint(swiperParams.breakpoints);
        var breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;
        if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) slidesPerViewParams = breakpointOnlyParams.slidesPerView;
    }
    var loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
    loopedSlides += swiperParams.loopAdditionalSlides;
    if (loopedSlides > slides.length) loopedSlides = slides.length;
    return loopedSlides;
}
function renderLoop(swiper, slides, swiperParams) {
    var duplicateSlide = function duplicateSlide(child, index, position) {
        return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(child, {
            key: "".concat(child.key, "-duplicate-").concat(index, "-").concat(position),
            className: "".concat(child.props.className || "", " ").concat(swiperParams.slideDuplicateClass)
        });
    };
    var modifiedSlides = slides.map(function(child, index) {
        return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(child, {
            swiper: swiper,
            "data-swiper-slide-index": index
        });
    });
    if (swiperParams.loopFillGroupWithBlank) {
        var blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;
        if (blankSlidesNum !== swiperParams.slidesPerGroup) for(var i = 0; i < blankSlidesNum; i += 1){
            var blankSlide = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: "".concat(swiperParams.slideClass, " ").concat(swiperParams.slideBlankClass)
            });
            modifiedSlides.push(blankSlide);
        }
    }
    if (swiperParams.slidesPerView === "auto" && !swiperParams.loopedSlides) swiperParams.loopedSlides = modifiedSlides.length;
    var loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
    var prependSlides = [];
    var appendSlides = [];
    modifiedSlides.forEach(function(child, index) {
        if (index < loopedSlides) appendSlides.push(duplicateSlide(child, index, "prepend"));
        if (index < modifiedSlides.length && index >= modifiedSlides.length - loopedSlides) prependSlides.push(duplicateSlide(child, index, "append"));
    });
    if (swiper) swiper.loopedSlides = loopedSlides;
    return (0, _toConsumableArrayMjsDefault.default)(prependSlides).concat((0, _toConsumableArrayMjsDefault.default)(modifiedSlides), (0, _toConsumableArrayMjsDefault.default)(appendSlides));
}

},{"@swc/helpers/src/_to_consumable_array.mjs":"11hUU","react":"ihebA","swiper":"dBrcy","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"lGXUm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getChangedParams", function() {
    return getChangedParams;
});
var _paramsListJs = require("./params-list.js");
var _utilsJs = require("./utils.js");
function getChangedParams(swiperParams, oldParams, children, oldChildren) {
    var keys = [];
    if (!oldParams) return keys;
    var addKey = function(key) {
        if (keys.indexOf(key) < 0) keys.push(key);
    };
    var oldChildrenKeys = oldChildren.map(function(child) {
        return child.key;
    });
    var childrenKeys = children.map(function(child) {
        return child.key;
    });
    if (oldChildrenKeys.join("") !== childrenKeys.join("")) addKey("children");
    if (oldChildren.length !== children.length) addKey("children");
    var watchParams = (0, _paramsListJs.paramsList).filter(function(key) {
        return key[0] === "_";
    }).map(function(key) {
        return key.replace(/_/, "");
    });
    watchParams.forEach(function(key) {
        if (key in swiperParams && key in oldParams) {
            if ((0, _utilsJs.isObject)(swiperParams[key]) && (0, _utilsJs.isObject)(oldParams[key])) {
                var newKeys = Object.keys(swiperParams[key]);
                var oldKeys = Object.keys(oldParams[key]);
                if (newKeys.length !== oldKeys.length) addKey(key);
                else {
                    newKeys.forEach(function(newKey) {
                        if (swiperParams[key][newKey] !== oldParams[key][newKey]) addKey(key);
                    });
                    oldKeys.forEach(function(oldKey) {
                        if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
                    });
                }
            } else if (swiperParams[key] !== oldParams[key]) addKey(key);
        }
    });
    return keys;
}

},{"./params-list.js":"dfX5S","./utils.js":"7e9qr","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"bDr4W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getChildren", function() {
    return getChildren;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function processChildren(c) {
    var slides = [];
    (0, _reactDefault.default).Children.toArray(c).forEach(function(child) {
        if (child.type && child.type.displayName === "SwiperSlide") slides.push(child);
        else if (child.props && child.props.children) processChildren(child.props.children).forEach(function(slide) {
            return slides.push(slide);
        });
    });
    return slides;
}
function getChildren(c) {
    var slides = [];
    var slots = {
        "container-start": [],
        "container-end": [],
        "wrapper-start": [],
        "wrapper-end": []
    };
    (0, _reactDefault.default).Children.toArray(c).forEach(function(child) {
        if (child.type && child.type.displayName === "SwiperSlide") slides.push(child);
        else if (child.props && child.props.slot && slots[child.props.slot]) slots[child.props.slot].push(child);
        else if (child.props && child.props.children) {
            var foundSlides = processChildren(child.props.children);
            if (foundSlides.length > 0) foundSlides.forEach(function(slide) {
                return slides.push(slide);
            });
            else slots["container-end"].push(child);
        } else slots["container-end"].push(child);
    });
    return {
        slides: slides,
        slots: slots
    };
}

},{"react":"ihebA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"cZpJ3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateSwiper", function() {
    return updateSwiper;
});
var _utilsJs = require("./utils.js");
function updateSwiper(param) {
    var swiper = param.swiper, slides = param.slides, passedParams = param.passedParams, changedParams = param.changedParams, nextEl = param.nextEl, prevEl = param.prevEl, scrollbarEl = param.scrollbarEl, paginationEl = param.paginationEl;
    var updateParams = changedParams.filter(function(key) {
        return key !== "children" && key !== "direction";
    });
    var currentParams = swiper.params, pagination = swiper.pagination, navigation = swiper.navigation, scrollbar = swiper.scrollbar, virtual = swiper.virtual, thumbs = swiper.thumbs;
    var needThumbsInit;
    var needControllerInit;
    var needPaginationInit;
    var needScrollbarInit;
    var needNavigationInit;
    if (changedParams.includes("thumbs") && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) needThumbsInit = true;
    if (changedParams.includes("controller") && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) needControllerInit = true;
    if (changedParams.includes("pagination") && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) needPaginationInit = true;
    if (changedParams.includes("scrollbar") && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) needScrollbarInit = true;
    if (changedParams.includes("navigation") && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) needNavigationInit = true;
    var destroyModule = function(mod) {
        if (!swiper[mod]) return;
        swiper[mod].destroy();
        if (mod === "navigation") {
            currentParams[mod].prevEl = undefined;
            currentParams[mod].nextEl = undefined;
            swiper[mod].prevEl = undefined;
            swiper[mod].nextEl = undefined;
        } else {
            currentParams[mod].el = undefined;
            swiper[mod].el = undefined;
        }
    };
    updateParams.forEach(function(key) {
        if ((0, _utilsJs.isObject)(currentParams[key]) && (0, _utilsJs.isObject)(passedParams[key])) (0, _utilsJs.extend)(currentParams[key], passedParams[key]);
        else {
            var newValue = passedParams[key];
            if ((newValue === true || newValue === false) && (key === "navigation" || key === "pagination" || key === "scrollbar")) {
                if (newValue === false) destroyModule(key);
            } else currentParams[key] = passedParams[key];
        }
    });
    if (changedParams.includes("children") && virtual && currentParams.virtual.enabled) {
        virtual.slides = slides;
        virtual.update(true);
    } else if (changedParams.includes("children") && swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
    if (needThumbsInit) {
        var initialized = thumbs.init();
        if (initialized) thumbs.update(true);
    }
    if (needControllerInit) swiper.controller.control = currentParams.controller.control;
    if (needPaginationInit) {
        if (paginationEl) currentParams.pagination.el = paginationEl;
        pagination.init();
        pagination.render();
        pagination.update();
    }
    if (needScrollbarInit) {
        if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
        scrollbar.init();
        scrollbar.updateSize();
        scrollbar.setTranslate();
    }
    if (needNavigationInit) {
        if (nextEl) currentParams.navigation.nextEl = nextEl;
        if (prevEl) currentParams.navigation.prevEl = prevEl;
        navigation.init();
        navigation.update();
    }
    if (changedParams.includes("allowSlideNext")) swiper.allowSlideNext = passedParams.allowSlideNext;
    if (changedParams.includes("allowSlidePrev")) swiper.allowSlidePrev = passedParams.allowSlidePrev;
    if (changedParams.includes("direction")) swiper.changeDirection(passedParams.direction, false);
    swiper.update();
}

},{"./utils.js":"7e9qr","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"9doG4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderVirtual", function() {
    return renderVirtual;
});
parcelHelpers.export(exports, "updateOnVirtualData", function() {
    return updateOnVirtualData;
});
var _definePropertyMjs = require("@swc/helpers/src/_define_property.mjs");
var _definePropertyMjsDefault = parcelHelpers.interopDefault(_definePropertyMjs);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function updateOnVirtualData(swiper) {
    if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
    if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) swiper.parallax.setTranslate();
}
function renderVirtual(swiper, slides, virtualData) {
    if (!virtualData) return null;
    var style = swiper.isHorizontal() ? (0, _definePropertyMjsDefault.default)({}, swiper.rtlTranslate ? "right" : "left", "".concat(virtualData.offset, "px")) : {
        top: "".concat(virtualData.offset, "px")
    };
    return slides.filter(function(child, index) {
        return index >= virtualData.from && index <= virtualData.to;
    }).map(function(child) {
        return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(child, {
            swiper: swiper,
            style: style
        });
    });
}

},{"@swc/helpers/src/_define_property.mjs":"eI7TS","react":"ihebA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"cO17y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", function() {
    return useIsomorphicLayoutEffect;
});
var _react = require("react");
function useIsomorphicLayoutEffect(callback, deps) {
    // eslint-disable-next-line
    if (typeof window === "undefined") return (0, _react.useEffect)(callback, deps);
    return (0, _react.useLayoutEffect)(callback, deps);
}

},{"react":"ihebA","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"4G4xh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwiperSlide", function() {
    return SwiperSlide;
});
var _objectWithoutPropertiesMjs = require("@swc/helpers/src/_object_without_properties.mjs");
var _objectWithoutPropertiesMjsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesMjs);
var _slicedToArrayMjs = require("@swc/helpers/src/_sliced_to_array.mjs");
var _slicedToArrayMjsDefault = parcelHelpers.interopDefault(_slicedToArrayMjs);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utilsJs = require("./utils.js");
var _useIsomorphicLayoutEffectJs = require("./use-isomorphic-layout-effect.js");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var SwiperSlide = /*#__PURE__*/ (0, _react.forwardRef)(function() {
    var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, externalRef = arguments.length > 1 ? arguments[1] : void 0;
    var updateClasses = function updateClasses(_s, el, classNames) {
        if (el === slideElRef.current) setSlideClasses(classNames);
    };
    var tmp = _param.tag, Tag = tmp === void 0 ? "div" : tmp, children = _param.children, _param_className = _param.className, className = _param_className === void 0 ? "" : _param_className, swiper = _param.swiper, zoom = _param.zoom, virtualIndex = _param.virtualIndex, rest = (0, _objectWithoutPropertiesMjsDefault.default)(_param, [
        "tag",
        "children",
        "className",
        "swiper",
        "zoom",
        "virtualIndex"
    ]);
    var slideElRef = (0, _react.useRef)(null);
    var _useState = (0, _slicedToArrayMjsDefault.default)((0, _react.useState)("swiper-slide"), 2), slideClasses = _useState[0], setSlideClasses = _useState[1];
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(function() {
        if (externalRef) externalRef.current = slideElRef.current;
        if (!slideElRef.current || !swiper) return;
        if (swiper.destroyed) {
            if (slideClasses !== "swiper-slide") setSlideClasses("swiper-slide");
            return;
        }
        swiper.on("_slideClass", updateClasses); // eslint-disable-next-line
        return function() {
            if (!swiper) return;
            swiper.off("_slideClass", updateClasses);
        };
    });
    (0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect)(function() {
        if (swiper && slideElRef.current) setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }, [
        swiper
    ]);
    var slideData;
    if (typeof children === "function") slideData = {
        isActive: slideClasses.indexOf("swiper-slide-active") >= 0 || slideClasses.indexOf("swiper-slide-duplicate-active") >= 0,
        isVisible: slideClasses.indexOf("swiper-slide-visible") >= 0,
        isDuplicate: slideClasses.indexOf("swiper-slide-duplicate") >= 0,
        isPrev: slideClasses.indexOf("swiper-slide-prev") >= 0 || slideClasses.indexOf("swiper-slide-duplicate-prev") >= 0,
        isNext: slideClasses.indexOf("swiper-slide-next") >= 0 || slideClasses.indexOf("swiper-slide-duplicate-next") >= 0
    };
    var renderChildren = function() {
        return typeof children === "function" ? children(slideData) : children;
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, _extends({
        ref: slideElRef,
        className: (0, _utilsJs.uniqueClasses)("".concat(slideClasses).concat(className ? " ".concat(className) : "")),
        "data-swiper-slide-index": virtualIndex
    }, rest), zoom ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "swiper-zoom-container",
        "data-swiper-zoom": typeof zoom === "number" ? zoom : undefined
    }, renderChildren()) : renderChildren());
});
SwiperSlide.displayName = "SwiperSlide";

},{"@swc/helpers/src/_object_without_properties.mjs":"d0eOZ","@swc/helpers/src/_sliced_to_array.mjs":"l34hS","react":"ihebA","./utils.js":"7e9qr","./use-isomorphic-layout-effect.js":"cO17y","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"6DLi3":[function() {},{}],"2hxeU":[function() {},{}],"1r6I2":[function() {},{}],"4lAzf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _config = require("../uwpfilters/config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _quickshop = require("../../framework/_quickshop");
function ShopboxProductCard(param) {
    var product = param.product, style = param.style;
    var _product_images_, _product_images_1, _product_images_2, _product_images_3;
    // nodeRef is used to attach an IntersectionObserver to allow for infinite scrolling without
    // messy viewport scroll position arithmetic. If this is adapted for future projects that
    // require infinite scrolling, ensure that nodeRef is set as a ref on the outer element of
    // this component. --GAD
    // [TODO] This is a mess and needs refactoring, as it has been copied almost verbatim from
    // imperative code.
    // There might be no reason to why it was originally setup like this. 
    // Adding Quickshop.createQuickshop directly into the onClick attribute, in the return() seems to work fine. I'm leaving as is.
    var handleQuickshopClick = function(handle, shopboxProductURL) {
        return function() {
            (0, _quickshop.Quickshop).createQuickshop(handle, shopboxProductURL);
        };
    };
    var _config_themeVars_site_wide_sale;
    var site_wide_sale = (_config_themeVars_site_wide_sale = (0, _configDefault.default).themeVars.site_wide_sale) !== null && _config_themeVars_site_wide_sale !== void 0 ? _config_themeVars_site_wide_sale : {};
    var _config_themeVars_theme_accent_color;
    var site_wide_accent_color = (_config_themeVars_theme_accent_color = (0, _configDefault.default).themeVars.theme.accent_color) !== null && _config_themeVars_theme_accent_color !== void 0 ? _config_themeVars_theme_accent_color : "";
    var compare_at_price = String(product.compare_at_price);
    var price = String(product.price);
    var saleText = "SALE";
    var saleBannerColor = "#CE0E2D";
    var notifyMe = product.tags.includes("back-in-stock");
    var outOfStock = product.variants.filter(function(variant) {
        return variant.inventory_quantity === 0;
    }).length === product.variants.length;
    var showNotifyMe = outOfStock && notifyMe;
    if (site_wide_sale.activated == true) {
        var promoTag = site_wide_sale.promotion_tag;
        var tags = product.tags;
        var discount = (100 - site_wide_sale.promotion_percentage) / 100.0;
        tags.map(function(tag) {
            if (tag === promoTag) {
                compare_at_price = price;
                price = (Number(price) * discount).toFixed(2);
                saleText = site_wide_sale.banner_text;
                saleBannerColor = site_wide_sale.banner_color;
            }
        });
    }
    var onSale = +compare_at_price > +price;
    var labelText = getLabelTagText(product.tags);
    var labelBackgroundColor = getLabelBackgroundColor(product.tags);
    var productURL = "".concat(product.url); // URL obtained from Shopbox's API call (see 'productUrls' in shopboxComponent.tsx)
    //const productURL = `/products/${product.handle}`; Use this to get the URL from Shopify instead
    /* API is set in shopboxComponent.tsx in such a way, this is how it calls all the products in
    const shopboxResponse = await fetch(url,
    {
        headers: {
        "Content-Type": "application/json",
        "SB-TOKEN": 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MDA4MjAzMzIsImNsaWVudF9pZCI6InRxbWZGbEtQSzk3VEJHQldSQ3p0Iiwic3ViIjoiNDg3OTM4YzRjMWMyNDhhMDlkMTlkM2NkYzQyMzk2NjAiLCJ1c2VyX2lkIjoiNDUxNjIzNWQ2YWU4NGJlYjk4NDhlYzI3OTdiNTYxYzciLCJ3ZWJzaXRlIjoiIiwiYXBpIjp0cnVlLCJuYW1lIjoiVVdQIn0.LW0RyzhlDSXooSJ8-oafALN-PvvgSO_tLz_JX3B3Eic'
        }
    }
    )
          
  */ (0, _react.useEffect)(function() {
        try {
            if (window._swat) window._swat.initializeActionButtons("#productID-".concat(product.id));
            else {
                window.SwymCallbacks = window.SwymCallbacks || [];
                window.SwymCallbacks.push(function() {
                    window._swat.initializeActionButtons("#productID-".concat(product.id));
                });
            }
        } catch (error) {
            console.log(error);
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "prod-card",
        id: "productID-".concat(product.id),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "prod-card__image-container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "prod-card__rollover-images",
                        children: [
                            product.images[1] && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "prod-card__alternate-image",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: productURL,
                                        className: "sb-product-card",
                                        "data-url": productURL,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            width: "295",
                                            // onError="this.style.visibility='hidden'"
                                            height: "443",
                                            src: "".concat((_product_images_ = product.images[1]) === null || _product_images_ === void 0 ? void 0 : _product_images_.src, "&width=400"),
                                            alt: (_product_images_1 = product.images[1]) === null || _product_images_1 === void 0 ? void 0 : _product_images_1.alt,
                                            className: "prod-card__image"
                                        })
                                    }),
                                    style != "minicart" && window.themeSettings.enable_quickview ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "prod-card__quick-view prod-card__quick-view-".concat(product.handle),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "prod-card__quick-view__button",
                                            onClick: handleQuickshopClick(product.handle, productURL),
                                            children: "Buy Now"
                                        })
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "prod-card__original-image",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: productURL,
                                    className: "sb-product-card",
                                    "data-url": productURL,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        width: "295",
                                        height: "443",
                                        src: "".concat((_product_images_2 = product.images[0]) === null || _product_images_2 === void 0 ? void 0 : _product_images_2.src, "&width=400"),
                                        alt: "".concat((_product_images_3 = product.images[0]) === null || _product_images_3 === void 0 ? void 0 : _product_images_3.alt),
                                        className: "prod-card__image"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "prod-card__badges",
                        children: [
                            isNew(product) && !onSale && !showNotifyMe && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "prod-card__tag",
                                style: {
                                    backgroundColor: site_wide_accent_color
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "prod-card__tag__text",
                                    children: "New In"
                                })
                            }),
                            showNotifyMe && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "prod-card__tag",
                                style: {
                                    backgroundColor: site_wide_accent_color
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "prod-card__tag__text",
                                    children: "Notify Me"
                                })
                            })
                        ]
                    }),
                    style != "minicart" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "prod-card__wishlist-heart prod-card__wishlist-heart-".concat(product.handle),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            "data-with-epi": "true",
                            className: "swym-button swym-add-to-wishlist-view-product product_".concat(product.id),
                            "data-swaction": "addToWishlist",
                            "data-product-id": product.id,
                            "data-variant-id": product.variants[0].id,
                            "data-product-url": "https://www.carraigdonn.com/products/".concat(product.handle)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "prod-card__banner",
                children: [
                    onSale && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "prod-card__sale-banner",
                        style: {
                            backgroundColor: saleBannerColor
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "prod-card__banner__text",
                            children: saleText
                        })
                    }),
                    labelText && !onSale && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "prod-card__label-banner",
                        style: {
                            backgroundColor: labelBackgroundColor
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "prod-card__banner__text",
                            children: labelText.toUpperCase()
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "prod-card__info",
                style: {
                    flexDirection: "column",
                    flexWrap: "nowrap"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "prod-card__info__details",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: productURL,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "prod-card__title",
                                    dangerouslySetInnerHTML: {
                                        __html: product.title
                                    }
                                })
                            }),
                            style == "minicart" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "prod-card__vendor",
                                children: product.vendor
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "prod-card__info__price",
                                children: [
                                    style == "minicart" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "prod-card__price__container",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "prod-card__price ".concat(onSale ? "prod-card__price__sale" : ""),
                                                children: "".concat((0, _configDefault.default).currencySymbol).concat((Number(price) * (0, _configDefault.default).exchangeRate).toFixed(2))
                                            }),
                                            onSale && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "prod-card__compare-at-price",
                                                children: [
                                                    " Was",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: "".concat((0, _configDefault.default).currencySymbol).concat((Number(compare_at_price) * (0, _configDefault.default).exchangeRate).toFixed(2))
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    style != "minicart" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "prod-card__price__container",
                                        children: [
                                            onSale && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "prod-card__compare-at-price",
                                                children: "".concat((0, _configDefault.default).currencySymbol).concat((Number(compare_at_price) * (0, _configDefault.default).exchangeRate).toFixed(2))
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "prod-card__price ".concat(onSale ? "prod-card__price__sale" : ""),
                                                children: "".concat((0, _configDefault.default).currencySymbol).concat((Number(price) * (0, _configDefault.default).exchangeRate).toFixed(2))
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    style != "minicart" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "prod-card__vendor",
                        children: product.vendor
                    }),
                    style == "minicart" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        className: "prod-card__button",
                        href: productURL,
                        children: "Choose Option"
                    })
                ]
            })
        ]
    });
}
exports.default = ShopboxProductCard;
function isNew(product) {
    var createdAtDate = new Date(product.created_at);
    var now = new Date();
    var daysSinceCreation = Math.floor((now.valueOf() - createdAtDate.valueOf()) / 86400000);
    return daysSinceCreation <= 14;
}
// function getSwatches(product: ProductSwatches) {
//   return product.linked_products.map((swatch) => (
//     <a href={swatch.linked_url}>
//       <img
//         onClick={selectedSwatch()}
//         className="prod-card__swatch"
//         src={swatch.linked_swatch}
//         alt={product.title}
//       ></img>
//     </a>
//   ));
// }
function selectedSwatch() {
    return function(event) {
        var swatches = document.querySelectorAll(".prod-card__swatch");
        swatches.forEach(function(swatch) {
            swatch.classList.remove("selected");
        });
        var target = event.target;
        target.classList.add("selected");
    };
}
function getLabelTagText(tags) {
    // [TODO] Refactor
    var labelTagText = null;
    tags.forEach(function(tag) {
        var splitTag = tag.split("-");
        if (splitTag[0] == "label" && splitTag.length == 2) labelTagText = tag.split("-")[1];
        else if (splitTag[0] == "label" && splitTag.length == 3) labelTagText = "".concat(splitTag[1], " ").concat(splitTag[2]);
        else if (splitTag[0] == "label" && splitTag.length == 4) labelTagText = "".concat(splitTag[1], " ").concat(splitTag[2], " ").concat(splitTag[3]);
    });
    return labelTagText;
}
function getLabelBackgroundColor(tags) {
    var labelBackgroundColor = "#000000";
    tags.forEach(function(tag) {
        var splitTag = tag.split("-");
        if (splitTag[0] == "label" && splitTag[1] == "background") labelBackgroundColor = splitTag[2];
    });
    return labelBackgroundColor;
}

},{"react/jsx-runtime":"ebSqZ","../uwpfilters/config":"1C44m","react":"ihebA","../../framework/_quickshop":"dZwOO","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"kUeqk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var productRedirect = function() {
    var init = function init() {
        var ThemeVars = window.ThemeVars;
        if (ThemeVars && ThemeVars.freeGiftProducts) {
            var freeGiftProducts = ThemeVars.freeGiftProducts;
            var productId = document.querySelector("input.product_id").value;
            if (!productId) return;
            if (!Array.isArray(freeGiftProducts)) freeGiftProducts = [
                freeGiftProducts
            ];
            var isFreeGift = freeGiftProducts.some(function(freeGiftProducts) {
                return freeGiftProducts.id === parseInt(productId);
            });
            if (isFreeGift) {
                window.location.href = "/";
                return;
            }
        }
    };
    return {
        init: init
    };
}();
exports.default = productRedirect;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"6Dc29":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var cart = function() {
    var init = function init() {
        var cartPage = document.querySelector(".main-cart-template");
        if (cartPage) {
            cartQuantity();
            document.addEventListener("cartDataUpdated", function() {
                renderCartPage();
            });
        }
    };
    var cartQuantity = function cartQuantity() {
        var decrementBtns = document.querySelectorAll(".cart__item__decrement");
        var incrementBtns = document.querySelectorAll(".cart__item__increment");
        var qtyInputs = document.querySelectorAll(".cart__item__quantity");
        if (incrementBtns.length > 0) incrementBtns.forEach(function(incrementer) {
            incrementer.addEventListener("click", function(event) {
                var quantityInput = event.currentTarget.parentElement.querySelector(".cart__item__quantity");
                if (!quantityInput) return false;
                if (quantityInput.value == quantityInput.max) return console.error("Minicart incrementor: Cannot increment past max quantity.");
                quantityInput.value++;
                var changeBody = {
                    "line": quantityInput.dataset.id.toString(),
                    "quantity": parseInt(quantityInput.value)
                };
                Cart.sendCartChange(changeBody);
            });
        });
        if (qtyInputs.length > 0) qtyInputs.forEach(function(quantityInput) {
            quantityInput.addEventListener("input", function(event) {
                if (parseInt(event.target.value) && event.target.value != "") {
                    if (parseInt(event.target.value) > parseInt(event.target.max)) event.target.value = event.target.max;
                    var changeBody = {
                        "line": quantityInput.dataset.id.toString(),
                        "quantity": parseInt(quantityInput.value)
                    };
                    Cart.sendCartChange(changeBody);
                }
            });
        });
        if (decrementBtns.length > 0) decrementBtns.forEach(function(decrementer) {
            decrementer.addEventListener("click", function(event) {
                var quantityInput = event.currentTarget.parentElement.querySelector(".cart__item__quantity");
                if (!quantityInput) return false;
                quantityInput.value--;
                var changeBody = {
                    "line": quantityInput.dataset.id.toString(),
                    "quantity": parseInt(quantityInput.value)
                };
                Cart.sendCartChange(changeBody);
            });
        });
    };
    var renderCartPage = function renderCartPage() {
        var section_request = "/?section_id=cart";
        fetch(section_request).then(function(response) {
            return response.text();
        }).then(function(text) {
            var newElement = document.createElement("div");
            newElement.innerHTML = text;
            var newSummaryContent = newElement.querySelector(".summary-content");
            var summaryContentContainer = document.querySelector(".summary-content");
            if (newSummaryContent && summaryContentContainer) summaryContentContainer.innerHTML = newSummaryContent.innerHTML;
            var newFreeShipping = newElement.querySelector(".main-cart-summary .cart__free-shipping");
            var freeShippingContainer = document.querySelector(".main-cart-summary .cart__free-shipping");
            if (newFreeShipping && freeShippingContainer) freeShippingContainer.innerHTML = newFreeShipping.innerHTML;
            var newCartItemsList = newElement.querySelector(".main-cart-items-list");
            var cartItemsListContainer = document.querySelector(".main-cart-items-list");
            if (newCartItemsList && cartItemsListContainer) {
                cartItemsListContainer.innerHTML = newCartItemsList.innerHTML;
                cartQuantity();
                var newListItems = newCartItemsList.querySelectorAll(".cart__item");
                if (newListItems.length < 1) {
                    var emptyCart = document.querySelector(".main-cart-empty");
                    if (emptyCart) emptyCart.classList.remove("hidden");
                    var form = document.querySelector("#cart-form");
                    if (form) form.classList.add("hidden");
                }
            }
        }).catch(function(e) {
            console.error(e);
        });
    };
    return {
        init: init
    };
}();
exports.default = cart;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"jsMxg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _asyncToGeneratorMjs = require("@swc/helpers/src/_async_to_generator.mjs");
var _asyncToGeneratorMjsDefault = parcelHelpers.interopDefault(_asyncToGeneratorMjs);
var _tsGeneratorMjs = require("@swc/helpers/src/_ts_generator.mjs");
var _tsGeneratorMjsDefault = parcelHelpers.interopDefault(_tsGeneratorMjs);
var findInStore = function() {
    var init = function init() {
        var modal = document.querySelector(".js-find-in-store-modal");
        if (modal) toggleModal();
    };
    var toggleModal = function toggleModal() {
        var openModalBtn = document.querySelector(".js-open-find-in-store-modal");
        var closeModalBtns = document.querySelectorAll(".js-find-in-store-close-modal");
        if (openModalBtn) openModalBtn.addEventListener("click", showModal);
        closeModalBtns.forEach(function(closeModalBtn) {
            closeModalBtn.addEventListener("click", hideModal);
        });
    };
    var showModal = function showModal() {
        var modal = document.querySelector(".js-find-in-store-modal");
        if (modal) {
            var productId = modal.getAttribute("data-product-id");
            if (!productId) return false;
            var variantSelect = document.querySelector(".ProductForm #variant-selector-".concat(productId));
            if (!variantSelect) return false;
            var selectedOption = variantSelect.options[variantSelect.selectedIndex];
            var sku = selectedOption.getAttribute("data-sku");
            renderStoreList(sku);
            modal.classList.add("visible");
            document.querySelector("body").classList.add("find-in-store-modal-open");
        }
    };
    var hideModal = function hideModal() {
        var modal = document.querySelector(".js-find-in-store-modal");
        if (modal) {
            modal.classList.remove("visible");
            document.querySelector("body").classList.remove("find-in-store-modal-open");
        }
    };
    var searchStore = function searchStore() {
        var searchInput = document.querySelector(".js-find-in-store-search");
        var storeItems = document.querySelectorAll(".find-in-store-list-item");
        if (searchInput) searchInput.addEventListener("input", function() {
            var query = searchInput.value.toLowerCase();
            storeItems.forEach(function(item) {
                var storeName = item.querySelector(".find-in-store-list-store").textContent.toLowerCase();
                if (storeName.includes(query)) item.style.display = "";
                else item.style.display = "none";
            });
        });
    };
    function getStoresData(sku) {
        return _getStoresData.apply(this, arguments);
    }
    function _getStoresData() {
        _getStoresData = (0, _asyncToGeneratorMjsDefault.default)(function(sku) {
            var fisError, response, data, error;
            return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        fisError = document.querySelector(".js-find-in-store-error");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            fetch("https://carraig-donn.lerp.sf9dev.com/findinstore/branches", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                mode: "cors",
                                body: JSON.stringify({
                                    sku: sku
                                })
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (!response.ok) throw new Error("HTTP error! status: ".concat(response.status));
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        data = _state.sent();
                        if (!data[0].title) {
                            if (fisError) fisError.classList.remove("hidden");
                        }
                        return [
                            2,
                            data
                        ];
                    case 4:
                        error = _state.sent();
                        console.error("Error fetching store data:", error);
                        if (fisError) fisError.classList.remove("hidden");
                        return [
                            2,
                            []
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return _getStoresData.apply(this, arguments);
    }
    function renderStoreList(sku) {
        return _renderStoreList.apply(this, arguments);
    }
    function _renderStoreList() {
        _renderStoreList = (0, _asyncToGeneratorMjsDefault.default)(function(sku) {
            var storeListContainer, fisError, stores, lowStock, locatorPage, showStock;
            return (0, _tsGeneratorMjsDefault.default)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        storeListContainer = document.querySelector(".find-in-store-list");
                        fisError = document.querySelector(".js-find-in-store-error");
                        if (!storeListContainer) return [
                            2,
                            false
                        ];
                        if (fisError) fisError.classList.add("hidden");
                        return [
                            4,
                            getStoresData(sku)
                        ];
                    case 1:
                        stores = _state.sent();
                        stores.sort(function(a, b) {
                            return a.title.localeCompare(b.title);
                        });
                        lowStock = parseInt(storeListContainer.getAttribute("data-low-in-stock"));
                        locatorPage = storeListContainer.getAttribute("data-locator-page");
                        showStock = storeListContainer.getAttribute("data-show-stock");
                        storeListContainer.innerHTML = "";
                        stores.forEach(function(store) {
                            if (!store.title) return false;
                            var stockLabelClass = store.qty > lowStock ? "stock-label-in-store" : store.qty > 0 && store.qty <= lowStock ? "stock-label-low-in-stock" : "stock-label-out-of-stock";
                            var stockLabelText = store.qty > lowStock ? "In Stock" : store.qty > 0 && store.qty <= lowStock ? "Low In Stock" : "Out Of Stock";
                            var stock = "";
                            if (showStock == "true") stock = '<p class="find-in-store-list-stock-qty">'.concat(store.qty, "</p>");
                            var storeItem = '\n                <div class="find-in-store-list-item">\n                    <a href="'.concat(locatorPage, '" class="find-in-store-list-store">').concat(store.title, '</a>\n                    <p class="find-in-store-list-stock-label ').concat(stockLabelClass, '">').concat(stockLabelText, "</p>\n                    ").concat(stock, "\n                </div>\n            ");
                            if (storeMetaobjects.deliveryPoints && storeMetaobjects.deliveryPoints.length > 0) {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = storeMetaobjects.deliveryPoints[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var deliveryPoint = _step.value;
                                        if (deliveryPoint.pointLocationId === store.location) {
                                            if (deliveryPoint.active_store === true) storeListContainer.insertAdjacentHTML("beforeend", storeItem);
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            } else storeListContainer.insertAdjacentHTML("beforeend", storeItem);
                        });
                        searchStore();
                        return [
                            2
                        ];
                }
            });
        });
        return _renderStoreList.apply(this, arguments);
    }
    return {
        init: init
    };
}();
exports.default = findInStore;

},{"@swc/helpers/src/_async_to_generator.mjs":"7nC9G","@swc/helpers/src/_ts_generator.mjs":"cT4KU","@parcel/transformer-js/src/esmodule-helpers.js":"3Oqqe"}],"2WjDp":[function(require,module,exports) {
(function() {
    if (!window.location.pathname.includes("/products/")) return;
    var milliseconds = 100;
    var elapsed = 0;
    var interval = setInterval(function() {
        var klarnaPlacement = document.querySelector(".product__block-wrapper klarna-placement");
        if (klarnaPlacement) {
            var styleTag = document.createElement("style");
            styleTag.innerText = "\n                .credit-promotion-badge > .container {\n                    padding: 0;\n                    border: none;\n                    column-gap: 14px;\n                }\n\n                .credit-promotion-badge > .container > .text-wrapper {\n                    margin-left: 0;\n                }\n            ";
            klarnaPlacement.shadowRoot.appendChild(styleTag);
        }
        if (klarnaPlacement || elapsed >= 5000) clearInterval(interval);
        elapsed += milliseconds;
    }, milliseconds);
})();

},{}],"jB0W0":[function() {},{}]},["eJH2p"], "eJH2p", "parcelRequireb069")

